/******/
(function (modules) {
  // webpackBootstrap
  /******/ // install a JSONP callback for chunk loading
  /******/
  function webpackJsonpCallback(data) {
    /******/
    var chunkIds = data[0];
    /******/
    var moreModules = data[1];
    /******/
    /******/
    var prefetchChunks = data[3] || [];
    /******/ // add "moreModules" to the modules object,
    /******/ // then flag all "chunkIds" as loaded and fire callback
    /******/
    var moduleId,
      chunkId,
      i = 0,
      resolves = [];
    /******/
    for (; i < chunkIds.length; i++) {
      /******/
      chunkId = chunkIds[i];
      /******/
      if (Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
        /******/
        resolves.push(installedChunks[chunkId][0]);
        /******/
      }
      /******/
      installedChunks[chunkId] = 0;
      /******/
    }
    /******/
    for (moduleId in moreModules) {
      /******/
      if (Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
        /******/
        modules[moduleId] = moreModules[moduleId];
        /******/
      }
      /******/
    }
    /******/
    if (parentJsonpFunction) parentJsonpFunction(data);
    /******/ // chunk prefetching for javascript
    /******/
    prefetchChunks.forEach(function (chunkId) {
      /******/
      if (installedChunks[chunkId] === undefined) {
        /******/
        installedChunks[chunkId] = null;
        /******/
        var link = document.createElement("link");
        /******/
        /******/
        if (__webpack_require__.nc) {
          /******/
          link.setAttribute("nonce", __webpack_require__.nc);
          /******/
        }
        /******/
        link.rel = "prefetch";
        /******/
        link.as = "script";
        /******/
        link.href = jsonpScriptSrc(chunkId);
        /******/
        document.head.appendChild(link);
        /******/
      }
      /******/
    });
    /******/
    while (resolves.length) {
      /******/
      resolves.shift()();
      /******/
    }
    /******/
    /******/
  }
  /******/
  /******/
  /******/ // The module cache
  /******/
  var installedModules = {};
  /******/
  /******/ // object to store loaded and loading chunks
  /******/ // undefined = chunk not loaded, null = chunk preloaded/prefetched
  /******/ // Promise = chunk loading, 0 = chunk loaded
  /******/
  var installedChunks = {
    /******/
    2: 0,
    /******/
  };
  /******/
  /******/
  /******/
  /******/ // script path function
  /******/
  function jsonpScriptSrc(chunkId) {
    /******/
    return (
      __webpack_require__.p +
      "assets/" +
      ({
        1: "product-image-zoom",
        5: "vendors--product-image-zoom",
      }[chunkId] || chunkId) +
      ".min.js"
    );
    /******/
  }
  /******/
  /******/ // The require function
  /******/
  function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/
    var module = (installedModules[moduleId] = {
      /******/
      i: moduleId,
      /******/
      l: false,
      /******/
      exports: {},
      /******/
    });
    /******/
    /******/ // Execute the module function
    /******/
    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/
    module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/
    return module.exports;
    /******/
  }
  /******/
  /******/ // This file contains only the entry chunk.
  /******/ // The chunk loading function for additional chunks
  /******/
  __webpack_require__.e = function requireEnsure(chunkId) {
    /******/
    var promises = [];
    /******/
    /******/
    /******/ // JSONP chunk loading for javascript
    /******/
    /******/
    var installedChunkData = installedChunks[chunkId];
    /******/
    if (installedChunkData !== 0) {
      // 0 means "already installed".
      /******/
      /******/ // a Promise means "currently loading".
      /******/
      if (installedChunkData) {
        /******/
        promises.push(installedChunkData[2]);
        /******/
      } else {
        /******/ // setup Promise in chunk cache
        /******/
        var promise = new Promise(function (resolve, reject) {
          /******/
          installedChunkData = installedChunks[chunkId] = [resolve, reject];
          /******/
        });
        /******/
        promises.push((installedChunkData[2] = promise));
        /******/
        /******/ // start chunk loading
        /******/
        var script = document.createElement("script");
        /******/
        var onScriptComplete;
        /******/
        /******/
        script.charset = "utf-8";
        /******/
        script.timeout = 120;
        /******/
        if (__webpack_require__.nc) {
          /******/
          script.setAttribute("nonce", __webpack_require__.nc);
          /******/
        }
        /******/
        script.src = jsonpScriptSrc(chunkId);
        /******/
        /******/ // create error before stack unwound to get useful stacktrace later
        /******/
        var error = new Error();
        /******/
        onScriptComplete = function (event) {
          /******/ // avoid mem leaks in IE.
          /******/
          script.onerror = script.onload = null;
          /******/
          clearTimeout(timeout);
          /******/
          var chunk = installedChunks[chunkId];
          /******/
          if (chunk !== 0) {
            /******/
            if (chunk) {
              /******/
              var errorType = event && (event.type === "load" ? "missing" : event.type);
              /******/
              var realSrc = event && event.target && event.target.src;
              /******/
              error.message = "Loading chunk " + chunkId + " failed.\n(" + errorType + ": " + realSrc + ")";
              /******/
              error.name = "ChunkLoadError";
              /******/
              error.type = errorType;
              /******/
              error.request = realSrc;
              /******/
              chunk[1](error);
              /******/
            }
            /******/
            installedChunks[chunkId] = undefined;
            /******/
          }
          /******/
        };
        /******/
        var timeout = setTimeout(function () {
          /******/
          onScriptComplete({
            type: "timeout",
            target: script,
          });
          /******/
        }, 120000);
        /******/
        script.onerror = script.onload = onScriptComplete;
        /******/
        document.head.appendChild(script);
        /******/
      }
      /******/
    }
    /******/
    return Promise.all(promises);
    /******/
  };
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/
  __webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/
  __webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/
  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        enumerable: true,
        get: getter,
      });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/
  __webpack_require__.r = function (exports) {
    /******/
    if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
      /******/
      Object.defineProperty(exports, Symbol.toStringTag, {
        value: "Module",
      });
      /******/
    }
    /******/
    Object.defineProperty(exports, "__esModule", {
      value: true,
    });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/
  __webpack_require__.t = function (value, mode) {
    /******/
    if (mode & 1) value = __webpack_require__(value);
    /******/
    if (mode & 8) return value;
    /******/
    if (mode & 4 && typeof value === "object" && value && value.__esModule) return value;
    /******/
    var ns = Object.create(null);
    /******/
    __webpack_require__.r(ns);
    /******/
    Object.defineProperty(ns, "default", {
      enumerable: true,
      value: value,
    });
    /******/
    if (mode & 2 && typeof value != "string")
      for (var key in value)
        __webpack_require__.d(
          ns,
          key,
          function (key) {
            return value[key];
          }.bind(null, key)
        );
    /******/
    return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/
  __webpack_require__.n = function (module) {
    /******/
    var getter =
      module && module.__esModule
        ? /******/
          function getDefault() {
            return module["default"];
          }
        : /******/
          function getModuleExports() {
            return module;
          };
    /******/
    __webpack_require__.d(getter, "a", getter);
    /******/
    return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/
  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/
  __webpack_require__.p = "";
  /******/
  /******/ // on error function for async loading
  /******/
  __webpack_require__.oe = function (err) {
    console.error(err);
    throw err;
  };
  /******/
  /******/
  var jsonpArray = (window["baselineWebpackJsonp"] = window["baselineWebpackJsonp"] || []);
  /******/
  var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
  /******/
  jsonpArray.push = webpackJsonpCallback;
  /******/
  jsonpArray = jsonpArray.slice();
  /******/
  for (var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
  /******/
  var parentJsonpFunction = oldJsonpFunction;
  /******/
  /******/
  /******/
  var startupResult = (function () {
    /******/ // Load entry module and return exports
    /******/
    return __webpack_require__((__webpack_require__.s = 38));
    /******/
  })();
  /******/
  /******/
  webpackJsonpCallback([[], {}, 0, [5, 1]]);
  /******/
  return startupResult;
  /******/
})(
  /************************************************************************/
  /******/
  [
    /* 0 */
    /***/
    function (module, exports, __webpack_require__) {
      (function (window, factory) {
        var lazySizes = factory(window, window.document, Date);
        window.lazySizes = lazySizes;
        if (true && module.exports) {
          module.exports = lazySizes;
        }
      })(typeof window != "undefined" ? window : {}, function l(window, document, Date) {
        // Pass in the windoe Date function also for SSR because the Date class can be lost
        "use strict";
        /*jshint eqnull:true */

        var lazysizes, lazySizesCfg;

        (function () {
          var prop;

          var lazySizesDefaults = {
            lazyClass: "lazyload",
            loadedClass: "lazyloaded",
            loadingClass: "lazyloading",
            preloadClass: "lazypreload",
            errorClass: "lazyerror",
            //strictClass: 'lazystrict',
            autosizesClass: "lazyautosizes",
            fastLoadedClass: "ls-is-cached",
            iframeLoadMode: 0,
            srcAttr: "data-src",
            srcsetAttr: "data-srcset",
            sizesAttr: "data-sizes",
            //preloadAfterLoad: false,
            minSize: 40,
            customMedia: {},
            init: true,
            expFactor: 1.5,
            hFac: 0.8,
            loadMode: 2,
            loadHidden: true,
            ricTimeout: 0,
            throttleDelay: 125,
          };

          lazySizesCfg = window.lazySizesConfig || window.lazysizesConfig || {};

          for (prop in lazySizesDefaults) {
            if (!(prop in lazySizesCfg)) {
              lazySizesCfg[prop] = lazySizesDefaults[prop];
            }
          }
        })();

        if (!document || !document.getElementsByClassName) {
          return {
            init: function () {},
            cfg: lazySizesCfg,
            noSupport: true,
          };
        }

        var docElem = document.documentElement;

        var supportPicture = window.HTMLPictureElement;

        var _addEventListener = "addEventListener";

        var _getAttribute = "getAttribute";

        /**
         * Update to bind to window because 'this' becomes null during SSR
         * builds.
         */
        var addEventListener = window[_addEventListener].bind(window);

        var setTimeout = window.setTimeout;

        var requestAnimationFrame = window.requestAnimationFrame || setTimeout;

        var requestIdleCallback = window.requestIdleCallback;

        var regPicture = /^picture$/i;

        var loadEvents = ["load", "error", "lazyincluded", "_lazyloaded"];

        var regClassCache = {};

        var forEach = Array.prototype.forEach;

        var hasClass = function (ele, cls) {
          if (!regClassCache[cls]) {
            regClassCache[cls] = new RegExp("(\\s|^)" + cls + "(\\s|$)");
          }
          return regClassCache[cls].test(ele[_getAttribute]("class") || "") && regClassCache[cls];
        };

        var addClass = function (ele, cls) {
          if (!hasClass(ele, cls)) {
            ele.setAttribute("class", (ele[_getAttribute]("class") || "").trim() + " " + cls);
          }
        };

        var removeClass = function (ele, cls) {
          var reg;
          if ((reg = hasClass(ele, cls))) {
            ele.setAttribute("class", (ele[_getAttribute]("class") || "").replace(reg, " "));
          }
        };

        var addRemoveLoadEvents = function (dom, fn, add) {
          var action = add ? _addEventListener : "removeEventListener";
          if (add) {
            addRemoveLoadEvents(dom, fn);
          }
          loadEvents.forEach(function (evt) {
            dom[action](evt, fn);
          });
        };

        var triggerEvent = function (elem, name, detail, noBubbles, noCancelable) {
          var event = document.createEvent("Event");

          if (!detail) {
            detail = {};
          }

          detail.instance = lazysizes;

          event.initEvent(name, !noBubbles, !noCancelable);

          event.detail = detail;

          elem.dispatchEvent(event);
          return event;
        };

        var updatePolyfill = function (el, full) {
          var polyfill;
          if (!supportPicture && (polyfill = window.picturefill || lazySizesCfg.pf)) {
            if (full && full.src && !el[_getAttribute]("srcset")) {
              el.setAttribute("srcset", full.src);
            }
            polyfill({
              reevaluate: true,
              elements: [el],
            });
          } else if (full && full.src) {
            el.src = full.src;
          }
        };

        var getCSS = function (elem, style) {
          return (getComputedStyle(elem, null) || {})[style];
        };

        var getWidth = function (elem, parent, width) {
          width = width || elem.offsetWidth;

          while (width < lazySizesCfg.minSize && parent && !elem._lazysizesWidth) {
            width = parent.offsetWidth;
            parent = parent.parentNode;
          }

          return width;
        };

        var rAF = (function () {
          var running, waiting;
          var firstFns = [];
          var secondFns = [];
          var fns = firstFns;

          var run = function () {
            var runFns = fns;

            fns = firstFns.length ? secondFns : firstFns;

            running = true;
            waiting = false;

            while (runFns.length) {
              runFns.shift()();
            }

            running = false;
          };

          var rafBatch = function (fn, queue) {
            if (running && !queue) {
              fn.apply(this, arguments);
            } else {
              fns.push(fn);

              if (!waiting) {
                waiting = true;
                (document.hidden ? setTimeout : requestAnimationFrame)(run);
              }
            }
          };

          rafBatch._lsFlush = run;

          return rafBatch;
        })();

        var rAFIt = function (fn, simple) {
          return simple
            ? function () {
                rAF(fn);
              }
            : function () {
                var that = this;
                var args = arguments;
                rAF(function () {
                  fn.apply(that, args);
                });
              };
        };

        var throttle = function (fn) {
          var running;
          var lastTime = 0;
          var gDelay = lazySizesCfg.throttleDelay;
          var rICTimeout = lazySizesCfg.ricTimeout;
          var run = function () {
            running = false;
            lastTime = Date.now();
            fn();
          };
          var idleCallback =
            requestIdleCallback && rICTimeout > 49
              ? function () {
                  requestIdleCallback(run, {
                    timeout: rICTimeout,
                  });

                  if (rICTimeout !== lazySizesCfg.ricTimeout) {
                    rICTimeout = lazySizesCfg.ricTimeout;
                  }
                }
              : rAFIt(function () {
                  setTimeout(run);
                }, true);

          return function (isPriority) {
            var delay;

            if ((isPriority = isPriority === true)) {
              rICTimeout = 33;
            }

            if (running) {
              return;
            }

            running = true;

            delay = gDelay - (Date.now() - lastTime);

            if (delay < 0) {
              delay = 0;
            }

            if (isPriority || delay < 9) {
              idleCallback();
            } else {
              setTimeout(idleCallback, delay);
            }
          };
        };

        //based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
        var debounce = function (func) {
          var timeout, timestamp;
          var wait = 99;
          var run = function () {
            timeout = null;
            func();
          };
          var later = function () {
            var last = Date.now() - timestamp;

            if (last < wait) {
              setTimeout(later, wait - last);
            } else {
              (requestIdleCallback || run)(run);
            }
          };

          return function () {
            timestamp = Date.now();

            if (!timeout) {
              timeout = setTimeout(later, wait);
            }
          };
        };

        var loader = (function () {
          var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;

          var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;

          var regImg = /^img$/i;
          var regIframe = /^iframe$/i;

          var supportScroll = "onscroll" in window && !/(gle|ing)bot/.test(navigator.userAgent);

          var shrinkExpand = 0;
          var currentExpand = 0;

          var isLoading = 0;
          var lowRuns = -1;

          var resetPreloading = function (e) {
            isLoading--;
            if (!e || isLoading < 0 || !e.target) {
              isLoading = 0;
            }
          };

          var isVisible = function (elem) {
            if (isBodyHidden == null) {
              isBodyHidden = getCSS(document.body, "visibility") == "hidden";
            }

            return (
              isBodyHidden ||
              !(getCSS(elem.parentNode, "visibility") == "hidden" && getCSS(elem, "visibility") == "hidden")
            );
          };

          var isNestedVisible = function (elem, elemExpand) {
            var outerRect;
            var parent = elem;
            var visible = isVisible(elem);

            eLtop -= elemExpand;
            eLbottom += elemExpand;
            eLleft -= elemExpand;
            eLright += elemExpand;

            while (visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem) {
              visible = (getCSS(parent, "opacity") || 1) > 0;

              if (visible && getCSS(parent, "overflow") != "visible") {
                outerRect = parent.getBoundingClientRect();
                visible =
                  eLright > outerRect.left &&
                  eLleft < outerRect.right &&
                  eLbottom > outerRect.top - 1 &&
                  eLtop < outerRect.bottom + 1;
              }
            }

            return visible;
          };

          var checkElements = function () {
            var eLlen,
              i,
              rect,
              autoLoadElem,
              loadedSomething,
              elemExpand,
              elemNegativeExpand,
              elemExpandVal,
              beforeExpandVal,
              defaultExpand,
              preloadExpand,
              hFac;
            var lazyloadElems = lazysizes.elements;

            if ((loadMode = lazySizesCfg.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)) {
              i = 0;

              lowRuns++;

              for (; i < eLlen; i++) {
                if (!lazyloadElems[i] || lazyloadElems[i]._lazyRace) {
                  continue;
                }

                if (!supportScroll || (lazysizes.prematureUnveil && lazysizes.prematureUnveil(lazyloadElems[i]))) {
                  unveilElement(lazyloadElems[i]);
                  continue;
                }

                if (
                  !(elemExpandVal = lazyloadElems[i][_getAttribute]("data-expand")) ||
                  !(elemExpand = elemExpandVal * 1)
                ) {
                  elemExpand = currentExpand;
                }

                if (!defaultExpand) {
                  defaultExpand =
                    !lazySizesCfg.expand || lazySizesCfg.expand < 1
                      ? docElem.clientHeight > 500 && docElem.clientWidth > 500
                        ? 500
                        : 370
                      : lazySizesCfg.expand;

                  lazysizes._defEx = defaultExpand;

                  preloadExpand = defaultExpand * lazySizesCfg.expFactor;
                  hFac = lazySizesCfg.hFac;
                  isBodyHidden = null;

                  if (
                    currentExpand < preloadExpand &&
                    isLoading < 1 &&
                    lowRuns > 2 &&
                    loadMode > 2 &&
                    !document.hidden
                  ) {
                    currentExpand = preloadExpand;
                    lowRuns = 0;
                  } else if (loadMode > 1 && lowRuns > 1 && isLoading < 6) {
                    currentExpand = defaultExpand;
                  } else {
                    currentExpand = shrinkExpand;
                  }
                }

                if (beforeExpandVal !== elemExpand) {
                  eLvW = innerWidth + elemExpand * hFac;
                  elvH = innerHeight + elemExpand;
                  elemNegativeExpand = elemExpand * -1;
                  beforeExpandVal = elemExpand;
                }

                rect = lazyloadElems[i].getBoundingClientRect();

                if (
                  (eLbottom = rect.bottom) >= elemNegativeExpand &&
                  (eLtop = rect.top) <= elvH &&
                  (eLright = rect.right) >= elemNegativeExpand * hFac &&
                  (eLleft = rect.left) <= eLvW &&
                  (eLbottom || eLright || eLleft || eLtop) &&
                  (lazySizesCfg.loadHidden || isVisible(lazyloadElems[i])) &&
                  ((isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4)) ||
                    isNestedVisible(lazyloadElems[i], elemExpand))
                ) {
                  unveilElement(lazyloadElems[i]);
                  loadedSomething = true;
                  if (isLoading > 9) {
                    break;
                  }
                } else if (
                  !loadedSomething &&
                  isCompleted &&
                  !autoLoadElem &&
                  isLoading < 4 &&
                  lowRuns < 4 &&
                  loadMode > 2 &&
                  (preloadElems[0] || lazySizesCfg.preloadAfterLoad) &&
                  (preloadElems[0] ||
                    (!elemExpandVal &&
                      (eLbottom ||
                        eLright ||
                        eLleft ||
                        eLtop ||
                        lazyloadElems[i][_getAttribute](lazySizesCfg.sizesAttr) != "auto")))
                ) {
                  autoLoadElem = preloadElems[0] || lazyloadElems[i];
                }
              }

              if (autoLoadElem && !loadedSomething) {
                unveilElement(autoLoadElem);
              }
            }
          };

          var throttledCheckElements = throttle(checkElements);

          var switchLoadingClass = function (e) {
            var elem = e.target;

            if (elem._lazyCache) {
              delete elem._lazyCache;
              return;
            }

            resetPreloading(e);
            addClass(elem, lazySizesCfg.loadedClass);
            removeClass(elem, lazySizesCfg.loadingClass);
            addRemoveLoadEvents(elem, rafSwitchLoadingClass);
            triggerEvent(elem, "lazyloaded");
          };
          var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
          var rafSwitchLoadingClass = function (e) {
            rafedSwitchLoadingClass({
              target: e.target,
            });
          };

          var changeIframeSrc = function (elem, src) {
            var loadMode = elem.getAttribute("data-load-mode") || lazySizesCfg.iframeLoadMode;

            // loadMode can be also a string!
            if (loadMode == 0) {
              elem.contentWindow.location.replace(src);
            } else if (loadMode == 1) {
              elem.src = src;
            }
          };

          var handleSources = function (source) {
            var customMedia;

            var sourceSrcset = source[_getAttribute](lazySizesCfg.srcsetAttr);

            if (
              (customMedia =
                lazySizesCfg.customMedia[source[_getAttribute]("data-media") || source[_getAttribute]("media")])
            ) {
              source.setAttribute("media", customMedia);
            }

            if (sourceSrcset) {
              source.setAttribute("srcset", sourceSrcset);
            }
          };

          var lazyUnveil = rAFIt(function (elem, detail, isAuto, sizes, isImg) {
            var src, srcset, parent, isPicture, event, firesLoad;

            if (!(event = triggerEvent(elem, "lazybeforeunveil", detail)).defaultPrevented) {
              if (sizes) {
                if (isAuto) {
                  addClass(elem, lazySizesCfg.autosizesClass);
                } else {
                  elem.setAttribute("sizes", sizes);
                }
              }

              srcset = elem[_getAttribute](lazySizesCfg.srcsetAttr);
              src = elem[_getAttribute](lazySizesCfg.srcAttr);

              if (isImg) {
                parent = elem.parentNode;
                isPicture = parent && regPicture.test(parent.nodeName || "");
              }

              firesLoad = detail.firesLoad || ("src" in elem && (srcset || src || isPicture));

              event = {
                target: elem,
              };

              addClass(elem, lazySizesCfg.loadingClass);

              if (firesLoad) {
                clearTimeout(resetPreloadingTimer);
                resetPreloadingTimer = setTimeout(resetPreloading, 2500);
                addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
              }

              if (isPicture) {
                forEach.call(parent.getElementsByTagName("source"), handleSources);
              }

              if (srcset) {
                elem.setAttribute("srcset", srcset);
              } else if (src && !isPicture) {
                if (regIframe.test(elem.nodeName)) {
                  changeIframeSrc(elem, src);
                } else {
                  elem.src = src;
                }
              }

              if (isImg && (srcset || isPicture)) {
                updatePolyfill(elem, {
                  src: src,
                });
              }
            }

            if (elem._lazyRace) {
              delete elem._lazyRace;
            }
            removeClass(elem, lazySizesCfg.lazyClass);

            rAF(function () {
              // Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)
              var isLoaded = elem.complete && elem.naturalWidth > 1;

              if (!firesLoad || isLoaded) {
                if (isLoaded) {
                  addClass(elem, lazySizesCfg.fastLoadedClass);
                }
                switchLoadingClass(event);
                elem._lazyCache = true;
                setTimeout(function () {
                  if ("_lazyCache" in elem) {
                    delete elem._lazyCache;
                  }
                }, 9);
              }
              if (elem.loading == "lazy") {
                isLoading--;
              }
            }, true);
          });

          var unveilElement = function (elem) {
            if (elem._lazyRace) {
              return;
            }
            var detail;

            var isImg = regImg.test(elem.nodeName);

            //allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
            var sizes = isImg && (elem[_getAttribute](lazySizesCfg.sizesAttr) || elem[_getAttribute]("sizes"));
            var isAuto = sizes == "auto";

            if (
              (isAuto || !isCompleted) &&
              isImg &&
              (elem[_getAttribute]("src") || elem.srcset) &&
              !elem.complete &&
              !hasClass(elem, lazySizesCfg.errorClass) &&
              hasClass(elem, lazySizesCfg.lazyClass)
            ) {
              return;
            }

            detail = triggerEvent(elem, "lazyunveilread").detail;

            if (isAuto) {
              autoSizer.updateElem(elem, true, elem.offsetWidth);
            }

            elem._lazyRace = true;
            isLoading++;

            lazyUnveil(elem, detail, isAuto, sizes, isImg);
          };

          var afterScroll = debounce(function () {
            lazySizesCfg.loadMode = 3;
            throttledCheckElements();
          });

          var altLoadmodeScrollListner = function () {
            if (lazySizesCfg.loadMode == 3) {
              lazySizesCfg.loadMode = 2;
            }
            afterScroll();
          };

          var onload = function () {
            if (isCompleted) {
              return;
            }
            if (Date.now() - started < 999) {
              setTimeout(onload, 999);
              return;
            }

            isCompleted = true;

            lazySizesCfg.loadMode = 3;

            throttledCheckElements();

            addEventListener("scroll", altLoadmodeScrollListner, true);
          };

          return {
            _: function () {
              started = Date.now();

              lazysizes.elements = document.getElementsByClassName(lazySizesCfg.lazyClass);
              preloadElems = document.getElementsByClassName(lazySizesCfg.lazyClass + " " + lazySizesCfg.preloadClass);

              addEventListener("scroll", throttledCheckElements, true);

              addEventListener("resize", throttledCheckElements, true);

              addEventListener("pageshow", function (e) {
                if (e.persisted) {
                  var loadingElements = document.querySelectorAll("." + lazySizesCfg.loadingClass);

                  if (loadingElements.length && loadingElements.forEach) {
                    requestAnimationFrame(function () {
                      loadingElements.forEach(function (img) {
                        if (img.complete) {
                          unveilElement(img);
                        }
                      });
                    });
                  }
                }
              });

              if (window.MutationObserver) {
                new MutationObserver(throttledCheckElements).observe(docElem, {
                  childList: true,
                  subtree: true,
                  attributes: true,
                });
              } else {
                docElem[_addEventListener]("DOMNodeInserted", throttledCheckElements, true);
                docElem[_addEventListener]("DOMAttrModified", throttledCheckElements, true);
                setInterval(throttledCheckElements, 999);
              }

              addEventListener("hashchange", throttledCheckElements, true);

              //, 'fullscreenchange'
              ["focus", "mouseover", "click", "load", "transitionend", "animationend"].forEach(function (name) {
                document[_addEventListener](name, throttledCheckElements, true);
              });

              if (/d$|^c/.test(document.readyState)) {
                onload();
              } else {
                addEventListener("load", onload);
                document[_addEventListener]("DOMContentLoaded", throttledCheckElements);
                setTimeout(onload, 20000);
              }

              if (lazysizes.elements.length) {
                checkElements();
                rAF._lsFlush();
              } else {
                throttledCheckElements();
              }
            },
            checkElems: throttledCheckElements,
            unveil: unveilElement,
            _aLSL: altLoadmodeScrollListner,
          };
        })();

        var autoSizer = (function () {
          var autosizesElems;

          var sizeElement = rAFIt(function (elem, parent, event, width) {
            var sources, i, len;
            elem._lazysizesWidth = width;
            width += "px";

            elem.setAttribute("sizes", width);

            if (regPicture.test(parent.nodeName || "")) {
              sources = parent.getElementsByTagName("source");
              for (i = 0, len = sources.length; i < len; i++) {
                sources[i].setAttribute("sizes", width);
              }
            }

            if (!event.detail.dataAttr) {
              updatePolyfill(elem, event.detail);
            }
          });
          var getSizeElement = function (elem, dataAttr, width) {
            var event;
            var parent = elem.parentNode;

            if (parent) {
              width = getWidth(elem, parent, width);
              event = triggerEvent(elem, "lazybeforesizes", {
                width: width,
                dataAttr: !!dataAttr,
              });

              if (!event.defaultPrevented) {
                width = event.detail.width;

                if (width && width !== elem._lazysizesWidth) {
                  sizeElement(elem, parent, event, width);
                }
              }
            }
          };

          var updateElementsSizes = function () {
            var i;
            var len = autosizesElems.length;
            if (len) {
              i = 0;

              for (; i < len; i++) {
                getSizeElement(autosizesElems[i]);
              }
            }
          };

          var debouncedUpdateElementsSizes = debounce(updateElementsSizes);

          return {
            _: function () {
              autosizesElems = document.getElementsByClassName(lazySizesCfg.autosizesClass);
              addEventListener("resize", debouncedUpdateElementsSizes);
            },
            checkElems: debouncedUpdateElementsSizes,
            updateElem: getSizeElement,
          };
        })();

        var init = function () {
          if (!init.i && document.getElementsByClassName) {
            init.i = true;
            autoSizer._();
            loader._();
          }
        };

        setTimeout(function () {
          if (lazySizesCfg.init) {
            init();
          }
        });

        lazysizes = {
          cfg: lazySizesCfg,
          autoSizer: autoSizer,
          loader: loader,
          init: init,
          uP: updatePolyfill,
          aC: addClass,
          rC: removeClass,
          hC: hasClass,
          fire: triggerEvent,
          gW: getWidth,
          rAF: rAF,
        };

        return lazysizes;
      });

      /***/
    },
    /* 1 */
    /***/
    function (module, exports, __webpack_require__) {
      var isObject = __webpack_require__(7),
        now = __webpack_require__(23),
        toNumber = __webpack_require__(25);

      /** Error message constants. */
      var FUNC_ERROR_TEXT = "Expected a function";

      /* Built-in method references for those with the same name as other `lodash` methods. */
      var nativeMax = Math.max,
        nativeMin = Math.min;

      /**
       * Creates a debounced function that delays invoking `func` until after `wait`
       * milliseconds have elapsed since the last time the debounced function was
       * invoked. The debounced function comes with a `cancel` method to cancel
       * delayed `func` invocations and a `flush` method to immediately invoke them.
       * Provide `options` to indicate whether `func` should be invoked on the
       * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
       * with the last arguments provided to the debounced function. Subsequent
       * calls to the debounced function return the result of the last `func`
       * invocation.
       *
       * **Note:** If `leading` and `trailing` options are `true`, `func` is
       * invoked on the trailing edge of the timeout only if the debounced function
       * is invoked more than once during the `wait` timeout.
       *
       * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
       * until to the next tick, similar to `setTimeout` with a timeout of `0`.
       *
       * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
       * for details over the differences between `_.debounce` and `_.throttle`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Function
       * @param {Function} func The function to debounce.
       * @param {number} [wait=0] The number of milliseconds to delay.
       * @param {Object} [options={}] The options object.
       * @param {boolean} [options.leading=false]
       *  Specify invoking on the leading edge of the timeout.
       * @param {number} [options.maxWait]
       *  The maximum time `func` is allowed to be delayed before it's invoked.
       * @param {boolean} [options.trailing=true]
       *  Specify invoking on the trailing edge of the timeout.
       * @returns {Function} Returns the new debounced function.
       * @example
       *
       * // Avoid costly calculations while the window size is in flux.
       * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
       *
       * // Invoke `sendMail` when clicked, debouncing subsequent calls.
       * jQuery(element).on('click', _.debounce(sendMail, 300, {
       *   'leading': true,
       *   'trailing': false
       * }));
       *
       * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
       * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
       * var source = new EventSource('/stream');
       * jQuery(source).on('message', debounced);
       *
       * // Cancel the trailing debounced invocation.
       * jQuery(window).on('popstate', debounced.cancel);
       */
      function debounce(func, wait, options) {
        var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

        if (typeof func != "function") {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        wait = toNumber(wait) || 0;
        if (isObject(options)) {
          leading = !!options.leading;
          maxing = "maxWait" in options;
          maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
          trailing = "trailing" in options ? !!options.trailing : trailing;
        }

        function invokeFunc(time) {
          var args = lastArgs,
            thisArg = lastThis;

          lastArgs = lastThis = undefined;
          lastInvokeTime = time;
          result = func.apply(thisArg, args);
          return result;
        }

        function leadingEdge(time) {
          // Reset any `maxWait` timer.
          lastInvokeTime = time;
          // Start the timer for the trailing edge.
          timerId = setTimeout(timerExpired, wait);
          // Invoke the leading edge.
          return leading ? invokeFunc(time) : result;
        }

        function remainingWait(time) {
          var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

          return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
        }

        function shouldInvoke(time) {
          var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

          // Either this is the first call, activity has stopped and we're at the
          // trailing edge, the system time has gone backwards and we're treating
          // it as the trailing edge, or we've hit the `maxWait` limit.
          return (
            lastCallTime === undefined ||
            timeSinceLastCall >= wait ||
            timeSinceLastCall < 0 ||
            (maxing && timeSinceLastInvoke >= maxWait)
          );
        }

        function timerExpired() {
          var time = now();
          if (shouldInvoke(time)) {
            return trailingEdge(time);
          }
          // Restart the timer.
          timerId = setTimeout(timerExpired, remainingWait(time));
        }

        function trailingEdge(time) {
          timerId = undefined;

          // Only invoke if we have `lastArgs` which means `func` has been
          // debounced at least once.
          if (trailing && lastArgs) {
            return invokeFunc(time);
          }
          lastArgs = lastThis = undefined;
          return result;
        }

        function cancel() {
          if (timerId !== undefined) {
            clearTimeout(timerId);
          }
          lastInvokeTime = 0;
          lastArgs = lastCallTime = lastThis = timerId = undefined;
        }

        function flush() {
          return timerId === undefined ? result : trailingEdge(now());
        }

        function debounced() {
          var time = now(),
            isInvoking = shouldInvoke(time);

          lastArgs = arguments;
          lastThis = this;
          lastCallTime = time;

          if (isInvoking) {
            if (timerId === undefined) {
              return leadingEdge(lastCallTime);
            }
            if (maxing) {
              // Handle invocations in a tight loop.
              clearTimeout(timerId);
              timerId = setTimeout(timerExpired, wait);
              return invokeFunc(lastCallTime);
            }
          }
          if (timerId === undefined) {
            timerId = setTimeout(timerExpired, wait);
          }
          return result;
        }
        debounced.cancel = cancel;
        debounced.flush = flush;
        return debounced;
      }

      module.exports = debounce;

      /***/
    },
    /* 2 */
    /***/
    function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;
      /*!
       * JavaScript Cookie v2.2.1
       * https://github.com/js-cookie/js-cookie
       *
       * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
       * Released under the MIT license
       */
      (function (factory) {
        var registeredInModuleLoader;
        if (true) {
          !((__WEBPACK_AMD_DEFINE_FACTORY__ = factory),
          (__WEBPACK_AMD_DEFINE_RESULT__ =
            typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function"
              ? __WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)
              : __WEBPACK_AMD_DEFINE_FACTORY__),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
          registeredInModuleLoader = true;
        }
        if (true) {
          module.exports = factory();
          registeredInModuleLoader = true;
        }
        if (!registeredInModuleLoader) {
          var OldCookies = window.Cookies;
          var api = (window.Cookies = factory());
          api.noConflict = function () {
            window.Cookies = OldCookies;
            return api;
          };
        }
      })(function () {
        function extend() {
          var i = 0;
          var result = {};
          for (; i < arguments.length; i++) {
            var attributes = arguments[i];
            for (var key in attributes) {
              result[key] = attributes[key];
            }
          }
          return result;
        }

        function decode(s) {
          return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
        }

        function init(converter) {
          function api() {}

          function set(key, value, attributes) {
            if (typeof document === "undefined") {
              return;
            }

            attributes = extend(
              {
                path: "/",
              },
              api.defaults,
              attributes
            );

            if (typeof attributes.expires === "number") {
              attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e5);
            }

            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";

            try {
              var result = JSON.stringify(value);
              if (/^[\{\[]/.test(result)) {
                value = result;
              }
            } catch (e) {}

            value = converter.write
              ? converter.write(value, key)
              : encodeURIComponent(String(value)).replace(
                  /%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,
                  decodeURIComponent
                );

            key = encodeURIComponent(String(key))
              .replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
              .replace(/[\(\)]/g, escape);

            var stringifiedAttributes = "";
            for (var attributeName in attributes) {
              if (!attributes[attributeName]) {
                continue;
              }
              stringifiedAttributes += "; " + attributeName;
              if (attributes[attributeName] === true) {
                continue;
              }

              // Considers RFC 6265 section 5.2:
              // ...
              // 3.  If the remaining unparsed-attributes contains a %x3B (";")
              //     character:
              // Consume the characters of the unparsed-attributes up to,
              // not including, the first %x3B (";") character.
              // ...
              stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }

            return (document.cookie = key + "=" + value + stringifiedAttributes);
          }

          function get(key, json) {
            if (typeof document === "undefined") {
              return;
            }

            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var i = 0;

            for (; i < cookies.length; i++) {
              var parts = cookies[i].split("=");
              var cookie = parts.slice(1).join("=");

              if (!json && cookie.charAt(0) === '"') {
                cookie = cookie.slice(1, -1);
              }

              try {
                var name = decode(parts[0]);
                cookie = (converter.read || converter)(cookie, name) || decode(cookie);

                if (json) {
                  try {
                    cookie = JSON.parse(cookie);
                  } catch (e) {}
                }

                jar[name] = cookie;

                if (key === name) {
                  break;
                }
              } catch (e) {}
            }

            return key ? jar[key] : jar;
          }

          api.set = set;
          api.get = function (key) {
            return get(key, false /* read as raw */);
          };
          api.getJSON = function (key) {
            return get(key, true /* read as json */);
          };
          api.remove = function (key, attributes) {
            set(
              key,
              "",
              extend(attributes, {
                expires: -1,
              })
            );
          };

          api.defaults = {};

          api.withConverter = init;

          return api;
        }

        return init(function () {});
      });

      /***/
    },
    /* 3 */
    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true,
      });
      exports.formatMoney = formatMoney;
      /**
       * Currency Helpers
       * -----------------------------------------------------------------------------
       * A collection of useful functions that help with currency formatting
       *
       * Current contents
       * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
       *
       */

      var moneyFormat = "${{amount}}";

      /**
       * Format money values based on your shop currency settings
       * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
       * or 3.00 dollars
       * @param  {String} format - shop money_format setting
       * @return {String} value - formatted value
       */
      function formatMoney(cents, format) {
        if (typeof cents === "string") {
          cents = cents.replace(".", "");
        }
        var value = "";
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = format || moneyFormat;

        function formatWithDelimiters(number) {
          var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
          var thousands = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ",";
          var decimal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ".";

          if (isNaN(number) || number == null) {
            return 0;
          }

          number = (number / 100.0).toFixed(precision);

          var parts = number.split(".");
          var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
          var centsAmount = parts[1] ? decimal + parts[1] : "";

          return dollarsAmount + centsAmount;
        }

        switch (formatString.match(placeholderRegex)[1]) {
          case "amount":
            value = formatWithDelimiters(cents, 2);
            break;
          case "amount_no_decimals":
            value = formatWithDelimiters(cents, 0);
            break;
          case "amount_with_comma_separator":
            value = formatWithDelimiters(cents, 2, ".", ",");
            break;
          case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(cents, 0, ".", ",");
            break;
        }

        return formatString.replace(placeholderRegex, value);
      }

      /***/
    },
    /* 4 */
    /***/
    function (module, exports, __webpack_require__) {
      /*!
       * Splide.js
       * Version  : 2.4.20
       * License  : MIT
       * Copyright: 2020 Naotoshi Fujita
       */
      (function webpackUniversalModuleDefinition(root, factory) {
        if (true) module.exports = factory();
        else {
        }
      })(self, function () {
        return /******/ (() => {
          // webpackBootstrap
          /******/
          "use strict";
          /******/
          var __webpack_modules__ = {
            /***/
            311:
              /***/
              (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
                // ESM COMPAT FLAG
                __webpack_require__.r(__webpack_exports__);

                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                  default: () => /* binding */ module_Splide,
                });

                // NAMESPACE OBJECT: ./src/js/constants/states.js
                var states_namespaceObject = {};
                __webpack_require__.r(states_namespaceObject);
                __webpack_require__.d(states_namespaceObject, {
                  CREATED: () => CREATED,
                  DESTROYED: () => DESTROYED,
                  IDLE: () => IDLE,
                  MOUNTED: () => MOUNTED,
                  MOVING: () => MOVING,
                }); // CONCATENATED MODULE: ./src/js/core/event.js

                /**
                 * The function for providing an Event object simply managing events.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                /**
                 * The function for providing an Event object simply managing events.
                 */
                /* harmony default export */
                const core_event = function () {
                  /**
                   * Store all event data.
                   *
                   * @type {Array}
                   */
                  var data = [];
                  var Event = {
                    /**
                     * Subscribe the given event(s).
                     *
                     * @param {string}   events  - An event name. Use space to separate multiple events.
                     *                             Also, namespace is accepted by dot, such as 'resize.{namespace}'.
                     * @param {function} handler - A callback function.
                     * @param {Element}  elm     - Optional. Native event will be listened to when this arg is provided.
                     * @param {Object}   options - Optional. Options for addEventListener.
                     */
                    on: function on(events, handler, elm, options) {
                      if (elm === void 0) {
                        elm = null;
                      }

                      if (options === void 0) {
                        options = {};
                      }

                      events.split(" ").forEach(function (event) {
                        if (elm) {
                          elm.addEventListener(event, handler, options);
                        }

                        data.push({
                          event: event,
                          handler: handler,
                          elm: elm,
                          options: options,
                        });
                      });
                    },

                    /**
                     * Unsubscribe the given event(s).
                     *
                     * @param {string}  events - A event name or names split by space.
                     * @param {Element} elm    - Optional. removeEventListener() will be called when this arg is provided.
                     */
                    off: function off(events, elm) {
                      if (elm === void 0) {
                        elm = null;
                      }

                      events.split(" ").forEach(function (event) {
                        data = data.filter(function (item) {
                          if (item && item.event === event && item.elm === elm) {
                            unsubscribe(item);
                            return false;
                          }

                          return true;
                        });
                      });
                    },

                    /**
                     * Emit an event.
                     * This method is only for custom events.
                     *
                     * @param {string}  event - An event name.
                     * @param {*}       args  - Any number of arguments passed to handlers.
                     */
                    emit: function emit(event) {
                      for (
                        var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1;
                        _key < _len;
                        _key++
                      ) {
                        args[_key - 1] = arguments[_key];
                      }

                      data.forEach(function (item) {
                        if (!item.elm && item.event.split(".")[0] === event) {
                          item.handler.apply(item, args);
                        }
                      });
                    },

                    /**
                     * Clear event data.
                     */
                    destroy: function destroy() {
                      data.forEach(unsubscribe);
                      data = [];
                    },
                  };
                  /**
                   * Remove the registered event listener.
                   *
                   * @param {Object} item - An object containing event data.
                   */

                  function unsubscribe(item) {
                    if (item.elm) {
                      item.elm.removeEventListener(item.event, item.handler, item.options);
                    }
                  }

                  return Event;
                }; // CONCATENATED MODULE: ./src/js/core/state.js
                /**
                 * The function providing a super simple state system.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                /**
                 * The function providing a super simple state system.
                 *
                 * @param {string|number} initialState - Provide the initial state value.
                 */
                /* harmony default export */
                const state = function (initialState) {
                  /**
                   * Store the current state.
                   *
                   * @type {string|number}
                   */
                  var curr = initialState;
                  return {
                    /**
                     * Change state.
                     *
                     * @param {string|number} state - A new state.
                     */
                    set: function set(state) {
                      curr = state;
                    },

                    /**
                     * Verify if the current state is given one or not.
                     *
                     * @param {string|number} state - A state name to be verified.
                     *
                     * @return {boolean} - True if the current state is the given one.
                     */
                    is: function is(state) {
                      return state === curr;
                    },
                  };
                }; // CONCATENATED MODULE: ./src/js/utils/object.js
                function _extends() {
                  _extends =
                    Object.assign ||
                    function (target) {
                      for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                          if (Object.prototype.hasOwnProperty.call(source, key)) {
                            target[key] = source[key];
                          }
                        }
                      }
                      return target;
                    };
                  return _extends.apply(this, arguments);
                }

                /**
                 * Some utility functions related with Object, supporting IE.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */
                var keys = Object.keys;
                /**
                 * Iterate an object like Array.forEach.
                 * IE doesn't support forEach of HTMLCollection.
                 *
                 * @param {Object}    obj       - An object.
                 * @param {function}  callback  - A function handling each value. Arguments are value, property and index.
                 */

                function each(obj, callback) {
                  keys(obj).some(function (key, index) {
                    return callback(obj[key], key, index);
                  });
                }
                /**
                 * Return values of the given object as an array.
                 * IE doesn't support Object.values.
                 *
                 * @param {Object} obj - An object.
                 *
                 * @return {Array} - An array containing all values of the given object.
                 */

                function values(obj) {
                  return keys(obj).map(function (key) {
                    return obj[key];
                  });
                }
                /**
                 * Check if the given subject is object or not.
                 *
                 * @param {*} subject - A subject to be verified.
                 *
                 * @return {boolean} - True if object, false otherwise.
                 */

                function isObject(subject) {
                  return typeof subject === "object";
                }
                /**
                 * Merge two objects deeply.
                 *
                 * @param {Object} to   - An object where "from" is merged.
                 * @param {Object} from - An object merged to "to".
                 *
                 * @return {Object} - A merged object.
                 */

                function merge(_ref, from) {
                  var to = _extends({}, _ref);

                  each(from, function (value, key) {
                    if (isObject(value)) {
                      if (!isObject(to[key])) {
                        to[key] = {};
                      }

                      to[key] = merge(to[key], value);
                    } else {
                      to[key] = value;
                    }
                  });
                  return to;
                }
                /**
                 * Assign all properties "from" to "to" object.
                 *
                 * @param {Object} to   - An object where properties are assigned.
                 * @param {Object} from - An object whose properties are assigned to "to".
                 *
                 * @return {Object} - An assigned object.
                 */

                function object_assign(to, from) {
                  keys(from).forEach(function (key) {
                    if (!to[key]) {
                      Object.defineProperty(to, key, Object.getOwnPropertyDescriptor(from, key));
                    }
                  });
                  return to;
                } // CONCATENATED MODULE: ./src/js/utils/utils.js
                /**
                 * A package of some miscellaneous utility functions.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                /**
                 * Convert the given value to array.
                 *
                 * @param {*} value - Any value.
                 *
                 * @return {*[]} - Array containing the given value.
                 */

                function toArray(value) {
                  return Array.isArray(value) ? value : [value];
                }
                /**
                 * Check if the given value is between min and max.
                 * Min will be returned when the value is less than min or max will do when greater than max.
                 *
                 * @param {number} value - A number to be checked.
                 * @param {number} m1    - Minimum or maximum number.
                 * @param {number} m2    - Maximum or minimum number.
                 *
                 * @return {number} - A value itself, min or max.
                 */

                function between(value, m1, m2) {
                  return Math.min(Math.max(value, m1 > m2 ? m2 : m1), m1 > m2 ? m1 : m2);
                }
                /**
                 * The sprintf method with minimum functionality.
                 *
                 * @param {string}       format       - The string format.
                 * @param {string|Array} replacements - Replacements accepting multiple arguments.
                 *
                 * @returns {string} - Converted string.
                 */

                function sprintf(format, replacements) {
                  var i = 0;
                  return format.replace(/%s/g, function () {
                    return toArray(replacements)[i++];
                  });
                }
                /**
                 * Append px unit to the given subject if necessary.
                 *
                 * @param {number|string} value - A value that may not include an unit.
                 *
                 * @return {string} - If the value is string, return itself.
                 *                    If number, do value + "px". An empty string, otherwise.
                 */

                function unit(value) {
                  var type = typeof value;

                  if (type === "number" && value > 0) {
                    return parseFloat(value) + "px";
                  }

                  return type === "string" ? value : "";
                }
                /**
                 * Pad start with 0.
                 *
                 * @param {number} number - A number to be filled with 0.
                 *
                 * @return {string|number} - Padded number.
                 */

                function pad(number) {
                  return number < 10 ? "0" + number : number;
                }
                /**
                 * Convert the given value to pixel.
                 *
                 * @param {Element}       root  - Root element where a dummy div is appended.
                 * @param {string|number} value - CSS value to be converted, such as 10rem.
                 *
                 * @return {number} - Pixel.
                 */

                function toPixel(root, value) {
                  if (typeof value === "string") {
                    var div = create("div", {});
                    applyStyle(div, {
                      position: "absolute",
                      width: value,
                    });
                    append(root, div);
                    value = div.clientWidth;
                    dom_remove(div);
                  }

                  return +value || 0;
                } // CONCATENATED MODULE: ./src/js/utils/dom.js
                /**
                 * Some utility functions related with DOM.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                /**
                 * Find the first element matching the given selector.
                 * Be aware that all selectors after a space are ignored.
                 *
                 * @param {Element|Node}  elm       - An ancestor element.
                 * @param {string}        selector  - DOMString.
                 *
                 * @return {Element|null} - A found element or null.
                 */

                function find(elm, selector) {
                  return elm ? elm.querySelector(selector.split(" ")[0]) : null;
                }
                /**
                 * Find a first child having the given tag or class name.
                 *
                 * @param {Element} parent         - A parent element.
                 * @param {string}  tagOrClassName - A tag or class name.
                 *
                 * @return {Element|undefined} - A found element on success or undefined on failure.
                 */

                function child(parent, tagOrClassName) {
                  return children(parent, tagOrClassName)[0];
                }
                /**
                 * Return chile elements that matches the provided tag or class name.
                 *
                 * @param {Element} parent         - A parent element.
                 * @param {string}  tagOrClassName - A tag or class name.
                 *
                 * @return {Element[]} - Found elements.
                 */

                function children(parent, tagOrClassName) {
                  if (parent) {
                    return values(parent.children).filter(function (child) {
                      return hasClass(child, tagOrClassName.split(" ")[0]) || child.tagName === tagOrClassName;
                    });
                  }

                  return [];
                }
                /**
                 * Create an element with some optional attributes.
                 *
                 * @param {string} tag   - A tag name.
                 * @param {Object} attrs - An object any attribute pairs of name and value.
                 *
                 * @return {Element} - A created element.
                 */

                function create(tag, attrs) {
                  var elm = document.createElement(tag);
                  each(attrs, function (value, key) {
                    return setAttribute(elm, key, value);
                  });
                  return elm;
                }
                /**
                 * Convert HTML string to DOM node.
                 *
                 * @param {string} html - HTML string.
                 *
                 * @return {Node} - A created node.
                 */

                function domify(html) {
                  var div = create("div", {});
                  div.innerHTML = html;
                  return div.firstChild;
                }
                /**
                 * Remove a given element from a DOM tree.
                 *
                 * @param {Element|Element[]} elms - Element(s) to be removed.
                 */

                function dom_remove(elms) {
                  toArray(elms).forEach(function (elm) {
                    if (elm) {
                      var parent = elm.parentElement;
                      parent && parent.removeChild(elm);
                    }
                  });
                }
                /**
                 * Append a child to a given element.
                 *
                 * @param {Element} parent - A parent element.
                 * @param {Element} child  - An element to be appended.
                 */

                function append(parent, child) {
                  if (parent) {
                    parent.appendChild(child);
                  }
                }
                /**
                 * Insert an element before the reference element.
                 *
                 * @param {Element|Node} ref - A reference element.
                 * @param {Element}      elm - An element to be inserted.
                 */

                function before(elm, ref) {
                  if (elm && ref) {
                    var parent = ref.parentElement;
                    parent && parent.insertBefore(elm, ref);
                  }
                }
                /**
                 * Apply styles to the given element.
                 *
                 * @param {Element} elm     - An element where styles are applied.
                 * @param {Object}  styles  - Object containing styles.
                 */

                function applyStyle(elm, styles) {
                  if (elm) {
                    each(styles, function (value, prop) {
                      if (value !== null) {
                        elm.style[prop] = value;
                      }
                    });
                  }
                }
                /**
                 * Add or remove classes to/from the element.
                 * This function is for internal usage.
                 *
                 * @param {Element}         elm     - An element where classes are added.
                 * @param {string|string[]} classes - Class names being added.
                 * @param {boolean}         remove  - Whether to remove or add classes.
                 */

                function addOrRemoveClasses(elm, classes, remove) {
                  if (elm) {
                    toArray(classes).forEach(function (name) {
                      if (name) {
                        elm.classList[remove ? "remove" : "add"](name);
                      }
                    });
                  }
                }
                /**
                 * Add classes to the element.
                 *
                 * @param {Element}          elm     - An element where classes are added.
                 * @param {string|string[]}  classes - Class names being added.
                 */

                function addClass(elm, classes) {
                  addOrRemoveClasses(elm, classes, false);
                }
                /**
                 * Remove a class from the element.
                 *
                 * @param {Element}         elm     - An element where classes are removed.
                 * @param {string|string[]} classes - A class name being removed.
                 */

                function removeClass(elm, classes) {
                  addOrRemoveClasses(elm, classes, true);
                }
                /**
                 * Verify if the provided element has the class or not.
                 *
                 * @param {Element} elm       - An element.
                 * @param {string}  className - A class name.
                 *
                 * @return {boolean} - True if the element has the class or false if not.
                 */

                function hasClass(elm, className) {
                  return !!elm && elm.classList.contains(className);
                }
                /**
                 * Set attribute to the given element.
                 *
                 * @param {Element}                 elm   - An element where an attribute is assigned.
                 * @param {string}                  name  - Attribute name.
                 * @param {string|number|boolean}   value - Attribute value.
                 */

                function setAttribute(elm, name, value) {
                  if (elm) {
                    elm.setAttribute(name, value);
                  }
                }
                /**
                 * Get attribute from the given element.
                 *
                 * @param {Element} elm  - An element where an attribute is assigned.
                 * @param {string}  name - Attribute name.
                 *
                 * @return {string} - The value of the given attribute if available. An empty string if not.
                 */

                function getAttribute(elm, name) {
                  return elm ? elm.getAttribute(name) : "";
                }
                /**
                 * Remove attribute from the given element.
                 *
                 * @param {Element|Element[]} elms  - An element where an attribute is removed.
                 * @param {string|string[]}      names - Attribute name.
                 */

                function removeAttribute(elms, names) {
                  toArray(names).forEach(function (name) {
                    toArray(elms).forEach(function (elm) {
                      return elm && elm.removeAttribute(name);
                    });
                  });
                }
                /**
                 * Return the Rect object of the provided object.
                 *
                 * @param {Element} elm - An element.
                 *
                 * @return {ClientRect|DOMRect} - A rect object.
                 */

                function getRect(elm) {
                  return elm.getBoundingClientRect();
                }
                /**
                 * Trigger the given callback after all images contained by the element are loaded.
                 *
                 * @param {Element}  elm      - Element that may contain images.
                 * @param {Function} callback - Callback function fired right after all images are loaded.
                 */

                function loaded(elm, callback) {
                  var images = elm.querySelectorAll("img");
                  var length = images.length;

                  if (length) {
                    var count = 0;
                    each(images, function (img) {
                      img.onload = img.onerror = function () {
                        if (++count === length) {
                          callback();
                        }
                      };
                    });
                  } else {
                    // Trigger the callback immediately if there is no image.
                    callback();
                  }
                } // CONCATENATED MODULE: ./src/js/constants/types.js
                /**
                 * Export slider types.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                /**
                 * Normal slider.
                 *
                 * @type {string}
                 */
                var SLIDE = "slide";
                /**
                 * Loop after the last slide and before the first one.
                 *
                 * @type {string}
                 */

                var LOOP = "loop";
                /**
                 * The track doesn't move.
                 *
                 * @type {string}
                 */

                var FADE = "fade"; // CONCATENATED MODULE: ./src/js/transitions/slide/index.js
                /**
                 * The component for general slide effect transition.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                /**
                 * The component for general slide effect transition.
                 *
                 * @param {Splide} Splide     - A Splide instance.
                 * @param {Object} Components - An object containing components.
                 *
                 * @return {Object} - The component object.
                 */

                /* harmony default export */
                const slide = function (Splide, Components) {
                  /**
                   * Hold the list element.
                   *
                   * @type {Element}
                   */
                  var list;
                  /**
                   * Hold the onEnd callback function.
                   *
                   * @type {function}
                   */

                  var endCallback;
                  return {
                    /**
                     * Called when the component is mounted.
                     */
                    mount: function mount() {
                      list = Components.Elements.list;
                      Splide.on(
                        "transitionend",
                        function (e) {
                          if (e.target === list && endCallback) {
                            endCallback();
                          }
                        },
                        list
                      );
                    },

                    /**
                     * Start transition.
                     *
                     * @param {number}   destIndex - Destination slide index that might be clone's.
                     * @param {number}   newIndex  - New index.
                     * @param {number}   prevIndex - Previous index.
                     * @param {Object}   coord     - Destination coordinates.
                     * @param {function} done      - Callback function must be invoked when transition is completed.
                     */
                    start: function start(destIndex, newIndex, prevIndex, coord, done) {
                      var options = Splide.options;
                      var edgeIndex = Components.Controller.edgeIndex;
                      var speed = options.speed;
                      endCallback = done;

                      if (Splide.is(SLIDE)) {
                        if ((prevIndex === 0 && newIndex >= edgeIndex) || (prevIndex >= edgeIndex && newIndex === 0)) {
                          speed = options.rewindSpeed || speed;
                        }
                      }

                      applyStyle(list, {
                        transition: "transform " + speed + "ms " + options.easing,
                        transform: "translate(" + coord.x + "px," + coord.y + "px)",
                      });
                    },
                  };
                }; // CONCATENATED MODULE: ./src/js/transitions/fade/index.js
                /**
                 * The component for fade transition.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                /**
                 * The component for fade transition.
                 *
                 * @param {Splide} Splide     - A Splide instance.
                 * @param {Object} Components - An object containing components.
                 *
                 * @return {Object} - The component object.
                 */

                /* harmony default export */
                const fade = function (Splide, Components) {
                  var Fade = {
                    /**
                     * Called when the component is mounted.
                     * Apply transition style to the first slide.
                     */
                    mount: function mount() {
                      apply(Splide.index);
                    },

                    /**
                     * Start transition.
                     *
                     * @param {number}    destIndex - Destination slide index that might be clone's.
                     * @param {number}    newIndex  - New index.
                     * @param {number}    prevIndex - Previous index.
                     * @param {Object}    coord     - Destination coordinates.
                     * @param {function}  done      - Callback function must be invoked when transition is completed.
                     */
                    start: function start(destIndex, newIndex, prevIndex, coord, done) {
                      var track = Components.Elements.track;
                      applyStyle(track, {
                        height: unit(track.clientHeight),
                      });
                      apply(newIndex);
                      setTimeout(function () {
                        done();
                        applyStyle(track, {
                          height: "",
                        });
                      });
                    },
                  };
                  /**
                   * Apply transition style to the slide specified by the given index.
                   *
                   * @param {number} index - A slide index.
                   */

                  function apply(index) {
                    var options = Splide.options;
                    applyStyle(Components.Elements.slides[index], {
                      transition: "opacity " + options.speed + "ms " + options.easing,
                    });
                  }

                  return Fade;
                }; // CONCATENATED MODULE: ./src/js/transitions/index.js // CONCATENATED MODULE: ./src/js/core/composer.js
                /**
                 * Export transition components.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                /**
                 * Provide a function for composing components.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                /**
                 * Compose components.
                 *
                 * @param {Splide}   Splide     - Splide instance.
                 * @param {Object}   Components - Additional components.
                 * @param {function} Transition - Change component for transition.
                 *
                 * @return {Object} - An object containing all components.
                 */

                function compose(Splide, Components, Transition) {
                  var components = {};
                  each(Components, function (Component, name) {
                    components[name] = Component(Splide, components, name.toLowerCase());
                  });

                  if (!Transition) {
                    Transition = Splide.is(FADE) ? fade : slide;
                  }

                  components.Transition = Transition(Splide, components);
                  return components;
                } // CONCATENATED MODULE: ./src/js/utils/error.js
                /**
                 * Utility functions for outputting logs.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                /**
                 * Prefix of an error massage.
                 *
                 * @type {string}
                 */
                var MESSAGE_PREFIX = "[SPLIDE]";
                /**
                 * Display an error message on the browser console.
                 *
                 * @param {string} message - An error message.
                 */

                function error(message) {
                  console.error(MESSAGE_PREFIX + " " + message);
                }
                /**
                 * Check existence of the given object and throw an error if it doesn't.
                 *
                 * @throws {Error}
                 *
                 * @param {*}      subject - A subject to be confirmed.
                 * @param {string} message - An error message.
                 */

                function exist(subject, message) {
                  if (!subject) {
                    throw new Error(message);
                  }
                } // CONCATENATED MODULE: ./src/js/constants/classes.js
                /**
                 * Export class names.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                /**
                 * A root class name.
                 *
                 * @type {string}
                 */
                var ROOT = "splide";
                /**
                 * The definition table of all classes for elements.
                 * They might be modified by options.
                 *
                 * @type {Object}
                 */

                var ELEMENT_CLASSES = {
                  root: ROOT,
                  slider: ROOT + "__slider",
                  track: ROOT + "__track",
                  list: ROOT + "__list",
                  slide: ROOT + "__slide",
                  container: ROOT + "__slide__container",
                  arrows: ROOT + "__arrows",
                  arrow: ROOT + "__arrow",
                  prev: ROOT + "__arrow--prev",
                  next: ROOT + "__arrow--next",
                  pagination: ROOT + "__pagination",
                  page: ROOT + "__pagination__page",
                  clone: ROOT + "__slide--clone",
                  progress: ROOT + "__progress",
                  bar: ROOT + "__progress__bar",
                  autoplay: ROOT + "__autoplay",
                  play: ROOT + "__play",
                  pause: ROOT + "__pause",
                  spinner: ROOT + "__spinner",
                  sr: ROOT + "__sr",
                };
                /**
                 * Definitions of status classes.
                 *
                 * @type {Object}
                 */

                var STATUS_CLASSES = {
                  active: "is-active",
                  visible: "is-visible",
                  loading: "is-loading",
                }; // CONCATENATED MODULE: ./src/js/constants/i18n.js
                /**
                 * Export i18n texts as object.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                /**
                 * Texts for i18n.
                 *
                 * @type {Object}
                 */
                var I18N = {
                  prev: "Previous slide",
                  next: "Next slide",
                  first: "Go to first slide",
                  last: "Go to last slide",
                  slideX: "Go to slide %s",
                  pageX: "Go to page %s",
                  play: "Start autoplay",
                  pause: "Pause autoplay",
                }; // CONCATENATED MODULE: ./src/js/constants/defaults.js
                /**
                 * Export default options.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                var DEFAULTS = {
                  /**
                   * Determine a slider type.
                   * - 'slide': Regular slider.
                   * - 'loop' : Carousel slider.
                   * - 'fade' : Change slides with fade transition. perPage, drag options are ignored.
                   *
                   * @type {string}
                   */
                  type: "slide",

                  /**
                   * Whether to rewind a slider before the first slide or after the last one.
                   * In "loop" mode, this option is ignored.
                   *
                   * @type {boolean}
                   */
                  rewind: false,

                  /**
                   * Transition speed in milliseconds.
                   *
                   * @type {number}
                   */
                  speed: 400,

                  /**
                   * Transition speed on rewind in milliseconds.
                   *
                   * @type {number}
                   */
                  rewindSpeed: 0,

                  /**
                   * Whether to prevent any actions while a slider is transitioning.
                   * If false, navigation, drag and swipe work while the slider is running.
                   * Even so, it will be forced to wait for transition in some cases in the loop mode to shift a slider.
                   *
                   * @type {boolean}
                   */
                  waitForTransition: true,

                  /**
                   * Define slider max width.
                   *
                   * @type {number}
                   */
                  width: 0,

                  /**
                   * Define slider height.
                   *
                   * @type {number}
                   */
                  height: 0,

                  /**
                   * Fix width of slides. CSS format is allowed such as 10em, 80% or 80vw.
                   * perPage number will be ignored when this option is falsy.
                   *
                   * @type {number|string}
                   */
                  fixedWidth: 0,

                  /**
                   * Fix height of slides. CSS format is allowed such as 10em, 80vh but % unit is not accepted.
                   * heightRatio option will be ignored when this option is falsy.
                   *
                   * @type {number|string}
                   */
                  fixedHeight: 0,

                  /**
                   * Determine height of slides by ratio to a slider width.
                   * This will be ignored when the fixedHeight is provided.
                   *
                   * @type {number}
                   */
                  heightRatio: 0,

                  /**
                   * If true, slide width will be determined by the element width itself.
                   * - perPage/perMove should be 1.
                   *
                   * @type {boolean}
                   */
                  autoWidth: false,

                  /**
                   * If true, slide height will be determined by the element width itself.
                   * - perPage/perMove should be 1.
                   *
                   * @type {boolean}
                   */
                  autoHeight: false,

                  /**
                   * Determine how many slides should be displayed per page.
                   *
                   * @type {number}
                   */
                  perPage: 1,

                  /**
                   * Determine how many slides should be moved when a slider goes to next or perv.
                   *
                   * @type {number}
                   */
                  perMove: 0,

                  /**
                   * Determine manually how many clones should be generated on the left and right side.
                   * The total number of clones will be twice of this number.
                   *
                   * @type {number}
                   */
                  clones: 0,

                  /**
                   * Start index.
                   *
                   * @type {number}
                   */
                  start: 0,

                  /**
                   * Determine which slide should be focused if there are multiple slides in a page.
                   * A string "center" is acceptable for centering slides.
                   *
                   * @type {boolean|number|string}
                   */
                  focus: false,

                  /**
                   * Gap between slides. CSS format is allowed such as 1em.
                   *
                   * @type {number|string}
                   */
                  gap: 0,

                  /**
                   * Set padding-left/right in horizontal mode or padding-top/bottom in vertical one.
                   * Give a single value to set a same size for both sides or
                   * do an object for different sizes.
                   * Also, CSS format is allowed such as 1em.
                   *
                   * @example
                   * - 10: Number
                   * - '1em': CSS format.
                   * - { left: 0, right: 20 }: Object for different sizes in horizontal mode.
                   * - { top: 0, bottom: 20 }: Object for different sizes in vertical mode.
                   *
                   * @type {number|string|Object}
                   */
                  padding: 0,

                  /**
                   * Whether to append arrows.
                   *
                   * @type {boolean}
                   */
                  arrows: true,

                  /**
                   * Change the arrow SVG path like 'm7.61 0.807-2.12...'.
                   *
                   * @type {string}
                   */
                  arrowPath: "",

                  /**
                   * Whether to append pagination(indicator dots) or not.
                   *
                   * @type {boolean}
                   */
                  pagination: true,

                  /**
                   * Activate autoplay.
                   *
                   * @type {boolean}
                   */
                  autoplay: false,

                  /**
                   * Autoplay interval in milliseconds.
                   *
                   * @type {number}
                   */
                  interval: 5000,

                  /**
                   * Whether to stop autoplay when a slider is hovered.
                   *
                   * @type {boolean}
                   */
                  pauseOnHover: true,

                  /**
                   * Whether to stop autoplay when a slider elements are focused.
                   * True is recommended for accessibility.
                   *
                   * @type {boolean}
                   */
                  pauseOnFocus: true,

                  /**
                   * Whether to reset progress of the autoplay timer when resumed.
                   *
                   * @type {boolean}
                   */
                  resetProgress: true,

                  /**
                   * Loading images lazily.
                   * Image src must be provided by a data-splide-lazy attribute.
                   *
                   * - false: Do nothing.
                   * - 'nearby': Only images around an active slide will be loaded.
                   * - 'sequential': All images will be sequentially loaded.
                   *
                   * @type {boolean|string}
                   */
                  lazyLoad: false,

                  /**
                   * This option works only when a lazyLoad option is "nearby".
                   * Determine how many pages(not slides) around an active slide should be loaded beforehand.
                   *
                   * @type {number}
                   */
                  preloadPages: 1,

                  /**
                   * Easing for CSS transition. For example, linear, ease or cubic-bezier().
                   *
                   * @type {string}
                   */
                  easing: "cubic-bezier(.42,.65,.27,.99)",

                  /**
                   * Whether to enable keyboard shortcuts
                   * - true or 'global': Listen to keydown event of the document.
                   * - 'focused': Listen to the keydown event of the slider root element. tabindex="0" will be added to the element.
                   * - false: Disable keyboard shortcuts.
                   *
                   * @type {boolean|string}
                   */
                  keyboard: "global",

                  /**
                   * Whether to allow mouse drag and touch swipe.
                   *
                   * @type {boolean}
                   */
                  drag: true,

                  /**
                   * The angle threshold for drag.
                   * The slider starts moving only when the drag angle is less than this threshold.
                   *
                   * @type {number}
                   */
                  dragAngleThreshold: 30,

                  /**
                   * Distance threshold for determining if the action is "flick" or "swipe".
                   * When a drag distance is over this value, the action will be treated as "swipe", not "flick".
                   *
                   * @type {number}
                   */
                  swipeDistanceThreshold: 150,

                  /**
                   * Velocity threshold for determining if the action is "flick" or "swipe".
                   * Around 0.5 is recommended.
                   *
                   * @type {number}
                   */
                  flickVelocityThreshold: 0.6,

                  /**
                   * Determine power of flick. The larger number this is, the farther a slider runs by flick.
                   * Around 500 is recommended.
                   *
                   * @type {number}
                   */
                  flickPower: 600,

                  /**
                   * Limit a number of pages to move by flick.
                   *
                   * @type {number}
                   */
                  flickMaxPages: 1,

                  /**
                   * Slider direction.
                   * - 'ltr': Left to right.
                   * - 'rtl': Right to left.
                   * - 'ttb': Top to bottom.
                   *
                   * @type {string}
                   */
                  direction: "ltr",

                  /**
                   * Set img src to background-image of its parent element.
                   * Images with various sizes can be displayed as same dimension without cropping work.
                   * fixedHeight or heightRatio is required.
                   *
                   * @type {boolean}
                   */
                  cover: false,

                  /**
                   * Whether to enable accessibility(aria and screen reader texts) or not.
                   *
                   * @type {boolean}
                   */
                  accessibility: true,

                  /**
                   * Whether to add tabindex="0" to visible slides or not.
                   *
                   * @type {boolean}
                   */
                  slideFocus: true,

                  /**
                   * Determine if a slider is navigation for another.
                   * Use "sync" API to synchronize two sliders.
                   *
                   * @type {boolean}
                   */
                  isNavigation: false,

                  /**
                   * Whether to trim spaces before the fist slide or after the last one when "focus" is not 0.
                   *
                   * @type {boolean}
                   */
                  trimSpace: true,

                  /**
                   * The "is-active" class is added after transition as default.
                   * If true, it will be added before move.
                   *
                   * @type {boolean}
                   */
                  updateOnMove: false,

                  /**
                   * Throttle duration in milliseconds for the resize event.
                   *
                   * @type {number}
                   */
                  throttle: 100,

                  /**
                   * Whether to destroy a slider or not.
                   *
                   * @type {boolean}
                   */
                  destroy: false,

                  /**
                   * Options for specific breakpoints.
                   *
                   * @example
                   * {
                   *   1000: {
                   *     perPage: 3,
                   *     gap: 20
                   *   },
                   *   600: {
                   *     perPage: 1,
                   *     gap: 5,
                   *   }
                   * }
                   *
                   * @type {boolean|Object}
                   */
                  breakpoints: false,

                  /**
                   * Collection of class names.
                   *
                   * @see ./classes.js
                   *
                   * @type {Object}
                   */
                  classes: ELEMENT_CLASSES,

                  /**
                   * Collection of i18n texts.
                   *
                   * @see ./i18n.js
                   *
                   * @type {Object}
                   */
                  i18n: I18N,
                }; // CONCATENATED MODULE: ./src/js/constants/states.js
                /**
                 * Export state constants.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                /**
                 * Splide has been just created.
                 *
                 * @type {number}
                 */
                var CREATED = 1;
                /**
                 * All components have been mounted and initialized.
                 *
                 * @type {number}
                 */

                var MOUNTED = 2;
                /**
                 * Splide is ready for transition.
                 *
                 * @type {number}
                 */

                var IDLE = 3;
                /**
                 * Splide is moving.
                 *
                 * @type {number}
                 */

                var MOVING = 4;
                /**
                 * Splide is moving.
                 *
                 * @type {number}
                 */

                var DESTROYED = 5; // CONCATENATED MODULE: ./src/js/splide.js
                function _defineProperties(target, props) {
                  for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, descriptor.key, descriptor);
                  }
                }

                function _createClass(Constructor, protoProps, staticProps) {
                  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                  if (staticProps) _defineProperties(Constructor, staticProps);
                  return Constructor;
                }

                /**
                 * The main class for applying Splide to an element.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                /**
                 * The main class for applying Splide to an element,
                 * providing some APIs to control the behavior.
                 */

                var Splide = /*#__PURE__*/ (function () {
                  /**
                   * Splide constructor.
                   *
                   * @throws {Error} When the given root element or selector is invalid.
                   *
                   * @param {Element|string}  root       - A selector for a root element or an element itself.
                   * @param {Object}          options    - Optional. Options to change default behaviour.
                   * @param {Object}          Components - Optional. Components.
                   */
                  function Splide(root, options, Components) {
                    if (options === void 0) {
                      options = {};
                    }

                    if (Components === void 0) {
                      Components = {};
                    }

                    this.root = root instanceof Element ? root : document.querySelector(root);
                    exist(this.root, "An invalid element/selector was given.");
                    this.Components = null;
                    this.Event = core_event();
                    this.State = state(CREATED);
                    this.STATES = states_namespaceObject;
                    this._o = merge(DEFAULTS, options);
                    this._i = 0;
                    this._c = Components;
                    this._e = {}; // Extensions

                    this._t = null; // Transition
                  }
                  /**
                   * Compose and mount components.
                   *
                   * @param {Object}   Extensions - Optional. Additional components.
                   * @param {function} Transition - Optional. Set a custom transition component.
                   *
                   * @return {Splide|undefined} - This instance or undefined if an exception occurred.
                   */

                  var _proto = Splide.prototype;

                  _proto.mount = function mount(Extensions, Transition) {
                    var _this = this;

                    if (Extensions === void 0) {
                      Extensions = this._e;
                    }

                    if (Transition === void 0) {
                      Transition = this._t;
                    }

                    // Reset the state.
                    this.State.set(CREATED);
                    this._e = Extensions;
                    this._t = Transition;
                    this.Components = compose(this, merge(this._c, Extensions), Transition);

                    try {
                      each(this.Components, function (component, key) {
                        var required = component.required;

                        if (required === undefined || required) {
                          component.mount && component.mount();
                        } else {
                          delete _this.Components[key];
                        }
                      });
                    } catch (e) {
                      error(e.message);
                      return;
                    }

                    var State = this.State;
                    State.set(MOUNTED);
                    each(this.Components, function (component) {
                      component.mounted && component.mounted();
                    });
                    this.emit("mounted");
                    State.set(IDLE);
                    this.emit("ready");
                    applyStyle(this.root, {
                      visibility: "visible",
                    });
                    this.on("move drag", function () {
                      return State.set(MOVING);
                    }).on("moved dragged", function () {
                      return State.set(IDLE);
                    });
                    return this;
                  };
                  /**
                   * Set sync target.
                   *
                   * @param {Splide} splide - A Splide instance.
                   *
                   * @return {Splide} - This instance.
                   */

                  _proto.sync = function sync(splide) {
                    this.sibling = splide;
                    return this;
                  };
                  /**
                   * Register callback fired on the given event(s).
                   *
                   * @param {string}   events  - An event name. Use space to separate multiple events.
                   *                             Also, namespace is accepted by dot, such as 'resize.{namespace}'.
                   * @param {function} handler - A callback function.
                   * @param {Element}  elm     - Optional. Native event will be listened to when this arg is provided.
                   * @param {Object}   options - Optional. Options for addEventListener.
                   *
                   * @return {Splide} - This instance.
                   */

                  _proto.on = function on(events, handler, elm, options) {
                    if (elm === void 0) {
                      elm = null;
                    }

                    if (options === void 0) {
                      options = {};
                    }

                    this.Event.on(events, handler, elm, options);
                    return this;
                  };
                  /**
                   * Unsubscribe the given event.
                   *
                   * @param {string}  events - A event name.
                   * @param {Element} elm    - Optional. removeEventListener() will be called when this arg is provided.
                   *
                   * @return {Splide} - This instance.
                   */

                  _proto.off = function off(events, elm) {
                    if (elm === void 0) {
                      elm = null;
                    }

                    this.Event.off(events, elm);
                    return this;
                  };
                  /**
                   * Emit an event.
                   *
                   * @param {string} event - An event name.
                   * @param {*}      args  - Any number of arguments passed to handlers.
                   */

                  _proto.emit = function emit(event) {
                    var _this$Event;

                    for (
                      var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1;
                      _key < _len;
                      _key++
                    ) {
                      args[_key - 1] = arguments[_key];
                    }

                    (_this$Event = this.Event).emit.apply(_this$Event, [event].concat(args));

                    return this;
                  };
                  /**
                   * Go to the slide specified by the given control.
                   *
                   * @param {string|number} control - A control pattern.
                   * @param {boolean}       wait    - Optional. Whether to wait for transition.
                   */

                  _proto.go = function go(control, wait) {
                    if (wait === void 0) {
                      wait = this.options.waitForTransition;
                    }

                    if (this.State.is(IDLE) || (this.State.is(MOVING) && !wait)) {
                      this.Components.Controller.go(control, false);
                    }

                    return this;
                  };
                  /**
                   * Verify whether the slider type is the given one or not.
                   *
                   * @param {string} type - A slider type.
                   *
                   * @return {boolean} - True if the slider type is the provided type or false if not.
                   */

                  _proto.is = function is(type) {
                    return type === this._o.type;
                  };
                  /**
                   * Insert a slide.
                   *
                   * @param {Element|string} slide - A slide element to be added.
                   * @param {number}         index - A slide will be added at the position.
                   */

                  _proto.add = function add(slide, index) {
                    if (index === void 0) {
                      index = -1;
                    }

                    this.Components.Elements.add(slide, index, this.refresh.bind(this));
                    return this;
                  };
                  /**
                   * Remove the slide designated by the index.
                   *
                   * @param {number} index - A slide index.
                   */

                  _proto.remove = function remove(index) {
                    this.Components.Elements.remove(index);
                    this.refresh();
                    return this;
                  };
                  /**
                   * Destroy all Slide objects and clones and recreate them again.
                   */

                  _proto.refresh = function refresh() {
                    this.emit("refresh:before").emit("refresh").emit("resize");
                    return this;
                  };
                  /**
                   * Destroy the Splide.
                   * "Completely" boolean is mainly for breakpoints.
                   *
                   * @param {boolean} completely - Destroy completely.
                   */

                  _proto.destroy = function destroy(completely) {
                    var _this2 = this;

                    if (completely === void 0) {
                      completely = true;
                    }

                    // Postpone destroy because it should be done after mount.
                    if (this.State.is(CREATED)) {
                      this.on("ready", function () {
                        return _this2.destroy(completely);
                      });
                      return;
                    }

                    values(this.Components)
                      .reverse()
                      .forEach(function (component) {
                        component.destroy && component.destroy(completely);
                      });
                    this.emit("destroy", completely); // Destroy all event handlers, including ones for native events.

                    this.Event.destroy();
                    this.State.set(DESTROYED);
                    return this;
                  };
                  /**
                 * Return the current slide index.
                 *
                 * @return {number} - The current slide index.
                 // */

                  _createClass(Splide, [
                    {
                      key: "index",
                      get: function get() {
                        return this._i;
                      },
                      /**
                       * Set the current slide index.
                       *
                       * @param {number|string} index - A new index.
                       */
                      set: function set(index) {
                        this._i = parseInt(index);
                      },
                      /**
                       * Return length of slides.
                       * This is an alias of Elements.length.
                       *
                       * @return {number} - A number of slides.
                       */
                    },
                    {
                      key: "length",
                      get: function get() {
                        return this.Components.Elements.length;
                      },
                      /**
                       * Return options.
                       *
                       * @return {Object} - Options object.
                       */
                    },
                    {
                      key: "options",
                      get: function get() {
                        return this._o;
                      },
                      /**
                       * Set options with merging the given object to the current one.
                       *
                       * @param {Object} options - New options.
                       */
                      set: function set(options) {
                        var created = this.State.is(CREATED);

                        if (!created) {
                          this.emit("update");
                        }

                        this._o = merge(this._o, options);

                        if (!created) {
                          this.emit("updated", this._o);
                        }
                      },
                      /**
                       * Return the class list.
                       * This is an alias of Splide.options.classList.
                       *
                       * @return {Object} - An object containing all class list.
                       */
                    },
                    {
                      key: "classes",
                      get: function get() {
                        return this._o.classes;
                      },
                      /**
                       * Return the i18n strings.
                       * This is an alias of Splide.options.i18n.
                       *
                       * @return {Object} - An object containing all i18n strings.
                       */
                    },
                    {
                      key: "i18n",
                      get: function get() {
                        return this._o.i18n;
                      },
                    },
                  ]);

                  return Splide;
                })(); // CONCATENATED MODULE: ./src/js/components/options/index.js

                /**
                 * The component for initializing options.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                /**
                 * The component for initializing options.
                 *
                 * @param {Splide} Splide - A Splide instance.
                 *
                 * @return {Object} - The component object.
                 */

                /* harmony default export */
                const options = function (Splide) {
                  /**
                   * Retrieve options from the data attribute.
                   * Note that IE10 doesn't support dataset property.
                   *
                   * @type {string}
                   */
                  var options = getAttribute(Splide.root, "data-splide");

                  if (options) {
                    try {
                      Splide.options = JSON.parse(options);
                    } catch (e) {
                      error(e.message);
                    }
                  }

                  return {
                    /**
                     * Called when the component is mounted.
                     */
                    mount: function mount() {
                      if (Splide.State.is(CREATED)) {
                        Splide.index = Splide.options.start;
                      }
                    },
                  };
                }; // CONCATENATED MODULE: ./src/js/constants/directions.js
                /**
                 * Export layout modes.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                /**
                 * Enumerate slides from left to right.
                 *
                 * @type {string}
                 */
                var LTR = "ltr";
                /**
                 * Enumerate slides from right to left.
                 *
                 * @type {string}
                 */

                var RTL = "rtl";
                /**
                 * Enumerate slides in a col.
                 *
                 * @type {string}
                 */

                var TTB = "ttb"; // CONCATENATED MODULE: ./src/js/components/elements/slide.js
                /**
                 * The sub component for handling each slide.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                /**
                 * Events for restoring original styles.
                 *
                 * @type {string}
                 */

                var STYLE_RESTORE_EVENTS = "update.slide";
                /**
                 * The sub component for handling each slide.
                 *
                 * @param {Splide}  Splide    - A Splide instance.
                 * @param {number}  index     - An unique slide index.
                 * @param {number}  realIndex - Clones should pass a real slide index.
                 * @param {Element} slide     - A slide element.
                 *
                 * @return {Object} - The sub component object.
                 */

                /* harmony default export */
                const elements_slide = function (Splide, index, realIndex, slide) {
                  /**
                   * Whether to update "is-active" class before or after transition.
                   *
                   * @type {boolean}
                   */
                  var updateOnMove = Splide.options.updateOnMove;
                  /**
                   * Events when the slide status is updated.
                   * Append a namespace to remove listeners later.
                   *
                   * @type {string}
                   */

                  var STATUS_UPDATE_EVENTS =
                    "ready.slide updated.slide resized.slide moved.slide" + (updateOnMove ? " move.slide" : "");
                  /**
                   * Slide sub component object.
                   *
                   * @type {Object}
                   */

                  var Slide = {
                    /**
                     * Slide element.
                     *
                     * @type {Element}
                     */
                    slide: slide,

                    /**
                     * Slide index.
                     *
                     * @type {number}
                     */
                    index: index,

                    /**
                     * Real index for clones.
                     *
                     * @type {number}
                     */
                    realIndex: realIndex,

                    /**
                     * Container element if available.
                     *
                     * @type {Element|undefined}
                     */
                    container: child(slide, Splide.classes.container),

                    /**
                     * Whether this is a cloned slide or not.
                     *
                     * @type {boolean}
                     */
                    isClone: realIndex > -1,

                    /**
                     * Called when the component is mounted.
                     */
                    mount: function mount() {
                      var _this = this;

                      if (!this.isClone) {
                        slide.id = Splide.root.id + "-slide" + pad(index + 1);
                      }

                      Splide.on(STATUS_UPDATE_EVENTS, function () {
                        return _this.update();
                      })
                        .on(STYLE_RESTORE_EVENTS, restoreStyles)
                        .on(
                          "click",
                          function () {
                            return Splide.emit("click", _this);
                          },
                          slide
                        );
                      /*
                       * Add "is-active" class to a clone element temporarily
                       * and it will be removed on "moved" event.
                       */

                      if (updateOnMove) {
                        Splide.on("move.slide", function (newIndex) {
                          if (newIndex === realIndex) {
                            _update(true, false);
                          }
                        });
                      } // Make sure the slide is shown.

                      applyStyle(slide, {
                        display: "",
                      }); // Hold the original styles.

                      this.styles = getAttribute(slide, "style") || "";
                    },

                    /**
                     * Destroy.
                     */
                    destroy: function destroy() {
                      Splide.off(STATUS_UPDATE_EVENTS).off(STYLE_RESTORE_EVENTS).off("click", slide);
                      removeClass(slide, values(STATUS_CLASSES));
                      restoreStyles();
                      removeAttribute(this.container, "style");
                    },

                    /**
                     * Update active and visible status.
                     */
                    update: function update() {
                      _update(this.isActive(), false);

                      _update(this.isVisible(), true);
                    },

                    /**
                     * Check whether this slide is active or not.
                     *
                     * @return {boolean} - True if the slide is active or false if not.
                     */
                    isActive: function isActive() {
                      return Splide.index === index;
                    },

                    /**
                     * Check whether this slide is visible in the viewport or not.
                     *
                     * @return {boolean} - True if the slide is visible or false if not.
                     */
                    isVisible: function isVisible() {
                      var active = this.isActive();

                      if (Splide.is(FADE) || active) {
                        return active;
                      }

                      var ceil = Math.ceil;
                      var trackRect = getRect(Splide.Components.Elements.track);
                      var slideRect = getRect(slide);

                      if (Splide.options.direction === TTB) {
                        return trackRect.top <= slideRect.top && slideRect.bottom <= ceil(trackRect.bottom);
                      }

                      return trackRect.left <= slideRect.left && slideRect.right <= ceil(trackRect.right);
                    },

                    /**
                     * Calculate how far this slide is from another slide and
                     * return true if the distance is within the given number.
                     *
                     * @param {number} from   - Index of a target slide.
                     * @param {number} within - True if the slide is within this number.
                     *
                     * @return {boolean} - True if the slide is within the number or false otherwise.
                     */
                    isWithin: function isWithin(from, within) {
                      var diff = Math.abs(from - index);

                      if (!Splide.is(SLIDE) && !this.isClone) {
                        diff = Math.min(diff, Splide.length - diff);
                      }

                      return diff < within;
                    },
                  };
                  /**
                   * Update classes for activity or visibility.
                   *
                   * @param {boolean} active        - Is active/visible or not.
                   * @param {boolean} forVisibility - Toggle classes for activity or visibility.
                   */

                  function _update(active, forVisibility) {
                    var type = forVisibility ? "visible" : "active";
                    var className = STATUS_CLASSES[type];

                    if (active) {
                      addClass(slide, className);
                      Splide.emit("" + type, Slide);
                    } else {
                      if (hasClass(slide, className)) {
                        removeClass(slide, className);
                        Splide.emit("" + (forVisibility ? "hidden" : "inactive"), Slide);
                      }
                    }
                  }
                  /**
                   * Restore the original styles.
                   */

                  function restoreStyles() {
                    setAttribute(slide, "style", Slide.styles);
                  }

                  return Slide;
                }; // CONCATENATED MODULE: ./src/js/components/elements/index.js
                /**
                 * The component for main elements.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                /**
                 * The property name for UID stored in a window object.
                 *
                 * @type {string}
                 */

                var UID_NAME = "uid";
                /**
                 * The component for main elements.
                 *
                 * @param {Splide} Splide     - A Splide instance.
                 * @param {Object} Components - An object containing components.
                 *
                 * @return {Object} - The component object.
                 */

                /* harmony default export */
                const components_elements = function (Splide, Components) {
                  /**
                   * Hold the root element.
                   *
                   * @type {Element}
                   */
                  var root = Splide.root;
                  /**
                   * Hold the class list.
                   *
                   * @type {Object}
                   */

                  var classes = Splide.classes;
                  /**
                   * Store Slide objects.
                   *
                   * @type {Array}
                   */

                  var Slides = [];
                  /*
                   * Assign unique ID to the root element if it doesn't have the one.
                   * Note that IE doesn't support padStart() to fill the uid by 0.
                   */

                  if (!root.id) {
                    window.splide = window.splide || {};
                    var uid = window.splide[UID_NAME] || 0;
                    window.splide[UID_NAME] = ++uid;
                    root.id = "splide" + pad(uid);
                  }
                  /**
                   * Elements component object.
                   *
                   * @type {Object}
                   */

                  var Elements = {
                    /**
                     * Called when the component is mounted.
                     * Collect main elements and store them as member properties.
                     */
                    mount: function mount() {
                      var _this = this;

                      this.init();
                      Splide.on("refresh", function () {
                        _this.destroy();

                        _this.init();
                      }).on("updated", function () {
                        removeClass(root, getClasses());
                        addClass(root, getClasses());
                      });
                    },

                    /**
                     * Destroy.
                     */
                    destroy: function destroy() {
                      Slides.forEach(function (Slide) {
                        Slide.destroy();
                      });
                      Slides = [];
                      removeClass(root, getClasses());
                    },

                    /**
                     * Initialization.
                     */
                    init: function init() {
                      var _this2 = this;

                      collect();
                      addClass(root, getClasses());
                      this.slides.forEach(function (slide, index) {
                        _this2.register(slide, index, -1);
                      });
                    },

                    /**
                     * Register a slide to create a Slide object and handle its behavior.
                     *
                     * @param {Element} slide     - A slide element.
                     * @param {number}  index     - A unique index. This can be negative.
                     * @param {number}  realIndex - A real index for clones. Set -1 for real slides.
                     */
                    register: function register(slide, index, realIndex) {
                      var SlideObject = elements_slide(Splide, index, realIndex, slide);
                      SlideObject.mount();
                      Slides.push(SlideObject);
                    },

                    /**
                     * Return the Slide object designated by the index.
                     * Note that "find" is not supported by IE.
                     *
                     * @return {Object|undefined} - A Slide object if available. Undefined if not.
                     */
                    getSlide: function getSlide(index) {
                      return Slides.filter(function (Slide) {
                        return Slide.index === index;
                      })[0];
                    },

                    /**
                     * Return all Slide objects.
                     *
                     * @param {boolean} includeClones - Whether to include cloned slides or not.
                     *
                     * @return {Object[]} - Slide objects.
                     */
                    getSlides: function getSlides(includeClones) {
                      return includeClones
                        ? Slides
                        : Slides.filter(function (Slide) {
                            return !Slide.isClone;
                          });
                    },

                    /**
                     * Return Slide objects belonging to the given page.
                     *
                     * @param {number} page - A page number.
                     *
                     * @return {Object[]} - An array containing Slide objects.
                     */
                    getSlidesByPage: function getSlidesByPage(page) {
                      var idx = Components.Controller.toIndex(page);
                      var options = Splide.options;
                      var max = options.focus !== false ? 1 : options.perPage;
                      return Slides.filter(function (_ref) {
                        var index = _ref.index;
                        return idx <= index && index < idx + max;
                      });
                    },

                    /**
                     * Insert a slide to a slider.
                     * Need to refresh Splide after adding a slide.
                     *
                     * @param {Node|string} slide    - A slide element to be added.
                     * @param {number}      index    - A slide will be added at the position.
                     * @param {Function}    callback - Called right after the slide is added to the DOM tree.
                     */
                    add: function add(slide, index, callback) {
                      if (typeof slide === "string") {
                        slide = domify(slide);
                      }

                      if (slide instanceof Element) {
                        var ref = this.slides[index]; // This will be removed in mount() of a Slide component.

                        applyStyle(slide, {
                          display: "none",
                        });

                        if (ref) {
                          before(slide, ref);
                          this.slides.splice(index, 0, slide);
                        } else {
                          append(this.list, slide);
                          this.slides.push(slide);
                        }

                        loaded(slide, function () {
                          callback && callback(slide);
                        });
                      }
                    },

                    /**
                     * Remove a slide from a slider.
                     * Need to refresh Splide after removing a slide.
                     *
                     * @param index - Slide index.
                     */
                    remove: function remove(index) {
                      dom_remove(this.slides.splice(index, 1)[0]);
                    },

                    /**
                     * Trigger the provided callback for each Slide object.
                     *
                     * @param {Function} callback - A callback function. The first argument will be the Slide object.
                     */
                    each: function each(callback) {
                      Slides.forEach(callback);
                    },

                    /**
                     * Return slides length without clones.
                     *
                     * @return {number} - Slide length.
                     */
                    get length() {
                      return this.slides.length;
                    },

                    /**
                     * Return "SlideObjects" length including clones.
                     *
                     * @return {number} - Slide length including clones.
                     */
                    get total() {
                      return Slides.length;
                    },
                  };
                  /**
                   * Collect elements.
                   */

                  function collect() {
                    Elements.slider = child(root, classes.slider);
                    Elements.track = find(root, "." + classes.track);
                    Elements.list = child(Elements.track, classes.list);
                    exist(Elements.track && Elements.list, "Track or list was not found.");
                    Elements.slides = children(Elements.list, classes.slide);
                    var arrows = findParts(classes.arrows);
                    Elements.arrows = {
                      prev: find(arrows, "." + classes.prev),
                      next: find(arrows, "." + classes.next),
                    };
                    var autoplay = findParts(classes.autoplay);
                    Elements.bar = find(findParts(classes.progress), "." + classes.bar);
                    Elements.play = find(autoplay, "." + classes.play);
                    Elements.pause = find(autoplay, "." + classes.pause);
                    Elements.track.id = Elements.track.id || root.id + "-track";
                    Elements.list.id = Elements.list.id || root.id + "-list";
                  }
                  /**
                   * Return class names for the root element.
                   */

                  function getClasses() {
                    var rootClass = classes.root;
                    var options = Splide.options;
                    return [
                      rootClass + "--" + options.type,
                      rootClass + "--" + options.direction,
                      options.drag ? rootClass + "--draggable" : "",
                      options.isNavigation ? rootClass + "--nav" : "",
                      STATUS_CLASSES.active,
                    ];
                  }
                  /**
                   * Find parts only from children of the root or track.
                   *
                   * @return {Element} - A found element or undefined.
                   */

                  function findParts(className) {
                    return child(root, className) || child(Elements.slider, className);
                  }

                  return Elements;
                }; // CONCATENATED MODULE: ./src/js/components/controller/index.js
                /**
                 * The component for controlling the track.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                var floor = Math.floor;
                /**
                 * The component for controlling the track.
                 *
                 * @param {Splide} Splide     - A Splide instance.
                 * @param {Object} Components - An object containing components.
                 *
                 * @return {Object} - The component object.
                 */

                /* harmony default export */
                const controller = function (Splide, Components) {
                  /**
                   * Store current options.
                   *
                   * @type {Object}
                   */
                  var options;
                  /**
                   * True if the slide is LOOP mode.
                   *
                   * @type {boolean}
                   */

                  var isLoop;
                  /**
                   * Controller component object.
                   *
                   * @type {Object}
                   */

                  var Controller = {
                    /**
                     * Called when the component is mounted.
                     */
                    mount: function mount() {
                      options = Splide.options;
                      isLoop = Splide.is(LOOP);
                      bind();
                    },

                    /**
                     * Make track run by the given control.
                     * - "+{i}" : Increment the slide index by i.
                     * - "-{i}" : Decrement the slide index by i.
                     * - "{i}"  : Go to the slide whose index is i.
                     * - ">"    : Go to next page.
                     * - "<"    : Go to prev page.
                     * - ">{i}" : Go to page i.
                     *
                     * @param {string|number} control  - A control pattern.
                     * @param {boolean}       silently - Go to the destination without event emission.
                     */
                    go: function go(control, silently) {
                      var destIndex = this.trim(this.parse(control));
                      Components.Track.go(destIndex, this.rewind(destIndex), silently);
                    },

                    /**
                     * Parse the given control and return the destination index for the track.
                     *
                     * @param {string} control - A control target pattern.
                     *
                     * @return {number} - A parsed target.
                     */
                    parse: function parse(control) {
                      var index = Splide.index;
                      var matches = String(control).match(/([+\-<>]+)(\d+)?/);
                      var indicator = matches ? matches[1] : "";
                      var number = matches ? parseInt(matches[2]) : 0;

                      switch (indicator) {
                        case "+":
                          index += number || 1;
                          break;

                        case "-":
                          index -= number || 1;
                          break;

                        case ">":
                        case "<":
                          index = parsePage(number, index, indicator === "<");
                          break;

                        default:
                          index = parseInt(control);
                      }

                      return index;
                    },

                    /**
                     * Compute index from the given page number.
                     *
                     * @param {number} page - Page number.
                     *
                     * @return {number} - A computed page number.
                     */
                    toIndex: function toIndex(page) {
                      if (hasFocus()) {
                        return page;
                      }

                      var length = Splide.length;
                      var perPage = options.perPage;
                      var index = page * perPage;
                      index = index - (this.pageLength * perPage - length) * floor(index / length); // Adjustment for the last page.

                      if (length - perPage <= index && index < length) {
                        index = length - perPage;
                      }

                      return index;
                    },

                    /**
                     * Compute page number from the given slide index.
                     *
                     * @param {number} index - Slide index.
                     *
                     * @return {number} - A computed page number.
                     */
                    toPage: function toPage(index) {
                      if (hasFocus()) {
                        return index;
                      }

                      var length = Splide.length;
                      var perPage = options.perPage; // Make the last "perPage" number of slides belong to the last page.

                      if (length - perPage <= index && index < length) {
                        return floor((length - 1) / perPage);
                      }

                      return floor(index / perPage);
                    },

                    /**
                     * Trim the given index according to the current mode.
                     * Index being returned could be less than 0 or greater than the length in Loop mode.
                     *
                     * @param {number} index - An index being trimmed.
                     *
                     * @return {number} - A trimmed index.
                     */
                    trim: function trim(index) {
                      if (!isLoop) {
                        index = options.rewind ? this.rewind(index) : between(index, 0, this.edgeIndex);
                      }

                      return index;
                    },

                    /**
                     * Rewind the given index if it's out of range.
                     *
                     * @param {number} index - An index.
                     *
                     * @return {number} - A rewound index.
                     */
                    rewind: function rewind(index) {
                      var edge = this.edgeIndex;

                      if (isLoop) {
                        while (index > edge) {
                          index -= edge + 1;
                        }

                        while (index < 0) {
                          index += edge + 1;
                        }
                      } else {
                        if (index > edge) {
                          index = 0;
                        } else if (index < 0) {
                          index = edge;
                        }
                      }

                      return index;
                    },

                    /**
                     * Check if the direction is "rtl" or not.
                     *
                     * @return {boolean} - True if "rtl" or false if not.
                     */
                    isRtl: function isRtl() {
                      return options.direction === RTL;
                    },

                    /**
                     * Return the page length.
                     *
                     * @return {number} - Max page number.
                     */
                    get pageLength() {
                      var length = Splide.length;
                      return hasFocus() ? length : Math.ceil(length / options.perPage);
                    },

                    /**
                     * Return the edge index.
                     *
                     * @return {number} - Edge index.
                     */
                    get edgeIndex() {
                      var length = Splide.length;

                      if (!length) {
                        return 0;
                      }

                      if (hasFocus() || options.isNavigation || isLoop) {
                        return length - 1;
                      }

                      return length - options.perPage;
                    },

                    /**
                     * Return the index of the previous slide.
                     *
                     * @return {number} - The index of the previous slide if available. -1 otherwise.
                     */
                    get prevIndex() {
                      var prev = Splide.index - 1;

                      if (isLoop || options.rewind) {
                        prev = this.rewind(prev);
                      }

                      return prev > -1 ? prev : -1;
                    },

                    /**
                     * Return the index of the next slide.
                     *
                     * @return {number} - The index of the next slide if available. -1 otherwise.
                     */
                    get nextIndex() {
                      var next = Splide.index + 1;

                      if (isLoop || options.rewind) {
                        next = this.rewind(next);
                      }

                      return (Splide.index < next && next <= this.edgeIndex) || next === 0 ? next : -1;
                    },
                  };
                  /**
                   * Listen to some events.
                   */

                  function bind() {
                    Splide.on("move", function (newIndex) {
                      Splide.index = newIndex;
                    }).on("updated refresh", function (newOptions) {
                      options = newOptions || options;
                      Splide.index = between(Splide.index, 0, Controller.edgeIndex);
                    });
                  }
                  /**
                   * Verify if the focus option is available or not.
                   *
                   * @return {boolean} - True if a slider has the focus option.
                   */

                  function hasFocus() {
                    return options.focus !== false;
                  }
                  /**
                   * Return the next or previous page index computed by the page number and current index.
                   *
                   * @param {number}  number - Specify the page number.
                   * @param {number}  index  - Current index.
                   * @param {boolean} prev   - Prev or next.
                   *
                   * @return {number} - Slide index.
                   */

                  function parsePage(number, index, prev) {
                    if (number > -1) {
                      return Controller.toIndex(number);
                    }

                    var perMove = options.perMove;
                    var sign = prev ? -1 : 1;

                    if (perMove) {
                      return index + perMove * sign;
                    }

                    return Controller.toIndex(Controller.toPage(index) + sign);
                  }

                  return Controller;
                }; // CONCATENATED MODULE: ./src/js/components/track/index.js
                /**
                 * The component for moving list in the track.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                var abs = Math.abs;
                /**
                 * The component for moving list in the track.
                 *
                 * @param {Splide} Splide     - A Splide instance.
                 * @param {Object} Components - An object containing components.
                 *
                 * @return {Object} - The component object.
                 */

                /* harmony default export */
                const track = function (Splide, Components) {
                  /**
                   * Hold the Layout component.
                   *
                   * @type {Object}
                   */
                  var Layout;
                  /**
                   * Hold the Layout component.
                   *
                   * @type {Object}
                   */

                  var Elements;
                  /**
                   * Store the list element.
                   *
                   * @type {Element}
                   */

                  var list;
                  /**
                   * Whether the current direction is vertical or not.
                   *
                   * @type {boolean}
                   */

                  var isVertical = Splide.options.direction === TTB;
                  /**
                   * Whether the slider type is FADE or not.
                   *
                   * @type {boolean}
                   */

                  var isFade = Splide.is(FADE);
                  /**
                   * Whether the slider direction is RTL or not.
                   *
                   * @type {boolean}
                   */

                  var isRTL = Splide.options.direction === RTL;
                  /**
                   * This will be true while transitioning from the last index to the first one.
                   *
                   * @type {boolean}
                   */

                  var isLoopPending = false;
                  /**
                   * Sign for the direction. Only RTL mode uses the positive sign.
                   *
                   * @type {number}
                   */

                  var sign = isRTL ? 1 : -1;
                  /**
                   * Track component object.
                   *
                   * @type {Object}
                   */

                  var Track = {
                    /**
                     * Make public the sign defined locally.
                     *
                     * @type {number}
                     */
                    sign: sign,

                    /**
                     * Called when the component is mounted.
                     */
                    mount: function mount() {
                      Elements = Components.Elements;
                      Layout = Components.Layout;
                      list = Elements.list;
                    },

                    /**
                     * Called after the component is mounted.
                     * The resize event must be registered after the Layout's one is done.
                     */
                    mounted: function mounted() {
                      var _this = this;

                      if (!isFade) {
                        this.jump(0);
                        Splide.on("mounted resize updated", function () {
                          _this.jump(Splide.index);
                        });
                      }
                    },

                    /**
                     * Go to the given destination index.
                     * After arriving there, the track is jump to the new index without animation, mainly for loop mode.
                     *
                     * @param {number}  destIndex - A destination index.
                     *                              This can be negative or greater than slides length for reaching clones.
                     * @param {number}  newIndex  - An actual new index. They are always same in Slide and Rewind mode.
                     * @param {boolean} silently  - If true, suppress emitting events.
                     */
                    go: function go(destIndex, newIndex, silently) {
                      var newPosition = getTrimmedPosition(destIndex);
                      var prevIndex = Splide.index; // Prevent any actions while transitioning from the last index to the first one for jump.

                      if (Splide.State.is(MOVING) && isLoopPending) {
                        return;
                      }

                      isLoopPending = destIndex !== newIndex;

                      if (!silently) {
                        Splide.emit("move", newIndex, prevIndex, destIndex);
                      }

                      if (Math.abs(newPosition - this.position) >= 1 || isFade) {
                        Components.Transition.start(
                          destIndex,
                          newIndex,
                          prevIndex,
                          this.toCoord(newPosition),
                          function () {
                            onTransitionEnd(destIndex, newIndex, prevIndex, silently);
                          }
                        );
                      } else {
                        if (destIndex !== prevIndex && Splide.options.trimSpace === "move") {
                          Components.Controller.go(destIndex + destIndex - prevIndex, silently);
                        } else {
                          onTransitionEnd(destIndex, newIndex, prevIndex, silently);
                        }
                      }
                    },

                    /**
                     * Move the track to the specified index.
                     *
                     * @param {number} index - A destination index where the track jumps.
                     */
                    jump: function jump(index) {
                      this.translate(getTrimmedPosition(index));
                    },

                    /**
                     * Set the list position by CSS translate property.
                     *
                     * @param {number} position - A new position value.
                     */
                    translate: function translate(position) {
                      applyStyle(list, {
                        transform: "translate" + (isVertical ? "Y" : "X") + "(" + position + "px)",
                      });
                    },

                    /**
                     * Cancel the transition and set the list position.
                     * Also, loop the slider if necessary.
                     */
                    cancel: function cancel() {
                      if (Splide.is(LOOP)) {
                        this.shift();
                      } else {
                        // Ensure the current position.
                        this.translate(this.position);
                      }

                      applyStyle(list, {
                        transition: "",
                      });
                    },

                    /**
                     * Shift the slider if it exceeds borders on the edge.
                     */
                    shift: function shift() {
                      var position = abs(this.position);
                      var left = abs(this.toPosition(0));
                      var right = abs(this.toPosition(Splide.length));
                      var innerSize = right - left;

                      if (position < left) {
                        position += innerSize;
                      } else if (position > right) {
                        position -= innerSize;
                      }

                      this.translate(sign * position);
                    },

                    /**
                     * Trim redundant spaces on the left or right edge if necessary.
                     *
                     * @param {number} position - Position value to be trimmed.
                     *
                     * @return {number} - Trimmed position.
                     */
                    trim: function trim(position) {
                      if (!Splide.options.trimSpace || Splide.is(LOOP)) {
                        return position;
                      }

                      var edge = sign * (Layout.totalSize() - Layout.size - Layout.gap);
                      return between(position, edge, 0);
                    },

                    /**
                     * Calculate the closest slide index from the given position.
                     *
                     * @param {number} position - A position converted to an slide index.
                     *
                     * @return {number} - The closest slide index.
                     */
                    toIndex: function toIndex(position) {
                      var _this2 = this;

                      var index = 0;
                      var minDistance = Infinity;
                      Elements.getSlides(true).forEach(function (Slide) {
                        var slideIndex = Slide.index;
                        var distance = abs(_this2.toPosition(slideIndex) - position);

                        if (distance < minDistance) {
                          minDistance = distance;
                          index = slideIndex;
                        }
                      });
                      return index;
                    },

                    /**
                     * Return coordinates object by the given position.
                     *
                     * @param {number} position - A position value.
                     *
                     * @return {Object} - A coordinates object.
                     */
                    toCoord: function toCoord(position) {
                      return {
                        x: isVertical ? 0 : position,
                        y: isVertical ? position : 0,
                      };
                    },

                    /**
                     * Calculate the track position by a slide index.
                     *
                     * @param {number} index - Slide index.
                     *
                     * @return {Object} - Calculated position.
                     */
                    toPosition: function toPosition(index) {
                      var position = Layout.totalSize(index) - Layout.slideSize(index) - Layout.gap;
                      return sign * (position + this.offset(index));
                    },

                    /**
                     * Return the current offset value, considering direction.
                     *
                     * @return {number} - Offset amount.
                     */
                    offset: function offset(index) {
                      var focus = Splide.options.focus;
                      var slideSize = Layout.slideSize(index);

                      if (focus === "center") {
                        return -(Layout.size - slideSize) / 2;
                      }

                      return -(parseInt(focus) || 0) * (slideSize + Layout.gap);
                    },

                    /**
                     * Return the current position.
                     * This returns the correct position even while transitioning by CSS.
                     *
                     * @return {number} - Current position.
                     */
                    get position() {
                      var prop = isVertical ? "top" : isRTL ? "right" : "left";
                      return getRect(list)[prop] - (getRect(Elements.track)[prop] - Layout.padding[prop] * sign);
                    },
                  };
                  /**
                   * Called whenever slides arrive at a destination.
                   *
                   * @param {number}  destIndex - A destination index.
                   * @param {number}  newIndex  - A new index.
                   * @param {number}  prevIndex - A previous index.
                   * @param {boolean} silently  - If true, suppress emitting events.
                   */

                  function onTransitionEnd(destIndex, newIndex, prevIndex, silently) {
                    applyStyle(list, {
                      transition: "",
                    });
                    isLoopPending = false;

                    if (!isFade) {
                      Track.jump(newIndex);
                    }

                    if (!silently) {
                      Splide.emit("moved", newIndex, prevIndex, destIndex);
                    }
                  }
                  /**
                   * Convert index to the trimmed position.
                   *
                   * @return {number} - Trimmed position.
                   */

                  function getTrimmedPosition(index) {
                    return Track.trim(Track.toPosition(index));
                  }

                  return Track;
                }; // CONCATENATED MODULE: ./src/js/components/clones/index.js
                /**
                 * The component for cloning some slides for "loop" mode of the track.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                /**
                 * The component for cloning some slides for "loop" mode of the track.
                 *
                 * @param {Splide} Splide     - A Splide instance.
                 * @param {Object} Components - An object containing components.
                 *
                 * @return {Object} - The component object.
                 */

                /* harmony default export */
                const clones = function (Splide, Components) {
                  /**
                   * Store information of all clones.
                   *
                   * @type {Array}
                   */
                  var clones = [];
                  /**
                   * Store the current clone count on one side.
                   *
                   * @type {number}
                   */

                  var cloneCount = 0;
                  /**
                   * Keep Elements component.
                   *
                   * @type {Object}
                   */

                  var Elements = Components.Elements;
                  /**
                   * Clones component object.
                   *
                   * @type {Object}
                   */

                  var Clones = {
                    /**
                     * Called when the component is mounted.
                     */
                    mount: function mount() {
                      var _this = this;

                      if (Splide.is(LOOP)) {
                        init();
                        Splide.on("refresh:before", function () {
                          _this.destroy();
                        })
                          .on("refresh", init)
                          .on("resize", function () {
                            if (cloneCount !== getCloneCount()) {
                              // Destroy before refresh not to collect clones by the Elements component.
                              _this.destroy();

                              Splide.refresh();
                            }
                          });
                      }
                    },

                    /**
                     * Destroy.
                     */
                    destroy: function destroy() {
                      dom_remove(clones);
                      clones = [];
                    },

                    /**
                     * Return all clones.
                     *
                     * @return {Element[]} - Cloned elements.
                     */
                    get clones() {
                      return clones;
                    },

                    /**
                     * Return clone length.
                     *
                     * @return {number} - A length of clones.
                     */
                    get length() {
                      return clones.length;
                    },
                  };
                  /**
                   * Initialization.
                   */

                  function init() {
                    Clones.destroy();
                    cloneCount = getCloneCount();
                    generateClones(cloneCount);
                  }
                  /**
                   * Generate and append/prepend clones.
                   *
                   * @param {number} count - The half number of clones.
                   */

                  function generateClones(count) {
                    var length = Elements.length,
                      register = Elements.register;

                    if (length) {
                      var slides = Elements.slides;

                      while (slides.length < count) {
                        slides = slides.concat(slides);
                      } // Clones after the last element.

                      slides.slice(0, count).forEach(function (elm, index) {
                        var clone = cloneDeeply(elm);
                        append(Elements.list, clone);
                        clones.push(clone);
                        register(clone, index + length, index % length);
                      }); // Clones before the first element.

                      slides.slice(-count).forEach(function (elm, index) {
                        var clone = cloneDeeply(elm);
                        before(clone, slides[0]);
                        clones.push(clone);
                        register(clone, index - count, (length + index - (count % length)) % length);
                      });
                    }
                  }
                  /**
                   * Return half count of clones to be generated.
                   * Clone count is determined by:
                   * - "clones" value in the options.
                   * - Number of slides that can be placed in a view in "fixed" mode.
                   * - Max pages a flick action can move.
                   * - Whether the slide length is enough for perPage.
                   *
                   * @return {number} - Count for clones.
                   */

                  function getCloneCount() {
                    var options = Splide.options;

                    if (options.clones) {
                      return options.clones;
                    } // Use the slide length in autoWidth mode because the number cannot be calculated.

                    var baseCount = options.autoWidth || options.autoHeight ? Elements.length : options.perPage;
                    var dimension = options.direction === TTB ? "Height" : "Width";
                    var fixedSize = toPixel(Splide.root, options["fixed" + dimension]);

                    if (fixedSize) {
                      // Roughly calculate the count. This needs not to be strict.
                      baseCount = Math.ceil(Elements.track["client" + dimension] / fixedSize);
                    }

                    return baseCount * (options.drag ? options.flickMaxPages + 1 : 1);
                  }
                  /**
                   * Clone deeply the given element.
                   *
                   * @param {Element} elm - An element being duplicated.
                   *
                   * @return {Node} - A cloned node(element).
                   */

                  function cloneDeeply(elm) {
                    var clone = elm.cloneNode(true);
                    addClass(clone, Splide.classes.clone); // ID should not be duplicated.

                    removeAttribute(clone, "id");
                    return clone;
                  }

                  return Clones;
                }; // CONCATENATED MODULE: ./src/js/components/layout/directions/horizontal.js
                /**
                 * The resolver component for horizontal layout.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                /**
                 * The resolver component for horizontal layout.
                 *
                 * @param {Splide} Splide     - A Splide instance.
                 * @param {Object} Components - An object containing components.
                 *
                 * @return {Object} - The resolver object.
                 */

                /* harmony default export */
                const horizontal = function (Splide, Components) {
                  /**
                   * Keep the Elements component.
                   *
                   * @type {string}
                   */
                  var Elements = Components.Elements;
                  /**
                   * Keep the root element.
                   *
                   * @type {Element}
                   */

                  var root = Splide.root;
                  /**
                   * Keep the track element.
                   *
                   * @type {Element}
                   */

                  var track;
                  /**
                   * Keep the latest options.
                   *
                   * @type {Element}
                   */

                  var options = Splide.options;
                  return {
                    /**
                     * Margin property name.
                     *
                     * @type {string}
                     */
                    margin: "margin" + (options.direction === RTL ? "Left" : "Right"),

                    /**
                     * Always 0 because the height will be determined by inner contents.
                     *
                     * @type {number}
                     */
                    height: 0,

                    /**
                     * Initialization.
                     */
                    init: function init() {
                      this.resize();
                    },

                    /**
                     * Resize gap and padding.
                     * This must be called on init.
                     */
                    resize: function resize() {
                      options = Splide.options;
                      track = Elements.track;
                      this.gap = toPixel(root, options.gap);
                      var padding = options.padding;
                      var left = toPixel(root, padding.left || padding);
                      var right = toPixel(root, padding.right || padding);
                      this.padding = {
                        left: left,
                        right: right,
                      };
                      applyStyle(track, {
                        paddingLeft: unit(left),
                        paddingRight: unit(right),
                      });
                    },

                    /**
                     * Return total width from the left of the list to the right of the slide specified by the provided index.
                     *
                     * @param {number} index - Optional. A slide index. If undefined, total width of the slider will be returned.
                     *
                     * @return {number} - Total width to the right side of the specified slide, or 0 for an invalid index.
                     */
                    totalWidth: function totalWidth(index) {
                      if (index === void 0) {
                        index = Splide.length - 1;
                      }

                      var Slide = Elements.getSlide(index);
                      var width = 0;

                      if (Slide) {
                        var slideRect = getRect(Slide.slide);
                        var listRect = getRect(Elements.list);

                        if (options.direction === RTL) {
                          width = listRect.right - slideRect.left;
                        } else {
                          width = slideRect.right - listRect.left;
                        }

                        width += this.gap;
                      }

                      return width;
                    },

                    /**
                     * Return the slide width in px.
                     *
                     * @param {number} index - Slide index.
                     *
                     * @return {number} - The slide width.
                     */
                    slideWidth: function slideWidth(index) {
                      if (options.autoWidth) {
                        var Slide = Elements.getSlide(index);
                        return Slide ? Slide.slide.offsetWidth : 0;
                      }

                      var width = options.fixedWidth || (this.width + this.gap) / options.perPage - this.gap;
                      return toPixel(root, width);
                    },

                    /**
                     * Return the slide height in px.
                     *
                     * @return {number} - The slide height.
                     */
                    slideHeight: function slideHeight() {
                      var height = options.height || options.fixedHeight || this.width * options.heightRatio;
                      return toPixel(root, height);
                    },

                    /**
                     * Return slider width without padding.
                     *
                     * @return {number} - Current slider width.
                     */
                    get width() {
                      return track.clientWidth - this.padding.left - this.padding.right;
                    },
                  };
                }; // CONCATENATED MODULE: ./src/js/components/layout/directions/vertical.js
                /**
                 * The resolver component for vertical layout.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                /**
                 * The resolver component for vertical layout.
                 *
                 * @param {Splide} Splide     - A Splide instance.
                 * @param {Object} Components - An object containing components.
                 *
                 * @return {Object} - The resolver object.
                 */

                /* harmony default export */
                const vertical = function (Splide, Components) {
                  /**
                   * Keep the Elements component.
                   *
                   * @type {string}
                   */
                  var Elements = Components.Elements;
                  /**
                   * Keep the root element.
                   *
                   * @type {Element}
                   */

                  var root = Splide.root;
                  /**
                   * Keep the track element.
                   *
                   * @type {Element}
                   */

                  var track;
                  /**
                   * Keep the latest options.
                   *
                   * @type {Element}
                   */

                  var options;
                  return {
                    /**
                     * Margin property name.
                     *
                     * @type {string}
                     */
                    margin: "marginBottom",

                    /**
                     * Initialization.
                     */
                    init: function init() {
                      this.resize();
                    },

                    /**
                     * Resize gap and padding.
                     * This must be called on init.
                     */
                    resize: function resize() {
                      options = Splide.options;
                      track = Elements.track;
                      this.gap = toPixel(root, options.gap);
                      var padding = options.padding;
                      var top = toPixel(root, padding.top || padding);
                      var bottom = toPixel(root, padding.bottom || padding);
                      this.padding = {
                        top: top,
                        bottom: bottom,
                      };
                      applyStyle(track, {
                        paddingTop: unit(top),
                        paddingBottom: unit(bottom),
                      });
                    },

                    /**
                     * Return total height from the top of the list to the bottom of the slide specified by the provided index.
                     *
                     * @param {number} index - Optional. A slide index. If undefined, total height of the slider will be returned.
                     *
                     * @return {number} - Total height to the bottom of the specified slide, or 0 for an invalid index.
                     */
                    totalHeight: function totalHeight(index) {
                      if (index === void 0) {
                        index = Splide.length - 1;
                      }

                      var Slide = Elements.getSlide(index);

                      if (Slide) {
                        return getRect(Slide.slide).bottom - getRect(Elements.list).top + this.gap;
                      }

                      return 0;
                    },

                    /**
                     * Return the slide width in px.
                     *
                     * @return {number} - The slide width.
                     */
                    slideWidth: function slideWidth() {
                      return toPixel(root, options.fixedWidth || this.width);
                    },

                    /**
                     * Return the slide height in px.
                     *
                     * @param {number} index - Slide index.
                     *
                     * @return {number} - The slide height.
                     */
                    slideHeight: function slideHeight(index) {
                      if (options.autoHeight) {
                        var Slide = Elements.getSlide(index);
                        return Slide ? Slide.slide.offsetHeight : 0;
                      }

                      var height = options.fixedHeight || (this.height + this.gap) / options.perPage - this.gap;
                      return toPixel(root, height);
                    },

                    /**
                     * Return slider width without padding.
                     *
                     * @return {number} - Current slider width.
                     */
                    get width() {
                      return track.clientWidth;
                    },

                    /**
                     * Return slide height without padding.
                     *
                     * @return {number} - Slider height.
                     */
                    get height() {
                      var height = options.height || this.width * options.heightRatio;
                      exist(height, '"height" or "heightRatio" is missing.');
                      return toPixel(root, height) - this.padding.top - this.padding.bottom;
                    },
                  };
                }; // CONCATENATED MODULE: ./src/js/utils/time.js
                /**
                 * A package of utility functions related with time.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                /**
                 * Simple throttle function that controls how often the given function is executed.
                 *
                 * @param {function} func - A function to be throttled.
                 * @param {number}   wait - Time in millisecond for interval of execution.
                 *
                 * @return {Function} - A debounced function.
                 */
                function throttle(func, wait) {
                  var timeout; // Declare function by the "function" keyword to prevent "this" from being inherited.

                  return function () {
                    if (!timeout) {
                      timeout = setTimeout(function () {
                        func();
                        timeout = null;
                      }, wait);
                    }
                  };
                }
                /**
                 * Custom setInterval function that provides progress rate as callback.
                 *
                 * @param {function} callback - A callback function fired every time the interval time passes.
                 * @param {number}   interval - Interval duration in milliseconds.
                 * @param {function} progress - A callback function fired whenever the progress goes.
                 *
                 * @return {Object} - An object containing play() and pause() functions.
                 */

                function createInterval(callback, interval, progress) {
                  var _window = window,
                    requestAnimationFrame = _window.requestAnimationFrame;
                  var start,
                    elapse,
                    rate,
                    _pause = true;

                  var step = function step(timestamp) {
                    if (!_pause) {
                      if (!start) {
                        start = timestamp;

                        if (rate && rate < 1) {
                          start -= rate * interval;
                        }
                      }

                      elapse = timestamp - start;
                      rate = elapse / interval;

                      if (elapse >= interval) {
                        start = 0;
                        rate = 1;
                        callback();
                      }

                      if (progress) {
                        progress(rate);
                      }

                      requestAnimationFrame(step);
                    }
                  };

                  return {
                    pause: function pause() {
                      _pause = true;
                      start = 0;
                    },
                    play: function play(reset) {
                      start = 0;

                      if (reset) {
                        rate = 0;
                      }

                      if (_pause) {
                        _pause = false;
                        requestAnimationFrame(step);
                      }
                    },
                  };
                } // CONCATENATED MODULE: ./src/js/components/layout/index.js
                /**
                 * The component for handing slide layouts and their sizes.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                /**
                 * The component for handing slide layouts and their sizes.
                 *
                 * @param {Splide} Splide     - A Splide instance.
                 * @param {Object} Components - An object containing components.
                 *
                 * @return {Object} - The component object.
                 */

                /* harmony default export */
                const layout = function (Splide, Components) {
                  /**
                   * Keep the Elements component.
                   *
                   * @type {string}
                   */
                  var Elements = Components.Elements;
                  /**
                   * Whether the slider is vertical or not.
                   *
                   * @type {boolean}
                   */

                  var isVertical = Splide.options.direction === TTB;
                  /**
                   * Layout component object.
                   *
                   * @type {Object}
                   */

                  var Layout = object_assign(
                    {
                      /**
                       * Called when the component is mounted.
                       */
                      mount: function mount() {
                        bind();
                        init(); // The word "size" means width for a horizontal slider and height for a vertical slider.

                        this.totalSize = isVertical ? this.totalHeight : this.totalWidth;
                        this.slideSize = isVertical ? this.slideHeight : this.slideWidth;
                      },

                      /**
                       * Destroy the component.
                       */
                      destroy: function destroy() {
                        removeAttribute([Elements.list, Elements.track], "style");
                      },

                      /**
                       * Return the slider height on the vertical mode or width on the horizontal mode.
                       *
                       * @return {number}
                       */
                      get size() {
                        return isVertical ? this.height : this.width;
                      },
                    },
                    isVertical ? vertical(Splide, Components) : horizontal(Splide, Components)
                  );
                  /**
                   * Init slider styles according to options.
                   */

                  function init() {
                    Layout.init();
                    applyStyle(Splide.root, {
                      maxWidth: unit(Splide.options.width),
                    });
                    Elements.each(function (Slide) {
                      Slide.slide.style[Layout.margin] = unit(Layout.gap);
                    });
                    resize();
                  }
                  /**
                   * Listen the resize native event with throttle.
                   * Initialize when the component is mounted or options are updated.
                   */

                  function bind() {
                    Splide.on(
                      "resize load",
                      throttle(function () {
                        Splide.emit("resize");
                      }, Splide.options.throttle),
                      window
                    )
                      .on("resize", resize)
                      .on("updated refresh", init);
                  }
                  /**
                   * Resize the track and slide elements.
                   */

                  function resize() {
                    var options = Splide.options;
                    Layout.resize();
                    applyStyle(Elements.track, {
                      height: unit(Layout.height),
                    });
                    var slideHeight = options.autoHeight ? null : unit(Layout.slideHeight());
                    Elements.each(function (Slide) {
                      applyStyle(Slide.container, {
                        height: slideHeight,
                      });
                      applyStyle(Slide.slide, {
                        width: options.autoWidth ? null : unit(Layout.slideWidth(Slide.index)),
                        height: Slide.container ? null : slideHeight,
                      });
                    });
                    Splide.emit("resized");
                  }

                  return Layout;
                }; // CONCATENATED MODULE: ./src/js/components/drag/index.js
                /**
                 * The component for supporting mouse drag and swipe.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                var drag_abs = Math.abs;
                /**
                 * If the absolute velocity is greater thant this value,
                 * a slider always goes to a different slide after drag, not allowed to stay on a current slide.
                 */

                var MIN_VELOCITY = 0.1;
                /**
                 * Adjust how much the track can be pulled on the first or last page.
                 * The larger number this is, the farther the track moves.
                 * This should be around 5 - 9.
                 *
                 * @type {number}
                 */

                var FRICTION_REDUCER = 7;
                /**
                 * The component supporting mouse drag and swipe.
                 *
                 * @param {Splide} Splide     - A Splide instance.
                 * @param {Object} Components - An object containing components.
                 *
                 * @return {Object} - The component object.
                 */

                /* harmony default export */
                const drag = function (Splide, Components) {
                  /**
                   * Store the Move component.
                   *
                   * @type {Object}
                   */
                  var Track = Components.Track;
                  /**
                   * Store the Controller component.
                   *
                   * @type {Object}
                   */

                  var Controller = Components.Controller;
                  /**
                   * Coordinate of the track on starting drag.
                   *
                   * @type {Object}
                   */

                  var startCoord;
                  /**
                   * Analyzed info on starting drag.
                   *
                   * @type {Object|null}
                   */

                  var startInfo;
                  /**
                   * Analyzed info being updated while dragging/swiping.
                   *
                   * @type {Object}
                   */

                  var currentInfo;
                  /**
                   * Determine whether slides are being dragged or not.
                   *
                   * @type {boolean}
                   */

                  var isDragging;
                  /**
                   * Whether the slider direction is vertical or not.
                   *
                   * @type {boolean}
                   */

                  var isVertical = Splide.options.direction === TTB;
                  /**
                   * Axis for the direction.
                   *
                   * @type {string}
                   */

                  var axis = isVertical ? "y" : "x";
                  /**
                   * Drag component object.
                   *
                   * @type {Object}
                   */

                  var Drag = {
                    /**
                     * Whether dragging is disabled or not.
                     *
                     * @type {boolean}
                     */
                    disabled: false,

                    /**
                     * Called when the component is mounted.
                     */
                    mount: function mount() {
                      var _this = this;

                      var Elements = Components.Elements;
                      var track = Elements.track;
                      Splide.on("touchstart mousedown", start, track)
                        .on("touchmove mousemove", move, track, {
                          passive: false,
                        })
                        .on("touchend touchcancel mouseleave mouseup dragend", end, track)
                        .on("mounted refresh", function () {
                          // Prevent dragging an image or anchor itself.
                          each(Elements.list.querySelectorAll("img, a"), function (elm) {
                            Splide.off("dragstart", elm).on(
                              "dragstart",
                              function (e) {
                                e.preventDefault();
                              },
                              elm,
                              {
                                passive: false,
                              }
                            );
                          });
                        })
                        .on("mounted updated", function () {
                          _this.disabled = !Splide.options.drag;
                        });
                    },
                  };
                  /**
                   * Called when the track starts to be dragged.
                   *
                   * @param {TouchEvent|MouseEvent} e - TouchEvent or MouseEvent object.
                   */

                  function start(e) {
                    if (!Drag.disabled && !isDragging) {
                      // These prams are used to evaluate whether the slider should start moving.
                      init(e);
                    }
                  }
                  /**
                   * Initialize parameters.
                   *
                   * @param {TouchEvent|MouseEvent} e - TouchEvent or MouseEvent object.
                   */

                  function init(e) {
                    startCoord = Track.toCoord(Track.position);
                    startInfo = analyze(e, {});
                    currentInfo = startInfo;
                  }
                  /**
                   * Called while the track being dragged.
                   *
                   * @param {TouchEvent|MouseEvent} e - TouchEvent or MouseEvent object.
                   */

                  function move(e) {
                    if (startInfo) {
                      currentInfo = analyze(e, startInfo);

                      if (isDragging) {
                        if (e.cancelable) {
                          e.preventDefault();
                        }

                        if (!Splide.is(FADE)) {
                          var position = startCoord[axis] + currentInfo.offset[axis];
                          Track.translate(resist(position));
                        }
                      } else {
                        if (shouldMove(currentInfo)) {
                          Splide.emit("drag", startInfo);
                          isDragging = true;
                          Track.cancel(); // These params are actual drag data.

                          init(e);
                        }
                      }
                    }
                  }
                  /**
                   * Determine whether to start moving the track or not by drag angle.
                   *
                   * @param {Object} info - An information object.
                   *
                   * @return {boolean} - True if the track should be moved or false if not.
                   */

                  function shouldMove(_ref) {
                    var offset = _ref.offset;

                    if (Splide.State.is(MOVING) && Splide.options.waitForTransition) {
                      return false;
                    }

                    var angle = (Math.atan(drag_abs(offset.y) / drag_abs(offset.x)) * 180) / Math.PI;

                    if (isVertical) {
                      angle = 90 - angle;
                    }

                    return angle < Splide.options.dragAngleThreshold;
                  }
                  /**
                   * Resist dragging the track on the first/last page because there is no more.
                   *
                   * @param {number} position - A position being applied to the track.
                   *
                   * @return {Object} - Adjusted position.
                   */

                  function resist(position) {
                    if (Splide.is(SLIDE)) {
                      var sign = Track.sign;

                      var _start = sign * Track.trim(Track.toPosition(0));

                      var _end = sign * Track.trim(Track.toPosition(Controller.edgeIndex));

                      position *= sign;

                      if (position < _start) {
                        position = _start - FRICTION_REDUCER * Math.log(_start - position);
                      } else if (position > _end) {
                        position = _end + FRICTION_REDUCER * Math.log(position - _end);
                      }

                      position *= sign;
                    }

                    return position;
                  }
                  /**
                   * Called when dragging ends.
                   */

                  function end() {
                    startInfo = null;

                    if (isDragging) {
                      Splide.emit("dragged", currentInfo);
                      go(currentInfo);
                      isDragging = false;
                    }
                  }
                  /**
                   * Go to the slide determined by the analyzed data.
                   *
                   * @param {Object} info - An info object.
                   */

                  function go(info) {
                    var velocity = info.velocity[axis];
                    var absV = drag_abs(velocity);

                    if (absV > 0) {
                      var options = Splide.options;
                      var index = Splide.index;
                      var sign = velocity < 0 ? -1 : 1;
                      var destIndex = index;

                      if (!Splide.is(FADE)) {
                        var destination = Track.position;

                        if (
                          absV > options.flickVelocityThreshold &&
                          drag_abs(info.offset[axis]) < options.swipeDistanceThreshold
                        ) {
                          destination +=
                            sign *
                            Math.min(absV * options.flickPower, Components.Layout.size * (options.flickMaxPages || 1));
                        }

                        destIndex = Track.toIndex(destination);
                      }
                      /*
                       * Do not allow the track to go to a previous position if there is enough velocity.
                       * Always use the adjacent index for the fade mode.
                       */

                      if (destIndex === index && absV > MIN_VELOCITY) {
                        destIndex = index + sign * Track.sign;
                      }

                      if (Splide.is(SLIDE)) {
                        destIndex = between(destIndex, 0, Controller.edgeIndex);
                      }

                      Controller.go(destIndex, options.isNavigation);
                    }
                  }
                  /**
                   * Analyze the given event object and return important information for handling swipe behavior.
                   *
                   * @param {Event}   e          - Touch or Mouse event object.
                   * @param {Object}  startInfo  - Information analyzed on start for calculating difference from the current one.
                   *
                   * @return {Object} - An object containing analyzed information, such as offset, velocity, etc.
                   */

                  function analyze(e, startInfo) {
                    var timeStamp = e.timeStamp,
                      touches = e.touches;

                    var _ref2 = touches ? touches[0] : e,
                      clientX = _ref2.clientX,
                      clientY = _ref2.clientY;

                    var _ref3 = startInfo.to || {},
                      _ref3$x = _ref3.x,
                      fromX = _ref3$x === void 0 ? clientX : _ref3$x,
                      _ref3$y = _ref3.y,
                      fromY = _ref3$y === void 0 ? clientY : _ref3$y;

                    var startTime = startInfo.time || 0;
                    var offset = {
                      x: clientX - fromX,
                      y: clientY - fromY,
                    };
                    var duration = timeStamp - startTime;
                    var velocity = {
                      x: offset.x / duration,
                      y: offset.y / duration,
                    };
                    return {
                      to: {
                        x: clientX,
                        y: clientY,
                      },
                      offset: offset,
                      time: timeStamp,
                      velocity: velocity,
                    };
                  }

                  return Drag;
                }; // CONCATENATED MODULE: ./src/js/components/click/index.js
                /**
                 * The component for handling a click event.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                /**
                 * The component for handling a click event.
                 * Click should be disabled during drag/swipe.
                 *
                 * @param {Splide} Splide     - A Splide instance.
                 * @param {Object} Components - An object containing components.
                 *
                 * @return {Object} - The component object.
                 */
                /* harmony default export */
                const click = function (Splide, Components) {
                  /**
                   * Whether click is disabled or not.
                   *
                   * @type {boolean}
                   */
                  var disabled = false;
                  /**
                   * Click component object.
                   *
                   * @type {Object}
                   */

                  var Click = {
                    /**
                     * Mount only when the drag is activated and the slide type is not "fade".
                     *
                     * @type {boolean}
                     */
                    required: Splide.options.drag,

                    /**
                     * Called when the component is mounted.
                     */
                    mount: function mount() {
                      Splide.on("click", onClick, Components.Elements.track, {
                        capture: true,
                      })
                        .on("drag", function () {
                          disabled = true;
                        })
                        .on("dragged", function () {
                          // Make sure the flag is released after the click event is fired.
                          setTimeout(function () {
                            disabled = false;
                          });
                        });
                    },
                  };
                  /**
                   * Called when a track element is clicked.
                   *
                   * @param {Event} e - A click event.
                   */

                  function onClick(e) {
                    if (disabled) {
                      e.preventDefault();
                      e.stopPropagation();
                      e.stopImmediatePropagation();
                    }
                  }

                  return Click;
                }; // CONCATENATED MODULE: ./src/js/components/autoplay/index.js
                /**
                 * The component for playing slides automatically.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                /**
                 * Set of pause flags.
                 */

                var PAUSE_FLAGS = {
                  HOVER: 1,
                  FOCUS: 2,
                  MANUAL: 3,
                };
                /**
                 * The component for playing slides automatically.
                 *
                 * @param {Splide} Splide     - A Splide instance.
                 * @param {Object} Components - An object containing components.
                 * @param {string} name       - A component name as a lowercase string.
                 *
                 * @return {Object} - The component object.
                 */

                /* harmony default export */
                const autoplay = function (Splide, Components, name) {
                  /**
                   * Store pause flags.
                   *
                   * @type {Array}
                   */
                  var flags = [];
                  /**
                   * Store an interval object.
                   *
                   * @type {Object};
                   */

                  var interval;
                  /**
                   * Keep the Elements component.
                   *
                   * @type {string}
                   */

                  var Elements = Components.Elements;
                  /**
                   * Autoplay component object.
                   *
                   * @type {Object}
                   */

                  var Autoplay = {
                    /**
                     * Required only when the autoplay option is true.
                     *
                     * @type {boolean}
                     */
                    required: Splide.options.autoplay,

                    /**
                     * Called when the component is mounted.
                     * Note that autoplay starts only if there are slides over perPage number.
                     */
                    mount: function mount() {
                      var options = Splide.options;

                      if (Elements.slides.length > options.perPage) {
                        interval = createInterval(
                          function () {
                            Splide.go(">");
                          },
                          options.interval,
                          function (rate) {
                            Splide.emit(name + ":playing", rate);

                            if (Elements.bar) {
                              applyStyle(Elements.bar, {
                                width: rate * 100 + "%",
                              });
                            }
                          }
                        );
                        bind();
                        this.play();
                      }
                    },

                    /**
                     * Start autoplay.
                     *
                     * @param {number} flag - A pause flag to be removed.
                     */
                    play: function play(flag) {
                      if (flag === void 0) {
                        flag = 0;
                      }

                      flags = flags.filter(function (f) {
                        return f !== flag;
                      });

                      if (!flags.length) {
                        Splide.emit(name + ":play");
                        interval.play(Splide.options.resetProgress);
                      }
                    },

                    /**
                     * Pause autoplay.
                     * Note that Array.includes is not supported by IE.
                     *
                     * @param {number} flag - A pause flag to be added.
                     */
                    pause: function pause(flag) {
                      if (flag === void 0) {
                        flag = 0;
                      }

                      interval.pause();

                      if (flags.indexOf(flag) === -1) {
                        flags.push(flag);
                      }

                      if (flags.length === 1) {
                        Splide.emit(name + ":pause");
                      }
                    },
                  };
                  /**
                   * Listen some events.
                   */

                  function bind() {
                    var options = Splide.options;
                    var sibling = Splide.sibling;
                    var elms = [Splide.root, sibling ? sibling.root : null];

                    if (options.pauseOnHover) {
                      switchOn(elms, "mouseleave", PAUSE_FLAGS.HOVER, true);
                      switchOn(elms, "mouseenter", PAUSE_FLAGS.HOVER, false);
                    }

                    if (options.pauseOnFocus) {
                      switchOn(elms, "focusout", PAUSE_FLAGS.FOCUS, true);
                      switchOn(elms, "focusin", PAUSE_FLAGS.FOCUS, false);
                    }

                    if (Elements.play) {
                      Splide.on(
                        "click",
                        function () {
                          // Need to be removed a focus flag at first.
                          Autoplay.play(PAUSE_FLAGS.FOCUS);
                          Autoplay.play(PAUSE_FLAGS.MANUAL);
                        },
                        Elements.play
                      );
                    }

                    if (Elements.pause) {
                      switchOn([Elements.pause], "click", PAUSE_FLAGS.MANUAL, false);
                    }

                    Splide.on("move refresh", function () {
                      Autoplay.play();
                    }) // Rewind the timer.
                      .on("destroy", function () {
                        Autoplay.pause();
                      });
                  }
                  /**
                   * Play or pause on the given event.
                   *
                   * @param {Element[]} elms  - Elements.
                   * @param {string}    event - An event name or names.
                   * @param {number}    flag  - A pause flag defined on the top.
                   * @param {boolean}   play  - Determine whether to play or pause.
                   */

                  function switchOn(elms, event, flag, play) {
                    elms.forEach(function (elm) {
                      Splide.on(
                        event,
                        function () {
                          Autoplay[play ? "play" : "pause"](flag);
                        },
                        elm
                      );
                    });
                  }

                  return Autoplay;
                }; // CONCATENATED MODULE: ./src/js/components/cover/index.js
                /**
                 * The component for change an img element to background image of its wrapper.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                /**
                 * The component for change an img element to background image of its wrapper.
                 *
                 * @param {Splide} Splide     - A Splide instance.
                 * @param {Object} Components - An object containing components.
                 *
                 * @return {Object} - The component object.
                 */

                /* harmony default export */
                const cover = function (Splide, Components) {
                  /**
                   * Hold options.
                   *
                   * @type {Object}
                   */
                  var options = Splide.options;
                  /**
                   * Cover component object.
                   *
                   * @type {Object}
                   */

                  var Cover = {
                    /**
                     * Required only when "cover" option is true.
                     *
                     * @type {boolean}
                     */
                    required: options.cover,

                    /**
                     * Called when the component is mounted.
                     */
                    mount: function mount() {
                      Splide.on("lazyload:loaded", function (img) {
                        cover(img, false);
                      });
                      Splide.on("mounted updated refresh", function () {
                        return apply(false);
                      });
                    },

                    /**
                     * Destroy.
                     */
                    destroy: function destroy() {
                      apply(true);
                    },
                  };
                  /**
                   * Apply "cover" to all slides.
                   *
                   * @param {boolean} uncover - If true, "cover" will be clear.
                   */

                  function apply(uncover) {
                    Components.Elements.each(function (Slide) {
                      var img = child(Slide.slide, "IMG") || child(Slide.container, "IMG");

                      if (img && img.src) {
                        cover(img, uncover);
                      }
                    });
                  }
                  /**
                   * Set background image of the parent element, using source of the given image element.
                   *
                   * @param {Element} img     - An image element.
                   * @param {boolean} uncover - Reset "cover".
                   */

                  function cover(img, uncover) {
                    applyStyle(img.parentElement, {
                      background: uncover ? "" : 'center/cover no-repeat url("' + img.src + '")',
                    });
                    applyStyle(img, {
                      display: uncover ? "" : "none",
                    });
                  }

                  return Cover;
                }; // CONCATENATED MODULE: ./src/js/components/arrows/path.js
                /**
                 * Export vector path for an arrow.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                /**
                 * Namespace definition for SVG element.
                 *
                 * @type {string}
                 */
                var XML_NAME_SPACE = "http://www.w3.org/2000/svg";
                /**
                 * The arrow vector path.
                 *
                 * @type {number}
                 */

                var PATH = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z";
                /**
                 * SVG width and height.
                 *
                 * @type {number}
                 */

                var SIZE = 40; // CONCATENATED MODULE: ./src/js/components/arrows/index.js
                /**
                 * The component for appending prev/next arrows.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                /**
                 * The component for appending prev/next arrows.
                 *
                 * @param {Splide} Splide     - A Splide instance.
                 * @param {Object} Components - An object containing components.
                 * @param {string} name       - A component name as a lowercase string.
                 *
                 * @return {Object} - The component object.
                 */

                /* harmony default export */
                const arrows = function (Splide, Components, name) {
                  /**
                   * Previous arrow element.
                   *
                   * @type {Element|undefined}
                   */
                  var prev;
                  /**
                   * Next arrow element.
                   *
                   * @type {Element|undefined}
                   */

                  var next;
                  /**
                   * Store the class list.
                   *
                   * @type {Object}
                   */

                  var classes = Splide.classes;
                  /**
                   * Hold the root element.
                   *
                   * @type {Element}
                   */

                  var root = Splide.root;
                  /**
                   * Whether arrows are created programmatically or not.
                   *
                   * @type {boolean}
                   */

                  var created;
                  /**
                   * Hold the Elements component.
                   *
                   * @type {Object}
                   */

                  var Elements = Components.Elements;
                  /**
                   * Arrows component object.
                   *
                   * @type {Object}
                   */

                  var Arrows = {
                    /**
                     * Required when the arrows option is true.
                     *
                     * @type {boolean}
                     */
                    required: Splide.options.arrows,

                    /**
                     * Called when the component is mounted.
                     */
                    mount: function mount() {
                      // Attempt to get arrows from HTML source.
                      prev = Elements.arrows.prev;
                      next = Elements.arrows.next; // If arrows were not found in HTML, let's generate them.

                      if ((!prev || !next) && Splide.options.arrows) {
                        prev = createArrow(true);
                        next = createArrow(false);
                        created = true;
                        appendArrows();
                      }

                      if (prev && next) {
                        bind();
                      }

                      this.arrows = {
                        prev: prev,
                        next: next,
                      };
                    },

                    /**
                     * Called after all components are mounted.
                     */
                    mounted: function mounted() {
                      Splide.emit(name + ":mounted", prev, next);
                    },

                    /**
                     * Destroy.
                     */
                    destroy: function destroy() {
                      removeAttribute([prev, next], "disabled");

                      if (created) {
                        dom_remove(prev.parentElement);
                      }
                    },
                  };
                  /**
                   * Listen to native and custom events.
                   */

                  function bind() {
                    Splide.on(
                      "click",
                      function () {
                        Splide.go("<");
                      },
                      prev
                    )
                      .on(
                        "click",
                        function () {
                          Splide.go(">");
                        },
                        next
                      )
                      .on("mounted move updated refresh", updateDisabled);
                  }
                  /**
                   * Update a disabled attribute.
                   */

                  function updateDisabled() {
                    var _Components$Controlle = Components.Controller,
                      prevIndex = _Components$Controlle.prevIndex,
                      nextIndex = _Components$Controlle.nextIndex;
                    var isEnough = Splide.length > Splide.options.perPage || Splide.is(LOOP);
                    prev.disabled = prevIndex < 0 || !isEnough;
                    next.disabled = nextIndex < 0 || !isEnough;
                    Splide.emit(name + ":updated", prev, next, prevIndex, nextIndex);
                  }
                  /**
                   * Create a wrapper element and append arrows.
                   */

                  function appendArrows() {
                    var wrapper = create("div", {
                      class: classes.arrows,
                    });
                    append(wrapper, prev);
                    append(wrapper, next);
                    var slider = Elements.slider;
                    var parent = Splide.options.arrows === "slider" && slider ? slider : root;
                    before(wrapper, parent.firstElementChild);
                  }
                  /**
                   * Create an arrow element.
                   *
                   * @param {boolean} prev - Determine to create a prev arrow or next arrow.
                   *
                   * @return {Element} - A created arrow element.
                   */

                  function createArrow(prev) {
                    var arrow =
                      '<button class="' +
                      classes.arrow +
                      " " +
                      (prev ? classes.prev : classes.next) +
                      '" type="button">' +
                      ('<svg xmlns="' +
                        XML_NAME_SPACE +
                        '"\tviewBox="0 0 ' +
                        SIZE +
                        " " +
                        SIZE +
                        '"\twidth="' +
                        SIZE +
                        '"\theight="' +
                        SIZE +
                        '">') +
                      ('<path d="' + (Splide.options.arrowPath || PATH) + '" />');
                    return domify(arrow);
                  }

                  return Arrows;
                }; // CONCATENATED MODULE: ./src/js/components/pagination/index.js
                /**
                 * The component for handling pagination
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                /**
                 * The event name for updating some attributes of pagination nodes.
                 *
                 * @type {string}
                 */

                var ATTRIBUTES_UPDATE_EVENT = "move.page";
                /**
                 * The event name for recreating pagination.
                 *
                 * @type {string}
                 */

                var UPDATE_EVENT = "updated.page refresh.page";
                /**
                 * The component for handling pagination
                 *
                 * @param {Splide} Splide     - A Splide instance.
                 * @param {Object} Components - An object containing components.
                 * @param {string} name       - A component name as a lowercase string.
                 *
                 * @return {Object} - The component object.
                 */

                /* harmony default export */
                const pagination = function (Splide, Components, name) {
                  /**
                   * Store all data for pagination.
                   * - list: A list element.
                   * - items: An array that contains objects(li, button, index, page).
                   *
                   * @type {Object}
                   */
                  var data = {};
                  /**
                   * Hold the Elements component.
                   *
                   * @type {Object}
                   */

                  var Elements = Components.Elements;
                  /**
                   * Pagination component object.
                   *
                   * @type {Object}
                   */

                  var Pagination = {
                    /**
                     * Called when the component is mounted.
                     */
                    mount: function mount() {
                      var pagination = Splide.options.pagination;

                      if (pagination) {
                        data = createPagination();
                        var slider = Elements.slider;
                        var parent = pagination === "slider" && slider ? slider : Splide.root;
                        append(parent, data.list);
                        Splide.on(ATTRIBUTES_UPDATE_EVENT, updateAttributes);
                      }

                      Splide.off(UPDATE_EVENT).on(UPDATE_EVENT, function () {
                        Pagination.destroy();

                        if (Splide.options.pagination) {
                          Pagination.mount();
                          Pagination.mounted();
                        }
                      });
                    },

                    /**
                     * Called after all components are mounted.
                     */
                    mounted: function mounted() {
                      if (Splide.options.pagination) {
                        var index = Splide.index;
                        Splide.emit(name + ":mounted", data, this.getItem(index));
                        updateAttributes(index, -1);
                      }
                    },

                    /**
                     * Destroy the pagination.
                     * Be aware that node.remove() is not supported by IE.
                     */
                    destroy: function destroy() {
                      dom_remove(data.list);

                      if (data.items) {
                        data.items.forEach(function (item) {
                          Splide.off("click", item.button);
                        });
                      } // Do not remove UPDATE_EVENT to recreate pagination if needed.

                      Splide.off(ATTRIBUTES_UPDATE_EVENT);
                      data = {};
                    },

                    /**
                     * Return an item by index.
                     *
                     * @param {number} index - A slide index.
                     *
                     * @return {Object|undefined} - An item object on success or undefined on failure.
                     */
                    getItem: function getItem(index) {
                      return data.items[Components.Controller.toPage(index)];
                    },

                    /**
                     * Return object containing pagination data.
                     *
                     * @return {Object} - Pagination data including list and items.
                     */
                    get data() {
                      return data;
                    },
                  };
                  /**
                   * Update attributes.
                   *
                   * @param {number} index     - Active index.
                   * @param {number} prevIndex - Prev index.
                   */

                  function updateAttributes(index, prevIndex) {
                    var prev = Pagination.getItem(prevIndex);
                    var curr = Pagination.getItem(index);
                    var active = STATUS_CLASSES.active;

                    if (prev) {
                      removeClass(prev.button, active);
                    }

                    if (curr) {
                      addClass(curr.button, active);
                    }

                    Splide.emit(name + ":updated", data, prev, curr);
                  }
                  /**
                   * Create a wrapper and button elements.
                   *
                   * @return {Object} - An object contains all data.
                   */

                  function createPagination() {
                    var options = Splide.options;
                    var classes = Splide.classes;
                    var list = create("ul", {
                      class: classes.pagination,
                    });
                    var items = Elements.getSlides(false)
                      .filter(function (Slide) {
                        return options.focus !== false || Slide.index % options.perPage === 0;
                      })
                      .map(function (Slide, page) {
                        var li = create("li", {});
                        var button = create("button", {
                          class: classes.page,
                          type: "button",
                        });
                        append(li, button);
                        append(list, li);
                        Splide.on(
                          "click",
                          function () {
                            Splide.go(">" + page);
                          },
                          button
                        );
                        return {
                          li: li,
                          button: button,
                          page: page,
                          Slides: Elements.getSlidesByPage(page),
                        };
                      });
                    return {
                      list: list,
                      items: items,
                    };
                  }

                  return Pagination;
                }; // CONCATENATED MODULE: ./src/js/components/lazyload/index.js
                /**
                 * The component for loading slider images lazily.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                /**
                 * The name for a data attribute of src.
                 *
                 * @type {string}
                 */

                var SRC_DATA_NAME = "data-splide-lazy";
                /**
                 * The name for a data attribute of srcset.
                 *
                 * @type {string}
                 */

                var SRCSET_DATA_NAME = "data-splide-lazy-srcset";
                /**
                 * The component for loading slider images lazily.
                 *
                 * @param {Splide} Splide     - A Splide instance.
                 * @param {Object} Components - An object containing components.
                 * @param {string} name       - A component name as a lowercase string.
                 *
                 * @return {Object} - The component object.
                 */

                /* harmony default export */
                const lazyload = function (Splide, Components, name) {
                  /**
                   * Next index for sequential loading.
                   *
                   * @type {number}
                   */
                  var nextIndex;
                  /**
                   * Store objects containing an img element and a Slide object.
                   *
                   * @type {Object[]}
                   */

                  var images;
                  /**
                   * Store the options.
                   *
                   * @type {Object}
                   */

                  var options = Splide.options;
                  /**
                   * Whether to load images sequentially or not.
                   *
                   * @type {boolean}
                   */

                  var isSequential = options.lazyLoad === "sequential";
                  /**
                   * Lazyload component object.
                   *
                   * @type {Object}
                   */

                  var Lazyload = {
                    /**
                     * Mount only when the lazyload option is provided.
                     *
                     * @type {boolean}
                     */
                    required: options.lazyLoad,

                    /**
                     * Called when the component is mounted.
                     */
                    mount: function mount() {
                      Splide.on("mounted refresh", function () {
                        init();
                        Components.Elements.each(function (Slide) {
                          each(
                            Slide.slide.querySelectorAll("[" + SRC_DATA_NAME + "], [" + SRCSET_DATA_NAME + "]"),
                            function (img) {
                              if (!img.src && !img.srcset) {
                                images.push({
                                  img: img,
                                  Slide: Slide,
                                });
                                applyStyle(img, {
                                  display: "none",
                                });
                              }
                            }
                          );
                        });

                        if (isSequential) {
                          loadNext();
                        }
                      });

                      if (!isSequential) {
                        Splide.on("mounted refresh moved." + name, check);
                      }
                    },

                    /**
                     * Destroy.
                     */
                    destroy: init,
                  };
                  /**
                   * Initialize parameters.
                   */

                  function init() {
                    images = [];
                    nextIndex = 0;
                  }
                  /**
                   * Check how close each image is from the active slide and
                   * determine whether to start loading or not, according to the distance.
                   *
                   * @param {number} index - Current index.
                   */

                  function check(index) {
                    index = isNaN(index) ? Splide.index : index;
                    images = images.filter(function (image) {
                      if (image.Slide.isWithin(index, options.perPage * (options.preloadPages + 1))) {
                        load(image.img, image.Slide);
                        return false;
                      }

                      return true;
                    }); // Unbind if all images are loaded.

                    if (!images[0]) {
                      Splide.off("moved." + name);
                    }
                  }
                  /**
                   * Start loading an image.
                   * Creating a clone of the image element since setting src attribute directly to it
                   * often occurs 'hitch', blocking some other processes of a browser.
                   *
                   * @param {Element} img   - An image element.
                   * @param {Object}  Slide - A Slide object.
                   */

                  function load(img, Slide) {
                    addClass(Slide.slide, STATUS_CLASSES.loading);
                    var spinner = create("span", {
                      class: Splide.classes.spinner,
                    });
                    append(img.parentElement, spinner);

                    img.onload = function () {
                      loaded(img, spinner, Slide, false);
                    };

                    img.onerror = function () {
                      loaded(img, spinner, Slide, true);
                    };

                    setAttribute(img, "srcset", getAttribute(img, SRCSET_DATA_NAME) || "");
                    setAttribute(img, "src", getAttribute(img, SRC_DATA_NAME) || "");
                  }
                  /**
                   * Start loading a next image in images array.
                   */

                  function loadNext() {
                    if (nextIndex < images.length) {
                      var image = images[nextIndex];
                      load(image.img, image.Slide);
                    }

                    nextIndex++;
                  }
                  /**
                   * Called just after the image was loaded or loading was aborted by some error.
                   *
                   * @param {Element} img     - An image element.
                   * @param {Element} spinner - A spinner element.
                   * @param {Object}  Slide   - A Slide object.
                   * @param {boolean} error   - True if the image was loaded successfully or false on error.
                   */

                  function loaded(img, spinner, Slide, error) {
                    removeClass(Slide.slide, STATUS_CLASSES.loading);

                    if (!error) {
                      dom_remove(spinner);
                      applyStyle(img, {
                        display: "",
                      });
                      Splide.emit(name + ":loaded", img).emit("resize");
                    }

                    if (isSequential) {
                      loadNext();
                    }
                  }

                  return Lazyload;
                }; // CONCATENATED MODULE: ./src/js/constants/a11y.js
                /**
                 * Export aria attribute names.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                /**
                 * Attribute name for aria-current.
                 *
                 * @type {string}
                 */
                var ARIA_CURRENRT = "aria-current";
                /**
                 * Attribute name for aria-control.
                 *
                 * @type {string}
                 */

                var ARIA_CONTROLS = "aria-controls";
                /**
                 * Attribute name for aria-control.
                 *
                 * @type {string}
                 */

                var ARIA_LABEL = "aria-label";
                /**
                 * Attribute name for aria-labelledby.
                 *
                 * @type {string}
                 */

                var ARIA_LABELLEDBY = "aria-labelledby";
                /**
                 * Attribute name for aria-hidden.
                 *
                 * @type {string}
                 */

                var ARIA_HIDDEN = "aria-hidden";
                /**
                 * Attribute name for tab-index.
                 *
                 * @type {string}
                 */

                var TAB_INDEX = "tabindex"; // CONCATENATED MODULE: ./src/js/components/keyboard/index.js
                /**
                 * The component for controlling slides via keyboard.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                /**
                 * Map a key to a slide control.
                 *
                 * @type {Object}
                 */

                var KEY_MAP = {
                  ltr: {
                    ArrowLeft: "<",
                    ArrowRight: ">",
                    // For IE.
                    Left: "<",
                    Right: ">",
                  },
                  rtl: {
                    ArrowLeft: ">",
                    ArrowRight: "<",
                    // For IE.
                    Left: ">",
                    Right: "<",
                  },
                  ttb: {
                    ArrowUp: "<",
                    ArrowDown: ">",
                    // For IE.
                    Up: "<",
                    Down: ">",
                  },
                };
                /**
                 * The component for controlling slides via keyboard.
                 *
                 * @param {Splide} Splide - A Splide instance.
                 *
                 * @return {Object} - The component object.
                 */

                /* harmony default export */
                const keyboard = function (Splide) {
                  /**
                   * Hold the target element.
                   *
                   * @type {Element|Document|undefined}
                   */
                  var target;
                  return {
                    /**
                     * Called when the component is mounted.
                     */
                    mount: function mount() {
                      Splide.on("mounted updated", function () {
                        var options = Splide.options;
                        var root = Splide.root;
                        var map = KEY_MAP[options.direction];
                        var keyboard = options.keyboard;

                        if (target) {
                          Splide.off("keydown", target);
                          removeAttribute(root, TAB_INDEX);
                        }

                        if (keyboard) {
                          if (keyboard === "focused") {
                            target = root;
                            setAttribute(root, TAB_INDEX, 0);
                          } else {
                            target = document;
                          }

                          Splide.on(
                            "keydown",
                            function (e) {
                              if (map[e.key]) {
                                Splide.go(map[e.key]);
                              }
                            },
                            target
                          );
                        }
                      });
                    },
                  };
                }; // CONCATENATED MODULE: ./src/js/components/a11y/index.js
                /**
                 * The component for enhancing accessibility.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                /**
                 * The component for enhancing accessibility.
                 *
                 * @param {Splide} Splide     - A Splide instance.
                 * @param {Object} Components - An object containing components.
                 *
                 * @return {Object} - The component object.
                 */

                /* harmony default export */
                const a11y = function (Splide, Components) {
                  /**
                   * Hold a i18n object.
                   *
                   * @type {Object}
                   */
                  var i18n = Splide.i18n;
                  /**
                   * Hold the Elements component.
                   *
                   * @type {Object}
                   */

                  var Elements = Components.Elements;
                  /**
                   * All attributes related with A11y.
                   *
                   * @type {string[]}
                   */

                  var allAttributes = [ARIA_HIDDEN, TAB_INDEX, ARIA_CONTROLS, ARIA_LABEL, ARIA_CURRENRT, "role"];
                  /**
                   * A11y component object.
                   *
                   * @type {Object}
                   */

                  var A11y = {
                    /**
                     * Required only when the accessibility option is true.
                     *
                     * @type {boolean}
                     */
                    required: Splide.options.accessibility,

                    /**
                     * Called when the component is mounted.
                     */
                    mount: function mount() {
                      Splide.on("visible", function (Slide) {
                        updateSlide(Slide.slide, true);
                      })
                        .on("hidden", function (Slide) {
                          updateSlide(Slide.slide, false);
                        })
                        .on("arrows:mounted", initArrows)
                        .on("arrows:updated", updateArrows)
                        .on("pagination:mounted", initPagination)
                        .on("pagination:updated", updatePagination)
                        .on("refresh", function () {
                          removeAttribute(Components.Clones.clones, allAttributes);
                        });

                      if (Splide.options.isNavigation) {
                        Splide.on("navigation:mounted navigation:updated", initNavigation)
                          .on("active", function (Slide) {
                            updateNavigation(Slide, true);
                          })
                          .on("inactive", function (Slide) {
                            updateNavigation(Slide, false);
                          });
                      }

                      initAutoplay();
                    },

                    /**
                     * Destroy.
                     */
                    destroy: function destroy() {
                      var Arrows = Components.Arrows;
                      var arrows = Arrows ? Arrows.arrows : {};
                      removeAttribute(
                        Elements.slides.concat([arrows.prev, arrows.next, Elements.play, Elements.pause]),
                        allAttributes
                      );
                    },
                  };
                  /**
                   * Update slide attributes when it gets visible or hidden.
                   *
                   * @param {Element} slide   - A slide element.
                   * @param {Boolean} visible - True when the slide gets visible, or false when hidden.
                   */

                  function updateSlide(slide, visible) {
                    setAttribute(slide, ARIA_HIDDEN, !visible);

                    if (Splide.options.slideFocus) {
                      setAttribute(slide, TAB_INDEX, visible ? 0 : -1);
                    }
                  }
                  /**
                   * Initialize arrows if they are available.
                   * Append screen reader elements and add aria-controls attribute.
                   *
                   * @param {Element} prev - Previous arrow element.
                   * @param {Element} next - Next arrow element.
                   */

                  function initArrows(prev, next) {
                    var controls = Elements.track.id;
                    setAttribute(prev, ARIA_CONTROLS, controls);
                    setAttribute(next, ARIA_CONTROLS, controls);
                  }
                  /**
                   * Update arrow attributes.
                   *
                   * @param {Element} prev      - Previous arrow element.
                   * @param {Element} next      - Next arrow element.
                   * @param {number}  prevIndex - Previous slide index or -1 when there is no precede slide.
                   * @param {number}  nextIndex - Next slide index or -1 when there is no next slide.
                   */

                  function updateArrows(prev, next, prevIndex, nextIndex) {
                    var index = Splide.index;
                    var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
                    var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
                    setAttribute(prev, ARIA_LABEL, prevLabel);
                    setAttribute(next, ARIA_LABEL, nextLabel);
                  }
                  /**
                   * Initialize pagination if it's available.
                   * Append a screen reader element and add aria-controls/label attribute to each item.
                   *
                   * @param {Object} data       - Data object containing all items.
                   * @param {Object} activeItem - An initial active item.
                   */

                  function initPagination(data, activeItem) {
                    if (activeItem) {
                      setAttribute(activeItem.button, ARIA_CURRENRT, true);
                    }

                    data.items.forEach(function (item) {
                      var options = Splide.options;
                      var text = options.focus === false && options.perPage > 1 ? i18n.pageX : i18n.slideX;
                      var label = sprintf(text, item.page + 1);
                      var button = item.button;
                      var controls = item.Slides.map(function (Slide) {
                        return Slide.slide.id;
                      });
                      setAttribute(button, ARIA_CONTROLS, controls.join(" "));
                      setAttribute(button, ARIA_LABEL, label);
                    });
                  }
                  /**
                   * Update pagination attributes.
                   *
                   * @param {Object}  data - Data object containing all items.
                   * @param {Element} prev - A previous active element.
                   * @param {Element} curr - A current active element.
                   */

                  function updatePagination(data, prev, curr) {
                    if (prev) {
                      removeAttribute(prev.button, ARIA_CURRENRT);
                    }

                    if (curr) {
                      setAttribute(curr.button, ARIA_CURRENRT, true);
                    }
                  }
                  /**
                   * Initialize autoplay buttons.
                   */

                  function initAutoplay() {
                    ["play", "pause"].forEach(function (name) {
                      var elm = Elements[name];

                      if (elm) {
                        if (!isButton(elm)) {
                          setAttribute(elm, "role", "button");
                        }

                        setAttribute(elm, ARIA_CONTROLS, Elements.track.id);
                        setAttribute(elm, ARIA_LABEL, i18n[name]);
                      }
                    });
                  }
                  /**
                   * Initialize navigation slider.
                   * Add button role, aria-label, aria-controls to slide elements and append screen reader text to them.
                   *
                   * @param {Splide} main - A main Splide instance.
                   */

                  function initNavigation(main) {
                    Elements.each(function (Slide) {
                      var slide = Slide.slide;
                      var realIndex = Slide.realIndex;

                      if (!isButton(slide)) {
                        setAttribute(slide, "role", "button");
                      }

                      var slideIndex = realIndex > -1 ? realIndex : Slide.index;
                      var label = sprintf(i18n.slideX, slideIndex + 1);
                      var mainSlide = main.Components.Elements.getSlide(slideIndex);
                      setAttribute(slide, ARIA_LABEL, label);

                      if (mainSlide) {
                        setAttribute(slide, ARIA_CONTROLS, mainSlide.slide.id);
                      }
                    });
                  }
                  /**
                   * Update navigation attributes.
                   *
                   * @param {Object}  Slide  - A target Slide object.
                   * @param {boolean} active - True if the slide is active or false if inactive.
                   */

                  function updateNavigation(_ref, active) {
                    var slide = _ref.slide;

                    if (active) {
                      setAttribute(slide, ARIA_CURRENRT, true);
                    } else {
                      removeAttribute(slide, ARIA_CURRENRT);
                    }
                  }
                  /**
                   * Check if the given element is button or not.
                   *
                   * @param {Element} elm - An element to be checked.
                   *
                   * @return {boolean} - True if the given element is button.
                   */

                  function isButton(elm) {
                    return elm.tagName === "BUTTON";
                  }

                  return A11y;
                }; // CONCATENATED MODULE: ./src/js/components/sync/index.js
                /**
                 * The component for synchronizing a slider with another.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                /**
                 * The event name for sync.
                 *
                 * @type {string}
                 */

                var SYNC_EVENT = "move.sync";
                /**
                 * The event names for click navigation.
                 * @type {string}
                 */

                var CLICK_EVENTS = "mouseup touchend";
                /**
                 * The keys for triggering the navigation button.
                 *
                 * @type {String[]}
                 */

                var TRIGGER_KEYS = [" ", "Enter", "Spacebar"];
                /**
                 * The component for synchronizing a slider with another.
                 *
                 * @param {Splide} Splide - A Splide instance.
                 *
                 * @return {Object} - The component object.
                 */

                /* harmony default export */
                const sync = function (Splide) {
                  /**
                   * Keep the sibling Splide instance.
                   *
                   * @type {Splide}
                   */
                  var sibling = Splide.sibling;
                  /**
                   * Whether the sibling slider is navigation or not.
                   *
                   * @type {Splide|boolean}
                   */

                  var isNavigation = sibling && sibling.options.isNavigation;
                  /**
                   * Layout component object.
                   *
                   * @type {Object}
                   */

                  var Sync = {
                    /**
                     * Required only when the sub slider is available.
                     *
                     * @type {boolean}
                     */
                    required: !!sibling,

                    /**
                     * Called when the component is mounted.
                     */
                    mount: function mount() {
                      syncMain();
                      syncSibling();

                      if (isNavigation) {
                        bind();
                        Splide.on("refresh", function () {
                          setTimeout(function () {
                            bind();
                            sibling.emit("navigation:updated", Splide);
                          });
                        });
                      }
                    },

                    /**
                     * Called after all components are mounted.
                     */
                    mounted: function mounted() {
                      if (isNavigation) {
                        sibling.emit("navigation:mounted", Splide);
                      }
                    },
                  };
                  /**
                   * Listen the primary slider event to move secondary one.
                   * Must unbind a handler at first to avoid infinite loop.
                   */

                  function syncMain() {
                    Splide.on(SYNC_EVENT, function (newIndex, prevIndex, destIndex) {
                      sibling.off(SYNC_EVENT).go(sibling.is(LOOP) ? destIndex : newIndex, false);
                      syncSibling();
                    });
                  }
                  /**
                   * Listen the secondary slider event to move primary one.
                   * Must unbind a handler at first to avoid infinite loop.
                   */

                  function syncSibling() {
                    sibling.on(SYNC_EVENT, function (newIndex, prevIndex, destIndex) {
                      Splide.off(SYNC_EVENT).go(Splide.is(LOOP) ? destIndex : newIndex, false);
                      syncMain();
                    });
                  }
                  /**
                   * Listen some events on each slide.
                   */

                  function bind() {
                    sibling.Components.Elements.each(function (_ref) {
                      var slide = _ref.slide,
                        index = _ref.index;

                      /*
                       * Listen mouseup and touchend events to handle click.
                       */
                      Splide.off(CLICK_EVENTS, slide).on(
                        CLICK_EVENTS,
                        function (e) {
                          // Ignore a middle or right click.
                          if (!e.button || e.button === 0) {
                            moveSibling(index);
                          }
                        },
                        slide
                      );
                      /*
                       * Subscribe keyup to handle Enter and Space key.
                       * Note that Array.includes is not supported by IE.
                       */

                      Splide.off("keyup", slide).on(
                        "keyup",
                        function (e) {
                          if (TRIGGER_KEYS.indexOf(e.key) > -1) {
                            e.preventDefault();
                            moveSibling(index);
                          }
                        },
                        slide,
                        {
                          passive: false,
                        }
                      );
                    });
                  }
                  /**
                   * Move the sibling to the given index.
                   * Need to check "IDLE" status because slides can be moving by Drag component.
                   *
                   * @param {number} index - Target index.
                   */

                  function moveSibling(index) {
                    if (Splide.State.is(IDLE)) {
                      sibling.go(index);
                    }
                  }

                  return Sync;
                }; // CONCATENATED MODULE: ./src/js/components/breakpoints/index.js
                /**
                 * The component for updating options according to a current window width.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                /**
                 * Interval time for throttle.
                 *
                 * @type {number}
                 */

                var THROTTLE = 50;
                /**
                 * The component for updating options according to a current window width.
                 *
                 * @param {Splide} Splide - A Splide instance.
                 *
                 * @return {Object} - The component object.
                 */

                /* harmony default export */
                const breakpoints = function (Splide) {
                  /**
                   * Store breakpoints.
                   *
                   * @type {Object|boolean}
                   */
                  var breakpoints = Splide.options.breakpoints;
                  /**
                   * The check function whose frequency of call is reduced.
                   *
                   * @type {Function}
                   */

                  var throttledCheck = throttle(check, THROTTLE);
                  /**
                   * Keep initial options.
                   *
                   * @type {Object}
                   */

                  var initialOptions;
                  /**
                   * An array containing objects of point and MediaQueryList.
                   *
                   * @type {Object[]}
                   */

                  var map = [];
                  /**
                   * Hold the previous breakpoint.
                   *
                   * @type {number|undefined}
                   */

                  var prevPoint;
                  /**
                   * Breakpoints component object.
                   *
                   * @type {Object}
                   */

                  var Breakpoints = {
                    /**
                     * Required only when the breakpoints definition is provided and browser supports matchMedia.
                     *
                     * @type {boolean}
                     */
                    required: breakpoints && matchMedia,

                    /**
                     * Called when the component is mounted.
                     */
                    mount: function mount() {
                      map = Object.keys(breakpoints)
                        .sort(function (n, m) {
                          return +n - +m;
                        })
                        .map(function (point) {
                          return {
                            point: point,
                            mql: matchMedia("(max-width:" + point + "px)"),
                          };
                        });
                      /*
                       * To keep monitoring resize event after destruction without "completely",
                       * use native addEventListener instead of Splide.on.
                       */

                      this.destroy(true);
                      addEventListener("resize", throttledCheck); // Keep initial options to apply them when no breakpoint matches.

                      initialOptions = Splide.options;
                      check();
                    },

                    /**
                     * Destroy.
                     *
                     * @param {boolean} completely - Whether to destroy Splide completely.
                     */
                    destroy: function destroy(completely) {
                      if (completely) {
                        removeEventListener("resize", throttledCheck);
                      }
                    },
                  };
                  /**
                   * Check the breakpoint.
                   */

                  function check() {
                    var point = getPoint();

                    if (point !== prevPoint) {
                      prevPoint = point;
                      var State = Splide.State;
                      var options = breakpoints[point] || initialOptions;
                      var destroy = options.destroy;

                      if (destroy) {
                        Splide.options = initialOptions;
                        Splide.destroy(destroy === "completely");
                      } else {
                        if (State.is(DESTROYED)) {
                          Splide.mount();
                        }

                        Splide.options = options;
                      }
                    }
                  }
                  /**
                   * Return the breakpoint matching current window width.
                   * Note that Array.prototype.find is not supported by IE.
                   *
                   * @return {number|string} - A breakpoint as number or string. -1 if no point matches.
                   */

                  function getPoint() {
                    var item = map.filter(function (item) {
                      return item.mql.matches;
                    })[0];
                    return item ? item.point : -1;
                  }

                  return Breakpoints;
                }; // CONCATENATED MODULE: ./src/js/components/index.js
                /**
                 * Export components.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                var COMPLETE = {
                  Options: options,
                  Breakpoints: breakpoints,
                  Controller: controller,
                  Elements: components_elements,
                  Track: track,
                  Clones: clones,
                  Layout: layout,
                  Drag: drag,
                  Click: click,
                  Autoplay: autoplay,
                  Cover: cover,
                  Arrows: arrows,
                  Pagination: pagination,
                  LazyLoad: lazyload,
                  Keyboard: keyboard,
                  Sync: sync,
                  A11y: a11y,
                };
                var LIGHT = {
                  Options: options,
                  Controller: controller,
                  Elements: components_elements,
                  Track: track,
                  Clones: clones,
                  Layout: layout,
                  Drag: drag,
                  Click: click,
                  Arrows: arrows,
                  Pagination: pagination,
                  A11y: a11y,
                }; // CONCATENATED MODULE: ./build/module/module.js
                function _inheritsLoose(subClass, superClass) {
                  subClass.prototype = Object.create(superClass.prototype);
                  subClass.prototype.constructor = subClass;
                  subClass.__proto__ = superClass;
                }

                /**
                 * Export Splide class for import.
                 *
                 * @author    Naotoshi Fujita
                 * @copyright Naotoshi Fujita. All rights reserved.
                 */

                /**
                 * Export Splide class for import from other projects.
                 */

                var module_Splide = /*#__PURE__*/ (function (_Core) {
                  _inheritsLoose(Splide, _Core);

                  function Splide(root, options) {
                    return _Core.call(this, root, options, COMPLETE) || this;
                  }

                  return Splide;
                })(Splide);

                /***/
              },

            /******/
          };
          /************************************************************************/
          /******/ // The module cache
          /******/
          var __webpack_module_cache__ = {};
          /******/
          /******/ // The require function
          /******/
          function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/
            if (__webpack_module_cache__[moduleId]) {
              /******/
              return __webpack_module_cache__[moduleId].exports;
              /******/
            }
            /******/ // Create a new module (and put it into the cache)
            /******/
            var module = (__webpack_module_cache__[moduleId] = {
              /******/ // no module.id needed
              /******/ // no module.loaded needed
              /******/
              exports: {},
              /******/
            });
            /******/
            /******/ // Execute the module function
            /******/
            __webpack_modules__[moduleId](module, module.exports, __webpack_require__);
            /******/
            /******/ // Return the exports of the module
            /******/
            return module.exports;
            /******/
          }
          /******/
          /************************************************************************/
          /******/
          /* webpack/runtime/define property getters */
          /******/
          (() => {
            /******/ // define getter functions for harmony exports
            /******/
            __webpack_require__.d = (exports, definition) => {
              /******/
              for (var key in definition) {
                /******/
                if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
                  /******/
                  Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key],
                  });
                  /******/
                }
                /******/
              }
              /******/
            };
            /******/
          })();
          /******/
          /******/
          /* webpack/runtime/hasOwnProperty shorthand */
          /******/
          (() => {
            /******/
            __webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
            /******/
          })();
          /******/
          /******/
          /* webpack/runtime/make namespace object */
          /******/
          (() => {
            /******/ // define __esModule on exports
            /******/
            __webpack_require__.r = (exports) => {
              /******/
              if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
                /******/
                Object.defineProperty(exports, Symbol.toStringTag, {
                  value: "Module",
                });
                /******/
              }
              /******/
              Object.defineProperty(exports, "__esModule", {
                value: true,
              });
              /******/
            };
            /******/
          })();
          /******/
          /************************************************************************/
          /******/ // module exports must be returned from runtime so entry inlining is disabled
          /******/ // startup
          /******/ // Load entry module and return exports
          /******/
          return __webpack_require__(311);
          /******/
        })();
      });

      /***/
    },
    /* 5 */
    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* WEBPACK VAR INJECTION */
      (function (global) {
        function e(e, t, r) {
          return (
            t in e
              ? Object.defineProperty(e, t, {
                  value: r,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0,
                })
              : (e[t] = r),
            e
          );
        }

        function t(e, t) {
          var r = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t &&
              (n = n.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })),
              r.push.apply(r, n);
          }
          return r;
        }
        "undefined" != typeof globalThis
          ? globalThis
          : "undefined" != typeof window
          ? window
          : "undefined" != typeof global
          ? global
          : "undefined" != typeof self && self;
        var r,
          n =
            ((function (e, t) {
              e.exports = (function () {
                var e =
                  /^v?(?:\d+)(\.(?:[x*]|\d+)(\.(?:[x*]|\d+)(\.(?:[x*]|\d+))?(?:-[\da-z\-]+(?:\.[\da-z\-]+)*)?(?:\+[\da-z\-]+(?:\.[\da-z\-]+)*)?)?)?$/i;

                function t(e) {
                  var t,
                    r = e.replace(/^v/, "").replace(/\+.*$/, ""),
                    n = -1 === (t = r).indexOf("-") ? t.length : t.indexOf("-"),
                    i = r.substring(0, n).split(".");
                  return i.push(r.substring(n + 1)), i;
                }

                function r(e) {
                  return isNaN(Number(e)) ? e : Number(e);
                }

                function n(t) {
                  if ("string" != typeof t) throw new TypeError("Invalid argument expected string");
                  if (!e.test(t)) throw new Error("Invalid argument not valid semver ('" + t + "' received)");
                }

                function i(e, i) {
                  [e, i].forEach(n);
                  for (var s = t(e), o = t(i), a = 0; a < Math.max(s.length - 1, o.length - 1); a++) {
                    var c = parseInt(s[a] || 0, 10),
                      u = parseInt(o[a] || 0, 10);
                    if (c > u) return 1;
                    if (u > c) return -1;
                  }
                  var f = s[s.length - 1],
                    h = o[o.length - 1];
                  if (f && h) {
                    var l = f.split(".").map(r),
                      p = h.split(".").map(r);
                    for (a = 0; a < Math.max(l.length, p.length); a++) {
                      if (void 0 === l[a] || ("string" == typeof p[a] && "number" == typeof l[a])) return -1;
                      if (void 0 === p[a] || ("string" == typeof l[a] && "number" == typeof p[a])) return 1;
                      if (l[a] > p[a]) return 1;
                      if (p[a] > l[a]) return -1;
                    }
                  } else if (f || h) return f ? -1 : 1;
                  return 0;
                }
                var s = [">", ">=", "=", "<", "<="],
                  o = {
                    ">": [1],
                    ">=": [0, 1],
                    "=": [0],
                    "<=": [-1, 0],
                    "<": [-1],
                  };
                return (
                  (i.validate = function (t) {
                    return "string" == typeof t && e.test(t);
                  }),
                  (i.compare = function (e, t, r) {
                    !(function (e) {
                      if ("string" != typeof e)
                        throw new TypeError("Invalid operator type, expected string but got " + typeof e);
                      if (-1 === s.indexOf(e)) throw new TypeError("Invalid operator, expected one of " + s.join("|"));
                    })(r);
                    var n = i(e, t);
                    return o[r].indexOf(n) > -1;
                  }),
                  i
                );
              })();
            })(
              (r = {
                exports: {},
              })
            ),
            r.exports),
          i = function (e) {
            return null == e;
          },
          s = function (e) {
            return Object.getPrototypeOf(e) === Object.prototype;
          },
          o = function (e) {
            return Array.isArray(e);
          },
          a = function (e, t) {
            return (
              Object.entries(e).forEach(function (r) {
                var n = r[0],
                  c = r[1];
                i(c) || (!s(c) && !o(c)) || (e[n] = a(c, t));
              }),
              new Proxy(e, {
                get: function (e, r, n) {
                  return t.get(e, r, n);
                },
                set: function (e, r, n, c) {
                  i(n) || (!s(n) && !o(n)) || (n = a(n, t));
                  var u = e[r];
                  return (
                    (e[r] = n), i(u) || i(u.__watchers) || (e[r].__watchers = u.__watchers), t.set(e, r, e[r], c), !0
                  );
                },
              })
            );
          },
          c = {
            stores: {},
            persistenceDriver: window.localStorage,
            persisted: [],
            subscribers: [],
            pendingWatchers: {},
            disableReactivity: !1,
            startingCallbacks: [],
            startedCallbacks: [],
            hasStarted: !1,
            start: function () {
              var e = this;
              this.startingCallbacks.forEach(function (e) {
                return e();
              }),
                this.attach(),
                (this.stores = a(this.stores, {
                  get: function (t, r, n) {
                    return Object.is(n, e.stores) && ["get", "set", "toggle", "call", "clear"].includes(r)
                      ? e[r].bind(e)
                      : Reflect.get(t, r, n);
                  },
                  set: function (t, r, n, i) {
                    if (!e.disableReactivity) {
                      e.updateSubscribers(), e.runWatchers(t, r, n, i), (e.disableReactivity = !0);
                      try {
                        e.persisted.forEach(e.updateLocalStorage.bind(e));
                      } catch (e) {}
                      e.disableReactivity = !1;
                    }
                  },
                })),
                (this.hasStarted = !0),
                (this.disableReactivity = !0),
                Object.entries(this.pendingWatchers).forEach(function (t) {
                  var r = t[0];
                  t[1].forEach(function (t) {
                    return e.watch(r, t);
                  });
                }),
                (this.disableReactivity = !1),
                this.startedCallbacks.forEach(function (e) {
                  return e();
                });
            },
            starting: function (e) {
              this.startingCallbacks.push(e);
            },
            started: function (e) {
              this.startedCallbacks.push(e);
            },
            attach: function () {
              if (
                !(
                  navigator.userAgent.includes("Node.js") ||
                  navigator.userAgent.includes("jsdom") ||
                  (window.Alpine && n.compare(window.Alpine.version, "2.7.0", ">="))
                )
              )
                throw new Error("[Spruce] You must be using Alpine >= 2.5.0 to use Spruce.");
              var e = this;
              window.Alpine.addMagicProperty("store", function (t) {
                return e.subscribe(t), e.stores;
              });
            },
            store: function (e, t, r) {
              if ((void 0 === r && (r = !1), "function" == typeof t && (t = t()), r))
                try {
                  (this.stores[e] = this.retrieveFromLocalStorage(
                    e,
                    ((n = {}),
                    Object.entries(t)
                      .filter(function (e) {
                        return "function" == typeof e[1];
                      })
                      .forEach(function (e) {
                        return (n[e[0]] = e[1]);
                      }),
                    n)
                  )),
                    this.persisted.includes(e) || this.persisted.push(e);
                } catch (e) {}
              var n;
              return this.stores[e] || (this.stores[e] = t), this.stores[e];
            },
            reset: function (e, t) {
              void 0 !== this.stores[e] && (this.stores[e] = t);
            },
            subscribe: function (e) {
              return this.subscribers.includes(e) || this.subscribers.push(e), this.stores;
            },
            updateSubscribers: function () {
              this.subscribers
                .filter(function (e) {
                  return !!e.__x;
                })
                .forEach(function (e) {
                  e.__x.updateElements(e);
                });
            },
            retrieveFromLocalStorage: function (e, t) {
              void 0 === t && (t = {});
              var r = this.persistenceDriver.getItem("__spruce:" + e);
              if (!r) return null;
              var n = JSON.parse(r);
              return "object" == typeof n && (delete (n = Object.assign(t, n)).__watchers, delete n.__key_name), n;
            },
            updateLocalStorage: function (r) {
              var n = (function (r) {
                for (var n = 1; n < arguments.length; n++) {
                  var i = null != arguments[n] ? arguments[n] : {};
                  n % 2
                    ? t(Object(i), !0).forEach(function (t) {
                        e(r, t, i[t]);
                      })
                    : Object.getOwnPropertyDescriptors
                    ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(i))
                    : t(Object(i)).forEach(function (e) {
                        Object.defineProperty(r, e, Object.getOwnPropertyDescriptor(i, e));
                      });
                }
                return r;
              })({}, this.store(r));
              delete n.__watchers,
                delete n.__key_name,
                this.persistenceDriver.setItem("__spruce:" + r, JSON.stringify(this.store(r)));
            },
            get: function (e, t) {
              return (
                void 0 === t && (t = this.stores),
                e.split(".").reduce(function (e, t) {
                  return e[t];
                }, t)
              );
            },
            set: function (e, t, r) {
              return (
                void 0 === r && (r = this.stores),
                o(e) || (e = e.split(".")),
                1 === e.length
                  ? (r[e[0]] = t)
                  : r[e[0]]
                  ? this.set(e.slice(1), t, r[e[0]])
                  : ((r[e[0]] = {}), this.set(e.slice(1), t, r[e[0]]))
              );
            },
            toggle: function (e) {
              return this.set(e, !this.get(e));
            },
            call: function (e) {
              for (var t = [], r = arguments.length - 1; r-- > 0; ) t[r] = arguments[r + 1];
              return this.get(e).apply(void 0, t);
            },
            clear: function (e) {
              return this.persistenceDriver.removeItem("__spruce:" + e);
            },
            watch: function (e, t) {
              var r = this;
              if (!this.hasStarted)
                return (
                  this.pendingWatchers[e] || (this.pendingWatchers[e] = []),
                  this.pendingWatchers[e].push(t),
                  [
                    function () {
                      return r.unwatch(e, t);
                    },
                  ]
                );
              var n = e.split("."),
                a = n.reduce(function (e, t) {
                  var r = e[t];
                  return i(r) || (!s(r) && !o(r)) ? e : r;
                }, this.stores),
                c = Object.is(a, this.get(e)) ? "__self" : n[n.length - 1];
              return (
                a.__watchers || (a.__watchers = new Map()),
                a.__watchers.has(c) || a.__watchers.set(c, new Set()),
                a.__watchers.get(c).add(t),
                [
                  function () {
                    return r.unwatch(e, t);
                  },
                ]
              );
            },
            unwatch: function (e, t) {
              var r = e.split("."),
                n = r.reduce(function (e, t) {
                  var r = e[t];
                  return i(r) || (!s(r) && !o(r)) ? e : r;
                }, this.stores),
                a = Object.is(n, this.get(e)) ? "__self" : r[r.length - 1],
                c = n.__watchers;
              c.has(a) && c.get(a).delete(t);
            },
            watchers: function (e) {
              var t = e.split("."),
                r = t.reduce(function (e, t) {
                  var r = e[t];
                  return i(r) || (!s(r) && !o(r)) ? e : r;
                }, this.stores),
                n = Object.is(r, this.get(e)) ? "__self" : t[t.length - 1];
              return r.__watchers ? r.__watchers.get(n) : {};
            },
            runWatchers: function (e, t, r) {
              e.__watchers &&
                (e.__watchers.has(t) &&
                  e.__watchers.get(t).forEach(function (e) {
                    return e(r);
                  }),
                e.__watchers.has("__self") &&
                  e.__watchers.get("__self").forEach(function (e) {
                    return e(r, t);
                  }));
            },
            persistUsing: function (e) {
              if (
                (this.persisted.length > 0 &&
                  console.warn(
                    "[Spruce] You have already initialised a persisted store. Changing the driver may cause issues."
                  ),
                "function" != typeof e.getItem)
              )
                throw new Error("[Spruce] The persistence driver must have a `getItem(key)` method.");
              if ("function" != typeof e.setItem)
                throw new Error("[Spruce] The persistence driver must have a `setItem(key, value)` method.");
              if ("function" != typeof e.removeItem)
                throw new Error("[Spruce] The persistence driver must have a `removeItem(name)` method.");
              this.persistenceDriver = e;
            },
          };
        window.Spruce = c;
        var u =
          window.deferLoadingAlpine ||
          function (e) {
            e();
          };
        window.deferLoadingAlpine = function (e) {
          window.Spruce.start(), u(e);
        }; /* unused harmony default export */
        var _unused_webpack_default_export = c;
        //# sourceMappingURL=spruce.module.js.map

        /* WEBPACK VAR INJECTION */
      }).call(this, __webpack_require__(6));

      /***/
    },
    /* 6 */
    /***/
    function (module, exports) {
      var g;

      // This works in non-strict mode
      g = (function () {
        return this;
      })();

      try {
        // This works if eval is allowed (see CSP)
        g = g || new Function("return this")();
      } catch (e) {
        // This works if the window reference is available
        if (typeof window === "object") g = window;
      }

      // g can still be undefined, but nothing to do about it...
      // We return undefined, instead of nothing here, so it's
      // easier to handle this case. if(!global) { ...}

      module.exports = g;

      /***/
    },
    /* 7 */
    /***/
    function (module, exports) {
      /**
       * Checks if `value` is the
       * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
       * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an object, else `false`.
       * @example
       *
       * _.isObject({});
       * // => true
       *
       * _.isObject([1, 2, 3]);
       * // => true
       *
       * _.isObject(_.noop);
       * // => true
       *
       * _.isObject(null);
       * // => false
       */
      function isObject(value) {
        var type = typeof value;
        return value != null && (type == "object" || type == "function");
      }

      module.exports = isObject;

      /***/
    },
    /* 8 */
    /***/
    function (module, exports, __webpack_require__) {
      var freeGlobal = __webpack_require__(24);

      /** Detect free variable `self`. */
      var freeSelf = typeof self == "object" && self && self.Object === Object && self;

      /** Used as a reference to the global object. */
      var root = freeGlobal || freeSelf || Function("return this")();

      module.exports = root;

      /***/
    },
    /* 9 */
    /***/
    function (module, exports, __webpack_require__) {
      var root = __webpack_require__(8);

      /** Built-in value references. */
      var Symbol = root.Symbol;

      module.exports = Symbol;

      /***/
    },
    /* 10 */
    /***/
    function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
      (function (window, factory) {
        if (!window) {
          return;
        }
        var globalInstall = function (initialEvent) {
          factory(window.lazySizes, initialEvent);
          window.removeEventListener("lazyunveilread", globalInstall, true);
        };

        factory = factory.bind(null, window, window.document);

        if (true && module.exports) {
          factory(__webpack_require__(0));
        } else if (true) {
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)]),
          (__WEBPACK_AMD_DEFINE_FACTORY__ = factory),
          (__WEBPACK_AMD_DEFINE_RESULT__ =
            typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function"
              ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)
              : __WEBPACK_AMD_DEFINE_FACTORY__),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {
        }
      })(typeof window != "undefined" ? window : 0, function (window, document, lazySizes, initialEvent) {
        "use strict";
        var cloneElementClass;
        var style = document.createElement("a").style;
        var fitSupport = "objectFit" in style;
        var positionSupport = fitSupport && "objectPosition" in style;
        var regCssFit = /object-fit["']*\s*:\s*["']*(contain|cover)/;
        var regCssPosition = /object-position["']*\s*:\s*["']*(.+?)(?=($|,|'|"|;))/;
        var blankSrc = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
        var regBgUrlEscape = /\(|\)|'/;
        var positionDefaults = {
          "center": "center",
          "50% 50%": "center",
        };

        function getObject(element) {
          var css = getComputedStyle(element, null) || {};
          var content = css.fontFamily || "";
          var objectFit = content.match(regCssFit) || "";
          var objectPosition = (objectFit && content.match(regCssPosition)) || "";

          if (objectPosition) {
            objectPosition = objectPosition[1];
          }

          return {
            fit: (objectFit && objectFit[1]) || "",
            position: positionDefaults[objectPosition] || objectPosition || "center",
          };
        }

        function generateStyleClass() {
          if (cloneElementClass) {
            return;
          }

          var styleElement = document.createElement("style");

          cloneElementClass = lazySizes.cfg.objectFitClass || "lazysizes-display-clone";

          document.querySelector("head").appendChild(styleElement);
        }

        function removePrevClone(element) {
          var prev = element.previousElementSibling;

          if (prev && lazySizes.hC(prev, cloneElementClass)) {
            prev.parentNode.removeChild(prev);
            element.style.position = prev.getAttribute("data-position") || "";
            element.style.visibility = prev.getAttribute("data-visibility") || "";
          }
        }

        function initFix(element, config) {
          var switchClassesAdded, addedSrc, styleElement, styleElementStyle;
          var lazysizesCfg = lazySizes.cfg;

          var onChange = function () {
            var src = element.currentSrc || element.src;

            if (src && addedSrc !== src) {
              addedSrc = src;
              styleElementStyle.backgroundImage = "url(" + (regBgUrlEscape.test(src) ? JSON.stringify(src) : src) + ")";

              if (!switchClassesAdded) {
                switchClassesAdded = true;
                lazySizes.rC(styleElement, lazysizesCfg.loadingClass);
                lazySizes.aC(styleElement, lazysizesCfg.loadedClass);
              }
            }
          };
          var rafedOnChange = function () {
            lazySizes.rAF(onChange);
          };

          element._lazysizesParentFit = config.fit;

          element.addEventListener("lazyloaded", rafedOnChange, true);
          element.addEventListener("load", rafedOnChange, true);

          lazySizes.rAF(function () {
            var hideElement = element;
            var container = element.parentNode;

            if (container.nodeName.toUpperCase() == "PICTURE") {
              hideElement = container;
              container = container.parentNode;
            }

            removePrevClone(hideElement);

            if (!cloneElementClass) {
              generateStyleClass();
            }

            styleElement = element.cloneNode(false);
            styleElementStyle = styleElement.style;

            styleElement.addEventListener("load", function () {
              var curSrc = styleElement.currentSrc || styleElement.src;

              if (curSrc && curSrc != blankSrc) {
                styleElement.src = blankSrc;
                styleElement.srcset = "";
              }
            });

            lazySizes.rC(styleElement, lazysizesCfg.loadedClass);
            lazySizes.rC(styleElement, lazysizesCfg.lazyClass);
            lazySizes.rC(styleElement, lazysizesCfg.autosizesClass);
            lazySizes.aC(styleElement, lazysizesCfg.loadingClass);
            lazySizes.aC(styleElement, cloneElementClass);

            [
              "data-parent-fit",
              "data-parent-container",
              "data-object-fit-polyfilled",
              lazysizesCfg.srcsetAttr,
              lazysizesCfg.srcAttr,
            ].forEach(function (attr) {
              styleElement.removeAttribute(attr);
            });

            styleElement.src = blankSrc;
            styleElement.srcset = "";

            styleElementStyle.backgroundRepeat = "no-repeat";
            styleElementStyle.backgroundPosition = config.position;
            styleElementStyle.backgroundSize = config.fit;

            styleElement.setAttribute("data-position", hideElement.style.position);
            styleElement.setAttribute("data-visibility", hideElement.style.visibility);

            hideElement.style.visibility = "hidden";
            hideElement.style.position = "absolute";

            element.setAttribute("data-parent-fit", config.fit);
            element.setAttribute("data-parent-container", "prev");
            element.setAttribute("data-object-fit-polyfilled", "");
            element._objectFitPolyfilledDisplay = styleElement;

            container.insertBefore(styleElement, hideElement);

            if (element._lazysizesParentFit) {
              delete element._lazysizesParentFit;
            }

            if (element.complete) {
              onChange();
            }
          });
        }

        if (!fitSupport || !positionSupport) {
          var onRead = function (e) {
            if (e.detail.instance != lazySizes) {
              return;
            }

            var element = e.target;
            var obj = getObject(element);

            if (obj.fit && (!fitSupport || obj.position != "center")) {
              initFix(element, obj);
              return true;
            }

            return false;
          };

          window.addEventListener("lazybeforesizes", function (e) {
            if (e.detail.instance != lazySizes) {
              return;
            }
            var element = e.target;

            if (element.getAttribute("data-object-fit-polyfilled") != null && !element._objectFitPolyfilledDisplay) {
              if (!onRead(e)) {
                lazySizes.rAF(function () {
                  element.removeAttribute("data-object-fit-polyfilled");
                });
              }
            }
          });
          window.addEventListener("lazyunveilread", onRead, true);

          if (initialEvent && initialEvent.detail) {
            onRead(initialEvent);
          }
        }
      });

      /***/
    },
    /* 11 */
    /***/
    function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
      (function (window, factory) {
        if (!window) {
          return;
        }
        var globalInstall = function () {
          factory(window.lazySizes);
          window.removeEventListener("lazyunveilread", globalInstall, true);
        };

        factory = factory.bind(null, window, window.document);

        if (true && module.exports) {
          factory(__webpack_require__(0));
        } else if (true) {
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)]),
          (__WEBPACK_AMD_DEFINE_FACTORY__ = factory),
          (__WEBPACK_AMD_DEFINE_RESULT__ =
            typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function"
              ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)
              : __WEBPACK_AMD_DEFINE_FACTORY__),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {
        }
      })(typeof window != "undefined" ? window : 0, function (window, document, lazySizes) {
        "use strict";

        if (!window.addEventListener) {
          return;
        }

        var regDescriptors = /\s+(\d+)(w|h)\s+(\d+)(w|h)/;
        var regCssFit = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/;
        var regCssObject = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/;
        var regPicture = /^picture$/i;
        var cfg = lazySizes.cfg;

        var getCSS = function (elem) {
          return getComputedStyle(elem, null) || {};
        };

        var parentFit = {
          getParent: function (element, parentSel) {
            var parent = element;
            var parentNode = element.parentNode;

            if ((!parentSel || parentSel == "prev") && parentNode && regPicture.test(parentNode.nodeName || "")) {
              parentNode = parentNode.parentNode;
            }

            if (parentSel != "self") {
              if (parentSel == "prev") {
                parent = element.previousElementSibling;
              } else if (parentSel && (parentNode.closest || window.jQuery)) {
                parent =
                  (parentNode.closest ? parentNode.closest(parentSel) : jQuery(parentNode).closest(parentSel)[0]) ||
                  parentNode;
              } else {
                parent = parentNode;
              }
            }

            return parent;
          },

          getFit: function (element) {
            var tmpMatch, parentObj;
            var css = getCSS(element);
            var content = css.content || css.fontFamily;
            var obj = {
              fit: element._lazysizesParentFit || element.getAttribute("data-parent-fit"),
            };

            if (!obj.fit && content && (tmpMatch = content.match(regCssFit))) {
              obj.fit = tmpMatch[1];
            }

            if (obj.fit) {
              parentObj = element._lazysizesParentContainer || element.getAttribute("data-parent-container");

              if (!parentObj && content && (tmpMatch = content.match(regCssObject))) {
                parentObj = tmpMatch[1];
              }

              obj.parent = parentFit.getParent(element, parentObj);
            } else {
              obj.fit = css.objectFit;
            }

            return obj;
          },

          getImageRatio: function (element) {
            var i, srcset, media, ratio, match, width, height;
            var parent = element.parentNode;
            var elements =
              parent && regPicture.test(parent.nodeName || "") ? parent.querySelectorAll("source, img") : [element];

            for (i = 0; i < elements.length; i++) {
              element = elements[i];
              srcset =
                element.getAttribute(cfg.srcsetAttr) ||
                element.getAttribute("srcset") ||
                element.getAttribute("data-pfsrcset") ||
                element.getAttribute("data-risrcset") ||
                "";
              media = element._lsMedia || element.getAttribute("media");
              media = cfg.customMedia[element.getAttribute("data-media") || media] || media;

              if (srcset && (!media || ((window.matchMedia && matchMedia(media)) || {}).matches)) {
                ratio = parseFloat(element.getAttribute("data-aspectratio"));

                if (!ratio) {
                  match = srcset.match(regDescriptors);

                  if (match) {
                    if (match[2] == "w") {
                      width = match[1];
                      height = match[3];
                    } else {
                      width = match[3];
                      height = match[1];
                    }
                  } else {
                    width = element.getAttribute("width");
                    height = element.getAttribute("height");
                  }

                  ratio = width / height;
                }

                break;
              }
            }

            return ratio;
          },

          calculateSize: function (element, width) {
            var displayRatio, height, imageRatio, retWidth;
            var fitObj = this.getFit(element);
            var fit = fitObj.fit;
            var fitElem = fitObj.parent;

            if (
              fit != "width" &&
              ((fit != "contain" && fit != "cover") || !(imageRatio = this.getImageRatio(element)))
            ) {
              return width;
            }

            if (fitElem) {
              width = fitElem.clientWidth;
            } else {
              fitElem = element;
            }

            retWidth = width;

            if (fit == "width") {
              retWidth = width;
            } else {
              height = fitElem.clientHeight;

              if (
                (displayRatio = width / height) &&
                ((fit == "cover" && displayRatio < imageRatio) || (fit == "contain" && displayRatio > imageRatio))
              ) {
                retWidth = width * (imageRatio / displayRatio);
              }
            }

            return retWidth;
          },
        };

        lazySizes.parentFit = parentFit;

        document.addEventListener("lazybeforesizes", function (e) {
          if (e.defaultPrevented || e.detail.instance != lazySizes) {
            return;
          }

          var element = e.target;
          e.detail.width = parentFit.calculateSize(element, e.detail.width);
        });
      });

      /***/
    },
    /* 12 */
    /***/
    function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
      (function (window, factory) {
        var globalInstall = function () {
          factory(window.lazySizes);
          window.removeEventListener("lazyunveilread", globalInstall, true);
        };

        factory = factory.bind(null, window, window.document);

        if (true && module.exports) {
          factory(__webpack_require__(0));
        } else if (true) {
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)]),
          (__WEBPACK_AMD_DEFINE_FACTORY__ = factory),
          (__WEBPACK_AMD_DEFINE_RESULT__ =
            typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function"
              ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)
              : __WEBPACK_AMD_DEFINE_FACTORY__),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {
        }
      })(window, function (window, document, lazySizes) {
        /*jshint eqnull:true */
        "use strict";

        var config, riasCfg;
        var lazySizesCfg = lazySizes.cfg;
        var replaceTypes = {
          string: 1,
          number: 1,
        };
        var regNumber = /^\-*\+*\d+\.*\d*$/;
        var regPicture = /^picture$/i;
        var regWidth = /\s*\{\s*width\s*\}\s*/i;
        var regHeight = /\s*\{\s*height\s*\}\s*/i;
        var regPlaceholder = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi;
        var regObj = /^\[.*\]|\{.*\}$/;
        var regAllowedSizes = /^(?:auto|\d+(px)?)$/;
        var anchor = document.createElement("a");
        var img = document.createElement("img");
        var buggySizes = "srcset" in img && !("sizes" in img);
        var supportPicture = !!window.HTMLPictureElement && !buggySizes;

        (function () {
          var prop;
          var noop = function () {};
          var riasDefaults = {
            prefix: "",
            postfix: "",
            srcAttr: "data-src",
            absUrl: false,
            modifyOptions: noop,
            widthmap: {},
            ratio: false,
            traditionalRatio: false,
            aspectratio: false,
          };

          config = lazySizes && lazySizes.cfg;

          if (!config.supportsType) {
            config.supportsType = function (type /*, elem*/) {
              return !type;
            };
          }

          if (!config.rias) {
            config.rias = {};
          }
          riasCfg = config.rias;

          if (!("widths" in riasCfg)) {
            riasCfg.widths = [];
            (function (widths) {
              var width;
              var i = 0;
              while (!width || width < 3000) {
                i += 5;
                if (i > 30) {
                  i += 1;
                }
                width = 36 * i;
                widths.push(width);
              }
            })(riasCfg.widths);
          }

          for (prop in riasDefaults) {
            if (!(prop in riasCfg)) {
              riasCfg[prop] = riasDefaults[prop];
            }
          }
        })();

        function getElementOptions(elem, src, options) {
          var attr, parent, setOption, prop, opts;
          var elemStyles = window.getComputedStyle(elem);

          if (!options) {
            parent = elem.parentNode;

            options = {
              isPicture: !!(parent && regPicture.test(parent.nodeName || "")),
            };
          } else {
            opts = {};

            for (prop in options) {
              opts[prop] = options[prop];
            }

            options = opts;
          }

          setOption = function (attr, run) {
            var attrVal = elem.getAttribute("data-" + attr);

            if (!attrVal) {
              // no data- attr, get value from the CSS
              var styles = elemStyles.getPropertyValue("--ls-" + attr);
              // at least Safari 9 returns null rather than
              // an empty string for getPropertyValue causing
              // .trim() to fail
              if (styles) {
                attrVal = styles.trim();
              }
            }

            if (attrVal) {
              if (attrVal == "true") {
                attrVal = true;
              } else if (attrVal == "false") {
                attrVal = false;
              } else if (regNumber.test(attrVal)) {
                attrVal = parseFloat(attrVal);
              } else if (typeof riasCfg[attr] == "function") {
                attrVal = riasCfg[attr](elem, attrVal);
              } else if (regObj.test(attrVal)) {
                try {
                  attrVal = JSON.parse(attrVal);
                } catch (e) {}
              }
              options[attr] = attrVal;
            } else if (attr in riasCfg && typeof riasCfg[attr] != "function" && !options[attr]) {
              options[attr] = riasCfg[attr];
            } else if (run && typeof riasCfg[attr] == "function") {
              options[attr] = riasCfg[attr](elem, attrVal);
            }
          };

          for (attr in riasCfg) {
            setOption(attr);
          }
          src.replace(regPlaceholder, function (full, match) {
            if (!(match in options)) {
              setOption(match, true);
            }
          });

          return options;
        }

        function replaceUrlProps(url, options) {
          var candidates = [];
          var replaceFn = function (full, match) {
            return replaceTypes[typeof options[match]] ? options[match] : full;
          };
          candidates.srcset = [];

          if (options.absUrl) {
            anchor.setAttribute("href", url);
            url = anchor.href;
          }

          url = ((options.prefix || "") + url + (options.postfix || "")).replace(regPlaceholder, replaceFn);

          options.widths.forEach(function (width) {
            var widthAlias = options.widthmap[width] || width;
            var ratio = options.aspectratio || options.ratio;
            var traditionalRatio = !options.aspectratio && riasCfg.traditionalRatio;
            var candidate = {
              u: url
                .replace(regWidth, widthAlias)
                .replace(
                  regHeight,
                  ratio ? (traditionalRatio ? Math.round(width * ratio) : Math.round(width / ratio)) : ""
                ),
              w: width,
            };

            candidates.push(candidate);
            candidates.srcset.push((candidate.c = candidate.u + " " + width + "w"));
          });
          return candidates;
        }

        function setSrc(src, opts, elem) {
          var elemW = 0;
          var elemH = 0;
          var sizeElement = elem;

          if (!src) {
            return;
          }

          if (opts.ratio === "container") {
            // calculate image or parent ratio
            elemW = sizeElement.scrollWidth;
            elemH = sizeElement.scrollHeight;

            while ((!elemW || !elemH) && sizeElement !== document) {
              sizeElement = sizeElement.parentNode;
              elemW = sizeElement.scrollWidth;
              elemH = sizeElement.scrollHeight;
            }
            if (elemW && elemH) {
              opts.ratio = opts.traditionalRatio ? elemH / elemW : elemW / elemH;
            }
          }

          src = replaceUrlProps(src, opts);

          src.isPicture = opts.isPicture;

          if (buggySizes && elem.nodeName.toUpperCase() == "IMG") {
            elem.removeAttribute(config.srcsetAttr);
          } else {
            elem.setAttribute(config.srcsetAttr, src.srcset.join(", "));
          }

          Object.defineProperty(elem, "_lazyrias", {
            value: src,
            writable: true,
          });
        }

        function createAttrObject(elem, src) {
          var opts = getElementOptions(elem, src);

          riasCfg.modifyOptions.call(elem, {
            target: elem,
            details: opts,
            detail: opts,
          });

          lazySizes.fire(elem, "lazyriasmodifyoptions", opts);
          return opts;
        }

        function getSrc(elem) {
          return (
            elem.getAttribute(elem.getAttribute("data-srcattr") || riasCfg.srcAttr) ||
            elem.getAttribute(config.srcsetAttr) ||
            elem.getAttribute(config.srcAttr) ||
            elem.getAttribute("data-pfsrcset") ||
            ""
          );
        }

        addEventListener(
          "lazybeforesizes",
          function (e) {
            if (e.detail.instance != lazySizes) {
              return;
            }

            var elem,
              src,
              elemOpts,
              sourceOpts,
              parent,
              sources,
              i,
              len,
              sourceSrc,
              sizes,
              detail,
              hasPlaceholder,
              modified,
              emptyList;
            elem = e.target;

            if (
              !e.detail.dataAttr ||
              e.defaultPrevented ||
              riasCfg.disabled ||
              !(
                (sizes = elem.getAttribute(config.sizesAttr) || elem.getAttribute("sizes")) &&
                regAllowedSizes.test(sizes)
              )
            ) {
              return;
            }

            src = getSrc(elem);

            elemOpts = createAttrObject(elem, src);

            hasPlaceholder = regWidth.test(elemOpts.prefix) || regWidth.test(elemOpts.postfix);

            if (elemOpts.isPicture && (parent = elem.parentNode)) {
              sources = parent.getElementsByTagName("source");
              for (i = 0, len = sources.length; i < len; i++) {
                if (hasPlaceholder || regWidth.test((sourceSrc = getSrc(sources[i])))) {
                  sourceOpts = getElementOptions(sources[i], sourceSrc, elemOpts);
                  setSrc(sourceSrc, sourceOpts, sources[i]);
                  modified = true;
                }
              }
            }

            if (hasPlaceholder || regWidth.test(src)) {
              setSrc(src, elemOpts, elem);
              modified = true;
            } else if (modified) {
              emptyList = [];
              emptyList.srcset = [];
              emptyList.isPicture = true;
              Object.defineProperty(elem, "_lazyrias", {
                value: emptyList,
                writable: true,
              });
            }

            if (modified) {
              if (supportPicture) {
                elem.removeAttribute(config.srcAttr);
              } else if (sizes != "auto") {
                detail = {
                  width: parseInt(sizes, 10),
                };
                polyfill({
                  target: elem,
                  detail: detail,
                });
              }
            }
          },
          true
        );
        // partial polyfill
        var polyfill = (function () {
          var ascendingSort = function (a, b) {
            return a.w - b.w;
          };

          var reduceCandidate = function (srces) {
            var lowerCandidate, bonusFactor;
            var len = srces.length;
            var candidate = srces[len - 1];
            var i = 0;

            for (i; i < len; i++) {
              candidate = srces[i];
              candidate.d = candidate.w / srces.w;
              if (candidate.d >= srces.d) {
                if (
                  !candidate.cached &&
                  (lowerCandidate = srces[i - 1]) &&
                  lowerCandidate.d > srces.d - 0.13 * Math.pow(srces.d, 2.2)
                ) {
                  bonusFactor = Math.pow(lowerCandidate.d - 0.6, 1.6);

                  if (lowerCandidate.cached) {
                    lowerCandidate.d += 0.15 * bonusFactor;
                  }

                  if (lowerCandidate.d + (candidate.d - srces.d) * bonusFactor > srces.d) {
                    candidate = lowerCandidate;
                  }
                }
                break;
              }
            }
            return candidate;
          };

          var getWSet = function (elem, testPicture) {
            var src;
            if (
              !elem._lazyrias &&
              lazySizes.pWS &&
              (src = lazySizes.pWS(elem.getAttribute(config.srcsetAttr || ""))).length
            ) {
              Object.defineProperty(elem, "_lazyrias", {
                value: src,
                writable: true,
              });
              if (testPicture && elem.parentNode) {
                src.isPicture = elem.parentNode.nodeName.toUpperCase() == "PICTURE";
              }
            }
            return elem._lazyrias;
          };

          var getX = function (elem) {
            var dpr = window.devicePixelRatio || 1;
            var optimum = lazySizes.getX && lazySizes.getX(elem);
            return Math.min(optimum || dpr, 2.4, dpr);
          };

          var getCandidate = function (elem, width) {
            var sources, i, len, media, srces, src;

            srces = elem._lazyrias;

            if (srces.isPicture && window.matchMedia) {
              for (
                i = 0, sources = elem.parentNode.getElementsByTagName("source"), len = sources.length;
                i < len;
                i++
              ) {
                if (
                  getWSet(sources[i]) &&
                  !sources[i].getAttribute("type") &&
                  (!(media = sources[i].getAttribute("media")) || (matchMedia(media) || {}).matches)
                ) {
                  srces = sources[i]._lazyrias;
                  break;
                }
              }
            }

            if (!srces.w || srces.w < width) {
              srces.w = width;
              srces.d = getX(elem);
              src = reduceCandidate(srces.sort(ascendingSort));
            }

            return src;
          };

          var polyfill = function (e) {
            if (e.detail.instance != lazySizes) {
              return;
            }

            var candidate;
            var elem = e.target;

            if (!buggySizes && (window.respimage || window.picturefill || lazySizesCfg.pf)) {
              document.removeEventListener("lazybeforesizes", polyfill);
              return;
            }

            if (!("_lazyrias" in elem) && (!e.detail.dataAttr || !getWSet(elem, true))) {
              return;
            }

            candidate = getCandidate(elem, e.detail.width);

            if (candidate && candidate.u && elem._lazyrias.cur != candidate.u) {
              elem._lazyrias.cur = candidate.u;
              candidate.cached = true;
              lazySizes.rAF(function () {
                elem.setAttribute(config.srcAttr, candidate.u);
                elem.setAttribute("src", candidate.u);
              });
            }
          };

          if (!supportPicture) {
            addEventListener("lazybeforesizes", polyfill);
          } else {
            polyfill = function () {};
          }

          return polyfill;
        })();
      });

      /***/
    },
    /* 13 */
    /***/
    function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
      (function (window, factory) {
        var globalInstall = function () {
          factory(window.lazySizes);
          window.removeEventListener("lazyunveilread", globalInstall, true);
        };

        factory = factory.bind(null, window, window.document);

        if (true && module.exports) {
          factory(__webpack_require__(0));
        } else if (true) {
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)]),
          (__WEBPACK_AMD_DEFINE_FACTORY__ = factory),
          (__WEBPACK_AMD_DEFINE_RESULT__ =
            typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function"
              ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)
              : __WEBPACK_AMD_DEFINE_FACTORY__),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {
        }
      })(window, function (window, document, lazySizes) {
        "use strict";
        if (!window.addEventListener) {
          return;
        }

        var lazySizesCfg = lazySizes.cfg;
        var regWhite = /\s+/g;
        var regSplitSet = /\s*\|\s+|\s+\|\s*/g;
        var regSource = /^(.+?)(?:\s+\[\s*(.+?)\s*\])(?:\s+\[\s*(.+?)\s*\])?$/;
        var regType = /^\s*\(*\s*type\s*:\s*(.+?)\s*\)*\s*$/;
        var regBgUrlEscape = /\(|\)|'/;
        var allowedBackgroundSize = {
          contain: 1,
          cover: 1,
        };
        var proxyWidth = function (elem) {
          var width = lazySizes.gW(elem, elem.parentNode);

          if (!elem._lazysizesWidth || width > elem._lazysizesWidth) {
            elem._lazysizesWidth = width;
          }
          return elem._lazysizesWidth;
        };
        var getBgSize = function (elem) {
          var bgSize;

          bgSize = (
            getComputedStyle(elem) || {
              getPropertyValue: function () {},
            }
          ).getPropertyValue("background-size");

          if (!allowedBackgroundSize[bgSize] && allowedBackgroundSize[elem.style.backgroundSize]) {
            bgSize = elem.style.backgroundSize;
          }

          return bgSize;
        };
        var setTypeOrMedia = function (source, match) {
          if (match) {
            var typeMatch = match.match(regType);
            if (typeMatch && typeMatch[1]) {
              source.setAttribute("type", typeMatch[1]);
            } else {
              source.setAttribute("media", lazySizesCfg.customMedia[match] || match);
            }
          }
        };
        var createPicture = function (sets, elem, img) {
          var picture = document.createElement("picture");
          var sizes = elem.getAttribute(lazySizesCfg.sizesAttr);
          var ratio = elem.getAttribute("data-ratio");
          var optimumx = elem.getAttribute("data-optimumx");

          if (elem._lazybgset && elem._lazybgset.parentNode == elem) {
            elem.removeChild(elem._lazybgset);
          }

          Object.defineProperty(img, "_lazybgset", {
            value: elem,
            writable: true,
          });
          Object.defineProperty(elem, "_lazybgset", {
            value: picture,
            writable: true,
          });

          sets = sets.replace(regWhite, " ").split(regSplitSet);

          picture.style.display = "none";
          img.className = lazySizesCfg.lazyClass;

          if (sets.length == 1 && !sizes) {
            sizes = "auto";
          }

          sets.forEach(function (set) {
            var match;
            var source = document.createElement("source");

            if (sizes && sizes != "auto") {
              source.setAttribute("sizes", sizes);
            }

            if ((match = set.match(regSource))) {
              source.setAttribute(lazySizesCfg.srcsetAttr, match[1]);

              setTypeOrMedia(source, match[2]);
              setTypeOrMedia(source, match[3]);
            } else {
              source.setAttribute(lazySizesCfg.srcsetAttr, set);
            }

            picture.appendChild(source);
          });

          if (sizes) {
            img.setAttribute(lazySizesCfg.sizesAttr, sizes);
            elem.removeAttribute(lazySizesCfg.sizesAttr);
            elem.removeAttribute("sizes");
          }
          if (optimumx) {
            img.setAttribute("data-optimumx", optimumx);
          }
          if (ratio) {
            img.setAttribute("data-ratio", ratio);
          }

          picture.appendChild(img);

          elem.appendChild(picture);
        };

        var proxyLoad = function (e) {
          if (!e.target._lazybgset) {
            return;
          }

          var image = e.target;
          var elem = image._lazybgset;
          var bg = image.currentSrc || image.src;

          if (bg) {
            var useSrc = regBgUrlEscape.test(bg) ? JSON.stringify(bg) : bg;
            var event = lazySizes.fire(elem, "bgsetproxy", {
              src: bg,
              useSrc: useSrc,
              fullSrc: null,
            });

            if (!event.defaultPrevented) {
              elem.style.backgroundImage = event.detail.fullSrc || "url(" + event.detail.useSrc + ")";
            }
          }

          if (image._lazybgsetLoading) {
            lazySizes.fire(elem, "_lazyloaded", {}, false, true);
            delete image._lazybgsetLoading;
          }
        };

        addEventListener("lazybeforeunveil", function (e) {
          var set, image, elem;

          if (e.defaultPrevented || !(set = e.target.getAttribute("data-bgset"))) {
            return;
          }

          elem = e.target;
          image = document.createElement("img");

          image.alt = "";

          image._lazybgsetLoading = true;
          e.detail.firesLoad = true;

          createPicture(set, elem, image);

          setTimeout(function () {
            lazySizes.loader.unveil(image);

            lazySizes.rAF(function () {
              lazySizes.fire(image, "_lazyloaded", {}, true, true);
              if (image.complete) {
                proxyLoad({
                  target: image,
                });
              }
            });
          });
        });

        document.addEventListener("load", proxyLoad, true);

        window.addEventListener(
          "lazybeforesizes",
          function (e) {
            if (e.detail.instance != lazySizes) {
              return;
            }
            if (e.target._lazybgset && e.detail.dataAttr) {
              var elem = e.target._lazybgset;
              var bgSize = getBgSize(elem);

              if (allowedBackgroundSize[bgSize]) {
                e.target._lazysizesParentFit = bgSize;

                lazySizes.rAF(function () {
                  e.target.setAttribute("data-parent-fit", bgSize);
                  if (e.target._lazysizesParentFit) {
                    delete e.target._lazysizesParentFit;
                  }
                });
              }
            }
          },
          true
        );

        document.documentElement.addEventListener("lazybeforesizes", function (e) {
          if (e.defaultPrevented || !e.target._lazybgset || e.detail.instance != lazySizes) {
            return;
          }
          e.detail.width = proxyWidth(e.target._lazybgset);
        });
      });

      /***/
    },
    /* 14 */
    /***/
    function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
      (function (window, factory) {
        if (!window) {
          return;
        }
        var globalInstall = function () {
          factory(window.lazySizes);
          window.removeEventListener("lazyunveilread", globalInstall, true);
        };

        factory = factory.bind(null, window, window.document);

        if (true && module.exports) {
          factory(__webpack_require__(0));
        } else if (true) {
          !((__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)]),
          (__WEBPACK_AMD_DEFINE_FACTORY__ = factory),
          (__WEBPACK_AMD_DEFINE_RESULT__ =
            typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function"
              ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)
              : __WEBPACK_AMD_DEFINE_FACTORY__),
          __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {
        }
      })(typeof window != "undefined" ? window : 0, function (window, document, lazySizes) {
        /*jshint eqnull:true */
        "use strict";
        var polyfill;
        var lazySizesCfg = lazySizes.cfg;
        var img = document.createElement("img");
        var supportSrcset = "sizes" in img && "srcset" in img;
        var regHDesc = /\s+\d+h/g;
        var fixEdgeHDescriptor = (function () {
          var regDescriptors = /\s+(\d+)(w|h)\s+(\d+)(w|h)/;
          var forEach = Array.prototype.forEach;

          return function () {
            var img = document.createElement("img");
            var removeHDescriptors = function (source) {
              var ratio, match;
              var srcset = source.getAttribute(lazySizesCfg.srcsetAttr);
              if (srcset) {
                if ((match = srcset.match(regDescriptors))) {
                  if (match[2] == "w") {
                    ratio = match[1] / match[3];
                  } else {
                    ratio = match[3] / match[1];
                  }

                  if (ratio) {
                    source.setAttribute("data-aspectratio", ratio);
                  }
                  source.setAttribute(lazySizesCfg.srcsetAttr, srcset.replace(regHDesc, ""));
                }
              }
            };
            var handler = function (e) {
              if (e.detail.instance != lazySizes) {
                return;
              }
              var picture = e.target.parentNode;

              if (picture && picture.nodeName == "PICTURE") {
                forEach.call(picture.getElementsByTagName("source"), removeHDescriptors);
              }
              removeHDescriptors(e.target);
            };

            var test = function () {
              if (!!img.currentSrc) {
                document.removeEventListener("lazybeforeunveil", handler);
              }
            };

            document.addEventListener("lazybeforeunveil", handler);

            img.onload = test;
            img.onerror = test;

            img.srcset = "data:,a 1w 1h";

            if (img.complete) {
              test();
            }
          };
        })();

        if (!lazySizesCfg.supportsType) {
          lazySizesCfg.supportsType = function (type /*, elem*/) {
            return !type;
          };
        }

        if (window.HTMLPictureElement && supportSrcset) {
          if (!lazySizes.hasHDescriptorFix && document.msElementsFromPoint) {
            lazySizes.hasHDescriptorFix = true;
            fixEdgeHDescriptor();
          }
          return;
        }

        if (window.picturefill || lazySizesCfg.pf) {
          return;
        }

        lazySizesCfg.pf = function (options) {
          var i, len;
          if (window.picturefill) {
            return;
          }
          for (i = 0, len = options.elements.length; i < len; i++) {
            polyfill(options.elements[i]);
          }
        };

        // partial polyfill
        polyfill = (function () {
          var ascendingSort = function (a, b) {
            return a.w - b.w;
          };
          var regPxLength = /^\s*\d+\.*\d*px\s*$/;
          var reduceCandidate = function (srces) {
            var lowerCandidate, bonusFactor;
            var len = srces.length;
            var candidate = srces[len - 1];
            var i = 0;

            for (i; i < len; i++) {
              candidate = srces[i];
              candidate.d = candidate.w / srces.w;

              if (candidate.d >= srces.d) {
                if (
                  !candidate.cached &&
                  (lowerCandidate = srces[i - 1]) &&
                  lowerCandidate.d > srces.d - 0.13 * Math.pow(srces.d, 2.2)
                ) {
                  bonusFactor = Math.pow(lowerCandidate.d - 0.6, 1.6);

                  if (lowerCandidate.cached) {
                    lowerCandidate.d += 0.15 * bonusFactor;
                  }

                  if (lowerCandidate.d + (candidate.d - srces.d) * bonusFactor > srces.d) {
                    candidate = lowerCandidate;
                  }
                }
                break;
              }
            }
            return candidate;
          };

          var parseWsrcset = (function () {
            var candidates;
            var regWCandidates = /(([^,\s].[^\s]+)\s+(\d+)w)/g;
            var regMultiple = /\s/;
            var addCandidate = function (match, candidate, url, wDescriptor) {
              candidates.push({
                c: candidate,
                u: url,
                w: wDescriptor * 1,
              });
            };

            return function (input) {
              candidates = [];
              input = input.trim();
              input.replace(regHDesc, "").replace(regWCandidates, addCandidate);

              if (!candidates.length && input && !regMultiple.test(input)) {
                candidates.push({
                  c: input,
                  u: input,
                  w: 99,
                });
              }

              return candidates;
            };
          })();

          var runMatchMedia = function () {
            if (runMatchMedia.init) {
              return;
            }

            runMatchMedia.init = true;
            addEventListener(
              "resize",
              (function () {
                var timer;
                var matchMediaElems = document.getElementsByClassName("lazymatchmedia");
                var run = function () {
                  var i, len;
                  for (i = 0, len = matchMediaElems.length; i < len; i++) {
                    polyfill(matchMediaElems[i]);
                  }
                };

                return function () {
                  clearTimeout(timer);
                  timer = setTimeout(run, 66);
                };
              })()
            );
          };

          var createSrcset = function (elem, isImage) {
            var parsedSet;
            var srcSet = elem.getAttribute("srcset") || elem.getAttribute(lazySizesCfg.srcsetAttr);

            if (!srcSet && isImage) {
              srcSet = !elem._lazypolyfill
                ? elem.getAttribute(lazySizesCfg.srcAttr) || elem.getAttribute("src")
                : elem._lazypolyfill._set;
            }

            if (!elem._lazypolyfill || elem._lazypolyfill._set != srcSet) {
              parsedSet = parseWsrcset(srcSet || "");
              if (isImage && elem.parentNode) {
                parsedSet.isPicture = elem.parentNode.nodeName.toUpperCase() == "PICTURE";

                if (parsedSet.isPicture) {
                  if (window.matchMedia) {
                    lazySizes.aC(elem, "lazymatchmedia");
                    runMatchMedia();
                  }
                }
              }

              parsedSet._set = srcSet;
              Object.defineProperty(elem, "_lazypolyfill", {
                value: parsedSet,
                writable: true,
              });
            }
          };

          var getX = function (elem) {
            var dpr = window.devicePixelRatio || 1;
            var optimum = lazySizes.getX && lazySizes.getX(elem);
            return Math.min(optimum || dpr, 2.5, dpr);
          };

          var matchesMedia = function (media) {
            if (window.matchMedia) {
              matchesMedia = function (media) {
                return !media || (matchMedia(media) || {}).matches;
              };
            } else {
              return !media;
            }

            return matchesMedia(media);
          };

          var getCandidate = function (elem) {
            var sources, i, len, media, source, srces, src, width;

            source = elem;
            createSrcset(source, true);
            srces = source._lazypolyfill;

            if (srces.isPicture) {
              for (
                i = 0, sources = elem.parentNode.getElementsByTagName("source"), len = sources.length;
                i < len;
                i++
              ) {
                if (
                  lazySizesCfg.supportsType(sources[i].getAttribute("type"), elem) &&
                  matchesMedia(sources[i].getAttribute("media"))
                ) {
                  source = sources[i];
                  createSrcset(source);
                  srces = source._lazypolyfill;
                  break;
                }
              }
            }

            if (srces.length > 1) {
              width = source.getAttribute("sizes") || "";
              width = (regPxLength.test(width) && parseInt(width, 10)) || lazySizes.gW(elem, elem.parentNode);
              srces.d = getX(elem);
              if (!srces.src || !srces.w || srces.w < width) {
                srces.w = width;
                src = reduceCandidate(srces.sort(ascendingSort));
                srces.src = src;
              } else {
                src = srces.src;
              }
            } else {
              src = srces[0];
            }

            return src;
          };

          var p = function (elem) {
            if (supportSrcset && elem.parentNode && elem.parentNode.nodeName.toUpperCase() != "PICTURE") {
              return;
            }
            var candidate = getCandidate(elem);

            if (candidate && candidate.u && elem._lazypolyfill.cur != candidate.u) {
              elem._lazypolyfill.cur = candidate.u;
              candidate.cached = true;
              elem.setAttribute(lazySizesCfg.srcAttr, candidate.u);
              elem.setAttribute("src", candidate.u);
            }
          };

          p.parse = parseWsrcset;

          return p;
        })();

        if (lazySizesCfg.loadedClass && lazySizesCfg.loadingClass) {
          (function () {
            var sels = [];
            ['img[sizes$="px"][srcset].', "picture > img:not([srcset])."].forEach(function (sel) {
              sels.push(sel + lazySizesCfg.loadedClass);
              sels.push(sel + lazySizesCfg.loadingClass);
            });
            lazySizesCfg.pf({
              elements: document.querySelectorAll(sels.join(", ")),
            });
          })();
        }
      });

      /***/
    },
    /* 15 */
    /***/
    function (module, exports) {
      window.Spruce.store("cartCount", {
        count: (window.theme && window.theme.cartItemCount) || 0,

        countWithText() {
          let string = theme.strings.itemCountOther;

          if (this.count === 1) {
            string = theme.strings.itemCountOne;
          }

          return string.replace("{{ count }}", this.count);
        },
      });
      document.body.addEventListener("baseline:modalcart:itemcountupdate", (e) => {
        window.Spruce.store("cartCount").count = e.detail.count || 0;
      });

      /***/
    },
    /* 16 */
    /***/
    function (module, exports, __webpack_require__) {
      (function (global, factory) {
        true ? (module.exports = factory()) : undefined;
      })(this, function () {
        "use strict";

        function _defineProperty(obj, key, value) {
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true,
            });
          } else {
            obj[key] = value;
          }

          return obj;
        }

        function ownKeys(object, enumerableOnly) {
          var keys = Object.keys(object);

          if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly)
              symbols = symbols.filter(function (sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
              });
            keys.push.apply(keys, symbols);
          }

          return keys;
        }

        function _objectSpread2(target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i] != null ? arguments[i] : {};

            if (i % 2) {
              ownKeys(Object(source), true).forEach(function (key) {
                _defineProperty(target, key, source[key]);
              });
            } else if (Object.getOwnPropertyDescriptors) {
              Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            } else {
              ownKeys(Object(source)).forEach(function (key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
              });
            }
          }

          return target;
        }

        // Thanks @stimulus:
        // https://github.com/stimulusjs/stimulus/blob/master/packages/%40stimulus/core/src/application.ts
        function domReady() {
          return new Promise((resolve) => {
            if (document.readyState == "loading") {
              document.addEventListener("DOMContentLoaded", resolve);
            } else {
              resolve();
            }
          });
        }

        function arrayUnique(array) {
          return Array.from(new Set(array));
        }

        function isTesting() {
          return navigator.userAgent.includes("Node.js") || navigator.userAgent.includes("jsdom");
        }

        function checkedAttrLooseCompare(valueA, valueB) {
          return valueA == valueB;
        }

        function warnIfMalformedTemplate(el, directive) {
          if (el.tagName.toLowerCase() !== "template") {
            console.warn(
              `Alpine: [${directive}] directive should only be added to <template> tags. See https://github.com/alpinejs/alpine#${directive}`
            );
          } else if (el.content.childElementCount !== 1) {
            console.warn(
              `Alpine: <template> tag with [${directive}] encountered with multiple element roots. Make sure <template> only has a single child element.`
            );
          }
        }

        function kebabCase(subject) {
          return subject
            .replace(/([a-z])([A-Z])/g, "$1-$2")
            .replace(/[_\s]/, "-")
            .toLowerCase();
        }

        function camelCase(subject) {
          return subject.toLowerCase().replace(/-(\w)/g, (match, char) => char.toUpperCase());
        }

        function walk(el, callback) {
          if (callback(el) === false) return;
          let node = el.firstElementChild;

          while (node) {
            walk(node, callback);
            node = node.nextElementSibling;
          }
        }

        function debounce(func, wait) {
          var timeout;
          return function () {
            var context = this,
              args = arguments;

            var later = function later() {
              timeout = null;
              func.apply(context, args);
            };

            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
          };
        }

        const handleError = (el, expression, error) => {
          console.warn(`Alpine Error: "${error}"\n\nExpression: "${expression}"\nElement:`, el);

          if (!isTesting()) {
            throw error;
          }
        };

        function tryCatch(cb, { el, expression }) {
          try {
            const value = cb();
            return value instanceof Promise ? value.catch((e) => handleError(el, expression, e)) : value;
          } catch (e) {
            handleError(el, expression, e);
          }
        }

        function saferEval(el, expression, dataContext, additionalHelperVariables = {}) {
          return tryCatch(
            () => {
              if (typeof expression === "function") {
                return expression.call(dataContext);
              }

              return new Function(
                ["$data", ...Object.keys(additionalHelperVariables)],
                `var __alpine_result; with($data) { __alpine_result = ${expression} }; return __alpine_result`
              )(dataContext, ...Object.values(additionalHelperVariables));
            },
            {
              el,
              expression,
            }
          );
        }

        function saferEvalNoReturn(el, expression, dataContext, additionalHelperVariables = {}) {
          return tryCatch(
            () => {
              if (typeof expression === "function") {
                return Promise.resolve(expression.call(dataContext, additionalHelperVariables["$event"]));
              }

              let AsyncFunction = Function;
              /* MODERN-ONLY:START */

              AsyncFunction = Object.getPrototypeOf(async function () {}).constructor;
              /* MODERN-ONLY:END */
              // For the cases when users pass only a function reference to the caller: `x-on:click="foo"`
              // Where "foo" is a function. Also, we'll pass the function the event instance when we call it.

              if (Object.keys(dataContext).includes(expression)) {
                let methodReference = new Function(
                  ["dataContext", ...Object.keys(additionalHelperVariables)],
                  `with(dataContext) { return ${expression} }`
                )(dataContext, ...Object.values(additionalHelperVariables));

                if (typeof methodReference === "function") {
                  return Promise.resolve(methodReference.call(dataContext, additionalHelperVariables["$event"]));
                } else {
                  return Promise.resolve();
                }
              }

              return Promise.resolve(
                new AsyncFunction(
                  ["dataContext", ...Object.keys(additionalHelperVariables)],
                  `with(dataContext) { ${expression} }`
                )(dataContext, ...Object.values(additionalHelperVariables))
              );
            },
            {
              el,
              expression,
            }
          );
        }
        const xAttrRE = /^x-(on|bind|data|text|html|model|if|for|show|cloak|transition|ref|spread)\b/;

        function isXAttr(attr) {
          const name = replaceAtAndColonWithStandardSyntax(attr.name);
          return xAttrRE.test(name);
        }

        function getXAttrs(el, component, type) {
          let directives = Array.from(el.attributes).filter(isXAttr).map(parseHtmlAttribute); // Get an object of directives from x-spread.

          let spreadDirective = directives.filter((directive) => directive.type === "spread")[0];

          if (spreadDirective) {
            let spreadObject = saferEval(el, spreadDirective.expression, component.$data); // Add x-spread directives to the pile of existing directives.

            directives = directives.concat(
              Object.entries(spreadObject).map(([name, value]) =>
                parseHtmlAttribute({
                  name,
                  value,
                })
              )
            );
          }

          if (type) return directives.filter((i) => i.type === type);
          return sortDirectives(directives);
        }

        function sortDirectives(directives) {
          let directiveOrder = ["bind", "model", "show", "catch-all"];
          return directives.sort((a, b) => {
            let typeA = directiveOrder.indexOf(a.type) === -1 ? "catch-all" : a.type;
            let typeB = directiveOrder.indexOf(b.type) === -1 ? "catch-all" : b.type;
            return directiveOrder.indexOf(typeA) - directiveOrder.indexOf(typeB);
          });
        }

        function parseHtmlAttribute({ name, value }) {
          const normalizedName = replaceAtAndColonWithStandardSyntax(name);
          const typeMatch = normalizedName.match(xAttrRE);
          const valueMatch = normalizedName.match(/:([a-zA-Z0-9\-:]+)/);
          const modifiers = normalizedName.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
          return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i) => i.replace(".", "")),
            expression: value,
          };
        }

        function isBooleanAttr(attrName) {
          // As per HTML spec table https://html.spec.whatwg.org/multipage/indices.html#attributes-3:boolean-attribute
          // Array roughly ordered by estimated usage
          const booleanAttributes = [
            "disabled",
            "checked",
            "required",
            "readonly",
            "hidden",
            "open",
            "selected",
            "autofocus",
            "itemscope",
            "multiple",
            "novalidate",
            "allowfullscreen",
            "allowpaymentrequest",
            "formnovalidate",
            "autoplay",
            "controls",
            "loop",
            "muted",
            "playsinline",
            "default",
            "ismap",
            "reversed",
            "async",
            "defer",
            "nomodule",
          ];
          return booleanAttributes.includes(attrName);
        }

        function replaceAtAndColonWithStandardSyntax(name) {
          if (name.startsWith("@")) {
            return name.replace("@", "x-on:");
          } else if (name.startsWith(":")) {
            return name.replace(":", "x-bind:");
          }

          return name;
        }

        function convertClassStringToArray(classList, filterFn = Boolean) {
          return classList.split(" ").filter(filterFn);
        }
        const TRANSITION_TYPE_IN = "in";
        const TRANSITION_TYPE_OUT = "out";
        const TRANSITION_CANCELLED = "cancelled";

        function transitionIn(el, show, reject, component, forceSkip = false) {
          // We don't want to transition on the initial page load.
          if (forceSkip) return show();

          if (el.__x_transition && el.__x_transition.type === TRANSITION_TYPE_IN) {
            // there is already a similar transition going on, this was probably triggered by
            // a change in a different property, let's just leave the previous one doing its job
            return;
          }

          const attrs = getXAttrs(el, component, "transition");
          const showAttr = getXAttrs(el, component, "show")[0]; // If this is triggered by a x-show.transition.

          if (showAttr && showAttr.modifiers.includes("transition")) {
            let modifiers = showAttr.modifiers; // If x-show.transition.out, we'll skip the "in" transition.

            if (modifiers.includes("out") && !modifiers.includes("in")) return show();
            const settingBothSidesOfTransition = modifiers.includes("in") && modifiers.includes("out"); // If x-show.transition.in...out... only use "in" related modifiers for this transition.

            modifiers = settingBothSidesOfTransition
              ? modifiers.filter((i, index) => index < modifiers.indexOf("out"))
              : modifiers;
            transitionHelperIn(el, modifiers, show, reject); // Otherwise, we can assume x-transition:enter.
          } else if (attrs.some((attr) => ["enter", "enter-start", "enter-end"].includes(attr.value))) {
            transitionClassesIn(el, component, attrs, show, reject);
          } else {
            // If neither, just show that damn thing.
            show();
          }
        }

        function transitionOut(el, hide, reject, component, forceSkip = false) {
          // We don't want to transition on the initial page load.
          if (forceSkip) return hide();

          if (el.__x_transition && el.__x_transition.type === TRANSITION_TYPE_OUT) {
            // there is already a similar transition going on, this was probably triggered by
            // a change in a different property, let's just leave the previous one doing its job
            return;
          }

          const attrs = getXAttrs(el, component, "transition");
          const showAttr = getXAttrs(el, component, "show")[0];

          if (showAttr && showAttr.modifiers.includes("transition")) {
            let modifiers = showAttr.modifiers;
            if (modifiers.includes("in") && !modifiers.includes("out")) return hide();
            const settingBothSidesOfTransition = modifiers.includes("in") && modifiers.includes("out");
            modifiers = settingBothSidesOfTransition
              ? modifiers.filter((i, index) => index > modifiers.indexOf("out"))
              : modifiers;
            transitionHelperOut(el, modifiers, settingBothSidesOfTransition, hide, reject);
          } else if (attrs.some((attr) => ["leave", "leave-start", "leave-end"].includes(attr.value))) {
            transitionClassesOut(el, component, attrs, hide, reject);
          } else {
            hide();
          }
        }

        function transitionHelperIn(el, modifiers, showCallback, reject) {
          // Default values inspired by: https://material.io/design/motion/speed.html#duration
          const styleValues = {
            duration: modifierValue(modifiers, "duration", 150),
            origin: modifierValue(modifiers, "origin", "center"),
            first: {
              opacity: 0,
              scale: modifierValue(modifiers, "scale", 95),
            },
            second: {
              opacity: 1,
              scale: 100,
            },
          };
          transitionHelper(el, modifiers, showCallback, () => {}, reject, styleValues, TRANSITION_TYPE_IN);
        }

        function transitionHelperOut(el, modifiers, settingBothSidesOfTransition, hideCallback, reject) {
          // Make the "out" transition .5x slower than the "in". (Visually better)
          // HOWEVER, if they explicitly set a duration for the "out" transition,
          // use that.
          const duration = settingBothSidesOfTransition
            ? modifierValue(modifiers, "duration", 150)
            : modifierValue(modifiers, "duration", 150) / 2;
          const styleValues = {
            duration: duration,
            origin: modifierValue(modifiers, "origin", "center"),
            first: {
              opacity: 1,
              scale: 100,
            },
            second: {
              opacity: 0,
              scale: modifierValue(modifiers, "scale", 95),
            },
          };
          transitionHelper(el, modifiers, () => {}, hideCallback, reject, styleValues, TRANSITION_TYPE_OUT);
        }

        function modifierValue(modifiers, key, fallback) {
          // If the modifier isn't present, use the default.
          if (modifiers.indexOf(key) === -1) return fallback; // If it IS present, grab the value after it: x-show.transition.duration.500ms

          const rawValue = modifiers[modifiers.indexOf(key) + 1];
          if (!rawValue) return fallback;

          if (key === "scale") {
            // Check if the very next value is NOT a number and return the fallback.
            // If x-show.transition.scale, we'll use the default scale value.
            // That is how a user opts out of the opacity transition.
            if (!isNumeric(rawValue)) return fallback;
          }

          if (key === "duration") {
            // Support x-show.transition.duration.500ms && duration.500
            let match = rawValue.match(/([0-9]+)ms/);
            if (match) return match[1];
          }

          if (key === "origin") {
            // Support chaining origin directions: x-show.transition.top.right
            if (["top", "right", "left", "center", "bottom"].includes(modifiers[modifiers.indexOf(key) + 2])) {
              return [rawValue, modifiers[modifiers.indexOf(key) + 2]].join(" ");
            }
          }

          return rawValue;
        }

        function transitionHelper(el, modifiers, hook1, hook2, reject, styleValues, type) {
          // clear the previous transition if exists to avoid caching the wrong styles
          if (el.__x_transition) {
            el.__x_transition.cancel && el.__x_transition.cancel();
          } // If the user set these style values, we'll put them back when we're done with them.

          const opacityCache = el.style.opacity;
          const transformCache = el.style.transform;
          const transformOriginCache = el.style.transformOrigin; // If no modifiers are present: x-show.transition, we'll default to both opacity and scale.

          const noModifiers = !modifiers.includes("opacity") && !modifiers.includes("scale");
          const transitionOpacity = noModifiers || modifiers.includes("opacity");
          const transitionScale = noModifiers || modifiers.includes("scale"); // These are the explicit stages of a transition (same stages for in and for out).
          // This way you can get a birds eye view of the hooks, and the differences
          // between them.

          const stages = {
            start() {
              if (transitionOpacity) el.style.opacity = styleValues.first.opacity;
              if (transitionScale) el.style.transform = `scale(${styleValues.first.scale / 100})`;
            },

            during() {
              if (transitionScale) el.style.transformOrigin = styleValues.origin;
              el.style.transitionProperty = [transitionOpacity ? `opacity` : ``, transitionScale ? `transform` : ``]
                .join(" ")
                .trim();
              el.style.transitionDuration = `${styleValues.duration / 1000}s`;
              el.style.transitionTimingFunction = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
            },

            show() {
              hook1();
            },

            end() {
              if (transitionOpacity) el.style.opacity = styleValues.second.opacity;
              if (transitionScale) el.style.transform = `scale(${styleValues.second.scale / 100})`;
            },

            hide() {
              hook2();
            },

            cleanup() {
              if (transitionOpacity) el.style.opacity = opacityCache;
              if (transitionScale) el.style.transform = transformCache;
              if (transitionScale) el.style.transformOrigin = transformOriginCache;
              el.style.transitionProperty = null;
              el.style.transitionDuration = null;
              el.style.transitionTimingFunction = null;
            },
          };
          transition(el, stages, type, reject);
        }

        const ensureStringExpression = (expression, el, component) => {
          return typeof expression === "function" ? component.evaluateReturnExpression(el, expression) : expression;
        };

        function transitionClassesIn(el, component, directives, showCallback, reject) {
          const enter = convertClassStringToArray(
            ensureStringExpression(
              (
                directives.find((i) => i.value === "enter") || {
                  expression: "",
                }
              ).expression,
              el,
              component
            )
          );
          const enterStart = convertClassStringToArray(
            ensureStringExpression(
              (
                directives.find((i) => i.value === "enter-start") || {
                  expression: "",
                }
              ).expression,
              el,
              component
            )
          );
          const enterEnd = convertClassStringToArray(
            ensureStringExpression(
              (
                directives.find((i) => i.value === "enter-end") || {
                  expression: "",
                }
              ).expression,
              el,
              component
            )
          );
          transitionClasses(el, enter, enterStart, enterEnd, showCallback, () => {}, TRANSITION_TYPE_IN, reject);
        }

        function transitionClassesOut(el, component, directives, hideCallback, reject) {
          const leave = convertClassStringToArray(
            ensureStringExpression(
              (
                directives.find((i) => i.value === "leave") || {
                  expression: "",
                }
              ).expression,
              el,
              component
            )
          );
          const leaveStart = convertClassStringToArray(
            ensureStringExpression(
              (
                directives.find((i) => i.value === "leave-start") || {
                  expression: "",
                }
              ).expression,
              el,
              component
            )
          );
          const leaveEnd = convertClassStringToArray(
            ensureStringExpression(
              (
                directives.find((i) => i.value === "leave-end") || {
                  expression: "",
                }
              ).expression,
              el,
              component
            )
          );
          transitionClasses(el, leave, leaveStart, leaveEnd, () => {}, hideCallback, TRANSITION_TYPE_OUT, reject);
        }

        function transitionClasses(el, classesDuring, classesStart, classesEnd, hook1, hook2, type, reject) {
          // clear the previous transition if exists to avoid caching the wrong classes
          if (el.__x_transition) {
            el.__x_transition.cancel && el.__x_transition.cancel();
          }

          const originalClasses = el.__x_original_classes || [];
          const stages = {
            start() {
              el.classList.add(...classesStart);
            },

            during() {
              el.classList.add(...classesDuring);
            },

            show() {
              hook1();
            },

            end() {
              // Don't remove classes that were in the original class attribute.
              el.classList.remove(...classesStart.filter((i) => !originalClasses.includes(i)));
              el.classList.add(...classesEnd);
            },

            hide() {
              hook2();
            },

            cleanup() {
              el.classList.remove(...classesDuring.filter((i) => !originalClasses.includes(i)));
              el.classList.remove(...classesEnd.filter((i) => !originalClasses.includes(i)));
            },
          };
          transition(el, stages, type, reject);
        }

        function transition(el, stages, type, reject) {
          const finish = once(() => {
            stages.hide(); // Adding an "isConnected" check, in case the callback
            // removed the element from the DOM.

            if (el.isConnected) {
              stages.cleanup();
            }

            delete el.__x_transition;
          });
          el.__x_transition = {
            // Set transition type so we can avoid clearing transition if the direction is the same
            type: type,
            // create a callback for the last stages of the transition so we can call it
            // from different point and early terminate it. Once will ensure that function
            // is only called one time.
            cancel: once(() => {
              reject(TRANSITION_CANCELLED);
              finish();
            }),
            finish,
            // This store the next animation frame so we can cancel it
            nextFrame: null,
          };
          stages.start();
          stages.during();
          el.__x_transition.nextFrame = requestAnimationFrame(() => {
            // Note: Safari's transitionDuration property will list out comma separated transition durations
            // for every single transition property. Let's grab the first one and call it a day.
            let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1000;

            if (duration === 0) {
              duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1000;
            }

            stages.show();
            el.__x_transition.nextFrame = requestAnimationFrame(() => {
              stages.end();
              setTimeout(el.__x_transition.finish, duration);
            });
          });
        }

        function isNumeric(subject) {
          return !Array.isArray(subject) && !isNaN(subject);
        } // Thanks @vuejs
        // https://github.com/vuejs/vue/blob/4de4649d9637262a9b007720b59f80ac72a5620c/src/shared/util.js

        function once(callback) {
          let called = false;
          return function () {
            if (!called) {
              called = true;
              callback.apply(this, arguments);
            }
          };
        }

        function handleForDirective(component, templateEl, expression, initialUpdate, extraVars) {
          warnIfMalformedTemplate(templateEl, "x-for");
          let iteratorNames =
            typeof expression === "function"
              ? parseForExpression(component.evaluateReturnExpression(templateEl, expression))
              : parseForExpression(expression);
          let items = evaluateItemsAndReturnEmptyIfXIfIsPresentAndFalseOnElement(
            component,
            templateEl,
            iteratorNames,
            extraVars
          ); // As we walk the array, we'll also walk the DOM (updating/creating as we go).

          let currentEl = templateEl;
          items.forEach((item, index) => {
            let iterationScopeVariables = getIterationScopeVariables(iteratorNames, item, index, items, extraVars());
            let currentKey = generateKeyForIteration(component, templateEl, index, iterationScopeVariables);
            let nextEl = lookAheadForMatchingKeyedElementAndMoveItIfFound(currentEl.nextElementSibling, currentKey); // If we haven't found a matching key, insert the element at the current position.

            if (!nextEl) {
              nextEl = addElementInLoopAfterCurrentEl(templateEl, currentEl); // And transition it in if it's not the first page load.

              transitionIn(
                nextEl,
                () => {},
                () => {},
                component,
                initialUpdate
              );
              nextEl.__x_for = iterationScopeVariables;
              component.initializeElements(nextEl, () => nextEl.__x_for); // Otherwise update the element we found.
            } else {
              // Temporarily remove the key indicator to allow the normal "updateElements" to work.
              delete nextEl.__x_for_key;
              nextEl.__x_for = iterationScopeVariables;
              component.updateElements(nextEl, () => nextEl.__x_for);
            }

            currentEl = nextEl;
            currentEl.__x_for_key = currentKey;
          });
          removeAnyLeftOverElementsFromPreviousUpdate(currentEl, component);
        } // This was taken from VueJS 2.* core. Thanks Vue!

        function parseForExpression(expression) {
          let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
          let stripParensRE = /^\(|\)$/g;
          let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
          let inMatch = expression.match(forAliasRE);
          if (!inMatch) return;
          let res = {};
          res.items = inMatch[2].trim();
          let item = inMatch[1].trim().replace(stripParensRE, "");
          let iteratorMatch = item.match(forIteratorRE);

          if (iteratorMatch) {
            res.item = item.replace(forIteratorRE, "").trim();
            res.index = iteratorMatch[1].trim();

            if (iteratorMatch[2]) {
              res.collection = iteratorMatch[2].trim();
            }
          } else {
            res.item = item;
          }

          return res;
        }

        function getIterationScopeVariables(iteratorNames, item, index, items, extraVars) {
          // We must create a new object, so each iteration has a new scope
          let scopeVariables = extraVars ? _objectSpread2({}, extraVars) : {};
          scopeVariables[iteratorNames.item] = item;
          if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
          if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
          return scopeVariables;
        }

        function generateKeyForIteration(component, el, index, iterationScopeVariables) {
          let bindKeyAttribute = getXAttrs(el, component, "bind").filter((attr) => attr.value === "key")[0]; // If the dev hasn't specified a key, just return the index of the iteration.

          if (!bindKeyAttribute) return index;
          return component.evaluateReturnExpression(el, bindKeyAttribute.expression, () => iterationScopeVariables);
        }

        function evaluateItemsAndReturnEmptyIfXIfIsPresentAndFalseOnElement(component, el, iteratorNames, extraVars) {
          let ifAttribute = getXAttrs(el, component, "if")[0];

          if (ifAttribute && !component.evaluateReturnExpression(el, ifAttribute.expression)) {
            return [];
          }

          let items = component.evaluateReturnExpression(el, iteratorNames.items, extraVars); // This adds support for the `i in n` syntax.

          if (isNumeric(items) && items > 0) {
            items = Array.from(Array(items).keys(), (i) => i + 1);
          }

          return items;
        }

        function addElementInLoopAfterCurrentEl(templateEl, currentEl) {
          let clone = document.importNode(templateEl.content, true);
          currentEl.parentElement.insertBefore(clone, currentEl.nextElementSibling);
          return currentEl.nextElementSibling;
        }

        function lookAheadForMatchingKeyedElementAndMoveItIfFound(nextEl, currentKey) {
          if (!nextEl) return; // If we are already past the x-for generated elements, we don't need to look ahead.

          if (nextEl.__x_for_key === undefined) return; // If the the key's DO match, no need to look ahead.

          if (nextEl.__x_for_key === currentKey) return nextEl; // If they don't, we'll look ahead for a match.
          // If we find it, we'll move it to the current position in the loop.

          let tmpNextEl = nextEl;

          while (tmpNextEl) {
            if (tmpNextEl.__x_for_key === currentKey) {
              return tmpNextEl.parentElement.insertBefore(tmpNextEl, nextEl);
            }

            tmpNextEl =
              tmpNextEl.nextElementSibling && tmpNextEl.nextElementSibling.__x_for_key !== undefined
                ? tmpNextEl.nextElementSibling
                : false;
          }
        }

        function removeAnyLeftOverElementsFromPreviousUpdate(currentEl, component) {
          var nextElementFromOldLoop =
            currentEl.nextElementSibling && currentEl.nextElementSibling.__x_for_key !== undefined
              ? currentEl.nextElementSibling
              : false;

          while (nextElementFromOldLoop) {
            let nextElementFromOldLoopImmutable = nextElementFromOldLoop;
            let nextSibling = nextElementFromOldLoop.nextElementSibling;
            transitionOut(
              nextElementFromOldLoop,
              () => {
                nextElementFromOldLoopImmutable.remove();
              },
              () => {},
              component
            );
            nextElementFromOldLoop = nextSibling && nextSibling.__x_for_key !== undefined ? nextSibling : false;
          }
        }

        function handleAttributeBindingDirective(component, el, attrName, expression, extraVars, attrType, modifiers) {
          var value = component.evaluateReturnExpression(el, expression, extraVars);

          if (attrName === "value") {
            if (Alpine.ignoreFocusedForValueBinding && document.activeElement.isSameNode(el)) return; // If nested model key is undefined, set the default value to empty string.

            if (value === undefined && expression.match(/\./)) {
              value = "";
            }

            if (el.type === "radio") {
              // Set radio value from x-bind:value, if no "value" attribute exists.
              // If there are any initial state values, radio will have a correct
              // "checked" value since x-bind:value is processed before x-model.
              if (el.attributes.value === undefined && attrType === "bind") {
                el.value = value;
              } else if (attrType !== "bind") {
                el.checked = checkedAttrLooseCompare(el.value, value);
              }
            } else if (el.type === "checkbox") {
              // If we are explicitly binding a string to the :value, set the string,
              // If the value is a boolean, leave it alone, it will be set to "on"
              // automatically.
              if (typeof value !== "boolean" && ![null, undefined].includes(value) && attrType === "bind") {
                el.value = String(value);
              } else if (attrType !== "bind") {
                if (Array.isArray(value)) {
                  // I'm purposely not using Array.includes here because it's
                  // strict, and because of Numeric/String mis-casting, I
                  // want the "includes" to be "fuzzy".
                  el.checked = value.some((val) => checkedAttrLooseCompare(val, el.value));
                } else {
                  el.checked = !!value;
                }
              }
            } else if (el.tagName === "SELECT") {
              updateSelect(el, value);
            } else {
              if (el.value === value) return;
              el.value = value;
            }
          } else if (attrName === "class") {
            if (Array.isArray(value)) {
              const originalClasses = el.__x_original_classes || [];
              el.setAttribute("class", arrayUnique(originalClasses.concat(value)).join(" "));
            } else if (typeof value === "object") {
              // Sorting the keys / class names by their boolean value will ensure that
              // anything that evaluates to `false` and needs to remove classes is run first.
              const keysSortedByBooleanValue = Object.keys(value).sort((a, b) => value[a] - value[b]);
              keysSortedByBooleanValue.forEach((classNames) => {
                if (value[classNames]) {
                  convertClassStringToArray(classNames).forEach((className) => el.classList.add(className));
                } else {
                  convertClassStringToArray(classNames).forEach((className) => el.classList.remove(className));
                }
              });
            } else {
              const originalClasses = el.__x_original_classes || [];
              const newClasses = value ? convertClassStringToArray(value) : [];
              el.setAttribute("class", arrayUnique(originalClasses.concat(newClasses)).join(" "));
            }
          } else {
            attrName = modifiers.includes("camel") ? camelCase(attrName) : attrName; // If an attribute's bound value is null, undefined or false, remove the attribute

            if ([null, undefined, false].includes(value)) {
              el.removeAttribute(attrName);
            } else {
              isBooleanAttr(attrName) ? setIfChanged(el, attrName, attrName) : setIfChanged(el, attrName, value);
            }
          }
        }

        function setIfChanged(el, attrName, value) {
          if (el.getAttribute(attrName) != value) {
            el.setAttribute(attrName, value);
          }
        }

        function updateSelect(el, value) {
          const arrayWrappedValue = [].concat(value).map((value) => {
            return value + "";
          });
          Array.from(el.options).forEach((option) => {
            option.selected = arrayWrappedValue.includes(option.value || option.text);
          });
        }

        function handleTextDirective(el, output, expression) {
          // If nested model key is undefined, set the default value to empty string.
          if (output === undefined && expression.match(/\./)) {
            output = "";
          }

          el.textContent = output;
        }

        function handleHtmlDirective(component, el, expression, extraVars) {
          el.innerHTML = component.evaluateReturnExpression(el, expression, extraVars);
        }

        function handleShowDirective(component, el, value, modifiers, initialUpdate = false) {
          const hide = () => {
            el.style.display = "none";
            el.__x_is_shown = false;
          };

          const show = () => {
            if (el.style.length === 1 && el.style.display === "none") {
              el.removeAttribute("style");
            } else {
              el.style.removeProperty("display");
            }

            el.__x_is_shown = true;
          };

          if (initialUpdate === true) {
            if (value) {
              show();
            } else {
              hide();
            }

            return;
          }

          const handle = (resolve, reject) => {
            if (value) {
              if (el.style.display === "none" || el.__x_transition) {
                transitionIn(
                  el,
                  () => {
                    show();
                  },
                  reject,
                  component
                );
              }

              resolve(() => {});
            } else {
              if (el.style.display !== "none") {
                transitionOut(
                  el,
                  () => {
                    resolve(() => {
                      hide();
                    });
                  },
                  reject,
                  component
                );
              } else {
                resolve(() => {});
              }
            }
          }; // The working of x-show is a bit complex because we need to
          // wait for any child transitions to finish before hiding
          // some element. Also, this has to be done recursively.
          // If x-show.immediate, foregoe the waiting.

          if (modifiers.includes("immediate")) {
            handle(
              (finish) => finish(),
              () => {}
            );
            return;
          } // x-show is encountered during a DOM tree walk. If an element
          // we encounter is NOT a child of another x-show element we
          // can execute the previous x-show stack (if one exists).

          if (component.showDirectiveLastElement && !component.showDirectiveLastElement.contains(el)) {
            component.executeAndClearRemainingShowDirectiveStack();
          }

          component.showDirectiveStack.push(handle);
          component.showDirectiveLastElement = el;
        }

        function handleIfDirective(component, el, expressionResult, initialUpdate, extraVars) {
          warnIfMalformedTemplate(el, "x-if");
          const elementHasAlreadyBeenAdded = el.nextElementSibling && el.nextElementSibling.__x_inserted_me === true;

          if (expressionResult && (!elementHasAlreadyBeenAdded || el.__x_transition)) {
            const clone = document.importNode(el.content, true);
            el.parentElement.insertBefore(clone, el.nextElementSibling);
            transitionIn(
              el.nextElementSibling,
              () => {},
              () => {},
              component,
              initialUpdate
            );
            component.initializeElements(el.nextElementSibling, extraVars);
            el.nextElementSibling.__x_inserted_me = true;
          } else if (!expressionResult && elementHasAlreadyBeenAdded) {
            transitionOut(
              el.nextElementSibling,
              () => {
                el.nextElementSibling.remove();
              },
              () => {},
              component,
              initialUpdate
            );
          }
        }

        function registerListener(component, el, event, modifiers, expression, extraVars = {}) {
          const options = {
            passive: modifiers.includes("passive"),
          };

          if (modifiers.includes("camel")) {
            event = camelCase(event);
          }

          if (modifiers.includes("away")) {
            let handler = (e) => {
              // Don't do anything if the click came from the element or within it.
              if (el.contains(e.target)) return; // Don't do anything if this element isn't currently visible.

              if (el.offsetWidth < 1 && el.offsetHeight < 1) return; // Now that we are sure the element is visible, AND the click
              // is from outside it, let's run the expression.

              runListenerHandler(component, expression, e, extraVars);

              if (modifiers.includes("once")) {
                document.removeEventListener(event, handler, options);
              }
            }; // Listen for this event at the root level.

            document.addEventListener(event, handler, options);
          } else {
            let listenerTarget = modifiers.includes("window") ? window : modifiers.includes("document") ? document : el;

            let handler = (e) => {
              // Remove this global event handler if the element that declared it
              // has been removed. It's now stale.
              if (listenerTarget === window || listenerTarget === document) {
                if (!document.body.contains(el)) {
                  listenerTarget.removeEventListener(event, handler, options);
                  return;
                }
              }

              if (isKeyEvent(event)) {
                if (isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) {
                  return;
                }
              }

              if (modifiers.includes("prevent")) e.preventDefault();
              if (modifiers.includes("stop")) e.stopPropagation(); // If the .self modifier isn't present, or if it is present and
              // the target element matches the element we are registering the
              // event on, run the handler

              if (!modifiers.includes("self") || e.target === el) {
                const returnValue = runListenerHandler(component, expression, e, extraVars);
                returnValue.then((value) => {
                  if (value === false) {
                    e.preventDefault();
                  } else {
                    if (modifiers.includes("once")) {
                      listenerTarget.removeEventListener(event, handler, options);
                    }
                  }
                });
              }
            };

            if (modifiers.includes("debounce")) {
              let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
              let wait = isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
              handler = debounce(handler, wait);
            }

            listenerTarget.addEventListener(event, handler, options);
          }
        }

        function runListenerHandler(component, expression, e, extraVars) {
          return component.evaluateCommandExpression(e.target, expression, () => {
            return _objectSpread2(
              _objectSpread2({}, extraVars()),
              {},
              {
                $event: e,
              }
            );
          });
        }

        function isKeyEvent(event) {
          return ["keydown", "keyup"].includes(event);
        }

        function isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
          let keyModifiers = modifiers.filter((i) => {
            return !["window", "document", "prevent", "stop"].includes(i);
          });

          if (keyModifiers.includes("debounce")) {
            let debounceIndex = keyModifiers.indexOf("debounce");
            keyModifiers.splice(
              debounceIndex,
              isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1
            );
          } // If no modifier is specified, we'll call it a press.

          if (keyModifiers.length === 0) return false; // If one is passed, AND it matches the key pressed, we'll call it a press.

          if (keyModifiers.length === 1 && keyModifiers[0] === keyToModifier(e.key)) return false; // The user is listening for key combinations.

          const systemKeyModifiers = ["ctrl", "shift", "alt", "meta", "cmd", "super"];
          const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier) => keyModifiers.includes(modifier));
          keyModifiers = keyModifiers.filter((i) => !selectedSystemKeyModifiers.includes(i));

          if (selectedSystemKeyModifiers.length > 0) {
            const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier) => {
              // Alias "cmd" and "super" to "meta"
              if (modifier === "cmd" || modifier === "super") modifier = "meta";
              return e[`${modifier}Key`];
            }); // If all the modifiers selected are pressed, ...

            if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
              // AND the remaining key is pressed as well. It's a press.
              if (keyModifiers[0] === keyToModifier(e.key)) return false;
            }
          } // We'll call it NOT a valid keypress.

          return true;
        }

        function keyToModifier(key) {
          switch (key) {
            case "/":
              return "slash";

            case " ":
            case "Spacebar":
              return "space";

            default:
              return key && kebabCase(key);
          }
        }

        function registerModelListener(component, el, modifiers, expression, extraVars) {
          // If the element we are binding to is a select, a radio, or checkbox
          // we'll listen for the change event instead of the "input" event.
          var event =
            el.tagName.toLowerCase() === "select" ||
            ["checkbox", "radio"].includes(el.type) ||
            modifiers.includes("lazy")
              ? "change"
              : "input";
          const listenerExpression = `${expression} = rightSideOfExpression($event, ${expression})`;
          registerListener(component, el, event, modifiers, listenerExpression, () => {
            return _objectSpread2(
              _objectSpread2({}, extraVars()),
              {},
              {
                rightSideOfExpression: generateModelAssignmentFunction(el, modifiers, expression),
              }
            );
          });
        }

        function generateModelAssignmentFunction(el, modifiers, expression) {
          if (el.type === "radio") {
            // Radio buttons only work properly when they share a name attribute.
            // People might assume we take care of that for them, because
            // they already set a shared "x-model" attribute.
            if (!el.hasAttribute("name")) el.setAttribute("name", expression);
          }

          return (event, currentValue) => {
            // Check for event.detail due to an issue where IE11 handles other events as a CustomEvent.
            if (event instanceof CustomEvent && event.detail) {
              return event.detail;
            } else if (el.type === "checkbox") {
              // If the data we are binding to is an array, toggle its value inside the array.
              if (Array.isArray(currentValue)) {
                const newValue = modifiers.includes("number")
                  ? safeParseNumber(event.target.value)
                  : event.target.value;
                return event.target.checked
                  ? currentValue.concat([newValue])
                  : currentValue.filter((el) => !checkedAttrLooseCompare(el, newValue));
              } else {
                return event.target.checked;
              }
            } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
              return modifiers.includes("number")
                ? Array.from(event.target.selectedOptions).map((option) => {
                    const rawValue = option.value || option.text;
                    return safeParseNumber(rawValue);
                  })
                : Array.from(event.target.selectedOptions).map((option) => {
                    return option.value || option.text;
                  });
            } else {
              const rawValue = event.target.value;
              return modifiers.includes("number")
                ? safeParseNumber(rawValue)
                : modifiers.includes("trim")
                ? rawValue.trim()
                : rawValue;
            }
          };
        }

        function safeParseNumber(rawValue) {
          const number = rawValue ? parseFloat(rawValue) : null;
          return isNumeric(number) ? number : rawValue;
        }

        /**
         * Copyright (C) 2017 salesforce.com, inc.
         */
        const { isArray } = Array;
        const {
          getPrototypeOf,
          create: ObjectCreate,
          defineProperty: ObjectDefineProperty,
          defineProperties: ObjectDefineProperties,
          isExtensible,
          getOwnPropertyDescriptor,
          getOwnPropertyNames,
          getOwnPropertySymbols,
          preventExtensions,
          hasOwnProperty,
        } = Object;
        const { push: ArrayPush, concat: ArrayConcat, map: ArrayMap } = Array.prototype;

        function isUndefined(obj) {
          return obj === undefined;
        }

        function isFunction(obj) {
          return typeof obj === "function";
        }

        function isObject(obj) {
          return typeof obj === "object";
        }
        const proxyToValueMap = new WeakMap();

        function registerProxy(proxy, value) {
          proxyToValueMap.set(proxy, value);
        }
        const unwrap = (replicaOrAny) => proxyToValueMap.get(replicaOrAny) || replicaOrAny;

        function wrapValue(membrane, value) {
          return membrane.valueIsObservable(value) ? membrane.getProxy(value) : value;
        }
        /**
         * Unwrap property descriptors will set value on original descriptor
         * We only need to unwrap if value is specified
         * @param descriptor external descrpitor provided to define new property on original value
         */
        function unwrapDescriptor(descriptor) {
          if (hasOwnProperty.call(descriptor, "value")) {
            descriptor.value = unwrap(descriptor.value);
          }
          return descriptor;
        }

        function lockShadowTarget(membrane, shadowTarget, originalTarget) {
          const targetKeys = ArrayConcat.call(
            getOwnPropertyNames(originalTarget),
            getOwnPropertySymbols(originalTarget)
          );
          targetKeys.forEach((key) => {
            let descriptor = getOwnPropertyDescriptor(originalTarget, key);
            // We do not need to wrap the descriptor if configurable
            // Because we can deal with wrapping it when user goes through
            // Get own property descriptor. There is also a chance that this descriptor
            // could change sometime in the future, so we can defer wrapping
            // until we need to
            if (!descriptor.configurable) {
              descriptor = wrapDescriptor(membrane, descriptor, wrapValue);
            }
            ObjectDefineProperty(shadowTarget, key, descriptor);
          });
          preventExtensions(shadowTarget);
        }
        class ReactiveProxyHandler {
          constructor(membrane, value) {
            this.originalTarget = value;
            this.membrane = membrane;
          }
          get(shadowTarget, key) {
            const { originalTarget, membrane } = this;
            const value = originalTarget[key];
            const { valueObserved } = membrane;
            valueObserved(originalTarget, key);
            return membrane.getProxy(value);
          }
          set(shadowTarget, key, value) {
            const {
              originalTarget,
              membrane: { valueMutated },
            } = this;
            const oldValue = originalTarget[key];
            if (oldValue !== value) {
              originalTarget[key] = value;
              valueMutated(originalTarget, key);
            } else if (key === "length" && isArray(originalTarget)) {
              // fix for issue #236: push will add the new index, and by the time length
              // is updated, the internal length is already equal to the new length value
              // therefore, the oldValue is equal to the value. This is the forking logic
              // to support this use case.
              valueMutated(originalTarget, key);
            }
            return true;
          }
          deleteProperty(shadowTarget, key) {
            const {
              originalTarget,
              membrane: { valueMutated },
            } = this;
            delete originalTarget[key];
            valueMutated(originalTarget, key);
            return true;
          }
          apply(shadowTarget, thisArg, argArray) {
            /* No op */
          }
          construct(target, argArray, newTarget) {
            /* No op */
          }
          has(shadowTarget, key) {
            const {
              originalTarget,
              membrane: { valueObserved },
            } = this;
            valueObserved(originalTarget, key);
            return key in originalTarget;
          }
          ownKeys(shadowTarget) {
            const { originalTarget } = this;
            return ArrayConcat.call(getOwnPropertyNames(originalTarget), getOwnPropertySymbols(originalTarget));
          }
          isExtensible(shadowTarget) {
            const shadowIsExtensible = isExtensible(shadowTarget);
            if (!shadowIsExtensible) {
              return shadowIsExtensible;
            }
            const { originalTarget, membrane } = this;
            const targetIsExtensible = isExtensible(originalTarget);
            if (!targetIsExtensible) {
              lockShadowTarget(membrane, shadowTarget, originalTarget);
            }
            return targetIsExtensible;
          }
          setPrototypeOf(shadowTarget, prototype) {}
          getPrototypeOf(shadowTarget) {
            const { originalTarget } = this;
            return getPrototypeOf(originalTarget);
          }
          getOwnPropertyDescriptor(shadowTarget, key) {
            const { originalTarget, membrane } = this;
            const { valueObserved } = this.membrane;
            // keys looked up via hasOwnProperty need to be reactive
            valueObserved(originalTarget, key);
            let desc = getOwnPropertyDescriptor(originalTarget, key);
            if (isUndefined(desc)) {
              return desc;
            }
            const shadowDescriptor = getOwnPropertyDescriptor(shadowTarget, key);
            if (!isUndefined(shadowDescriptor)) {
              return shadowDescriptor;
            }
            // Note: by accessing the descriptor, the key is marked as observed
            // but access to the value, setter or getter (if available) cannot observe
            // mutations, just like regular methods, in which case we just do nothing.
            desc = wrapDescriptor(membrane, desc, wrapValue);
            if (!desc.configurable) {
              // If descriptor from original target is not configurable,
              // We must copy the wrapped descriptor over to the shadow target.
              // Otherwise, proxy will throw an invariant error.
              // This is our last chance to lock the value.
              // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/handler/getOwnPropertyDescriptor#Invariants
              ObjectDefineProperty(shadowTarget, key, desc);
            }
            return desc;
          }
          preventExtensions(shadowTarget) {
            const { originalTarget, membrane } = this;
            lockShadowTarget(membrane, shadowTarget, originalTarget);
            preventExtensions(originalTarget);
            return true;
          }
          defineProperty(shadowTarget, key, descriptor) {
            const { originalTarget, membrane } = this;
            const { valueMutated } = membrane;
            const { configurable } = descriptor;
            // We have to check for value in descriptor
            // because Object.freeze(proxy) calls this method
            // with only { configurable: false, writeable: false }
            // Additionally, method will only be called with writeable:false
            // if the descriptor has a value, as opposed to getter/setter
            // So we can just check if writable is present and then see if
            // value is present. This eliminates getter and setter descriptors
            if (hasOwnProperty.call(descriptor, "writable") && !hasOwnProperty.call(descriptor, "value")) {
              const originalDescriptor = getOwnPropertyDescriptor(originalTarget, key);
              descriptor.value = originalDescriptor.value;
            }
            ObjectDefineProperty(originalTarget, key, unwrapDescriptor(descriptor));
            if (configurable === false) {
              ObjectDefineProperty(shadowTarget, key, wrapDescriptor(membrane, descriptor, wrapValue));
            }
            valueMutated(originalTarget, key);
            return true;
          }
        }

        function wrapReadOnlyValue(membrane, value) {
          return membrane.valueIsObservable(value) ? membrane.getReadOnlyProxy(value) : value;
        }
        class ReadOnlyHandler {
          constructor(membrane, value) {
            this.originalTarget = value;
            this.membrane = membrane;
          }
          get(shadowTarget, key) {
            const { membrane, originalTarget } = this;
            const value = originalTarget[key];
            const { valueObserved } = membrane;
            valueObserved(originalTarget, key);
            return membrane.getReadOnlyProxy(value);
          }
          set(shadowTarget, key, value) {
            return false;
          }
          deleteProperty(shadowTarget, key) {
            return false;
          }
          apply(shadowTarget, thisArg, argArray) {
            /* No op */
          }
          construct(target, argArray, newTarget) {
            /* No op */
          }
          has(shadowTarget, key) {
            const {
              originalTarget,
              membrane: { valueObserved },
            } = this;
            valueObserved(originalTarget, key);
            return key in originalTarget;
          }
          ownKeys(shadowTarget) {
            const { originalTarget } = this;
            return ArrayConcat.call(getOwnPropertyNames(originalTarget), getOwnPropertySymbols(originalTarget));
          }
          setPrototypeOf(shadowTarget, prototype) {}
          getOwnPropertyDescriptor(shadowTarget, key) {
            const { originalTarget, membrane } = this;
            const { valueObserved } = membrane;
            // keys looked up via hasOwnProperty need to be reactive
            valueObserved(originalTarget, key);
            let desc = getOwnPropertyDescriptor(originalTarget, key);
            if (isUndefined(desc)) {
              return desc;
            }
            const shadowDescriptor = getOwnPropertyDescriptor(shadowTarget, key);
            if (!isUndefined(shadowDescriptor)) {
              return shadowDescriptor;
            }
            // Note: by accessing the descriptor, the key is marked as observed
            // but access to the value or getter (if available) cannot be observed,
            // just like regular methods, in which case we just do nothing.
            desc = wrapDescriptor(membrane, desc, wrapReadOnlyValue);
            if (hasOwnProperty.call(desc, "set")) {
              desc.set = undefined; // readOnly membrane does not allow setters
            }
            if (!desc.configurable) {
              // If descriptor from original target is not configurable,
              // We must copy the wrapped descriptor over to the shadow target.
              // Otherwise, proxy will throw an invariant error.
              // This is our last chance to lock the value.
              // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/handler/getOwnPropertyDescriptor#Invariants
              ObjectDefineProperty(shadowTarget, key, desc);
            }
            return desc;
          }
          preventExtensions(shadowTarget) {
            return false;
          }
          defineProperty(shadowTarget, key, descriptor) {
            return false;
          }
        }

        function createShadowTarget(value) {
          let shadowTarget = undefined;
          if (isArray(value)) {
            shadowTarget = [];
          } else if (isObject(value)) {
            shadowTarget = {};
          }
          return shadowTarget;
        }
        const ObjectDotPrototype = Object.prototype;

        function defaultValueIsObservable(value) {
          // intentionally checking for null
          if (value === null) {
            return false;
          }
          // treat all non-object types, including undefined, as non-observable values
          if (typeof value !== "object") {
            return false;
          }
          if (isArray(value)) {
            return true;
          }
          const proto = getPrototypeOf(value);
          return proto === ObjectDotPrototype || proto === null || getPrototypeOf(proto) === null;
        }
        const defaultValueObserved = (obj, key) => {
          /* do nothing */
        };
        const defaultValueMutated = (obj, key) => {
          /* do nothing */
        };
        const defaultValueDistortion = (value) => value;

        function wrapDescriptor(membrane, descriptor, getValue) {
          const { set, get } = descriptor;
          if (hasOwnProperty.call(descriptor, "value")) {
            descriptor.value = getValue(membrane, descriptor.value);
          } else {
            if (!isUndefined(get)) {
              descriptor.get = function () {
                // invoking the original getter with the original target
                return getValue(membrane, get.call(unwrap(this)));
              };
            }
            if (!isUndefined(set)) {
              descriptor.set = function (value) {
                // At this point we don't have a clear indication of whether
                // or not a valid mutation will occur, we don't have the key,
                // and we are not sure why and how they are invoking this setter.
                // Nevertheless we preserve the original semantics by invoking the
                // original setter with the original target and the unwrapped value
                set.call(unwrap(this), membrane.unwrapProxy(value));
              };
            }
          }
          return descriptor;
        }
        class ReactiveMembrane {
          constructor(options) {
            this.valueDistortion = defaultValueDistortion;
            this.valueMutated = defaultValueMutated;
            this.valueObserved = defaultValueObserved;
            this.valueIsObservable = defaultValueIsObservable;
            this.objectGraph = new WeakMap();
            if (!isUndefined(options)) {
              const { valueDistortion, valueMutated, valueObserved, valueIsObservable } = options;
              this.valueDistortion = isFunction(valueDistortion) ? valueDistortion : defaultValueDistortion;
              this.valueMutated = isFunction(valueMutated) ? valueMutated : defaultValueMutated;
              this.valueObserved = isFunction(valueObserved) ? valueObserved : defaultValueObserved;
              this.valueIsObservable = isFunction(valueIsObservable) ? valueIsObservable : defaultValueIsObservable;
            }
          }
          getProxy(value) {
            const unwrappedValue = unwrap(value);
            const distorted = this.valueDistortion(unwrappedValue);
            if (this.valueIsObservable(distorted)) {
              const o = this.getReactiveState(unwrappedValue, distorted);
              // when trying to extract the writable version of a readonly
              // we return the readonly.
              return o.readOnly === value ? value : o.reactive;
            }
            return distorted;
          }
          getReadOnlyProxy(value) {
            value = unwrap(value);
            const distorted = this.valueDistortion(value);
            if (this.valueIsObservable(distorted)) {
              return this.getReactiveState(value, distorted).readOnly;
            }
            return distorted;
          }
          unwrapProxy(p) {
            return unwrap(p);
          }
          getReactiveState(value, distortedValue) {
            const { objectGraph } = this;
            let reactiveState = objectGraph.get(distortedValue);
            if (reactiveState) {
              return reactiveState;
            }
            const membrane = this;
            reactiveState = {
              get reactive() {
                const reactiveHandler = new ReactiveProxyHandler(membrane, distortedValue);
                // caching the reactive proxy after the first time it is accessed
                const proxy = new Proxy(createShadowTarget(distortedValue), reactiveHandler);
                registerProxy(proxy, value);
                ObjectDefineProperty(this, "reactive", {
                  value: proxy,
                });
                return proxy;
              },
              get readOnly() {
                const readOnlyHandler = new ReadOnlyHandler(membrane, distortedValue);
                // caching the readOnly proxy after the first time it is accessed
                const proxy = new Proxy(createShadowTarget(distortedValue), readOnlyHandler);
                registerProxy(proxy, value);
                ObjectDefineProperty(this, "readOnly", {
                  value: proxy,
                });
                return proxy;
              },
            };
            objectGraph.set(distortedValue, reactiveState);
            return reactiveState;
          }
        }
        /** version: 0.26.0 */

        function wrap(data, mutationCallback) {
          let membrane = new ReactiveMembrane({
            valueMutated(target, key) {
              mutationCallback(target, key);
            },
          });
          return {
            data: membrane.getProxy(data),
            membrane: membrane,
          };
        }

        function unwrap$1(membrane, observable) {
          let unwrappedData = membrane.unwrapProxy(observable);
          let copy = {};
          Object.keys(unwrappedData).forEach((key) => {
            if (["$el", "$refs", "$nextTick", "$watch"].includes(key)) return;
            copy[key] = unwrappedData[key];
          });
          return copy;
        }

        class Component {
          constructor(el, componentForClone = null) {
            this.$el = el;
            const dataAttr = this.$el.getAttribute("x-data");
            const dataExpression = dataAttr === "" ? "{}" : dataAttr;
            const initExpression = this.$el.getAttribute("x-init");
            let dataExtras = {
              $el: this.$el,
            };
            let canonicalComponentElementReference = componentForClone ? componentForClone.$el : this.$el;
            Object.entries(Alpine.magicProperties).forEach(([name, callback]) => {
              Object.defineProperty(dataExtras, `$${name}`, {
                get: function get() {
                  return callback(canonicalComponentElementReference);
                },
              });
            });
            this.unobservedData = componentForClone
              ? componentForClone.getUnobservedData()
              : saferEval(el, dataExpression, dataExtras);
            // Construct a Proxy-based observable. This will be used to handle reactivity.

            let { membrane, data } = this.wrapDataInObservable(this.unobservedData);
            this.$data = data;
            this.membrane = membrane; // After making user-supplied data methods reactive, we can now add
            // our magic properties to the original data for access.

            this.unobservedData.$el = this.$el;
            this.unobservedData.$refs = this.getRefsProxy();
            this.nextTickStack = [];

            this.unobservedData.$nextTick = (callback) => {
              this.nextTickStack.push(callback);
            };

            this.watchers = {};

            this.unobservedData.$watch = (property, callback) => {
              if (!this.watchers[property]) this.watchers[property] = [];
              this.watchers[property].push(callback);
            };
            /* MODERN-ONLY:START */
            // We remove this piece of code from the legacy build.
            // In IE11, we have already defined our helpers at this point.
            // Register custom magic properties.

            Object.entries(Alpine.magicProperties).forEach(([name, callback]) => {
              Object.defineProperty(this.unobservedData, `$${name}`, {
                get: function get() {
                  return callback(canonicalComponentElementReference, this.$el);
                },
              });
            });
            /* MODERN-ONLY:END */

            this.showDirectiveStack = [];
            this.showDirectiveLastElement;
            componentForClone || Alpine.onBeforeComponentInitializeds.forEach((callback) => callback(this));
            var initReturnedCallback; // If x-init is present AND we aren't cloning (skip x-init on clone)

            if (initExpression && !componentForClone) {
              // We want to allow data manipulation, but not trigger DOM updates just yet.
              // We haven't even initialized the elements with their Alpine bindings. I mean c'mon.
              this.pauseReactivity = true;
              initReturnedCallback = this.evaluateReturnExpression(this.$el, initExpression);
              this.pauseReactivity = false;
            } // Register all our listeners and set all our attribute bindings.

            this.initializeElements(this.$el); // Use mutation observer to detect new elements being added within this component at run-time.
            // Alpine's just so darn flexible amirite?

            this.listenForNewElementsToInitialize();

            if (typeof initReturnedCallback === "function") {
              // Run the callback returned from the "x-init" hook to allow the user to do stuff after
              // Alpine's got it's grubby little paws all over everything.
              initReturnedCallback.call(this.$data);
            }

            componentForClone ||
              setTimeout(() => {
                Alpine.onComponentInitializeds.forEach((callback) => callback(this));
              }, 0);
          }

          getUnobservedData() {
            return unwrap$1(this.membrane, this.$data);
          }

          wrapDataInObservable(data) {
            var self = this;
            let updateDom = debounce(function () {
              self.updateElements(self.$el);
            }, 0);
            return wrap(data, (target, key) => {
              if (self.watchers[key]) {
                // If there's a watcher for this specific key, run it.
                self.watchers[key].forEach((callback) => callback(target[key]));
              } else if (Array.isArray(target)) {
                // Arrays are special cases, if any of the items change, we consider the array as mutated.
                Object.keys(self.watchers).forEach((fullDotNotationKey) => {
                  let dotNotationParts = fullDotNotationKey.split("."); // Ignore length mutations since they would result in duplicate calls.
                  // For example, when calling push, we would get a mutation for the item's key
                  // and a second mutation for the length property.

                  if (key === "length") return;
                  dotNotationParts.reduce((comparisonData, part) => {
                    if (Object.is(target, comparisonData[part])) {
                      self.watchers[fullDotNotationKey].forEach((callback) => callback(target));
                    }

                    return comparisonData[part];
                  }, self.unobservedData);
                });
              } else {
                // Let's walk through the watchers with "dot-notation" (foo.bar) and see
                // if this mutation fits any of them.
                Object.keys(self.watchers)
                  .filter((i) => i.includes("."))
                  .forEach((fullDotNotationKey) => {
                    let dotNotationParts = fullDotNotationKey.split("."); // If this dot-notation watcher's last "part" doesn't match the current
                    // key, then skip it early for performance reasons.

                    if (key !== dotNotationParts[dotNotationParts.length - 1]) return; // Now, walk through the dot-notation "parts" recursively to find
                    // a match, and call the watcher if one's found.

                    dotNotationParts.reduce((comparisonData, part) => {
                      if (Object.is(target, comparisonData)) {
                        // Run the watchers.
                        self.watchers[fullDotNotationKey].forEach((callback) => callback(target[key]));
                      }

                      return comparisonData[part];
                    }, self.unobservedData);
                  });
              } // Don't react to data changes for cases like the `x-created` hook.

              if (self.pauseReactivity) return;
              updateDom();
            });
          }

          walkAndSkipNestedComponents(el, callback, initializeComponentCallback = () => {}) {
            walk(el, (el) => {
              // We've hit a component.
              if (el.hasAttribute("x-data")) {
                // If it's not the current one.
                if (!el.isSameNode(this.$el)) {
                  // Initialize it if it's not.
                  if (!el.__x) initializeComponentCallback(el); // Now we'll let that sub-component deal with itself.

                  return false;
                }
              }

              return callback(el);
            });
          }

          initializeElements(rootEl, extraVars = () => {}) {
            this.walkAndSkipNestedComponents(
              rootEl,
              (el) => {
                // Don't touch spawns from for loop
                if (el.__x_for_key !== undefined) return false; // Don't touch spawns from if directives

                if (el.__x_inserted_me !== undefined) return false;
                this.initializeElement(el, extraVars);
              },
              (el) => {
                el.__x = new Component(el);
              }
            );
            this.executeAndClearRemainingShowDirectiveStack();
            this.executeAndClearNextTickStack(rootEl);
          }

          initializeElement(el, extraVars) {
            // To support class attribute merging, we have to know what the element's
            // original class attribute looked like for reference.
            if (el.hasAttribute("class") && getXAttrs(el, this).length > 0) {
              el.__x_original_classes = convertClassStringToArray(el.getAttribute("class"));
            }

            this.registerListeners(el, extraVars);
            this.resolveBoundAttributes(el, true, extraVars);
          }

          updateElements(rootEl, extraVars = () => {}) {
            this.walkAndSkipNestedComponents(
              rootEl,
              (el) => {
                // Don't touch spawns from for loop (and check if the root is actually a for loop in a parent, don't skip it.)
                if (el.__x_for_key !== undefined && !el.isSameNode(this.$el)) return false;
                this.updateElement(el, extraVars);
              },
              (el) => {
                el.__x = new Component(el);
              }
            );
            this.executeAndClearRemainingShowDirectiveStack();
            this.executeAndClearNextTickStack(rootEl);
          }

          executeAndClearNextTickStack(el) {
            // Skip spawns from alpine directives
            if (el === this.$el && this.nextTickStack.length > 0) {
              // We run the tick stack after the next frame to allow any
              // running transitions to pass the initial show stage.
              requestAnimationFrame(() => {
                while (this.nextTickStack.length > 0) {
                  this.nextTickStack.shift()();
                }
              });
            }
          }

          executeAndClearRemainingShowDirectiveStack() {
            // The goal here is to start all the x-show transitions
            // and build a nested promise chain so that elements
            // only hide when the children are finished hiding.
            this.showDirectiveStack
              .reverse()
              .map((handler) => {
                return new Promise((resolve, reject) => {
                  handler(resolve, reject);
                });
              })
              .reduce(
                (promiseChain, promise) => {
                  return promiseChain.then(() => {
                    return promise.then((finishElement) => {
                      finishElement();
                    });
                  });
                },
                Promise.resolve(() => {})
              )
              .catch((e) => {
                if (e !== TRANSITION_CANCELLED) throw e;
              }); // We've processed the handler stack. let's clear it.

            this.showDirectiveStack = [];
            this.showDirectiveLastElement = undefined;
          }

          updateElement(el, extraVars) {
            this.resolveBoundAttributes(el, false, extraVars);
          }

          registerListeners(el, extraVars) {
            getXAttrs(el, this).forEach(({ type, value, modifiers, expression }) => {
              switch (type) {
                case "on":
                  registerListener(this, el, value, modifiers, expression, extraVars);
                  break;

                case "model":
                  registerModelListener(this, el, modifiers, expression, extraVars);
                  break;
              }
            });
          }

          resolveBoundAttributes(el, initialUpdate = false, extraVars) {
            let attrs = getXAttrs(el, this);
            attrs.forEach(({ type, value, modifiers, expression }) => {
              switch (type) {
                case "model":
                  handleAttributeBindingDirective(this, el, "value", expression, extraVars, type, modifiers);
                  break;

                case "bind":
                  // The :key binding on an x-for is special, ignore it.
                  if (el.tagName.toLowerCase() === "template" && value === "key") return;
                  handleAttributeBindingDirective(this, el, value, expression, extraVars, type, modifiers);
                  break;

                case "text":
                  var output = this.evaluateReturnExpression(el, expression, extraVars);
                  handleTextDirective(el, output, expression);
                  break;

                case "html":
                  handleHtmlDirective(this, el, expression, extraVars);
                  break;

                case "show":
                  var output = this.evaluateReturnExpression(el, expression, extraVars);
                  handleShowDirective(this, el, output, modifiers, initialUpdate);
                  break;

                case "if":
                  // If this element also has x-for on it, don't process x-if.
                  // We will let the "x-for" directive handle the "if"ing.
                  if (attrs.some((i) => i.type === "for")) return;
                  var output = this.evaluateReturnExpression(el, expression, extraVars);
                  handleIfDirective(this, el, output, initialUpdate, extraVars);
                  break;

                case "for":
                  handleForDirective(this, el, expression, initialUpdate, extraVars);
                  break;

                case "cloak":
                  el.removeAttribute("x-cloak");
                  break;
              }
            });
          }

          evaluateReturnExpression(el, expression, extraVars = () => {}) {
            return saferEval(
              el,
              expression,
              this.$data,
              _objectSpread2(
                _objectSpread2({}, extraVars()),
                {},
                {
                  $dispatch: this.getDispatchFunction(el),
                }
              )
            );
          }

          evaluateCommandExpression(el, expression, extraVars = () => {}) {
            return saferEvalNoReturn(
              el,
              expression,
              this.$data,
              _objectSpread2(
                _objectSpread2({}, extraVars()),
                {},
                {
                  $dispatch: this.getDispatchFunction(el),
                }
              )
            );
          }

          getDispatchFunction(el) {
            return (event, detail = {}) => {
              el.dispatchEvent(
                new CustomEvent(event, {
                  detail,
                  bubbles: true,
                })
              );
            };
          }

          listenForNewElementsToInitialize() {
            const targetNode = this.$el;
            const observerOptions = {
              childList: true,
              attributes: true,
              subtree: true,
            };
            const observer = new MutationObserver((mutations) => {
              for (let i = 0; i < mutations.length; i++) {
                // Filter out mutations triggered from child components.
                const closestParentComponent = mutations[i].target.closest("[x-data]");
                if (!(closestParentComponent && closestParentComponent.isSameNode(this.$el))) continue;

                if (mutations[i].type === "attributes" && mutations[i].attributeName === "x-data") {
                  const xAttr = mutations[i].target.getAttribute("x-data") || "{}";
                  const rawData = saferEval(this.$el, xAttr, {
                    $el: this.$el,
                  });
                  Object.keys(rawData).forEach((key) => {
                    if (this.$data[key] !== rawData[key]) {
                      this.$data[key] = rawData[key];
                    }
                  });
                }

                if (mutations[i].addedNodes.length > 0) {
                  mutations[i].addedNodes.forEach((node) => {
                    if (node.nodeType !== 1 || node.__x_inserted_me) return;

                    if (node.matches("[x-data]") && !node.__x) {
                      node.__x = new Component(node);
                      return;
                    }

                    this.initializeElements(node);
                  });
                }
              }
            });
            observer.observe(targetNode, observerOptions);
          }

          getRefsProxy() {
            var self = this;
            var refObj = {};
            // One of the goals of this is to not hold elements in memory, but rather re-evaluate
            // the DOM when the system needs something from it. This way, the framework is flexible and
            // friendly to outside DOM changes from libraries like Vue/Livewire.
            // For this reason, I'm using an "on-demand" proxy to fake a "$refs" object.

            return new Proxy(refObj, {
              get(object, property) {
                if (property === "$isAlpineProxy") return true;
                var ref; // We can't just query the DOM because it's hard to filter out refs in
                // nested components.

                self.walkAndSkipNestedComponents(self.$el, (el) => {
                  if (el.hasAttribute("x-ref") && el.getAttribute("x-ref") === property) {
                    ref = el;
                  }
                });
                return ref;
              },
            });
          }
        }

        const Alpine = {
          version: "2.8.0",
          pauseMutationObserver: false,
          magicProperties: {},
          onComponentInitializeds: [],
          onBeforeComponentInitializeds: [],
          ignoreFocusedForValueBinding: false,
          start: async function start() {
            if (!isTesting()) {
              await domReady();
            }

            this.discoverComponents((el) => {
              this.initializeComponent(el);
            }); // It's easier and more performant to just support Turbolinks than listen
            // to MutationObserver mutations at the document level.

            document.addEventListener("turbolinks:load", () => {
              this.discoverUninitializedComponents((el) => {
                this.initializeComponent(el);
              });
            });
            this.listenForNewUninitializedComponentsAtRunTime();
          },
          discoverComponents: function discoverComponents(callback) {
            const rootEls = document.querySelectorAll("[x-data]");
            rootEls.forEach((rootEl) => {
              callback(rootEl);
            });
          },
          discoverUninitializedComponents: function discoverUninitializedComponents(callback, el = null) {
            const rootEls = (el || document).querySelectorAll("[x-data]");
            Array.from(rootEls)
              .filter((el) => el.__x === undefined)
              .forEach((rootEl) => {
                callback(rootEl);
              });
          },
          listenForNewUninitializedComponentsAtRunTime: function listenForNewUninitializedComponentsAtRunTime() {
            const targetNode = document.querySelector("body");
            const observerOptions = {
              childList: true,
              attributes: true,
              subtree: true,
            };
            const observer = new MutationObserver((mutations) => {
              if (this.pauseMutationObserver) return;

              for (let i = 0; i < mutations.length; i++) {
                if (mutations[i].addedNodes.length > 0) {
                  mutations[i].addedNodes.forEach((node) => {
                    // Discard non-element nodes (like line-breaks)
                    if (node.nodeType !== 1) return; // Discard any changes happening within an existing component.
                    // They will take care of themselves.

                    if (node.parentElement && node.parentElement.closest("[x-data]")) return;
                    this.discoverUninitializedComponents((el) => {
                      this.initializeComponent(el);
                    }, node.parentElement);
                  });
                }
              }
            });
            observer.observe(targetNode, observerOptions);
          },
          initializeComponent: function initializeComponent(el) {
            if (!el.__x) {
              // Wrap in a try/catch so that we don't prevent other components
              // from initializing when one component contains an error.
              try {
                el.__x = new Component(el);
              } catch (error) {
                setTimeout(() => {
                  throw error;
                }, 0);
              }
            }
          },
          clone: function clone(component, newEl) {
            if (!newEl.__x) {
              newEl.__x = new Component(newEl, component);
            }
          },
          addMagicProperty: function addMagicProperty(name, callback) {
            this.magicProperties[name] = callback;
          },
          onComponentInitialized: function onComponentInitialized(callback) {
            this.onComponentInitializeds.push(callback);
          },
          onBeforeComponentInitialized: function onBeforeComponentInitialized(callback) {
            this.onBeforeComponentInitializeds.push(callback);
          },
        };

        if (!isTesting()) {
          window.Alpine = Alpine;

          if (window.deferLoadingAlpine) {
            window.deferLoadingAlpine(function () {
              window.Alpine.start();
            });
          } else {
            window.Alpine.start();
          }
        }

        return Alpine;
      });

      /***/
    },
    /* 17 */
    /***/
    function (module, exports, __webpack_require__) {
      // extracted by mini-css-extract-plugin
      /***/
    },
    /* 18 */
    /***/
    function (module, exports) {
      var _createClass = (function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }
        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      })();

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      /**
       * This work is licensed under the W3C Software and Document License
       * (http://www.w3.org/Consortium/Legal/2015/copyright-software-and-document).
       */

      (function () {
        // Return early if we're not running inside of the browser.
        if (typeof window === "undefined") {
          return;
        }

        // Convenience function for converting NodeLists.
        /** @type {typeof Array.prototype.slice} */
        var slice = Array.prototype.slice;

        /**
         * IE has a non-standard name for "matches".
         * @type {typeof Element.prototype.matches}
         */
        var matches = Element.prototype.matches || Element.prototype.msMatchesSelector;

        /** @type {string} */
        var _focusableElementsString = [
          "a[href]",
          "area[href]",
          "input:not([disabled])",
          "select:not([disabled])",
          "textarea:not([disabled])",
          "button:not([disabled])",
          "details",
          "summary",
          "iframe",
          "object",
          "embed",
          "[contenteditable]",
        ].join(",");

        /**
         * `InertRoot` manages a single inert subtree, i.e. a DOM subtree whose root element has an `inert`
         * attribute.
         *
         * Its main functions are:
         *
         * - to create and maintain a set of managed `InertNode`s, including when mutations occur in the
         *   subtree. The `makeSubtreeUnfocusable()` method handles collecting `InertNode`s via registering
         *   each focusable node in the subtree with the singleton `InertManager` which manages all known
         *   focusable nodes within inert subtrees. `InertManager` ensures that a single `InertNode`
         *   instance exists for each focusable node which has at least one inert root as an ancestor.
         *
         * - to notify all managed `InertNode`s when this subtree stops being inert (i.e. when the `inert`
         *   attribute is removed from the root node). This is handled in the destructor, which calls the
         *   `deregister` method on `InertManager` for each managed inert node.
         */

        var InertRoot = (function () {
          /**
           * @param {!Element} rootElement The Element at the root of the inert subtree.
           * @param {!InertManager} inertManager The global singleton InertManager object.
           */
          function InertRoot(rootElement, inertManager) {
            _classCallCheck(this, InertRoot);

            /** @type {!InertManager} */
            this._inertManager = inertManager;

            /** @type {!Element} */
            this._rootElement = rootElement;

            /**
             * @type {!Set<!InertNode>}
             * All managed focusable nodes in this InertRoot's subtree.
             */
            this._managedNodes = new Set();

            // Make the subtree hidden from assistive technology
            if (this._rootElement.hasAttribute("aria-hidden")) {
              /** @type {?string} */
              this._savedAriaHidden = this._rootElement.getAttribute("aria-hidden");
            } else {
              this._savedAriaHidden = null;
            }
            this._rootElement.setAttribute("aria-hidden", "true");

            // Make all focusable elements in the subtree unfocusable and add them to _managedNodes
            this._makeSubtreeUnfocusable(this._rootElement);

            // Watch for:
            // - any additions in the subtree: make them unfocusable too
            // - any removals from the subtree: remove them from this inert root's managed nodes
            // - attribute changes: if `tabindex` is added, or removed from an intrinsically focusable
            //   element, make that node a managed node.
            this._observer = new MutationObserver(this._onMutation.bind(this));
            this._observer.observe(this._rootElement, {
              attributes: true,
              childList: true,
              subtree: true,
            });
          }

          /**
           * Call this whenever this object is about to become obsolete.  This unwinds all of the state
           * stored in this object and updates the state of all of the managed nodes.
           */

          _createClass(InertRoot, [
            {
              key: "destructor",
              value: function destructor() {
                this._observer.disconnect();

                if (this._rootElement) {
                  if (this._savedAriaHidden !== null) {
                    this._rootElement.setAttribute("aria-hidden", this._savedAriaHidden);
                  } else {
                    this._rootElement.removeAttribute("aria-hidden");
                  }
                }

                this._managedNodes.forEach(function (inertNode) {
                  this._unmanageNode(inertNode.node);
                }, this);

                // Note we cast the nulls to the ANY type here because:
                // 1) We want the class properties to be declared as non-null, or else we
                //    need even more casts throughout this code. All bets are off if an
                //    instance has been destroyed and a method is called.
                // 2) We don't want to cast "this", because we want type-aware optimizations
                //    to know which properties we're setting.
                this._observer = /** @type {?} */ null;
                this._rootElement = /** @type {?} */ null;
                this._managedNodes = /** @type {?} */ null;
                this._inertManager = /** @type {?} */ null;
              },

              /**
               * @return {!Set<!InertNode>} A copy of this InertRoot's managed nodes set.
               */
            },
            {
              key: "_makeSubtreeUnfocusable",

              /**
               * @param {!Node} startNode
               */
              value: function _makeSubtreeUnfocusable(startNode) {
                var _this2 = this;

                composedTreeWalk(startNode, function (node) {
                  return _this2._visitNode(node);
                });

                var activeElement = document.activeElement;

                if (!document.body.contains(startNode)) {
                  // startNode may be in shadow DOM, so find its nearest shadowRoot to get the activeElement.
                  var node = startNode;
                  /** @type {!ShadowRoot|undefined} */
                  var root = undefined;
                  while (node) {
                    if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                      root = /** @type {!ShadowRoot} */ node;
                      break;
                    }
                    node = node.parentNode;
                  }
                  if (root) {
                    activeElement = root.activeElement;
                  }
                }
                if (startNode.contains(activeElement)) {
                  activeElement.blur();
                  // In IE11, if an element is already focused, and then set to tabindex=-1
                  // calling blur() will not actually move the focus.
                  // To work around this we call focus() on the body instead.
                  if (activeElement === document.activeElement) {
                    document.body.focus();
                  }
                }
              },

              /**
               * @param {!Node} node
               */
            },
            {
              key: "_visitNode",
              value: function _visitNode(node) {
                if (node.nodeType !== Node.ELEMENT_NODE) {
                  return;
                }
                var element = /** @type {!Element} */ node;

                // If a descendant inert root becomes un-inert, its descendants will still be inert because of
                // this inert root, so all of its managed nodes need to be adopted by this InertRoot.
                if (element !== this._rootElement && element.hasAttribute("inert")) {
                  this._adoptInertRoot(element);
                }

                if (matches.call(element, _focusableElementsString) || element.hasAttribute("tabindex")) {
                  this._manageNode(element);
                }
              },

              /**
               * Register the given node with this InertRoot and with InertManager.
               * @param {!Node} node
               */
            },
            {
              key: "_manageNode",
              value: function _manageNode(node) {
                var inertNode = this._inertManager.register(node, this);
                this._managedNodes.add(inertNode);
              },

              /**
               * Unregister the given node with this InertRoot and with InertManager.
               * @param {!Node} node
               */
            },
            {
              key: "_unmanageNode",
              value: function _unmanageNode(node) {
                var inertNode = this._inertManager.deregister(node, this);
                if (inertNode) {
                  this._managedNodes["delete"](inertNode);
                }
              },

              /**
               * Unregister the entire subtree starting at `startNode`.
               * @param {!Node} startNode
               */
            },
            {
              key: "_unmanageSubtree",
              value: function _unmanageSubtree(startNode) {
                var _this3 = this;

                composedTreeWalk(startNode, function (node) {
                  return _this3._unmanageNode(node);
                });
              },

              /**
               * If a descendant node is found with an `inert` attribute, adopt its managed nodes.
               * @param {!Element} node
               */
            },
            {
              key: "_adoptInertRoot",
              value: function _adoptInertRoot(node) {
                var inertSubroot = this._inertManager.getInertRoot(node);

                // During initialisation this inert root may not have been registered yet,
                // so register it now if need be.
                if (!inertSubroot) {
                  this._inertManager.setInert(node, true);
                  inertSubroot = this._inertManager.getInertRoot(node);
                }

                inertSubroot.managedNodes.forEach(function (savedInertNode) {
                  this._manageNode(savedInertNode.node);
                }, this);
              },

              /**
               * Callback used when mutation observer detects subtree additions, removals, or attribute changes.
               * @param {!Array<!MutationRecord>} records
               * @param {!MutationObserver} self
               */
            },
            {
              key: "_onMutation",
              value: function _onMutation(records, self) {
                records.forEach(function (record) {
                  var target = /** @type {!Element} */ record.target;
                  if (record.type === "childList") {
                    // Manage added nodes
                    slice.call(record.addedNodes).forEach(function (node) {
                      this._makeSubtreeUnfocusable(node);
                    }, this);

                    // Un-manage removed nodes
                    slice.call(record.removedNodes).forEach(function (node) {
                      this._unmanageSubtree(node);
                    }, this);
                  } else if (record.type === "attributes") {
                    if (record.attributeName === "tabindex") {
                      // Re-initialise inert node if tabindex changes
                      this._manageNode(target);
                    } else if (
                      target !== this._rootElement &&
                      record.attributeName === "inert" &&
                      target.hasAttribute("inert")
                    ) {
                      // If a new inert root is added, adopt its managed nodes and make sure it knows about the
                      // already managed nodes from this inert subroot.
                      this._adoptInertRoot(target);
                      var inertSubroot = this._inertManager.getInertRoot(target);
                      this._managedNodes.forEach(function (managedNode) {
                        if (target.contains(managedNode.node)) {
                          inertSubroot._manageNode(managedNode.node);
                        }
                      });
                    }
                  }
                }, this);
              },
            },
            {
              key: "managedNodes",
              get: function get() {
                return new Set(this._managedNodes);
              },

              /** @return {boolean} */
            },
            {
              key: "hasSavedAriaHidden",
              get: function get() {
                return this._savedAriaHidden !== null;
              },

              /** @param {?string} ariaHidden */
            },
            {
              key: "savedAriaHidden",
              set: function set(ariaHidden) {
                this._savedAriaHidden = ariaHidden;
              },

              /** @return {?string} */
              get: function get() {
                return this._savedAriaHidden;
              },
            },
          ]);

          return InertRoot;
        })();

        /**
         * `InertNode` initialises and manages a single inert node.
         * A node is inert if it is a descendant of one or more inert root elements.
         *
         * On construction, `InertNode` saves the existing `tabindex` value for the node, if any, and
         * either removes the `tabindex` attribute or sets it to `-1`, depending on whether the element
         * is intrinsically focusable or not.
         *
         * `InertNode` maintains a set of `InertRoot`s which are descendants of this `InertNode`. When an
         * `InertRoot` is destroyed, and calls `InertManager.deregister()`, the `InertManager` notifies the
         * `InertNode` via `removeInertRoot()`, which in turn destroys the `InertNode` if no `InertRoot`s
         * remain in the set. On destruction, `InertNode` reinstates the stored `tabindex` if one exists,
         * or removes the `tabindex` attribute if the element is intrinsically focusable.
         */

        var InertNode = (function () {
          /**
           * @param {!Node} node A focusable element to be made inert.
           * @param {!InertRoot} inertRoot The inert root element associated with this inert node.
           */
          function InertNode(node, inertRoot) {
            _classCallCheck(this, InertNode);

            /** @type {!Node} */
            this._node = node;

            /** @type {boolean} */
            this._overrodeFocusMethod = false;

            /**
             * @type {!Set<!InertRoot>} The set of descendant inert roots.
             *    If and only if this set becomes empty, this node is no longer inert.
             */
            this._inertRoots = new Set([inertRoot]);

            /** @type {?number} */
            this._savedTabIndex = null;

            /** @type {boolean} */
            this._destroyed = false;

            // Save any prior tabindex info and make this node untabbable
            this.ensureUntabbable();
          }

          /**
           * Call this whenever this object is about to become obsolete.
           * This makes the managed node focusable again and deletes all of the previously stored state.
           */

          _createClass(InertNode, [
            {
              key: "destructor",
              value: function destructor() {
                this._throwIfDestroyed();

                if (this._node && this._node.nodeType === Node.ELEMENT_NODE) {
                  var element = /** @type {!Element} */ this._node;
                  if (this._savedTabIndex !== null) {
                    element.setAttribute("tabindex", this._savedTabIndex);
                  } else {
                    element.removeAttribute("tabindex");
                  }

                  // Use `delete` to restore native focus method.
                  if (this._overrodeFocusMethod) {
                    delete element.focus;
                  }
                }

                // See note in InertRoot.destructor for why we cast these nulls to ANY.
                this._node = /** @type {?} */ null;
                this._inertRoots = /** @type {?} */ null;
                this._destroyed = true;
              },

              /**
               * @type {boolean} Whether this object is obsolete because the managed node is no longer inert.
               * If the object has been destroyed, any attempt to access it will cause an exception.
               */
            },
            {
              key: "_throwIfDestroyed",

              /**
               * Throw if user tries to access destroyed InertNode.
               */
              value: function _throwIfDestroyed() {
                if (this.destroyed) {
                  throw new Error("Trying to access destroyed InertNode");
                }
              },

              /** @return {boolean} */
            },
            {
              key: "ensureUntabbable",

              /** Save the existing tabindex value and make the node untabbable and unfocusable */
              value: function ensureUntabbable() {
                if (this.node.nodeType !== Node.ELEMENT_NODE) {
                  return;
                }
                var element = /** @type {!Element} */ this.node;
                if (matches.call(element, _focusableElementsString)) {
                  if (/** @type {!HTMLElement} */ element.tabIndex === -1 && this.hasSavedTabIndex) {
                    return;
                  }

                  if (element.hasAttribute("tabindex")) {
                    this._savedTabIndex = /** @type {!HTMLElement} */ element.tabIndex;
                  }
                  element.setAttribute("tabindex", "-1");
                  if (element.nodeType === Node.ELEMENT_NODE) {
                    element.focus = function () {};
                    this._overrodeFocusMethod = true;
                  }
                } else if (element.hasAttribute("tabindex")) {
                  this._savedTabIndex = /** @type {!HTMLElement} */ element.tabIndex;
                  element.removeAttribute("tabindex");
                }
              },

              /**
               * Add another inert root to this inert node's set of managing inert roots.
               * @param {!InertRoot} inertRoot
               */
            },
            {
              key: "addInertRoot",
              value: function addInertRoot(inertRoot) {
                this._throwIfDestroyed();
                this._inertRoots.add(inertRoot);
              },

              /**
               * Remove the given inert root from this inert node's set of managing inert roots.
               * If the set of managing inert roots becomes empty, this node is no longer inert,
               * so the object should be destroyed.
               * @param {!InertRoot} inertRoot
               */
            },
            {
              key: "removeInertRoot",
              value: function removeInertRoot(inertRoot) {
                this._throwIfDestroyed();
                this._inertRoots["delete"](inertRoot);
                if (this._inertRoots.size === 0) {
                  this.destructor();
                }
              },
            },
            {
              key: "destroyed",
              get: function get() {
                return /** @type {!InertNode} */ this._destroyed;
              },
            },
            {
              key: "hasSavedTabIndex",
              get: function get() {
                return this._savedTabIndex !== null;
              },

              /** @return {!Node} */
            },
            {
              key: "node",
              get: function get() {
                this._throwIfDestroyed();
                return this._node;
              },

              /** @param {?number} tabIndex */
            },
            {
              key: "savedTabIndex",
              set: function set(tabIndex) {
                this._throwIfDestroyed();
                this._savedTabIndex = tabIndex;
              },

              /** @return {?number} */
              get: function get() {
                this._throwIfDestroyed();
                return this._savedTabIndex;
              },
            },
          ]);

          return InertNode;
        })();

        /**
         * InertManager is a per-document singleton object which manages all inert roots and nodes.
         *
         * When an element becomes an inert root by having an `inert` attribute set and/or its `inert`
         * property set to `true`, the `setInert` method creates an `InertRoot` object for the element.
         * The `InertRoot` in turn registers itself as managing all of the element's focusable descendant
         * nodes via the `register()` method. The `InertManager` ensures that a single `InertNode` instance
         * is created for each such node, via the `_managedNodes` map.
         */

        var InertManager = (function () {
          /**
           * @param {!Document} document
           */
          function InertManager(document) {
            _classCallCheck(this, InertManager);

            if (!document) {
              throw new Error("Missing required argument; InertManager needs to wrap a document.");
            }

            /** @type {!Document} */
            this._document = document;

            /**
             * All managed nodes known to this InertManager. In a map to allow looking up by Node.
             * @type {!Map<!Node, !InertNode>}
             */
            this._managedNodes = new Map();

            /**
             * All inert roots known to this InertManager. In a map to allow looking up by Node.
             * @type {!Map<!Node, !InertRoot>}
             */
            this._inertRoots = new Map();

            /**
             * Observer for mutations on `document.body`.
             * @type {!MutationObserver}
             */
            this._observer = new MutationObserver(this._watchForInert.bind(this));

            // Add inert style.
            addInertStyle(document.head || document.body || document.documentElement);

            // Wait for document to be loaded.
            if (document.readyState === "loading") {
              document.addEventListener("DOMContentLoaded", this._onDocumentLoaded.bind(this));
            } else {
              this._onDocumentLoaded();
            }
          }

          /**
           * Set whether the given element should be an inert root or not.
           * @param {!Element} root
           * @param {boolean} inert
           */

          _createClass(InertManager, [
            {
              key: "setInert",
              value: function setInert(root, inert) {
                if (inert) {
                  if (this._inertRoots.has(root)) {
                    // element is already inert
                    return;
                  }

                  var inertRoot = new InertRoot(root, this);
                  root.setAttribute("inert", "");
                  this._inertRoots.set(root, inertRoot);
                  // If not contained in the document, it must be in a shadowRoot.
                  // Ensure inert styles are added there.
                  if (!this._document.body.contains(root)) {
                    var parent = root.parentNode;
                    while (parent) {
                      if (parent.nodeType === 11) {
                        addInertStyle(parent);
                      }
                      parent = parent.parentNode;
                    }
                  }
                } else {
                  if (!this._inertRoots.has(root)) {
                    // element is already non-inert
                    return;
                  }

                  var _inertRoot = this._inertRoots.get(root);
                  _inertRoot.destructor();
                  this._inertRoots["delete"](root);
                  root.removeAttribute("inert");
                }
              },

              /**
               * Get the InertRoot object corresponding to the given inert root element, if any.
               * @param {!Node} element
               * @return {!InertRoot|undefined}
               */
            },
            {
              key: "getInertRoot",
              value: function getInertRoot(element) {
                return this._inertRoots.get(element);
              },

              /**
               * Register the given InertRoot as managing the given node.
               * In the case where the node has a previously existing inert root, this inert root will
               * be added to its set of inert roots.
               * @param {!Node} node
               * @param {!InertRoot} inertRoot
               * @return {!InertNode} inertNode
               */
            },
            {
              key: "register",
              value: function register(node, inertRoot) {
                var inertNode = this._managedNodes.get(node);
                if (inertNode !== undefined) {
                  // node was already in an inert subtree
                  inertNode.addInertRoot(inertRoot);
                } else {
                  inertNode = new InertNode(node, inertRoot);
                }

                this._managedNodes.set(node, inertNode);

                return inertNode;
              },

              /**
               * De-register the given InertRoot as managing the given inert node.
               * Removes the inert root from the InertNode's set of managing inert roots, and remove the inert
               * node from the InertManager's set of managed nodes if it is destroyed.
               * If the node is not currently managed, this is essentially a no-op.
               * @param {!Node} node
               * @param {!InertRoot} inertRoot
               * @return {?InertNode} The potentially destroyed InertNode associated with this node, if any.
               */
            },
            {
              key: "deregister",
              value: function deregister(node, inertRoot) {
                var inertNode = this._managedNodes.get(node);
                if (!inertNode) {
                  return null;
                }

                inertNode.removeInertRoot(inertRoot);
                if (inertNode.destroyed) {
                  this._managedNodes["delete"](node);
                }

                return inertNode;
              },

              /**
               * Callback used when document has finished loading.
               */
            },
            {
              key: "_onDocumentLoaded",
              value: function _onDocumentLoaded() {
                // Find all inert roots in document and make them actually inert.
                var inertElements = slice.call(this._document.querySelectorAll("[inert]"));
                inertElements.forEach(function (inertElement) {
                  this.setInert(inertElement, true);
                }, this);

                // Comment this out to use programmatic API only.
                this._observer.observe(this._document.body || this._document.documentElement, {
                  attributes: true,
                  subtree: true,
                  childList: true,
                });
              },

              /**
               * Callback used when mutation observer detects attribute changes.
               * @param {!Array<!MutationRecord>} records
               * @param {!MutationObserver} self
               */
            },
            {
              key: "_watchForInert",
              value: function _watchForInert(records, self) {
                var _this = this;
                records.forEach(function (record) {
                  switch (record.type) {
                    case "childList":
                      slice.call(record.addedNodes).forEach(function (node) {
                        if (node.nodeType !== Node.ELEMENT_NODE) {
                          return;
                        }
                        var inertElements = slice.call(node.querySelectorAll("[inert]"));
                        if (matches.call(node, "[inert]")) {
                          inertElements.unshift(node);
                        }
                        inertElements.forEach(function (inertElement) {
                          this.setInert(inertElement, true);
                        }, _this);
                      }, _this);
                      break;
                    case "attributes":
                      if (record.attributeName !== "inert") {
                        return;
                      }
                      var target = /** @type {!Element} */ record.target;
                      var inert = target.hasAttribute("inert");
                      _this.setInert(target, inert);
                      break;
                  }
                }, this);
              },
            },
          ]);

          return InertManager;
        })();

        /**
         * Recursively walk the composed tree from |node|.
         * @param {!Node} node
         * @param {(function (!Element))=} callback Callback to be called for each element traversed,
         *     before descending into child nodes.
         * @param {?ShadowRoot=} shadowRootAncestor The nearest ShadowRoot ancestor, if any.
         */

        function composedTreeWalk(node, callback, shadowRootAncestor) {
          if (node.nodeType == Node.ELEMENT_NODE) {
            var element = /** @type {!Element} */ node;
            if (callback) {
              callback(element);
            }

            // Descend into node:
            // If it has a ShadowRoot, ignore all child elements - these will be picked
            // up by the <content> or <shadow> elements. Descend straight into the
            // ShadowRoot.
            var shadowRoot = /** @type {!HTMLElement} */ element.shadowRoot;
            if (shadowRoot) {
              composedTreeWalk(shadowRoot, callback, shadowRoot);
              return;
            }

            // If it is a <content> element, descend into distributed elements - these
            // are elements from outside the shadow root which are rendered inside the
            // shadow DOM.
            if (element.localName == "content") {
              var content = /** @type {!HTMLContentElement} */ element;
              // Verifies if ShadowDom v0 is supported.
              var distributedNodes = content.getDistributedNodes ? content.getDistributedNodes() : [];
              for (var i = 0; i < distributedNodes.length; i++) {
                composedTreeWalk(distributedNodes[i], callback, shadowRootAncestor);
              }
              return;
            }

            // If it is a <slot> element, descend into assigned nodes - these
            // are elements from outside the shadow root which are rendered inside the
            // shadow DOM.
            if (element.localName == "slot") {
              var slot = /** @type {!HTMLSlotElement} */ element;
              // Verify if ShadowDom v1 is supported.
              var _distributedNodes = slot.assignedNodes
                ? slot.assignedNodes({
                    flatten: true,
                  })
                : [];
              for (var _i = 0; _i < _distributedNodes.length; _i++) {
                composedTreeWalk(_distributedNodes[_i], callback, shadowRootAncestor);
              }
              return;
            }
          }

          // If it is neither the parent of a ShadowRoot, a <content> element, a <slot>
          // element, nor a <shadow> element recurse normally.
          var child = node.firstChild;
          while (child != null) {
            composedTreeWalk(child, callback, shadowRootAncestor);
            child = child.nextSibling;
          }
        }

        /**
         * Adds a style element to the node containing the inert specific styles
         * @param {!Node} node
         */
        function addInertStyle(node) {
          if (node.querySelector("style#inert-style, link#inert-style")) {
            return;
          }
          var style = document.createElement("style");
          style.setAttribute("id", "inert-style");
          style.textContent =
            "\n" +
            "[inert] {\n" +
            "  pointer-events: none;\n" +
            "  cursor: default;\n" +
            "}\n" +
            "\n" +
            "[inert], [inert] * {\n" +
            "  -webkit-user-select: none;\n" +
            "  -moz-user-select: none;\n" +
            "  -ms-user-select: none;\n" +
            "  user-select: none;\n" +
            "}\n";
          node.appendChild(style);
        }

        if (!Element.prototype.hasOwnProperty("inert")) {
          /** @type {!InertManager} */
          var inertManager = new InertManager(document);

          Object.defineProperty(Element.prototype, "inert", {
            enumerable: true,
            /** @this {!Element} */
            get: function get() {
              return this.hasAttribute("inert");
            },
            /** @this {!Element} */
            set: function set(inert) {
              inertManager.setInert(this, inert);
            },
          });
        }
      })();

      /***/
    },
    /* 19 */
    /***/
    function (module, exports) {
      /*! outline.js v1.2.0 - https://github.com/lindsayevans/outline.js/ */
      // modified by Switch Themes to use body classname instead of adding a style tag
      (function (d) {
        const dom_events = "addEventListener" in d;
        const add_event_listener = function (type, callback) {
          // Basic cross-browser event handling
          if (dom_events) {
            d.addEventListener(type, callback);
          } else {
            d.attachEvent("on" + type, callback);
          }
        };
        // Using mousedown instead of mouseover, so that previously focused elements don't lose focus ring on mouse move
        add_event_listener("mousedown", function () {
          document.body.classList.add("user-using-mouse");
        });

        add_event_listener("keydown", function () {
          document.body.classList.remove("user-using-mouse");
        });
      })(document);

      /***/
    },
    /* 20 */
    /***/
    function (module, exports) {
      window.BaselineLogin = () => {
        return {
          state: "login",

          mounted() {
            this.$watch("state", () => {
              this.$nextTick(() => {
                const toFocus = document.querySelector("[data-login-focus]");
                if (toFocus) toFocus.focus();
              });
            });
            this.$nextTick(() => {
              if (window.location.hash === "#recover" || document.querySelector("[data-recover-success]")) {
                this.state = "recover";
              }

              const toFocus = document.querySelector("[data-login-error]");
              if (toFocus) toFocus.focus();
            });
          },
        };
      };

      /***/
    },
    /* 21 */
    /***/
    function (module, exports) {
      window["QuantityControls"] = () => {
        return {
          shouldSendEvent: true,

          mounted(property) {
            this.$watch(property, (value) => {
              if (this.shouldSendEvent) {
                this.sendEvent(value);
              }
            });
          },

          qtyAdjust($event, value, property) {
            this[property] += value;

            if (this[property] < 0) {
              this[property] = 0;
            }
          },

          resetQuantity($event, value, property) {
            this.shouldSendEvent = false;
            this[property] = value;
            this.$nextTick(() => {
              this.shouldSendEvent = true;
            });
          },

          sendEvent(value) {
            const event = new CustomEvent("change", {
              detail: {
                line: this.$refs.quantity.dataset.index,
                value: value,
                name: document.activeElement.getAttribute("name"),
              },
            });
            document.body.dispatchEvent(event);
          },

          removeItem() {
            this.sendEvent(0);
          },
        };
      };

      /***/
    },
    /* 22 */
    /***/
    function (module, exports) {
      window["ThemeComponent_GiftCardRecipient"] = () => {
        return {
          enabled: false,
          recipientMessage: "",

          get messageLength() {
            return this.recipientMessage.length;
          },

          errorMessage: null,
          errors: null,

          mounted() {
            document.body.addEventListener("baseline:cart:adderror", (e) => {
              if (
                e.detail.source === "product-form" &&
                e.detail.sourceId === this.$el.closest("form").getAttribute("id")
              ) {
                this.errorMessage = e.detail.message;
                this.errors = e.detail.errors;
                this.enabled = true;
              }
            });
          },
        };
      };

      /***/
    },
    /* 23 */
    /***/
    function (module, exports, __webpack_require__) {
      var root = __webpack_require__(8);

      /**
       * Gets the timestamp of the number of milliseconds that have elapsed since
       * the Unix epoch (1 January 1970 00:00:00 UTC).
       *
       * @static
       * @memberOf _
       * @since 2.4.0
       * @category Date
       * @returns {number} Returns the timestamp.
       * @example
       *
       * _.defer(function(stamp) {
       *   console.log(_.now() - stamp);
       * }, _.now());
       * // => Logs the number of milliseconds it took for the deferred invocation.
       */
      var now = function () {
        return root.Date.now();
      };

      module.exports = now;

      /***/
    },
    /* 24 */
    /***/
    function (module, exports, __webpack_require__) {
      /* WEBPACK VAR INJECTION */
      (function (global) {
        /** Detect free variable `global` from Node.js. */
        var freeGlobal = typeof global == "object" && global && global.Object === Object && global;

        module.exports = freeGlobal;

        /* WEBPACK VAR INJECTION */
      }).call(this, __webpack_require__(6));

      /***/
    },
    /* 25 */
    /***/
    function (module, exports, __webpack_require__) {
      var baseTrim = __webpack_require__(26),
        isObject = __webpack_require__(7),
        isSymbol = __webpack_require__(28);

      /** Used as references for various `Number` constants. */
      var NAN = 0 / 0;

      /** Used to detect bad signed hexadecimal string values. */
      var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

      /** Used to detect binary string values. */
      var reIsBinary = /^0b[01]+$/i;

      /** Used to detect octal string values. */
      var reIsOctal = /^0o[0-7]+$/i;

      /** Built-in method references without a dependency on `root`. */
      var freeParseInt = parseInt;

      /**
       * Converts `value` to a number.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to process.
       * @returns {number} Returns the number.
       * @example
       *
       * _.toNumber(3.2);
       * // => 3.2
       *
       * _.toNumber(Number.MIN_VALUE);
       * // => 5e-324
       *
       * _.toNumber(Infinity);
       * // => Infinity
       *
       * _.toNumber('3.2');
       * // => 3.2
       */
      function toNumber(value) {
        if (typeof value == "number") {
          return value;
        }
        if (isSymbol(value)) {
          return NAN;
        }
        if (isObject(value)) {
          var other = typeof value.valueOf == "function" ? value.valueOf() : value;
          value = isObject(other) ? other + "" : other;
        }
        if (typeof value != "string") {
          return value === 0 ? value : +value;
        }
        value = baseTrim(value);
        var isBinary = reIsBinary.test(value);
        return isBinary || reIsOctal.test(value)
          ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
          : reIsBadHex.test(value)
          ? NAN
          : +value;
      }

      module.exports = toNumber;

      /***/
    },
    /* 26 */
    /***/
    function (module, exports, __webpack_require__) {
      var trimmedEndIndex = __webpack_require__(27);

      /** Used to match leading whitespace. */
      var reTrimStart = /^\s+/;

      /**
       * The base implementation of `_.trim`.
       *
       * @private
       * @param {string} string The string to trim.
       * @returns {string} Returns the trimmed string.
       */
      function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
      }

      module.exports = baseTrim;

      /***/
    },
    /* 27 */
    /***/
    function (module, exports) {
      /** Used to match a single whitespace character. */
      var reWhitespace = /\s/;

      /**
       * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
       * character of `string`.
       *
       * @private
       * @param {string} string The string to inspect.
       * @returns {number} Returns the index of the last non-whitespace character.
       */
      function trimmedEndIndex(string) {
        var index = string.length;

        while (index-- && reWhitespace.test(string.charAt(index))) {}
        return index;
      }

      module.exports = trimmedEndIndex;

      /***/
    },
    /* 28 */
    /***/
    function (module, exports, __webpack_require__) {
      var baseGetTag = __webpack_require__(29),
        isObjectLike = __webpack_require__(32);

      /** `Object#toString` result references. */
      var symbolTag = "[object Symbol]";

      /**
       * Checks if `value` is classified as a `Symbol` primitive or object.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
       * @example
       *
       * _.isSymbol(Symbol.iterator);
       * // => true
       *
       * _.isSymbol('abc');
       * // => false
       */
      function isSymbol(value) {
        return typeof value == "symbol" || (isObjectLike(value) && baseGetTag(value) == symbolTag);
      }

      module.exports = isSymbol;

      /***/
    },
    /* 29 */
    /***/
    function (module, exports, __webpack_require__) {
      var Symbol = __webpack_require__(9),
        getRawTag = __webpack_require__(30),
        objectToString = __webpack_require__(31);

      /** `Object#toString` result references. */
      var nullTag = "[object Null]",
        undefinedTag = "[object Undefined]";

      /** Built-in value references. */
      var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

      /**
       * The base implementation of `getTag` without fallbacks for buggy environments.
       *
       * @private
       * @param {*} value The value to query.
       * @returns {string} Returns the `toStringTag`.
       */
      function baseGetTag(value) {
        if (value == null) {
          return value === undefined ? undefinedTag : nullTag;
        }
        return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
      }

      module.exports = baseGetTag;

      /***/
    },
    /* 30 */
    /***/
    function (module, exports, __webpack_require__) {
      var Symbol = __webpack_require__(9);

      /** Used for built-in method references. */
      var objectProto = Object.prototype;

      /** Used to check objects for own properties. */
      var hasOwnProperty = objectProto.hasOwnProperty;

      /**
       * Used to resolve the
       * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
       * of values.
       */
      var nativeObjectToString = objectProto.toString;

      /** Built-in value references. */
      var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

      /**
       * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
       *
       * @private
       * @param {*} value The value to query.
       * @returns {string} Returns the raw `toStringTag`.
       */
      function getRawTag(value) {
        var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

        try {
          value[symToStringTag] = undefined;
          var unmasked = true;
        } catch (e) {}

        var result = nativeObjectToString.call(value);
        if (unmasked) {
          if (isOwn) {
            value[symToStringTag] = tag;
          } else {
            delete value[symToStringTag];
          }
        }
        return result;
      }

      module.exports = getRawTag;

      /***/
    },
    /* 31 */
    /***/
    function (module, exports) {
      /** Used for built-in method references. */
      var objectProto = Object.prototype;

      /**
       * Used to resolve the
       * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
       * of values.
       */
      var nativeObjectToString = objectProto.toString;

      /**
       * Converts `value` to a string using `Object.prototype.toString`.
       *
       * @private
       * @param {*} value The value to convert.
       * @returns {string} Returns the converted string.
       */
      function objectToString(value) {
        return nativeObjectToString.call(value);
      }

      module.exports = objectToString;

      /***/
    },
    /* 32 */
    /***/
    function (module, exports) {
      /**
       * Checks if `value` is object-like. A value is object-like if it's not `null`
       * and has a `typeof` result of "object".
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
       * @example
       *
       * _.isObjectLike({});
       * // => true
       *
       * _.isObjectLike([1, 2, 3]);
       * // => true
       *
       * _.isObjectLike(_.noop);
       * // => false
       *
       * _.isObjectLike(null);
       * // => false
       */
      function isObjectLike(value) {
        return value != null && typeof value == "object";
      }

      module.exports = isObjectLike;

      /***/
    },
    ,
    ,
    ,
    ,
    ,
    /* 33 */
    /* 34 */
    /* 35 */
    /* 36 */
    /* 37 */
    /* 38 */
    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      // ESM COMPAT FLAG
      __webpack_require__.r(__webpack_exports__);

      // EXTERNAL MODULE: ./node_modules/lazysizes/plugins/object-fit/ls.object-fit.js
      var ls_object_fit = __webpack_require__(10);

      // EXTERNAL MODULE: ./node_modules/lazysizes/plugins/parent-fit/ls.parent-fit.js
      var ls_parent_fit = __webpack_require__(11);

      // EXTERNAL MODULE: ./node_modules/lazysizes/plugins/rias/ls.rias.js
      var ls_rias = __webpack_require__(12);

      // EXTERNAL MODULE: ./node_modules/lazysizes/plugins/bgset/ls.bgset.js
      var ls_bgset = __webpack_require__(13);

      // EXTERNAL MODULE: ./node_modules/lazysizes/lazysizes.js
      var lazysizes = __webpack_require__(0);

      // EXTERNAL MODULE: ./node_modules/lazysizes/plugins/respimg/ls.respimg.js
      var ls_respimg = __webpack_require__(14);

      // EXTERNAL MODULE: ./node_modules/@ryangjchandler/spruce/dist/spruce.module.js
      var spruce_module = __webpack_require__(5);

      // CONCATENATED MODULE: ./node_modules/@shopify/theme-a11y/theme-a11y.js
      /**
       * A11y Helpers
       * -----------------------------------------------------------------------------
       * A collection of useful functions that help make your theme more accessible
       */

      /**
       * Moves focus to an HTML element
       * eg for In-page links, after scroll, focus shifts to content area so that
       * next `tab` is where user expects. Used in bindInPageLinks()
       * eg move focus to a modal that is opened. Used in trapFocus()
       *
       * @param {Element} container - Container DOM element to trap focus inside of
       * @param {Object} options - Settings unique to your theme
       * @param {string} options.className - Class name to apply to element on focus.
       */
      function forceFocus(element, options) {
        options = options || {};

        var savedTabIndex = element.tabIndex;

        element.tabIndex = -1;
        element.dataset.tabIndex = savedTabIndex;
        element.focus();
        if (typeof options.className !== "undefined") {
          element.classList.add(options.className);
        }
        element.addEventListener("blur", callback);

        function callback(event) {
          event.target.removeEventListener(event.type, callback);

          element.tabIndex = savedTabIndex;
          delete element.dataset.tabIndex;
          if (typeof options.className !== "undefined") {
            element.classList.remove(options.className);
          }
        }
      }

      /**
       * If there's a hash in the url, focus the appropriate element
       * This compensates for older browsers that do not move keyboard focus to anchor links.
       * Recommendation: To be called once the page in loaded.
       *
       * @param {Object} options - Settings unique to your theme
       * @param {string} options.className - Class name to apply to element on focus.
       * @param {string} options.ignore - Selector for elements to not include.
       */

      function focusHash(options) {
        options = options || {};
        var hash = window.location.hash;
        var element = document.getElementById(hash.slice(1));

        // if we are to ignore this element, early return
        if (element && options.ignore && element.matches(options.ignore)) {
          return false;
        }

        if (hash && element) {
          forceFocus(element, options);
        }
      }

      /**
       * When an in-page (url w/hash) link is clicked, focus the appropriate element
       * This compensates for older browsers that do not move keyboard focus to anchor links.
       * Recommendation: To be called once the page in loaded.
       *
       * @param {Object} options - Settings unique to your theme
       * @param {string} options.className - Class name to apply to element on focus.
       * @param {string} options.ignore - CSS selector for elements to not include.
       */

      function bindInPageLinks(options) {
        options = options || {};
        var links = Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]'));

        return links.filter(function (link) {
          if (link.hash === "#" || link.hash === "") {
            return false;
          }

          if (options.ignore && link.matches(options.ignore)) {
            return false;
          }

          var element = document.querySelector(link.hash);

          if (!element) {
            return false;
          }

          link.addEventListener("click", function () {
            forceFocus(element, options);
          });

          return true;
        });
      }

      function focusable(container) {
        var elements = Array.prototype.slice.call(
          container.querySelectorAll(
            "[tabindex]," +
              "[draggable]," +
              "a[href]," +
              "area," +
              "button:enabled," +
              "input:not([type=hidden]):enabled," +
              "object," +
              "select:enabled," +
              "textarea:enabled"
          )
        );

        // Filter out elements that are not visible.
        // Copied from jQuery https://github.com/jquery/jquery/blob/2d4f53416e5f74fa98e0c1d66b6f3c285a12f0ce/src/css/hiddenVisibleSelectors.js
        return elements.filter(function (element) {
          return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
        });
      }

      /**
       * Traps the focus in a particular container
       *
       * @param {Element} container - Container DOM element to trap focus inside of
       * @param {Element} elementToFocus - Element to be focused on first
       * @param {Object} options - Settings unique to your theme
       * @param {string} options.className - Class name to apply to element on focus.
       */

      var trapFocusHandlers = {};

      function trapFocus(container, options) {
        options = options || {};
        var elements = focusable(container);
        var elementToFocus = options.elementToFocus || container;
        var first = elements[0];
        var last = elements[elements.length - 1];

        removeTrapFocus();

        trapFocusHandlers.focusin = function (event) {
          if (container !== event.target && !container.contains(event.target)) {
            first.focus();
          }

          if (event.target !== container && event.target !== last && event.target !== first) return;
          document.addEventListener("keydown", trapFocusHandlers.keydown);
        };

        trapFocusHandlers.focusout = function () {
          document.removeEventListener("keydown", trapFocusHandlers.keydown);
        };

        trapFocusHandlers.keydown = function (event) {
          if (event.keyCode !== 9) return; // If not TAB key

          // On the last focusable element and tab forward, focus the first element.
          if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
          }

          //  On the first focusable element and tab backward, focus the last element.
          if ((event.target === container || event.target === first) && event.shiftKey) {
            event.preventDefault();
            last.focus();
          }
        };

        document.addEventListener("focusout", trapFocusHandlers.focusout);
        document.addEventListener("focusin", trapFocusHandlers.focusin);

        forceFocus(elementToFocus, options);
      }

      /**
       * Removes the trap of focus from the page
       */
      function removeTrapFocus() {
        document.removeEventListener("focusin", trapFocusHandlers.focusin);
        document.removeEventListener("focusout", trapFocusHandlers.focusout);
        document.removeEventListener("keydown", trapFocusHandlers.keydown);
      }

      /**
       * Add a preventive message to external links and links that open to a new window.
       * @param {string} elements - Specific elements to be targeted
       * @param {object} options.messages - Custom messages to overwrite with keys: newWindow, external, newWindowExternal
       * @param {string} options.messages.newWindow - When the link opens in a new window (e.g. target="_blank")
       * @param {string} options.messages.external - When the link is to a different host domain.
       * @param {string} options.messages.newWindowExternal - When the link is to a different host domain and opens in a new window.
       * @param {object} options.prefix - Prefix to namespace "id" of the messages
       */
      function accessibleLinks(elements, options) {
        if (typeof elements !== "string") {
          throw new TypeError(elements + " is not a String.");
        }

        elements = document.querySelectorAll(elements);

        if (elements.length === 0) {
          return;
        }

        options = options || {};
        options.messages = options.messages || {};

        var messages = {
          newWindow: options.messages.newWindow || "Opens in a new window.",
          external: options.messages.external || "Opens external website.",
          newWindowExternal: options.messages.newWindowExternal || "Opens external website in a new window.",
        };

        var prefix = options.prefix || "a11y";

        var messageSelectors = {
          newWindow: prefix + "-new-window-message",
          external: prefix + "-external-message",
          newWindowExternal: prefix + "-new-window-external-message",
        };

        function generateHTML(messages) {
          var container = document.createElement("ul");
          var htmlMessages = Object.keys(messages).reduce(function (html, key) {
            return (html += "<li id=" + messageSelectors[key] + ">" + messages[key] + "</li>");
          }, "");

          container.setAttribute("hidden", true);
          container.innerHTML = htmlMessages;

          document.body.appendChild(container);
        }

        function externalSite(link) {
          return link.hostname !== window.location.hostname;
        }

        elements.forEach(function (link) {
          var target = link.getAttribute("target");
          var rel = link.getAttribute("rel");
          var isExternal = externalSite(link);
          var isTargetBlank = target === "_blank";
          var missingRelNoopener = rel === null || rel.indexOf("noopener") === -1;

          if (isTargetBlank && missingRelNoopener) {
            var relValue = rel === null ? "noopener" : rel + " noopener";
            link.setAttribute("rel", relValue);
          }

          if (isExternal && isTargetBlank) {
            link.setAttribute("aria-describedby", messageSelectors.newWindowExternal);
          } else if (isExternal) {
            link.setAttribute("aria-describedby", messageSelectors.external);
          } else if (isTargetBlank) {
            link.setAttribute("aria-describedby", messageSelectors.newWindow);
          }
        });

        generateHTML(messages);
      }
      // CONCATENATED MODULE: ./node_modules/@switchthemes/utilities/index.js
      /**
       * Utility helpers
       * -----------------------------------------------------------------------------
       * A collection of useful functions for dealing with arrays and objects
       *
       * @namespace utils
       */

      function removeProtocol(path) {
        return path.replace(/http(s)?:/, "");
      }

      function getSizedImageUrl(src, size) {
        if (size === null) {
          return src;
        }

        if (size === "master") {
          return removeProtocol(src);
        }

        var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i);

        if (match) {
          var prefix = src.split(match[0]);
          var suffix = match[0];

          return removeProtocol(prefix[0] + "_" + size + suffix);
        } else {
          return null;
        }
      }

      /**
       * Make a selector from an element’s class and its data- and aria- attributes
       *
       * @param {HTMLElement} element The element to create a selector from
       * @param {Array.<String>} exclusions Attribute names to exclude
       */

      function makeSelectorFromElement(element, exclusions = []) {
        let selectorAttributes = [],
          classString;

        for (var i = 0; i < element.attributes.length; i++) {
          var attribute = element.attributes[i];

          if (attribute.name.indexOf("data-") === 0 || attribute.name.indexOf("aria-") === 0) {
            if (exclusions.indexOf(attribute.name) === -1) {
              selectorAttributes.push(attribute);
            }
          }

          if (attribute.name === "class" && attribute.value) {
            classString = attribute.value;
          }
        }

        let selector = "";

        if (classString && classString !== "") {
          selector += "." + classString.split(/\s+/).join(".");
        }

        if (selectorAttributes && selectorAttributes.length > 0) {
          for (var i = 0; i < selectorAttributes.length; i++) {
            var attribute = selectorAttributes[i];
            if (attribute.value) {
              selector += `[${attribute.name}="${attribute.value}"]`;
            } else {
              selector += `[${attribute.name}]`;
            }
          }
        }

        return selector;
      }

      /**
       * Return an object from an array of objects that matches the provided key and value
       *
       * @param {array} array - Array of objects
       * @param {string} key - Key to match the value against
       * @param {string} value - Value to get match of
       */
      function findInstance(array, key, value) {
        for (var i = 0; i < array.length; i++) {
          if (array[i][key] === value) {
            return array[i];
          }
        }
      }

      const keyboardKeys = {
        TAB: 9,
        ENTER: 13,
        ESCAPE: 27,
        LEFTARROW: 37,
        RIGHTARROW: 39,
        SPACE: 32,
      };

      /**
       * Remove an object from an array of objects by matching the provided key and value
       *
       * @param {array} array - Array of objects
       * @param {string} key - Key to match the value against
       * @param {string} value - Value to get match of
       */
      function removeInstance(array, key, value) {
        var i = array.length;
        while (i--) {
          if (array[i][key] === value) {
            array.splice(i, 1);
            break;
          }
        }

        return array;
      }

      /**
       * _.compact from lodash
       * Remove empty/false items from array
       * Source: https://github.com/lodash/lodash/blob/master/compact.js
       *
       * @param {array} array
       */
      function compact(array) {
        var index = -1;
        var length = array == null ? 0 : array.length;
        var resIndex = 0;
        var result = [];

        while (++index < length) {
          var value = array[index];
          if (value) {
            result[resIndex++] = value;
          }
        }
        return result;
      }

      /**
       * _.defaultTo from lodash
       * Checks `value` to determine whether a default value should be returned in
       * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
       * or `undefined`.
       * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
       *
       * @param {*} value - Value to check
       * @param {*} defaultValue - Default value
       * @returns {*} - Returns the resolved value
       */
      function defaultTo(value, defaultValue) {
        return value == null || value !== value ? defaultValue : value;
      }

      function text_truncate(str, length, ending) {
        if (length == null) {
          length = 200;
        }
        if (ending == null) {
          ending = "...";
        }
        if (str.length > length) {
          return str.substring(0, length - ending.length) + ending;
        } else {
          return str;
        }
      }

      /**
       * A very basic alternative to _.isEmpty for objects
       *
       * @param {Object} obj An object
       */

      function objectHasNoKeys(obj) {
        for (var key in obj) {
          if (obj.hasOwnProperty(key)) return false;
        }

        return true;
      }

      /**
       * Generate an srcset given an image’s src
       * and an array of sizes
       *
       * @param {string} src The image’s src
       * @param {(string|number)[]} sizes The sizes
       *
       * @returns {string}
       */

      function getImageSrcset(
        src,
        sizes = [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 1944, 2160, 2376, 2592, 2808, 3024]
      ) {
        if (!src) return;

        const srcset = [];

        sizes.forEach((size) => {
          srcset.push(`${getSizedImageUrl(src, size.toString() + "x")} ${size}w`);
        });

        return srcset.join(",\n");
      }

      /**
       * Header is active
       */

      function headerIsActive() {
        return document.querySelector(".site-header").classList.contains("active") || false;
      }

      /**
       * Returns the content of a JS Template
       *
       * @param {string} id The id of the template
       */
      function getJSTemplate(id) {
        try {
          return document.getElementById(id).content;
        } catch (e) {
          console.error(`There was an error getting template ${id}`);
          return null;
        }
      }

      /**
       * Initialize Alpine component after page load
       *
       * @param {string} functionName Name of Alpine data function for `x-data`
       */

      function initAlpineComponent(functionName) {
        if (!functionName) return;

        document.querySelectorAll(`[data-alpinejs-component="${functionName}()"`).forEach((el) => {
          el.removeAttribute("data-alpinejs-component");
          el.setAttribute("x-data", `${functionName}()`);
          window.Alpine.initializeComponent(el);
        });
      }

      const isEventSupported = (function () {
        const TAGNAMES = {
          select: "input",
          change: "input",
          submit: "form",
          reset: "form",
          error: "img",
          load: "img",
          abort: "img",
        };

        function isEventSupported(eventName) {
          let el = document.createElement(TAGNAMES[eventName] || "div");
          eventName = "on" + eventName;

          const isSupported = eventName in el;

          if (!isSupported) {
            el.setAttribute(eventName, "return;");
            isSupported = typeof el[eventName] == "function";
          }
          el = null;
          return isSupported;
        }

        return isEventSupported;
      })();

      /**
       * Get an element's siblings
       *
       * @param {elem} Element for which you want the sibling elements
       */

      function getSiblings(elem) {
        // Setup siblings array and get the first sibling
        let siblings = [];
        let sibling = elem.parentNode.firstChild;

        // Loop through each sibling and push to the array
        while (sibling) {
          if (sibling.nodeType === 1 && sibling !== elem) {
            siblings.push(sibling);
          }
          sibling = sibling.nextSibling;
        }

        return siblings;
      }

      /**
       * Wrap tables in a container div to make them scrollable when needed
       *
       * @param {object} options - Options to be used
       * @param {NodeList} options.tables - Elements of the table(s) to wrap
       * @param {string} options.tableWrapperClass - table wrapper class name
       */
      function wrapTable(options) {
        options.tables.forEach(function (table) {
          var wrapper = document.createElement("div");
          wrapper.classList.add(options.tableWrapperClass);

          table.parentNode.insertBefore(wrapper, table);
          wrapper.appendChild(table);
        });
      }

      /**
       * Wrap iframes in a container div to make them responsive
       *
       * @param {object} options - Options to be used
       * @param {NodeList} options.iframes - Elements of the iframe(s) to wrap
       * @param {string} options.iframeWrapperClass - class name used on the wrapping div
       */
      function wrapIframe(options) {
        options.iframes.forEach(function (iframe) {
          var wrapper = document.createElement("div");
          wrapper.classList.add(options.iframeWrapperClass);

          iframe.parentNode.insertBefore(wrapper, iframe);
          wrapper.appendChild(iframe);

          iframe.src = iframe.src;
        });
      }

      const Helpers = (function () {
        var touchDevice = false;

        function setTouch() {
          touchDevice = true;
        }

        function isTouch() {
          return touchDevice;
        }

        return {
          setTouch: setTouch,
          isTouch: isTouch,
        };
      })();
      // CONCATENATED MODULE: ./src/scripts/tools/drawer-store.js

      const store = Spruce.store("drawer", {
        menuDrawerOpen: false,
        cartDrawerOpen: false,
        availabilityDrawerOpen: false,
        cartOpener: null,
        availabilityOpener: null,
        passwordOpen: false,
      });
      Spruce.watch("drawer.availabilityDrawerOpen", (value) => {
        const drawer = document.querySelector("[data-availability-drawer]");
        const drawerToggle = store.availabilityOpener;
        toggleDrawer(drawer, drawerToggle, value);
      });
      Spruce.watch("drawer.menuDrawerOpen", (value) => {
        const drawer = document.querySelector("[data-menu-drawer]");
        const drawerToggle = document.querySelector("[data-menu-drawer-toggle]");
        toggleDrawer(drawer, drawerToggle, value);
      });
      Spruce.watch("drawer.cartDrawerOpen", (value) => {
        const drawer = document.querySelector("[data-cart-drawer]");
        const drawerToggle = store.cartOpener;
        toggleDrawer(drawer, drawerToggle, value);
      });
      Spruce.watch("drawer.passwordOpen", (value) => {
        const drawer = document.querySelector("[data-password-login]");
        const drawerToggle = document.querySelector("[data-password-toggle]");
        toggleDrawer(drawer, drawerToggle, value);
      });
      document.addEventListener("keyup", (event) => {
        if (event.key === "Escape") {
          if (store.menuDrawerOpen) Spruce.store("drawer").menuDrawerOpen = false;
          if (store.cartDrawerOpen) Spruce.store("drawer").cartDrawerOpen = false;
          if (store.availabilityDrawerOpen) Spruce.store("drawer").availabilityDrawerOpen = false;
          if (store.passwordOpen) Spruce.store("drawer").passwordOpen = false;
        }
      });
      /* Accepts
     drawer: a element (which must be a direct child of the body element)
     drawerToggle: element that triggered the drawer, focus will be returned to it when closed
     isOpen: Boolean, whether or not the drawer is being opened or closed
    */

      function toggleDrawer(drawer, drawerToggle, isOpen) {
        const parentSection = drawer.closest(".shopify-section") || drawer.closest("[data-section-type]") || drawer;
        const siblings = getSiblings(parentSection);

        if (isOpen === true) {
          document.documentElement.style.overflowY = "hidden";
          setTimeout(() => {
            trapFocus(drawer);
          }, 300); // Make everything else inert

          siblings.forEach((sibling) => {
            if (!sibling.getAttribute("aria-live")) {
              sibling.setAttribute("inert", true);
            }
          });
        } else {
          document.documentElement.style.overflowY = "auto";
          siblings.forEach((sibling) => {
            sibling.removeAttribute("inert");
          });
          removeTrapFocus(); // Focus on the toggle

          if (drawerToggle) {
            setTimeout(() => {
              drawerToggle.focus();
            }, 300);
          }
        }
      }
      // EXTERNAL MODULE: ./src/scripts/tools/cart-store.js
      var cart_store = __webpack_require__(15);

      // CONCATENATED MODULE: ./src/scripts/tools/availability-store.js

      const availability_store_store = Spruce.store("availability", {
        loading: false,
        product_title: null,
        current_variant: null,
        availability: {},

        getVariantTitle() {
          if (this.current_variant && this.current_variant.title) {
            if (!this.current_variant.title.includes("Default")) {
              return this.current_variant.title;
            }
          }

          return "";
        },
      });
      // EXTERNAL MODULE: ./node_modules/alpinejs/dist/alpine.js
      var alpine = __webpack_require__(16);

      // EXTERNAL MODULE: ./src/styles/theme.scss
      var styles_theme = __webpack_require__(17);

      // EXTERNAL MODULE: ./node_modules/wicg-inert/dist/inert.esm.js
      var inert_esm = __webpack_require__(18);

      // EXTERNAL MODULE: ./node_modules/@switchthemes/outline/index.js
      var outline = __webpack_require__(19);

      // EXTERNAL MODULE: ./src/scripts/components/login.js
      var login = __webpack_require__(20);

      // EXTERNAL MODULE: ./src/scripts/components/quantity.js
      var quantity = __webpack_require__(21);

      // CONCATENATED MODULE: ./src/scripts/components/popup.js

      window["ThemeComponent_PopUp"] = () => {
        return {
          open: false,

          mounted() {
            this.$watch("open", (value) => {
              value ? this.openModal() : this.closeModal();
            });
          },

          openModal() {
            document.documentElement.style.overflowY = "hidden";
            const headerSection = document.querySelector(".section-header");

            if (headerSection) {
              headerSection.style.zIndex = "0";
            }

            setTimeout(() => {
              trapFocus(this.$refs.modal);
              this.$refs.close.focus();
            }, 300);
          },

          closeModal() {
            document.documentElement.style.overflowY = "auto";
            const headerSection = document.querySelector(".section-header");

            if (headerSection) {
              headerSection.style.zIndex = "30";
            }

            removeTrapFocus(); //focus back on the trigger

            setTimeout(() => {
              this.$refs.trigger.focus();
            }, 300);
          },
        };
      };
      // CONCATENATED MODULE: ./node_modules/@switchthemes/library-loader/index.js
      const LibraryLoader = (function () {
        const types = {
          link: "link",
          script: "script",
        };

        const status = {
          requested: "requested",
          loaded: "loaded",
        };

        const cloudCdn = "https://cdn.shopify.com/shopifycloud/";

        const libraries = {
          youtubeSdk: {
            tagId: "youtube-sdk",
            src: "https://www.youtube.com/iframe_api",
            type: types.script,
          },
          vimeoSdk: {
            tagId: "vimeo-sdk",
            src: "https://player.vimeo.com/api/player.js",
            type: types.script,
          },
          plyrShopifyStyles: {
            tagId: "plyr-shopify-styles",
            src: cloudCdn + "plyr/v2.0/shopify-plyr.css",
            type: types.link,
          },
          shopifyXr: {
            tagId: "shopify-model-viewer-xr",
            src: cloudCdn + "shopify-xr-js/assets/v1.0/shopify-xr.en.js",
            type: types.script,
          },
          modelViewerUi: {
            tagId: "shopify-model-viewer-ui",
            src: cloudCdn + "model-viewer-ui/assets/v1.0/model-viewer-ui.en.js",
            type: types.script,
          },
          modelViewerUiStyles: {
            tagId: "shopify-model-viewer-ui-styles",
            src: cloudCdn + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
            type: types.link,
          },
        };

        function load(libraryName, callback) {
          const library = libraries[libraryName];

          if (!library) return;
          if (library.status === status.requested) return;

          callback = callback || function () {};
          if (library.status === status.loaded) {
            callback();
            return;
          }

          library.status = status.requested;

          let tag;

          switch (library.type) {
            case types.script:
              tag = createScriptTag(library, callback);
              break;
            case types.link:
              tag = createLinkTag(library, callback);
              break;
          }

          tag.id = library.tagId;
          library.element = tag;

          const firstScriptTag = document.getElementsByTagName(library.type)[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }

        function createScriptTag(library, callback) {
          const tag = document.createElement("script");
          tag.src = library.src;
          tag.addEventListener("load", function () {
            library.status = status.loaded;
            callback();
          });
          return tag;
        }

        function createLinkTag(library, callback) {
          const tag = document.createElement("link");
          tag.href = library.src;
          tag.rel = "stylesheet";
          tag.type = "text/css";
          tag.addEventListener("load", function () {
            library.status = status.loaded;
            callback();
          });
          return tag;
        }

        return {
          load: load,
        };
      })();

      /* harmony default export */
      var library_loader = LibraryLoader;

      // CONCATENATED MODULE: ./src/scripts/components/video.js

      document.addEventListener("touchstart", function () {
        Helpers.setTouch();
      });

      window["ThemeComponent_Video"] = (id, type, host, autoplay) => {
        return {
          enabled: false,
          id: id,
          type: type,
          host: host,
          youtubeReady: false,
          productMediaWrapper: null,
          ytPlayer: null,
          vimeoPlayer: null,
          autoPlayOnDesktop: autoplay,

          mounted() {
            document.body.addEventListener("pauseAllMedia", (e) => {
              if (e.detail !== null) {
                if (e.detail.id !== this.id) {
                  this.pause();
                }
              } else {
                this.pause();
              }
            });

            if (this.host === "youtube") {
              document.body.addEventListener("youtubeiframeapiready", () => {
                this.youtubeReady = true;
              });
              library_loader.load("youtubeSdk");
            }

            if (this.host === "vimeo") {
              library_loader.load("vimeoSdk");
            } //check if this is product media

            this.productMediaWrapper = this.$el.closest("[data-product-single-media-wrapper]");

            if (this.productMediaWrapper !== null) {
              this.setupProductMediaListeners();
            }
          },

          enableVideo() {
            this.enabled = true;
            this.$nextTick(() => {
              if (this.type === "video") {
                const video = this.$refs.video_container.querySelector(".video");

                video.onplay = () => {
                  this.dispatchPauseEvent();
                };
              } else {
                if (this.host === "youtube") {
                  const youtubeFrame = this.$refs.video_container.querySelector(".js-youtube");
                  this.ytPlayer = new YT.Player(youtubeFrame, {
                    events: {
                      onStateChange: function (e) {
                        if (e.data === 1) {
                          this.dispatchPauseEvent();
                        }
                      }.bind(this),
                    },
                  });
                }

                if (this.host === "vimeo") {
                  const vimeoFrame = this.$refs.video_container.querySelector(".js-vimeo");
                  this.vmPlayer = new Vimeo.Player(vimeoFrame);
                  this.vmPlayer.on("play", () => {
                    this.dispatchPauseEvent();
                  });
                }
              }
            });
          },

          dispatchPauseEvent() {
            document.body.dispatchEvent(
              new CustomEvent("pauseAllMedia", {
                detail: {
                  id: this.id,
                },
              })
            );
          },

          pause() {
            if (!this.enabled) {
              return false;
            }

            if (this.type === "video") {
              this.$refs.video_container.querySelector("video").pause();
            } else {
              switch (this.host) {
                case "youtube":
                  this.ytPlayer.pauseVideo();
                  break;

                case "vimeo":
                  this.vmPlayer.pause();
                  break;
              }
            }
          },

          play() {
            if (!this.enabled) {
              return false;
            }

            if (this.type === "video") {
              this.$refs.video_container.querySelector("video").play();
            } else {
              switch (this.host) {
                case "youtube":
                  this.ytPlayer.playVideo();
                  break;

                case "vimeo":
                  this.vmPlayer.play();
                  break;
              }
            } //this.dispatchPauseEvent();
          },

          setupProductMediaListeners() {
            this.productMediaWrapper.addEventListener("mediaHidden", () => {
              this.pause();
            });
            this.productMediaWrapper.addEventListener("xrLaunch", () => {
              this.pause();
            }); //function for when it is visible (we don't have thumbnails so commenting this out for now)

            this.productMediaWrapper.addEventListener("mediaVisible", () => {
              if (Helpers.isTouch()) return;

              if (!this.enabled && this.autoPlayOnDesktop) {
                this.enableVideo();
              } else {
                this.play();
              }
            });
          },
        };
      };
      // EXTERNAL MODULE: ./src/scripts/components/gift-card-recipient.js
      var gift_card_recipient = __webpack_require__(22);

      // CONCATENATED MODULE: ./node_modules/@shopify/theme-sections/section.js
      var SECTION_ID_ATTR = "data-section-id";

      function Section(container, properties) {
        this.container = validateContainerElement(container);
        this.id = container.getAttribute(SECTION_ID_ATTR);
        this.extensions = [];

        // eslint-disable-next-line es5/no-es6-static-methods
        Object.assign(this, validatePropertiesObject(properties));

        this.onLoad();
      }

      Section.prototype = {
        onLoad: Function.prototype,
        onUnload: Function.prototype,
        onSelect: Function.prototype,
        onDeselect: Function.prototype,
        onBlockSelect: Function.prototype,
        onBlockDeselect: Function.prototype,

        extend: function extend(extension) {
          this.extensions.push(extension); // Save original extension

          // eslint-disable-next-line es5/no-es6-static-methods
          var extensionClone = Object.assign({}, extension);
          delete extensionClone.init; // Remove init function before assigning extension properties

          // eslint-disable-next-line es5/no-es6-static-methods
          Object.assign(this, extensionClone);

          if (typeof extension.init === "function") {
            extension.init.apply(this);
          }
        },
      };

      function validateContainerElement(container) {
        if (!(container instanceof Element)) {
          throw new TypeError(
            "Theme Sections: Attempted to load section. The section container provided is not a DOM element."
          );
        }
        if (container.getAttribute(SECTION_ID_ATTR) === null) {
          throw new Error(
            "Theme Sections: The section container provided does not have an id assigned to the " +
              SECTION_ID_ATTR +
              " attribute."
          );
        }

        return container;
      }

      function validatePropertiesObject(value) {
        if ((typeof value !== "undefined" && typeof value !== "object") || value === null) {
          throw new TypeError("Theme Sections: The properties object provided is not a valid");
        }

        return value;
      }

      // Object.assign() polyfill from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#Polyfill
      if (typeof Object.assign != "function") {
        // Must be writable: true, enumerable: false, configurable: true
        Object.defineProperty(Object, "assign", {
          value: function assign(target) {
            // .length of function is 2
            "use strict";
            if (target == null) {
              // TypeError if undefined or null
              throw new TypeError("Cannot convert undefined or null to object");
            }

            var to = Object(target);

            for (var index = 1; index < arguments.length; index++) {
              var nextSource = arguments[index];

              if (nextSource != null) {
                // Skip over if undefined or null
                for (var nextKey in nextSource) {
                  // Avoid bugs when hasOwnProperty is shadowed
                  if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                    to[nextKey] = nextSource[nextKey];
                  }
                }
              }
            }
            return to;
          },
          writable: true,
          configurable: true,
        });
      }

      // CONCATENATED MODULE: ./node_modules/@shopify/theme-sections/theme-sections.js
      /*
       * @shopify/theme-sections
       * -----------------------------------------------------------------------------
       *
       * A framework to provide structure to your Shopify sections and a load and unload
       * lifecycle. The lifecycle is automatically connected to theme editor events so
       * that your sections load and unload as the editor changes the content and
       * settings of your sections.
       */

      var SECTION_TYPE_ATTR = "data-section-type";
      var theme_sections_SECTION_ID_ATTR = "data-section-id";

      window.Shopify = window.Shopify || {};
      window.Shopify.theme = window.Shopify.theme || {};
      window.Shopify.theme.sections = window.Shopify.theme.sections || {};

      var registered = (window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {});
      var instances = (window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || []);

      function register(type, properties) {
        if (typeof type !== "string") {
          throw new TypeError(
            "Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered"
          );
        }

        if (typeof registered[type] !== "undefined") {
          throw new Error(
            'Theme Sections: A section of type "' +
              type +
              '" has already been registered. You cannot register the same section type twice'
          );
        }

        function TypedSection(container) {
          Section.call(this, container, properties);
        }

        TypedSection.constructor = Section;
        TypedSection.prototype = Object.create(Section.prototype);
        TypedSection.prototype.type = type;

        return (registered[type] = TypedSection);
      }

      function unregister(types) {
        types = normalizeType(types);

        types.forEach(function (type) {
          delete registered[type];
        });
      }

      function load(types, containers) {
        types = normalizeType(types);

        if (typeof containers === "undefined") {
          containers = document.querySelectorAll("[" + SECTION_TYPE_ATTR + "]");
        }

        containers = normalizeContainers(containers);

        types.forEach(function (type) {
          var TypedSection = registered[type];

          if (typeof TypedSection === "undefined") {
            return;
          }

          containers = containers.filter(function (container) {
            // Filter from list of containers because container already has an instance loaded
            if (isInstance(container)) {
              return false;
            }

            // Filter from list of containers because container doesn't have data-section-type attribute
            if (container.getAttribute(SECTION_TYPE_ATTR) === null) {
              return false;
            }

            // Keep in list of containers because current type doesn't match
            if (container.getAttribute(SECTION_TYPE_ATTR) !== type) {
              return true;
            }

            instances.push(new TypedSection(container));

            // Filter from list of containers because container now has an instance loaded
            return false;
          });
        });
      }

      function unload(selector) {
        var instancesToUnload = getInstances(selector);

        instancesToUnload.forEach(function (instance) {
          var index = instances
            .map(function (e) {
              return e.id;
            })
            .indexOf(instance.id);
          instances.splice(index, 1);
          instance.onUnload();
        });
      }

      function extend(selector, extension) {
        var instancesToExtend = getInstances(selector);

        instancesToExtend.forEach(function (instance) {
          instance.extend(extension);
        });
      }

      function getInstances(selector) {
        var filteredInstances = [];

        // Fetch first element if its an array
        if (NodeList.prototype.isPrototypeOf(selector) || Array.isArray(selector)) {
          var firstElement = selector[0];
        }

        // If selector element is DOM element
        if (selector instanceof Element || firstElement instanceof Element) {
          var containers = normalizeContainers(selector);

          containers.forEach(function (container) {
            filteredInstances = filteredInstances.concat(
              instances.filter(function (instance) {
                return instance.container === container;
              })
            );
          });

          // If select is type string
        } else if (typeof selector === "string" || typeof firstElement === "string") {
          var types = normalizeType(selector);

          types.forEach(function (type) {
            filteredInstances = filteredInstances.concat(
              instances.filter(function (instance) {
                return instance.type === type;
              })
            );
          });
        }

        return filteredInstances;
      }

      function getInstanceById(id) {
        var instance;

        for (var i = 0; i < instances.length; i++) {
          if (instances[i].id === id) {
            instance = instances[i];
            break;
          }
        }
        return instance;
      }

      function isInstance(selector) {
        return getInstances(selector).length > 0;
      }

      function normalizeType(types) {
        // If '*' then fetch all registered section types
        if (types === "*") {
          types = Object.keys(registered);

          // If a single section type string is passed, put it in an array
        } else if (typeof types === "string") {
          types = [types];

          // If single section constructor is passed, transform to array with section
          // type string
        } else if (types.constructor === Section) {
          types = [types.prototype.type];

          // If array of typed section constructors is passed, transform the array to
          // type strings
        } else if (Array.isArray(types) && types[0].constructor === Section) {
          types = types.map(function (TypedSection) {
            return TypedSection.prototype.type;
          });
        }

        types = types.map(function (type) {
          return type.toLowerCase();
        });

        return types;
      }

      function normalizeContainers(containers) {
        // Nodelist with entries
        if (NodeList.prototype.isPrototypeOf(containers) && containers.length > 0) {
          containers = Array.prototype.slice.call(containers);

          // Empty Nodelist
        } else if (NodeList.prototype.isPrototypeOf(containers) && containers.length === 0) {
          containers = [];

          // Handle null (document.querySelector() returns null with no match)
        } else if (containers === null) {
          containers = [];

          // Single DOM element
        } else if (!Array.isArray(containers) && containers instanceof Element) {
          containers = [containers];
        }

        return containers;
      }

      if (window.Shopify.designMode) {
        document.addEventListener("shopify:section:load", function (event) {
          var id = event.detail.sectionId;
          var container = event.target.querySelector("[" + theme_sections_SECTION_ID_ATTR + '="' + id + '"]');

          if (container !== null) {
            load(container.getAttribute(SECTION_TYPE_ATTR), container);
          }
        });

        document.addEventListener("shopify:section:unload", function (event) {
          var id = event.detail.sectionId;
          var container = event.target.querySelector("[" + theme_sections_SECTION_ID_ATTR + '="' + id + '"]');
          var instance = getInstances(container)[0];

          if (typeof instance === "object") {
            unload(container);
          }
        });

        document.addEventListener("shopify:section:select", function (event) {
          var instance = getInstanceById(event.detail.sectionId);

          if (typeof instance === "object") {
            instance.onSelect(event);
          }
        });

        document.addEventListener("shopify:section:deselect", function (event) {
          var instance = getInstanceById(event.detail.sectionId);

          if (typeof instance === "object") {
            instance.onDeselect(event);
          }
        });

        document.addEventListener("shopify:block:select", function (event) {
          var instance = getInstanceById(event.detail.sectionId);

          if (typeof instance === "object") {
            instance.onBlockSelect(event);
          }
        });

        document.addEventListener("shopify:block:deselect", function (event) {
          var instance = getInstanceById(event.detail.sectionId);

          if (typeof instance === "object") {
            instance.onBlockDeselect(event);
          }
        });
      }

      // CONCATENATED MODULE: ./src/scripts/sections/header.js
      /**
       * Header
       * ------------------------------------------------------------------------------
       *
       * @namespace header
       */

      register("header", {
        onLoad() {
          const dropdownCount = parseInt(this.container.dataset.dropdownCount);
          const menuOpen = {};

          for (let i = 0; i < dropdownCount; i++) {
            menuOpen["menu" + i] = false;
          }

          const announcementBar = document.querySelector(".section-announcement-bar"); //set header height variable

          if (announcementBar) {
            document.documentElement.style.setProperty(
              "--header-height",
              `${this.container.clientHeight + announcementBar.clientHeight}px`
            );
          } else {
            document.documentElement.style.setProperty("--header-height", `${this.container.clientHeight}px`);
          }

          if (this.container.getAttribute("data-sticky")) {
            document.documentElement.style.setProperty("--sticky-header-height", `${this.container.clientHeight}px`);
          }

          const overlayHeaderWithSticky = this.container.dataset.overlayHeaderWithSticky === "true";
          const overlayTextColor = this.container.dataset.overlayTextColor;

          window["ThemeSection_header"] = () => {
            return {
              menuOpen: menuOpen,
              searchOpen: false,
              headerIsStuck: false,
              overlayHeaderWithSticky,
              overlayTextColor,

              mounted() {
                document.addEventListener("keyup", (event) => {
                  if (event.key === "Escape") {
                    for (let i = 0; i < dropdownCount; i++) {
                      if (this.menuOpen["menu" + i] === true) {
                        this.menuOpen["menu" + i] = false;
                        document.querySelector(`[aria-controls="menu${i}"]`).focus();
                      }
                    }
                  }
                });
                if (this.$refs.search) this.$refs.search.setAttribute("role", "button");

                if (this.overlayHeaderWithSticky) {
                  const headerSection = this.$el.closest(".section-header");
                  const positionerEl = document.createElement("div");
                  positionerEl.id = "sticky-positioner";
                  headerSection.parentNode.insertBefore(positionerEl, headerSection);
                  const observer = new IntersectionObserver(([e]) => {
                    e.intersectionRatio === 0 ? (this.headerIsStuck = true) : (this.headerIsStuck = false);
                  });
                  observer.observe(positionerEl);
                }

                this.updateHeaderColorScheme(this.headerIsStuck);
                this.$watch("headerIsStuck", (value) => {
                  this.updateHeaderColorScheme(value);
                });
                document.body.addEventListener("baseline:search:closebutton", () => {
                  this.searchOpen = false;
                  this.$nextTick(() => {
                    const searchToggleEls = this.$el.querySelectorAll("[data-open-search]");

                    if (searchToggleEls) {
                      setTimeout(() => {
                        const searchToggleEl = Array.from(searchToggleEls).filter((inputEl) =>
                          Boolean(inputEl.offsetParent)
                        )[0];

                        if (searchToggleEl) {
                          searchToggleEl.focus();
                        }
                      }, 300);
                    }
                  });
                });
              },

              openMenu(index) {
                for (let i = 0; i < dropdownCount; i++) {
                  this.menuOpen["menu" + i] = false;
                }

                this.menuOpen["menu" + index] = true;
              },

              openSearch() {
                if (!this.searchOpen) {
                  const searchInputEls = this.$el.querySelectorAll("[data-search-input]");
                  this.searchOpen = true;

                  if (searchInputEls) {
                    setTimeout(() => {
                      const searchInputEl = Array.from(searchInputEls).filter((inputEl) =>
                        Boolean(inputEl.offsetParent)
                      )[0];

                      if (searchInputEl) {
                        searchInputEl.focus();
                      }
                    }, 100);
                  }
                }
              },

              focusOut(event, menu) {
                if (event.relatedTarget) {
                  const dropdownParent = event.relatedTarget.closest("[data-header-dropdown]");

                  if (!dropdownParent) {
                    this.menuOpen[menu] = false;
                  }
                }
              },

              searchFocusOut(event) {
                if (event.relatedTarget) {
                  const searchParent = event.relatedTarget.closest("[data-header-search]");

                  if (!searchParent) {
                    this.searchOpen = false;
                  }
                }
              },

              updateHeaderColorScheme(headerIsStuck) {
                if (!this.overlayHeaderWithSticky || !this.$refs.header) {
                  return;
                }

                if (headerIsStuck) {
                  this.$refs.header.setAttribute("data-color-scheme", "header");
                  this.$refs.header.classList.remove("bg-transparent");
                  this.$refs.header.classList.add("bg-scheme-background");
                } else {
                  this.$refs.header.setAttribute("data-color-scheme", overlayTextColor);
                  this.$refs.header.classList.remove("bg-scheme-background");
                  this.$refs.header.classList.add("bg-transparent");
                }
              },
            };
          };
        },

        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload() {},
      });
      // CONCATENATED MODULE: ./src/scripts/sections/sidebar.js
      /**
       * Header
       * ------------------------------------------------------------------------------
       *
       * @namespace header
       */

      register("sidebar", {
        onLoad() {
          this.sectionId = this.id;
          const accordions = this.container.querySelectorAll("[data-accordion]");
          const accordionOpen = {};

          for (let i = 0; i < accordions.length; i++) {
            accordionOpen["accordion" + i] = false;
          }

          window["ThemeSection_sidebar"] = () => {
            return {
              accordionOpen: accordionOpen,

              mounted() {},
            };
          };
        },

        onSelect: function () {
          Spruce.store("drawer").menuDrawerOpen = true;
        },
        onDeselect: function () {
          Spruce.store("drawer").menuDrawerOpen = false;
        },

        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload() {},
      });
      // CONCATENATED MODULE: ./node_modules/@shopify/theme-cart/request.js
      function getDefaultRequestConfig() {
        return JSON.parse(
          JSON.stringify({
            credentials: "same-origin",
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              "Content-Type": "application/json;",
            },
          })
        );
      }

      function fetchJSON(url, config) {
        return fetch(url, config).then(function (response) {
          if (!response.ok) {
            throw response;
          }
          return response.json();
        });
      }

      function cart() {
        return fetchJSON("/cart.js", getDefaultRequestConfig());
      }

      function cartAdd(id, quantity, properties) {
        var config = getDefaultRequestConfig();

        config.method = "POST";
        config.body = JSON.stringify({
          id: id,
          quantity: quantity,
          properties: properties,
        });

        return fetchJSON("/cart/add.js", config);
      }

      function cartAddFromForm(formData) {
        var config = getDefaultRequestConfig();
        delete config.headers["Content-Type"];

        config.method = "POST";
        config.body = formData;

        return fetchJSON("/cart/add.js", config);
      }

      function cartChange(line, options) {
        var config = getDefaultRequestConfig();

        options = options || {};

        config.method = "POST";
        config.body = JSON.stringify({
          line: line,
          quantity: options.quantity,
          properties: options.properties,
        });

        return fetchJSON("/cart/change.js", config);
      }

      function cartClear() {
        var config = getDefaultRequestConfig();
        config.method = "POST";

        return fetchJSON("/cart/clear.js", config);
      }

      function cartUpdate(body) {
        var config = getDefaultRequestConfig();

        config.method = "POST";
        config.body = JSON.stringify(body);

        return fetchJSON("/cart/update.js", config);
      }

      function cartShippingRates() {
        return fetchJSON("/cart/shipping_rates.json", getDefaultRequestConfig());
      }

      // CONCATENATED MODULE: ./node_modules/@shopify/theme-cart/validate.js
      function validate_key(key) {
        if (typeof key !== "string" || key.split(":").length !== 2) {
          throw new TypeError("Theme Cart: Provided key value is not a string with the format xxx:xxx");
        }
      }

      function validate_quantity(quantity) {
        if (typeof quantity !== "number" || isNaN(quantity)) {
          throw new TypeError("Theme Cart: An object which specifies a quantity or properties value is required");
        }
      }

      function validate_id(id) {
        if (typeof id !== "number" || isNaN(id)) {
          throw new TypeError("Theme Cart: Variant ID must be a number");
        }
      }

      function validate_properties(properties) {
        if (typeof properties !== "object") {
          throw new TypeError("Theme Cart: Properties must be an object");
        }
      }

      function validate_form(form) {
        if (!(form instanceof HTMLFormElement)) {
          throw new TypeError("Theme Cart: Form must be an instance of HTMLFormElement");
        }
      }

      function validate_options(options) {
        if (typeof options !== "object") {
          throw new TypeError("Theme Cart: Options must be an object");
        }

        if (typeof options.quantity === "undefined" && typeof options.properties === "undefined") {
          throw new Error("Theme Cart: You muse define a value for quantity or properties");
        }

        if (typeof options.quantity !== "undefined") {
          validate_quantity(options.quantity);
        }

        if (typeof options.properties !== "undefined") {
          validate_properties(options.properties);
        }
      }

      // CONCATENATED MODULE: ./node_modules/@shopify/theme-cart/theme-cart.js
      /**
       * Cart Template Script
       * ------------------------------------------------------------------------------
       * A file that contains scripts highly couple code to the Cart template.
       *
       * @namespace cart
       */

      /**
       * Returns the state object of the cart
       * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
       */
      function getState() {
        return cart();
      }

      /**
       * Returns the index of the cart line item
       * @param {string} key The unique key of the line item
       * @returns {Promise} Resolves with the index number of the line item
       */
      function getItemIndex(key) {
        validate_key(key);

        return cart().then(function (state) {
          var index = -1;

          state.items.forEach(function (item, i) {
            index = item.key === key ? i + 1 : index;
          });

          if (index === -1) {
            return Promise.reject(new Error("Theme Cart: Unable to match line item with provided key"));
          }

          return index;
        });
      }

      /**
       * Fetches the line item object
       * @param {string} key The unique key of the line item
       * @returns {Promise} Resolves with the line item object (See response of cart/add.js https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#add-to-cart)
       */
      function getItem(key) {
        validate_key(key);

        return cart().then(function (state) {
          var lineItem = null;

          state.items.forEach(function (item) {
            lineItem = item.key === key ? item : lineItem;
          });

          if (lineItem === null) {
            return Promise.reject(new Error("Theme Cart: Unable to match line item with provided key"));
          }

          return lineItem;
        });
      }

      /**
       * Add a new line item to the cart
       * @param {number} id The variant's unique ID
       * @param {object} options Optional values to pass to /cart/add.js
       * @param {number} options.quantity The quantity of items to be added to the cart
       * @param {object} options.properties Line item property key/values (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-properties)
       * @returns {Promise} Resolves with the line item object (See response of cart/add.js https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#add-to-cart)
       */
      function addItem(id, options) {
        options = options || {};

        validate_id(id);

        return cartAdd(id, options.quantity, options.properties);
      }

      /**
       * Add a new line item to the cart from a product form
       * @param {object} form DOM element which is equal to the <form> node
       * @returns {Promise} Resolves with the line item object (See response of cart/add.js https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#add-to-cart)
       */
      function addItemFromForm(form) {
        validate_form(form);

        var formData = new FormData(form);
        validate_id(parseInt(formData.get("id"), 10));

        return cartAddFromForm(formData);
      }

      /**
       * Changes the quantity and/or properties of an existing line item.
       * @param {string} key The unique key of the line item (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-key)
       * @param {object} options Optional values to pass to /cart/add.js
       * @param {number} options.quantity The quantity of items to be added to the cart
       * @param {object} options.properties Line item property key/values (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-properties)
       * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
       */
      function updateItem(key, options) {
        validate_key(key);
        validate_options(options);

        return getItemIndex(key).then(function (line) {
          return cartChange(line, options);
        });
      }

      /**
       * Removes a line item from the cart
       * @param {string} key The unique key of the line item (https://help.shopify.com/en/themes/liquid/objects/line_item#line_item-key)
       * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
       */
      function removeItem(key) {
        validate_key(key);

        return getItemIndex(key).then(function (line) {
          return cartChange(line, {
            quantity: 0,
          });
        });
      }

      /**
       * Sets all quantities of all line items in the cart to zero. This does not remove cart attributes nor the cart note.
       * @returns {Promise} Resolves with the state object of the cart (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-cart)
       */
      function clearItems() {
        return cartClear();
      }

      /**
       * Gets all cart attributes
       * @returns {Promise} Resolves with the cart attributes object
       */
      function getAttributes() {
        return cart().then(function (state) {
          return state.attributes;
        });
      }

      /**
       * Sets all cart attributes
       * @returns {Promise} Resolves with the cart state object
       */
      function updateAttributes(attributes) {
        return cartUpdate({
          attributes: attributes,
        });
      }

      /**
       * Clears all cart attributes
       * @returns {Promise} Resolves with the cart state object
       */
      function clearAttributes() {
        return getAttributes().then(function (attributes) {
          for (var key in attributes) {
            attributes[key] = "";
          }
          return updateAttributes(attributes);
        });
      }

      /**
       * Gets cart note
       * @returns {Promise} Resolves with the cart note string
       */
      function getNote() {
        return cart().then(function (state) {
          return state.note;
        });
      }

      /**
       * Sets cart note
       * @returns {Promise} Resolves with the cart state object
       */
      function updateNote(note) {
        return cartUpdate({
          note: note,
        });
      }

      /**
       * Clears cart note
       * @returns {Promise} Resolves with the cart state object
       */
      function clearNote() {
        return cartUpdate({
          note: "",
        });
      }

      /**
       * Get estimated shipping rates.
       * @returns {Promise} Resolves with response of /cart/shipping_rates.json (https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#get-shipping-rates)
       */
      function getShippingRates() {
        return cartShippingRates();
      }

      // EXTERNAL MODULE: ./node_modules/@shopify/theme-currency/dist/currency.cjs.js
      var currency_cjs = __webpack_require__(3);

      // CONCATENATED MODULE: ./src/scripts/tools/theme-images.js
      /**
       * Adds a Shopify size attribute to a URL
       *
       * @param src
       * @param size
       * @returns {*}
       */
      function theme_images_getSizedImageUrl(src, size) {
        if (size === null) {
          return src;
        }

        if (size === "master") {
          return theme_images_removeProtocol(src);
        }

        var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i);

        if (match) {
          var prefix = src.split(match[0]);
          var suffix = match[0];
          return theme_images_removeProtocol(prefix[0] + "_" + size + suffix);
        } else {
          return null;
        }
      }

      function theme_images_removeProtocol(path) {
        return path.replace(/http(s)?:/, "");
      }
      // CONCATENATED MODULE: ./node_modules/@switchthemes/live-region/node_modules/@shopify/theme-currency/currency.js
      /**
       * Currency Helpers
       * -----------------------------------------------------------------------------
       * A collection of useful functions that help with currency formatting
       *
       * Current contents
       * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
       *
       */

      const moneyFormat = "${{amount}}";

      /**
       * Format money values based on your shop currency settings
       * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
       * or 3.00 dollars
       * @param  {String} format - shop money_format setting
       * @return {String} value - formatted value
       */
      function formatMoney(cents, format) {
        if (typeof cents === "string") {
          cents = cents.replace(".", "");
        }
        let value = "";
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        const formatString = format || moneyFormat;

        function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
          if (isNaN(number) || number == null) {
            return 0;
          }

          number = (number / 100.0).toFixed(precision);

          const parts = number.split(".");
          const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
          const centsAmount = parts[1] ? decimal + parts[1] : "";

          return dollarsAmount + centsAmount;
        }

        switch (formatString.match(placeholderRegex)[1]) {
          case "amount":
            value = formatWithDelimiters(cents, 2);
            break;
          case "amount_no_decimals":
            value = formatWithDelimiters(cents, 0);
            break;
          case "amount_with_comma_separator":
            value = formatWithDelimiters(cents, 2, ".", ",");
            break;
          case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(cents, 0, ".", ",");
            break;
        }

        return formatString.replace(placeholderRegex, value);
      }

      // CONCATENATED MODULE: ./node_modules/@switchthemes/live-region/index.js

      /**
       * Generic live region announcement
       *
       */
      function liveRegion(content, clear) {
        clearTimeout(window.liveRegionTimeout);
        let region = document.getElementById("screenreader-announce");
        region.innerHTML = content;

        window.liveRegionTimeout = setTimeout(() => {
          region.innerHTML = "";
        }, 3000);
      }

      function cartLiveRegion(item) {
        const templateString =
          theme.strings.update +
          ": [QuantityLabel]: [Quantity], [Regular] [$$] [DiscountedPrice] [$]. [PriceInformation]";

        function _liveRegionContent() {
          let liveRegionContent = templateString;

          liveRegionContent = liveRegionContent
            .replace("[QuantityLabel]", theme.strings.quantity)
            .replace("[Quantity]", item.quantity);

          let regularLabel = "";
          let regularPrice = formatMoney(item.original_line_price, theme.moneyFormat);
          let discountLabel = "";
          let discountPrice = "";
          let discountInformation = "";

          if (item.original_line_price > item.final_line_price) {
            regularLabel = theme.strings.regularTotal;

            discountLabel = theme.strings.discountedTotal;
            discountPrice = formatMoney(item.final_line_price, theme.moneyFormat);

            discountInformation = theme.strings.priceColumn;
          }

          liveRegionContent = liveRegionContent
            .replace("[Regular]", regularLabel)
            .replace("[$$]", regularPrice)
            .replace("[DiscountedPrice]", discountLabel)
            .replace("[$]", discountPrice)
            .replace("[PriceInformation]", discountInformation)
            .replace("  .", "")
            .trim();

          return liveRegionContent;
        }

        liveRegion(_liveRegionContent(), true);
      }

      function variantLiveRegion(variant) {
        const templateString = "[Availability] [Regular] [$$] [Sale] [$]. [UnitPrice] [$$$]";

        function _getBaseUnit() {
          if (variant.unit_price_measurement.reference_value === 1) {
            return variant.unit_price_measurement.reference_unit;
          }

          return variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit;
        }

        /**
         * Compose the live region’s content based on the
         * variant’s properties.
         *
         * @param {Object} variant The variant
         */
        function _liveRegionContent() {
          let liveRegionContent = templateString;

          // Update availability
          const availability = variant.available ? "" : theme.strings.soldOut + ",";
          liveRegionContent = liveRegionContent.replace("[Availability]", availability);

          // Update pricing
          let regularLabel = "";
          let regularPrice = formatMoney(variant.price, theme.moneyFormat);

          let saleLabel = "",
            salePrice = "",
            unitLabel = "",
            unitPrice = "";

          if (variant.compare_at_price > variant.price) {
            regularLabel = theme.strings.regularPrice;
            regularPrice = formatMoney(variant.compare_at_price, theme.moneyFormat);

            saleLabel = theme.strings.sale;
            salePrice = formatMoney(variant.price, theme.moneyFormat);
          }

          if (variant.unit_price) {
            unitLabel = theme.strings.unitPrice;
            unitPrice =
              formatMoney(variant.unit_price, theme.moneyFormat) +
              " " +
              theme.strings.unitPriceSeparator +
              " " +
              _getBaseUnit();
          }

          liveRegionContent = liveRegionContent
            .replace("[Regular]", regularLabel)
            .replace("[$$]", regularPrice)
            .replace("[Sale]", saleLabel)
            .replace("[$]", salePrice)
            .replace("[UnitPrice]", unitLabel)
            .replace("[$$$]", unitPrice)
            .replace("  .", "")
            .trim();

          return liveRegionContent;
        }

        liveRegion(_liveRegionContent(), false);
      }

      // CONCATENATED MODULE: ./src/scripts/sections/cart-drawer.js

      /* harmony default export */
      var cart_drawer = register("cart-drawer", {
        onLoad() {
          const section = this;
          this.sectionId = this.id;
          const toggles = document.querySelectorAll("[data-cart-drawer-toggle]");

          window["ThemeSection_cartDrawer"] = () => {
            return {
              state: null,
              lastUpdate: null,
              loading: true,
              updating: false,
              noteUpdating: false,
              errorMessages: {},
              getSizedImageUrl: theme_images_getSizedImageUrl,

              mounted() {
                toggles.forEach((toggle) => {
                  toggle.setAttribute("role", "button");
                });
                this.$watch("state", (value) => {
                  if (value) {
                    this.loading = false;
                    this.updating = false;
                    this.rowUpdating = false;
                    this.noteUpdating = false; // Save a non-reactive copy of the state
                    // to compare changes against

                    this.lastUpdate = JSON.parse(JSON.stringify(value));
                    document.body.dispatchEvent(
                      new CustomEvent("baseline:modalcart:itemcountupdate", {
                        detail: {
                          count: value.item_count,
                        },
                      })
                    );
                  }
                });
                document.body.addEventListener("baseline:modalcart:afteradditem", () => {
                  this._getState(() => {
                    if (section.container.dataset.showOnAdd == "true") {
                      Spruce.store("drawer").cartDrawerOpen = true;
                    }
                  });
                });

                this._getState();
              },

              _getState(callback) {
                getState().then((state) => {
                  this.state = state;

                  if (typeof callback === "function") {
                    callback();
                  }
                });
              },

              flatProperties(properties) {
                if (!properties || objectHasNoKeys(properties)) return [];
                const propertiesArray = [];

                for (const propKey in properties) {
                  // Ignore properties that start with
                  // an underscore as they are considered
                  // 'private' by Shopify
                  if (propKey.charAt(0) === "_" || !properties[propKey].trim()) continue;
                  const propObj = {};
                  propObj["name"] = propKey;
                  propObj["value"] = properties[propKey];
                  propertiesArray.push(propObj);
                }

                return propertiesArray;
              },

              formatMoney(amount) {
                return Object(currency_cjs["formatMoney"])(amount, window.theme.moneyFormat);
              },

              qtyAdjust($event, item) {
                if (this.updating) return;
                const operation = $event.currentTarget.dataset.qtyAdjust || "plus";

                if (operation === "plus") {
                  item.quantity++;
                }

                if (operation === "minus") {
                  item.quantity--;

                  if (item.quantity <= 0) {
                    item.quantity = 0;
                  }
                }

                if (operation === "remove") {
                  item.quantity = 0;
                }

                this.updateQuantity(item);
              },

              getCopyFromLastStateUpdate(item) {
                return this.lastUpdate.items[this.state.items.indexOf(item)];
              },

              updateQuantity(item) {
                const lastQuantity = this.getCopyFromLastStateUpdate(item).quantity || 0;
                if (lastQuantity === item.quantity) return;
                this.updating = true;
                this.rowUpdating = true;
                item.updating = true;
                delete this.errorMessages[item.key];
                updateItem(item.key, {
                  quantity: item.quantity,
                })
                  .then((state) => {
                    const newItem = state.items.find((newItemData) => {
                      return newItemData.key == item.key;
                    });

                    if (newItem) {
                      cartLiveRegion(newItem, false);

                      if (state.item_count === this.state.item_count) {
                        // Legacy quantity code
                        this.errorMessages[item.key] = window.theme.strings.cartAddError.replace(
                          "{{ title }}",
                          newItem.title
                        );
                      }
                    } else {
                      if (item.quantity === 0) {
                        liveRegion(window.theme.strings.quantity + " 0");
                        setTimeout(() => {
                          const title = document.getElementById("CartTitle");
                          if (title) title.focus();
                        }, 100);
                      }
                    }

                    this.state = state;
                  })
                  .catch((error) => {
                    error.json().then((errorData) => {
                      if (errorData.status === 422) {
                        this.errorMessages[item.key] = errorData.message;
                        item.quantity = lastQuantity;
                      }

                      this.updating = false;
                      this.rowUpdating = false;
                      item.updating = false;
                    });
                  });
              },

              updateNote($event) {
                const value = $event.currentTarget.value || "";
                if (this.lastUpdate.note == value) return;
                this.updating = true;
                this.noteUpdating = true;
                updateNote(value).then((state) => {
                  this.state = state;
                });
              },

              keyupOnInput($event) {
                // This handler must be debounced
                const target = $event.target;
                target.dispatchEvent(new Event("change"));
              },

              getCartImgSrcset(src) {
                const sizes = [60, 100, 120, 200];
                return getImageSrcset(src, sizes);
              },
            };
          };
        },

        onSelect: function () {
          Spruce.store("drawer").cartDrawerOpen = true;
        },
        onDeselect: function () {
          Spruce.store("drawer").cartDrawerOpen = false;
        },

        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload() {},
      });
      // CONCATENATED MODULE: ./node_modules/@shopify/theme-product/theme-product.js
      /**
       * Returns a product JSON object when passed a product URL
       * @param {*} url
       */
      function getProductJson(handle) {
        return fetch("/products/" + handle + ".js").then(function (response) {
          return response.json();
        });
      }

      /**
       * Find a match in the project JSON (using a ID number) and return the variant (as an Object)
       * @param {Object} product Product JSON object
       * @param {Number} value Accepts Number (e.g. 6908023078973)
       * @returns {Object} The variant object once a match has been successful. Otherwise null will be return
       */
      function getVariantFromId(product, value) {
        _validateProductStructure(product);

        if (typeof value !== "number") {
          throw new TypeError(value + " is not a Number.");
        }

        var result = product.variants.filter(function (variant) {
          return variant.id === value;
        });

        return result[0] || null;
      }

      /**
       * Convert the Object (with 'name' and 'value' keys) into an Array of values, then find a match & return the variant (as an Object)
       * @param {Object} product Product JSON object
       * @param {Object} collection Object with 'name' and 'value' keys (e.g. [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }])
       * @returns {Object || null} The variant object once a match has been successful. Otherwise null will be returned
       */
      function getVariantFromSerializedArray(product, collection) {
        _validateProductStructure(product);

        // If value is an array of options
        var optionArray = _createOptionArrayFromOptionCollection(product, collection);
        return getVariantFromOptionArray(product, optionArray);
      }

      /**
       * Find a match in the project JSON (using Array with option values) and return the variant (as an Object)
       * @param {Object} product Product JSON object
       * @param {Array} options List of submitted values (e.g. ['36', 'Black'])
       * @returns {Object || null} The variant object once a match has been successful. Otherwise null will be returned
       */
      function getVariantFromOptionArray(product, options) {
        _validateProductStructure(product);
        _validateOptionsArray(options);

        var result = product.variants.filter(function (variant) {
          return options.every(function (option, index) {
            return variant.options[index] === option;
          });
        });

        return result[0] || null;
      }

      /**
       * Creates an array of selected options from the object
       * Loops through the project.options and check if the "option name" exist (product.options.name) and matches the target
       * @param {Object} product Product JSON object
       * @param {Array} collection Array of object (e.g. [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }])
       * @returns {Array} The result of the matched values. (e.g. ['36', 'Black'])
       */
      function _createOptionArrayFromOptionCollection(product, collection) {
        _validateProductStructure(product);
        _validateSerializedArray(collection);

        var optionArray = [];

        collection.forEach(function (option) {
          for (var i = 0; i < product.options.length; i++) {
            if (product.options[i].name.toLowerCase() === option.name.toLowerCase()) {
              optionArray[i] = option.value;
              break;
            }
          }
        });

        return optionArray;
      }

      /**
       * Check if the product data is a valid JS object
       * Error will be thrown if type is invalid
       * @param {object} product Product JSON object
       */
      function _validateProductStructure(product) {
        if (typeof product !== "object") {
          throw new TypeError(product + " is not an object.");
        }

        if (Object.keys(product).length === 0 && product.constructor === Object) {
          throw new Error(product + " is empty.");
        }
      }

      /**
       * Validate the structure of the array
       * It must be formatted like jQuery's serializeArray()
       * @param {Array} collection Array of object [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }]
       */
      function _validateSerializedArray(collection) {
        if (!Array.isArray(collection)) {
          throw new TypeError(collection + " is not an array.");
        }

        if (collection.length === 0) {
          return [];
        }

        if (collection[0].hasOwnProperty("name")) {
          if (typeof collection[0].name !== "string") {
            throw new TypeError(
              "Invalid value type passed for name of option " + collection[0].name + ". Value should be string."
            );
          }
        } else {
          throw new Error(collection[0] + "does not contain name key.");
        }
      }

      /**
       * Validate the structure of the array
       * It must be formatted as list of values
       * @param {Array} collection Array of object (e.g. ['36', 'Black'])
       */
      function _validateOptionsArray(options) {
        if (Array.isArray(options) && typeof options[0] === "object") {
          throw new Error(options + "is not a valid array of options.");
        }
      }

      // CONCATENATED MODULE: ./node_modules/@shopify/theme-product-form/listeners.js
      function Listeners() {
        this.entries = [];
      }

      Listeners.prototype.add = function (element, event, fn) {
        this.entries.push({
          element: element,
          event: event,
          fn: fn,
        });
        element.addEventListener(event, fn);
      };

      Listeners.prototype.removeAll = function () {
        this.entries = this.entries.filter(function (listener) {
          listener.element.removeEventListener(listener.event, listener.fn);
          return false;
        });
      };

      // CONCATENATED MODULE: ./node_modules/@shopify/theme-product-form/theme-product-form.js

      var theme_product_form_selectors = {
        idInput: '[name="id"]',
        optionInput: '[name^="options"]',
        quantityInput: '[name="quantity"]',
        propertyInput: '[name^="properties"]',
      };

      // Public Methods
      // -----------------------------------------------------------------------------

      /**
       * Returns a URL with a variant ID query parameter. Useful for updating window.history
       * with a new URL based on the currently select product variant.
       * @param {string} url - The URL you wish to append the variant ID to
       * @param {number} id  - The variant ID you wish to append to the URL
       * @returns {string} - The new url which includes the variant ID query parameter
       */

      function getUrlWithVariant(url, id) {
        if (/variant=/.test(url)) {
          return url.replace(/(variant=)[^&]+/, "$1" + id);
        } else if (/\?/.test(url)) {
          return url.concat("&variant=").concat(id);
        }

        return url.concat("?variant=").concat(id);
      }

      /**
       * Constructor class that creates a new instance of a product form controller.
       *
       * @param {Element} element - DOM element which is equal to the <form> node wrapping product form inputs
       * @param {Object} product - A product object
       * @param {Object} options - Optional options object
       * @param {Function} options.onOptionChange - Callback for whenever an option input changes
       * @param {Function} options.onQuantityChange - Callback for whenever an quantity input changes
       * @param {Function} options.onPropertyChange - Callback for whenever a property input changes
       * @param {Function} options.onFormSubmit - Callback for whenever the product form is submitted
       */
      function ProductForm(element, product, options) {
        this.element = element;
        this.product = _validateProductObject(product);

        options = options || {};

        this._listeners = new Listeners();
        this._listeners.add(this.element, "submit", this._onSubmit.bind(this, options));

        this.optionInputs = this._initInputs(theme_product_form_selectors.optionInput, options.onOptionChange);

        this.quantityInputs = this._initInputs(theme_product_form_selectors.quantityInput, options.onQuantityChange);

        this.propertyInputs = this._initInputs(theme_product_form_selectors.propertyInput, options.onPropertyChange);
      }

      /**
       * Cleans up all event handlers that were assigned when the Product Form was constructed.
       * Useful for use when a section needs to be reloaded in the theme editor.
       */
      ProductForm.prototype.destroy = function () {
        this._listeners.removeAll();
      };

      /**
       * Getter method which returns the array of currently selected option values
       *
       * @returns {Array} An array of option values
       */
      ProductForm.prototype.options = function () {
        return _serializeOptionValues(this.optionInputs, function (item) {
          var regex = /(?:^(options\[))(.*?)(?:\])/;
          item.name = regex.exec(item.name)[2]; // Use just the value between 'options[' and ']'
          return item;
        });
      };

      /**
       * Getter method which returns the currently selected variant, or `null` if variant
       * doesn't exist.
       *
       * @returns {Object|null} Variant object
       */
      ProductForm.prototype.variant = function () {
        return getVariantFromSerializedArray(this.product, this.options());
      };

      /**
       * Getter method which returns a collection of objects containing name and values
       * of property inputs
       *
       * @returns {Array} Collection of objects with name and value keys
       */
      ProductForm.prototype.properties = function () {
        var properties = _serializePropertyValues(this.propertyInputs, function (propertyName) {
          var regex = /(?:^(properties\[))(.*?)(?:\])/;
          var name = regex.exec(propertyName)[2]; // Use just the value between 'properties[' and ']'
          return name;
        });

        return Object.entries(properties).length === 0 ? null : properties;
      };

      /**
       * Getter method which returns the current quantity or 1 if no quantity input is
       * included in the form
       *
       * @returns {Array} Collection of objects with name and value keys
       */
      ProductForm.prototype.quantity = function () {
        return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1;
      };

      // Private Methods
      // -----------------------------------------------------------------------------
      ProductForm.prototype._setIdInputValue = function (value) {
        var idInputElement = this.element.querySelector(theme_product_form_selectors.idInput);

        if (!idInputElement) {
          idInputElement = document.createElement("input");
          idInputElement.type = "hidden";
          idInputElement.name = "id";
          this.element.appendChild(idInputElement);
        }

        idInputElement.value = value.toString();
      };

      ProductForm.prototype._onSubmit = function (options, event) {
        event.dataset = this._getProductFormEventData();

        if (event.dataset.variant) {
          this._setIdInputValue(event.dataset.variant.id);
        }

        if (options.onFormSubmit) {
          options.onFormSubmit(event);
        }
      };

      ProductForm.prototype._onFormEvent = function (cb) {
        if (typeof cb === "undefined") {
          return Function.prototype;
        }

        return function (event) {
          event.dataset = this._getProductFormEventData();
          cb(event);
        }.bind(this);
      };

      ProductForm.prototype._initInputs = function (selector, cb) {
        var elements = Array.prototype.slice.call(this.element.querySelectorAll(selector));

        return elements.map(
          function (element) {
            this._listeners.add(element, "change", this._onFormEvent(cb));
            return element;
          }.bind(this)
        );
      };

      ProductForm.prototype._getProductFormEventData = function () {
        return {
          options: this.options(),
          variant: this.variant(),
          properties: this.properties(),
          quantity: this.quantity(),
        };
      };

      function _serializeOptionValues(inputs, transform) {
        return inputs.reduce(function (options, input) {
          if (
            input.checked || // If input is a checked (means type radio or checkbox)
            (input.type !== "radio" && input.type !== "checkbox") // Or if its any other type of input
          ) {
            options.push(
              transform({
                name: input.name,
                value: input.value,
              })
            );
          }

          return options;
        }, []);
      }

      function _serializePropertyValues(inputs, transform) {
        return inputs.reduce(function (properties, input) {
          if (
            input.checked || // If input is a checked (means type radio or checkbox)
            (input.type !== "radio" && input.type !== "checkbox") // Or if its any other type of input
          ) {
            properties[transform(input.name)] = input.value;
          }

          return properties;
        }, {});
      }

      function _validateProductObject(product) {
        if (typeof product !== "object") {
          throw new TypeError(product + " is not an object.");
        }

        if (typeof product.variants[0].options === "undefined") {
          throw new TypeError(
            "Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route"
          );
        }

        return product;
      }

      // EXTERNAL MODULE: ./node_modules/@splidejs/splide/dist/js/splide.esm.js
      var splide_esm = __webpack_require__(4);
      var splide_esm_default = /*#__PURE__*/ __webpack_require__.n(splide_esm);

      // CONCATENATED MODULE: ./node_modules/@switchthemes/splide-a11y/index.js
      const applyInert = function (splide) {
        // Make sure that clickable children of inactive slides can't be focused to
        const elements = splide.Components.Elements;
        const slides = Array.from(elements.getSlides(true));
        slides.forEach((slide) => {
          if (slide.isVisible()) {
            slide.slide.removeAttribute("inert");
          } else {
            slide.slide.setAttribute("inert", "");
          }
        });
      };

      // CONCATENATED MODULE: ./src/scripts/components/media.js

      document.addEventListener("touchstart", function () {
        Helpers.setTouch();
      });
      const ProductModel = (function () {
        const modelJsonSections = {};
        const models = {};
        const xrButtons = {};
        const selectors = {
          mediaGroup: "[data-product-single-media-group]",
          xrButton: "[data-shopify-xr]",
          activateButton: "[data-model-toggle]",
        };

        function init(modelViewerContainers, sectionId) {
          // loadFeature will use mutation observer.
          // Final version of debut will not check this.

          /*
        if (Shopify.designMode) {
          window.Shopify.detectLoadJS();
        }
        */
          modelJsonSections[sectionId] = {
            loaded: false,
          };
          modelViewerContainers.forEach((container, index) => {
            const mediaId = container.dataset.mediaId;
            const modelViewerElement = container.querySelector("model-viewer");
            const modelId = modelViewerElement.dataset.modelId;

            if (index === 0) {
              const xrButton = container.closest(selectors.mediaGroup).querySelector(selectors.xrButton);
              xrButtons[sectionId] = {
                element: xrButton,
                defaultId: modelId,
              };
            }

            models[mediaId] = {
              modelId: modelId,
              sectionId: sectionId,
              container: container,
              element: modelViewerElement,
            };
          }); //LibraryLoader.load('shopifyXr', setupShopifyXr);

          window.Shopify.loadFeatures([
            {
              name: "shopify-xr",
              version: "1.0",
              onLoad: setupShopifyXr,
            },
            {
              name: "model-viewer-ui",
              version: "1.0",
              onLoad: setupModelViewerUi,
            },
          ]);
          library_loader.load("modelViewerUiStyles");
        }

        function setupShopifyXr(errors) {
          if (errors) {
            errors.forEach((error) => {
              console.warn(error.message);
            }); // When loadFeature is implemented, you can console or throw errors by doing something like this:

            return;
          }

          if (!window.ShopifyXR) {
            document.addEventListener("shopify_xr_initialized", function () {
              setupShopifyXr();
            });
            return;
          }

          for (let sectionId in modelJsonSections) {
            if (modelJsonSections.hasOwnProperty(sectionId)) {
              const modelSection = modelJsonSections[sectionId];
              if (modelSection.loaded) continue;
              const modelJson = JSON.parse(document.getElementById("ModelJson-" + sectionId).innerHTML);

              if (modelJson) {
                window.ShopifyXR.addModels(modelJson);
                modelSection.loaded = true;
              }
            }
          }

          window.ShopifyXR.setupXRElements();
        }

        function setupModelViewerUi(errors) {
          if (errors) {
            // When loadFeature is implemented, you can console or throw errors by doing something like this:
            // errors.forEach((error) => { console.warn(error.message); });
            return;
          }

          for (let key in models) {
            if (models.hasOwnProperty(key)) {
              const model = models[key];

              if (!model.modelViewerUi) {
                const element = '[data-model-id="' + model.modelId + '"]';
                model.modelViewerUi = new Shopify.ModelViewerUI(element);
              }

              setupModelViewerListeners(model);
            }
          }
        }

        function setupModelViewerListeners(model) {
          const xrButton = xrButtons[model.sectionId];
          model.container.addEventListener("mediaVisible", function () {
            xrButton.element.setAttribute("data-shopify-model3d-id", model.modelId);
            if (Helpers.isTouch()) return;
            model.modelViewerUi.play();
          });
          model.container.addEventListener("mediaHidden", function () {
            xrButton.element.setAttribute("data-shopify-model3d-id", xrButton.defaultId);
            model.modelViewerUi.pause();
          });
          model.container.addEventListener("xrLaunch", function () {
            model.modelViewerUi.pause();
          });
        }

        function removeSectionModels(sectionId) {
          for (let key in models) {
            if (models.hasOwnProperty(key)) {
              var model = models[key];

              if (model.sectionId === sectionId) {
                delete models[key];
              }
            }
          }

          delete modelJsonSections[sectionId];
        }

        return {
          init: init,
          removeSectionModels: removeSectionModels,
        };
      })();
      // EXTERNAL MODULE: ./node_modules/lodash/debounce.js
      var debounce = __webpack_require__(1);
      var debounce_default = /*#__PURE__*/ __webpack_require__.n(debounce);

      // CONCATENATED MODULE: ./node_modules/@switchthemes/store-availability/index.js

      const store_availability_StoreAvailability = (function () {
        /**
         * @constructor
         * StoreAvailability constructor
         *
         * @param {HTMLElement} container An HTML container
         */
        function StoreAvailability(container) {
          this.container = container;
          this.fetchContent = debounce_default()(this.__fetchContent.bind(this), 500, {
            leading: true,
            trailing: true,
          });

          window.Spruce.store("availability").product_title = this.container.dataset.productTitle;
        }

        StoreAvailability.prototype = Object.assign({}, StoreAvailability.prototype, {
          /**
           * @description
           * Gets information about a variant’s store
           * pickup availability from its section response,
           * and replaces the inner HTML of the container element
           * with the one from the section response
           *
           * @param {Number} variantId The ID of the variant
           */
          __fetchContent: function (variant) {
            if (window.Spruce.store("availability").availability[variant.id]) {
              window.Spruce.store("availability").current_variant = variant;
              window.Spruce.store("availability").loading = false;
              return;
            } else {
              let baseUrl = this.container.dataset.baseUrl;

              if (!baseUrl.endsWith("/")) {
                baseUrl = baseUrl + "/";
              }

              const variantSectionUrl = baseUrl + "variants/" + variant.id + "/?section_id=store-availability";
              window.Spruce.store("availability").loading = true;

              return fetch(variantSectionUrl)
                .then(function (response) {
                  return response.text();
                })
                .then(function (storeAvailabilityHTML) {
                  // todo: think we can refactor this to be a little cleaner but right now i want this to work with both json and non json content
                  window.Spruce.store("availability").loading = false;
                  window.Spruce.store("availability").current_variant = variant;
                  let data = "";
                  const parser = new DOMParser();
                  const html = parser.parseFromString(storeAvailabilityHTML, "text/html");
                  const dataWrapper = html.querySelector("[data-availability-json]");
                  if (dataWrapper) {
                    data = JSON.parse(dataWrapper.innerHTML);
                  }
                  window.Spruce.store("availability").availability[data.variant] = data.availability;
                });
            }
          },
        });

        return StoreAvailability;
      })();

      /* harmony default export */
      var store_availability = store_availability_StoreAvailability;

      // CONCATENATED MODULE: ./src/scripts/sections/product.js
      /**
       * Product Template Script
       * ------------------------------------------------------------------------------
       * A file that contains scripts highly couple code to the Product template.
       *
       * @namespace product
       */
      //import Variants from '@shopify/theme-variants';

      /**
       * Product section constructor. Runs on page load as well as Theme Editor
       * `section:load` events.
       * @param {string} container - selector for the section container DOM element
       */

      register("product", {
        onLoad() {
          const section = this;
          const alpineId = this.container.dataset.alpineId;
          const storeAvailabilityContainer = this.container.querySelector("[data-store-availability]");
          const variantImageBehaviour = this.container.dataset.variantImageBehaviour;
          const isHorizontalGalleryTemplate = this.container.hasAttribute("data-product-horizontal-gallery");
          const hasGiftCardRecipientForm = Boolean(this.container.querySelector("[data-gift-card-recipient-form]"));

          if (!this.container.querySelector("[data-product-json]")) {
            return;
          }

          this.productSingleObject = JSON.parse(this.container.querySelector("[data-product-json]").innerHTML);
          this.selectedVariantObject = JSON.parse(
            this.container.querySelector("[data-selected-variant-json]").innerHTML
          );
          this.featuredMediaID = JSON.parse(this.container.querySelector("[data-featured-media-id]").innerHTML);

          if (storeAvailabilityContainer) {
            this.storeAvailability = new store_availability(storeAvailabilityContainer);
          }

          this.sectionId = this.id;
          this.setupSlideshow(isHorizontalGalleryTemplate);
          this._debouncedCalculateSlideshowHeight = debounce_default()(this.calculateSlideshowHeight.bind(this), 200);
          window.addEventListener("resize", this._debouncedCalculateSlideshowHeight);
          this.enableImageZoom = this.container.dataset.enableImageZoom === "true" || false;

          if (this.enableImageZoom) {
            Promise.all(/* import() | product-image-zoom */ [__webpack_require__.e(5), __webpack_require__.e(1)])
              .then(__webpack_require__.bind(null, 41))
              .then(({ default: PhotoSwipeModule }) => {
                this.setUpImageZoom(PhotoSwipeModule.PhotoSwipe, PhotoSwipeModule.PhotoSwipeUI_Default);
              })
              .catch((error) => console.warn(error));
          } //get add to cart button height and set it as css variable

          const addToCartBtn = document.getElementById("addToCartButton");

          if (addToCartBtn) {
            window.addEventListener("DOMContentLoaded", (event) => {
              document.documentElement.style.setProperty("--add-to-cart-height", `${addToCartBtn.offsetHeight}px`);
            });
          }

          const functionName = "ThemeSection_" + alpineId;

          window[functionName] = () => {
            return {
              current_media_id: this.featuredMediaID,
              product: this.productSingleObject,
              current_variant: this.selectedVariantObject,
              quantity: "1",
              headerSection: null,
              enableQuantityInput: false,
              options: [],
              optionHandles: [],
              current_price: this.selectedVariantObject.price,
              addedToCart: false,
              loading: false,
              addErrorMessage: "",
              changeVariant: null,
              showFullDescription: false,

              formatMoney(price) {
                return Object(currency_cjs["formatMoney"])(price, theme.moneyFormat);
              },

              get currentVariantAvailable() {
                if (this.current_variant) {
                  return this.current_variant.available;
                } else {
                  return null;
                }
              },

              get currentVariantId() {
                if (this.current_variant) {
                  return this.current_variant.id;
                } else {
                  return null;
                }
              },

              get currentVariantAvailability() {
                // this is on a lag to the actual current variant so that we can display an intermediary state while the fetch request is happening
                const id = window.Spruce.store("availability").current_variant.id;
                const storeData = window.Spruce.store("availability").availability[id];

                if (storeData) {
                  return storeData.closest_location;
                } else {
                  return null;
                }
              },

              get truncatedProductDescription() {
                if (!this.product || !this.product.hasOwnProperty("description")) {
                  return null;
                }

                const productDescriptionHTML = this.stringToHTML(this.product.description);

                while (productDescriptionHTML.innerText.length >= 25 && productDescriptionHTML.childNodes.length > 2) {
                  productDescriptionHTML.removeChild(productDescriptionHTML.lastChild);
                }

                return productDescriptionHTML.innerHTML;
              },

              stringToHTML(str) {
                const parser = new DOMParser();
                const doc = parser.parseFromString(str, "text/html");
                return doc.body;
              },

              initProductModels() {
                const models = section.container.querySelectorAll("[data-product-media-type-model]");
                ProductModel.init(models, section.sectionId);
              },

              // for combined products, select the appropriate variant on load based on the URL
              updateSelectedVariant() {
                const currentUrl = window.location.href;
                const url = new URL(currentUrl);
                const variantId = url.searchParams.get("variant");
                if (variantId && variantId != this.current_variant.id) {
                  const variants = JSON.parse(JSON.stringify(this.product.variants));
                  const variantToSelect = variants.filter((variant) => {
                    return variant.id == variantId;
                  })[0];

                  const firstAvailableSize = variants
                    .filter((variant) => {
                      return variantToSelect.option2 == variant.option2 && variant.available;
                    })
                    .map((variant) => {
                      return variant.option1;
                    })[0];
                  document.querySelector(`input[value="${variantToSelect.option2}"]`).checked = true;
                  if (firstAvailableSize) {
                    document.querySelector(`input[value="${firstAvailableSize}"]`).checked = true;
                  }

                  this.current_variant = variantToSelect;
                  if (this.current_variant.featured_media) {
                    if (variantImageBehaviour == "swap") {
                      this.swapVariantImage();
                    } else {
                      this.scrollToVariantImage();
                    }
                  }
                } else {
                  console.log("No variant id");
                }
              },

              mounted() {
                if (this.$refs.productForm) {
                  this.$refs.productForm.addEventListener("submit", this.submitForm.bind(this));
                }

                this.updateSelectedVariant();

                this.getOptions();
                this.updateVariantStatuses();
                this.changeVariant = debounce_default()(this.__changeVariant, 500, {
                  leading: true,
                  trailing: true,
                });
                this.initProductModels();
                window.Spruce.store("availability").current_variant = this.current_variant;
                this.updateStoreAvailability(this.current_variant);
                const featuredMedia = document.querySelector('[data-media-id="' + this.current_media_id + '"]');

                if (section.slides && section.slides.classList.contains("is-active")) {
                  const parentSlide = featuredMedia.closest("[data-index]");
                  const index = parseInt(parentSlide.dataset.index);
                  section.splideContainer.go(index);
                }
              },

              __changeVariant() {
                let matchedVariant = getVariantFromOptionArray(this.product, this.options);
                if (matchedVariant == null) {
                  const input = document.querySelector('input[name="options[SIZE]"][value="S"]');
                  if (input) {
                    input.checked = true;
                    input.dispatchEvent( new Event('change', { bubbles: true}));
                    return
                  }
                }
                this.current_variant = matchedVariant;

                if (this.current_variant) {
                  variantLiveRegion(this.current_variant);
                  this.current_price = this.current_variant.price;
                  this.updateStoreAvailability(this.current_variant);
                  const finalSaleInfo = JSON.parse(document.querySelector('[data-product-variants-final-sale]').textContent);
                  if (finalSaleInfo[this.current_variant.id]['final_sale'] == true) {
                    document.getElementById('_asrc').setAttribute('value', 'Final Sale');
                    document.getElementById('final-sale-label').innerHTML = '<p>FINAL SALE</p>';
                  } else {
                    document.getElementById('_asrc').setAttribute('value', '');
                    document.getElementById('final-sale-label').innerHTML = '<p></p>';
                  }

                  // console.log(this.product);
                  // console.log(this.current_variant);

                  /*

                // console.log(this.product);
                // console.log(this.current_variant);

                there should be no 23 for any color:
                  the only two variants that have 23 are set to show_on_website=False

                Sort the colors.
                  Ochre
                  Slate
                  Bone
                  Oxford
                  Butter
                  Chocolate Brown
                  Chalk
                  Ink

                */

                  if (this.current_variant.featured_media) {
                    if (variantImageBehaviour == "swap") {
                      this.swapVariantImage();
                    } else {
                      this.scrollToVariantImage();
                    }
                  }

                  const url = getUrlWithVariant(window.location.href, this.current_variant.id);
                  window.history.replaceState(
                    {
                      path: url,
                    },
                    "",
                    url
                  );
                  this.$refs.singleVariantSelector.dispatchEvent(
                    new Event("change", {
                      bubbles: true,
                    })
                  );

                  if (this.$el.querySelector(".product-inventory-status-block")) {
                    this.updateInventoryStatusBlock(url);
                  }
                }
              },

              updateInventoryStatusBlock(url) {
                const inventoryStatusBlockEl = this.$el.querySelector(".product-inventory-status-block");
                let productPageURL;

                if (inventoryStatusBlockEl.dataset.url) {
                  productPageURL = getUrlWithVariant(inventoryStatusBlockEl.dataset.url, this.current_variant.id);
                } else {
                  productPageURL = url;
                }

                inventoryStatusBlockEl.style.opacity = 0.5;
                fetch(productPageURL)
                  .then((data) => data.text())
                  .then((fetchedHTMLString) => {
                    const productPageForVariant = new DOMParser().parseFromString(fetchedHTMLString, "text/html");
                    const updatedInventoryStatusBlockEl = productPageForVariant.querySelector(
                      ".product-inventory-status-block"
                    );

                    if (updatedInventoryStatusBlockEl) {
                      inventoryStatusBlockEl.innerHTML = updatedInventoryStatusBlockEl.innerHTML;
                      inventoryStatusBlockEl.style.opacity = "";
                    } else {
                      inventoryStatusBlockEl.remove();
                    }
                  });
              },

              optionChange() {
                //loop through selectors and build product object to find current variant
                this.getOptions();
                this.changeVariant();
                this.updateVariantStatuses();
              },

              getOptions() {
                this.options = [];
                this.optionHandles = [];
                let selectors = this.$el.querySelectorAll("[data-single-option-selector]");
                selectors.forEach((selector) => {
                  if (selector.nodeName === "SELECT") {
                    let value = selector.value;
                    this.options.push(value);
                    this.optionHandles.push(selector.options[selector.selectedIndex].dataset.handle);
                  } else {
                    if (selector.checked) {
                      let value = selector.value;
                      this.options.push(value);
                      this.optionHandles.push(selector.dataset.handle);
                    }
                  }
                });
              },

              updateVariantStatuses() {
                const selectedOptionOneVariants = this.product.variants.filter(
                  (variant) =>
                    this.$el.querySelector('[data-option-index="1"] input[type="radio"]:checked').value ===
                    variant.option1
                );
                const selectedOptionTwoVariants = this.product.variants.filter(
                  (variant) =>
                    this.$el.querySelector('[data-option-index="2"] input[type="radio"]:checked').value ===
                    variant.option2
                );

                const inputWrappers = [...this.$el.querySelectorAll(".product-variant-picker-block")];

                inputWrappers.forEach((option, index) => {
                  // skip the first input wrapper
                  const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
                  let selectedOption, availableOptionInputsValue;
                  if (index === 0) {
                    selectedOption = inputWrappers[index + 1].querySelector(":checked").value;
                    availableOptionInputsValue = selectedOptionTwoVariants
                      .filter((variant) => variant.available && variant[`option${index + 2}`] === selectedOption)
                      .map((variantOption) => variantOption[`option${index + 1}`]);
                  } else {
                    selectedOption = inputWrappers[index - 1].querySelector(":checked").value;
                    availableOptionInputsValue = selectedOptionOneVariants
                      .filter((variant) => variant.available && variant[`option${index}`] === selectedOption)
                      .map((variantOption) => variantOption[`option${index + 1}`]);
                  }
                  this.setInputAvailability(optionInputs, availableOptionInputsValue);
                });
              },

              setInputAvailability(listOfOptions, listOfAvailableOptions) {
                listOfOptions.forEach((input) => {
                  if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
                    input.classList.remove("disabled");
                  } else {
                    input.classList.add("disabled");
                  }
                });
              },

              swapVariantImage() {
                let selectedVariantId = this.current_variant.id;
                let selectedVariantColor = this.current_variant.option2;

                const sizeChartButtons = document.querySelectorAll('button.size_chart');

                if (sizeChartButtons.length > 1) {
                  const sizeChart = document.querySelector(`button.size_chart[data-color="${selectedVariantColor}"]`) ?? '';

                  if (sizeChart) {
                    sizeChartButtons.forEach((button) => {
                      button.classList.add("inactive");
                    });
                    sizeChart.classList.remove('inactive');
                  }
                }

                let target = "data-variant-color"; // or [data-variant-id]
                let comparison = selectedVariantColor; // or selectedVariantId
                document.querySelectorAll(`[${target}]`).forEach(function (element) {
                  if (element.getAttribute(target) == comparison) {
                    element.classList.remove("hidden");
                  } else {
                    element.classList.add("hidden");
                  }
                });
                setTimeout(function () {
                  document.querySelector(".splide__list").scrollLeft = 0;
                }, 100);

                // const currentFirstMediaHTML = this.$refs.firstMedia.innerHTML;
                // const currentFirstMediaHTML = document.querySelector('[data-first-media]').innerHTML;
                // const nextVariantMediaHTML = document.querySelector('[data-media-id="' + this.current_variant.featured_media.id + '"]').closest('.product-media-height').outerHTML;
                // document.querySelector('[data-media-id="' + this.current_variant.featured_media.id + '"]').closest('li').innerHTML = currentFirstMediaHTML;
                // document.querySelector('[data-first-media]').innerHTML = nextVariantMediaHTML; //scroll back to first slide

                if (section.slides && section.slides.classList.contains("is-active")) {
                  if (window.innerWidth > 1023) {
                    section.splideContainer.go(0);
                  }
                }
              },

              scrollToVariantImage() {
                const stickyHeader = document.querySelector('[data-sticky="true"]');
                let additionalOffset = 0;

                if (stickyHeader !== null) {
                  additionalOffset = stickyHeader.clientHeight;
                }

                this.current_media_id = this.current_variant.featured_media.id;
                const featuredMedia = document.querySelector('[data-media-id="' + this.current_media_id + '"]');

                if (section.slides && section.slides.classList.contains("is-active")) {
                  const parentSlide = featuredMedia.closest("[data-index]");
                  const index = parseInt(parentSlide.dataset.index);
                  section.splideContainer.go(index);
                } else {
                  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
                  const offset = window.pageYOffset + featuredMedia.getBoundingClientRect().top - additionalOffset;
                  window.scroll({
                    top: offset,
                    ...(!prefersReducedMotion.matches && {
                      behavior: "smooth",
                    }),
                  });
                }
              },

              submitForm(evt) {
                evt.preventDefault();
                this.loading = true;
                liveRegion(theme.strings.loading);
                console.log("Product Form Refs: ", this.$refs.productForm);
                addItemFromForm(this.$refs.productForm)
                  .then((item) => {
                    console.log("Item: ", item);
                    this.loading = false;
                    this.addedToCart = true;
                    liveRegion(theme.strings.addedToCart, true);
                    document.body.dispatchEvent(new CustomEvent("baseline:modalcart:afteradditem")); //dispatch event if cart mode is set to page

                    if (window.theme.cartMethod == "page") {
                      getState().then((state) => {
                        document.body.dispatchEvent(
                          new CustomEvent("baseline:modalcart:itemcountupdate", {
                            detail: {
                              count: state.item_count,
                            },
                          })
                        );
                      });
                    }
                  })
                  .catch((error) => {
                    error.json().then((errorData) => {
                      this.loading = false;
                      this.addedToCart = false;
                      let errors = errorData.errors || errorData.description;
                      let message = errorData.description || errorData.message; // Gift card recipient form errors are handled in gift-card-recipient.js

                      if (!hasGiftCardRecipientForm) {
                        this.addErrorMessage = message || window.theme.strings.cartError;
                      }

                      if (errorData.status) {
                        document.body.dispatchEvent(
                          new CustomEvent("baseline:cart:adderror", {
                            detail: {
                              source: "product-form",
                              sourceId: this.$refs.productForm.getAttribute("id"),
                              errors,
                              message,
                            },
                          })
                        );
                      }
                    });
                  });
              },

              updateMedia(mediaId, mediaType) {
                this.current_media_id = mediaId;
              },

              updateStoreAvailability(variant) {
                if (section.storeAvailability && variant && variant.available) {
                  window.Spruce.store("availability").loading = true;
                  section.storeAvailability.fetchContent(variant);
                }
              },

              openZoom(index) {
                const items = window.matchMedia("(max-width: 767px)").matches
                  ? section.mobilePswpItems
                  : section.desktopPswpItems;

                section.pswpOptions.index = index;
                section.pswpOptions.tapToClose = false;
                section.pswpOptions.clickToCloseNonZoomable = false;
                section.pswpOptions.closeOnScroll = false;

                const gallery = new section.PhotoSwipe(
                  section.pswpElement,
                  section.PhotoSwipeUI_Default,
                  items,
                  section.pswpOptions
                );

                

                gallery.init();
                trapFocus(section.pswpElement);
                document.documentElement.style.overflowY = "hidden";

                const indexToRefocus = gallery.options.index;

                const prevButton = section.pswpElement.querySelector(".pswp__button--arrow--left");
                const nextButton = section.pswpElement.querySelector(".pswp__button--arrow--right");

                if (prevButton) {
                  const handlePrev = function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    if (event.stopImmediatePropagation) {
                      event.stopImmediatePropagation();
                    }
                    gallery.prev();
                  };

                  prevButton.onclick = handlePrev;
                  prevButton.onmousedown = handlePrev;
                  prevButton.onpointerup = handlePrev;
                  prevButton.ontouchend = handlePrev;
                }

                if (nextButton) {
                  const handleNext = function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    if (event.stopImmediatePropagation) {
                      event.stopImmediatePropagation();
                    }
                    gallery.next();
                  };

                  nextButton.onclick = handleNext;
                  nextButton.onmousedown = handleNext;
                  nextButton.onpointerup = handleNext;
                  nextButton.ontouchend = handleNext;
                }

                gallery.listen("close", function () {
                  removeTrapFocus();
                });

                gallery.listen("destroy", function () {
                  document.documentElement.style.overflowY = "";
                  const elToRefocus = section.container.querySelector(
                    `[data-product-image-index="${indexToRefocus}"]`
                  );

                  if (elToRefocus) {
                    elToRefocus.focus();
                  }
                });
              },
            };
          };
        },

        calculateSlideshowHeight() {
          const splideTrack = this.container.querySelector(".splide__track");

          if (this.slides && this.slides.classList.contains("is-active")) {
            const elements = this.splideContainer.Components.Elements;
            const slide = elements.getSlide(this.splideContainer.index).slide;
            const slideMedia = slide.querySelector(".product-media-height");
            splideTrack.style.maxHeight = slideMedia.offsetHeight + "px";
          } else {
            if (splideTrack !== null) {
              splideTrack.style.removeProperty("max-height");
            }
          }
        },

        setupSlideshow(isHorizontalGalleryTemplate) {
          this.slides = this.container.querySelector(".splide");
          this.slideList = this.container.querySelector(".splide__list");

          if (this.slides && this.slideList && this.slides.getAttribute("data-slideshow-enabled")) {
            this.slideshowSettings = {
              destroy: true,
              breakpoints: {
                1023: {
                  perPage: 1,
                  type: "slide",
                  pagination: true,
                  arrows: true,
                  drag: this.slides.dataset.dragDisabled == "true" ? false : true,
                  classes: {
                    // Add classes for pagination.
                    pagination:
                      "splide__pagination splide__pagination--product flex justify-start items-center mt-4 ml-1 w-auto", // container
                  },
                },
              },
            };

            if (isHorizontalGalleryTemplate) {
              this.slideshowSettings = {
                autoWidth: true,
                type: "slide",
                pagination: true,
                arrows: true,
                drag: this.slides.dataset.dragDisabled == "true" ? false : true,
                classes: {
                  // Add classes for pagination.
                  pagination:
                    "splide__pagination splide__pagination--product flex justify-start items-center mt-4 ml-1 w-auto lg:ml-4", // container
                },
                breakpoints: {
                  1023: {
                    type: "slide",
                    perPage: 1,
                    autoWidth: false,
                  },
                },
              };
            }

            this.splideContainer = new splide_esm_default.a(this.slides, this.slideshowSettings);
            this.splideContainer.mount({
              SplideProduct,
            });
            this.calculateSlideshowHeight();
          }
        },

        setUpImageZoom(PhotoSwipe, PhotoSwipeUI_Default) {
          const imageDataEl = this.container.querySelector("[data-product-images]");
          if (!imageDataEl) return;
          const mediaOrder = [];
          const mediaElsInPage = this.container
            .querySelectorAll("[data-product-media-type-image]")
            .forEach((mediaEl) => {
              mediaOrder.push(mediaEl.dataset.mediaId);
            });
          if (!mediaOrder.length) return;
          const imageData = JSON.parse(imageDataEl.innerHTML);
          const imageDataInOrder = [];

          for (const mediaId of mediaOrder) {
            imageDataInOrder.push(imageData[mediaId]);
          }

          this.pswpElement = document.querySelector(".pswp");
          this.PhotoSwipe = PhotoSwipe;
          this.PhotoSwipeUI_Default = PhotoSwipeUI_Default;
          const mobileWidth = 1400;
          const desktopMaxWidth = 3000;
          this.mobilePswpItems = [];
          this.desktopPswpItems = [];

          for (const productImage of imageDataInOrder) {
            const imageFullSizeUrl = productImage.fullSizeUrl,
              imageFullSizeWidth = productImage.width,
              imageFullSizeHeight = productImage.height,
              imageAspectRatio = productImage.aspectRatio,
              imageAlt = productImage.alt || null;
            const mobileItem = {
              src: theme_images_getSizedImageUrl(imageFullSizeUrl, `${mobileWidth}x`),
              w: mobileWidth,
              h: mobileWidth / imageAspectRatio,
              alt: imageAlt,
            };
            this.mobilePswpItems.push(mobileItem);
            let desktopImageFinalUrl = "",
              desktopImageFinalWidth = 0,
              desktopImageFinalHeight = 0;

            if (imageFullSizeWidth <= desktopMaxWidth) {
              desktopImageFinalUrl = imageFullSizeUrl;
              desktopImageFinalWidth = imageFullSizeWidth;
              desktopImageFinalHeight = imageFullSizeHeight;
            } else {
              const desktopSizedImgUrl = theme_images_getSizedImageUrl(imageFullSizeUrl, `${desktopMaxWidth}x`);
              desktopImageFinalUrl = desktopSizedImgUrl;
              desktopImageFinalWidth = desktopMaxWidth;
              desktopImageFinalHeight = desktopMaxWidth / imageAspectRatio;
            }

            const desktopItem = {
              src: desktopImageFinalUrl,
              w: desktopImageFinalWidth,
              h: desktopImageFinalHeight,
              alt: imageAlt,
            };
            this.desktopPswpItems.push(desktopItem);
            this.pswpOptions = {
              history: false,
              captionEl: false,
              fullscreenEl: false,
              zoomEl: false,
              shareEl: false,
              counterEl: false,
              arrowEl: true,
              preloaderEl: false,
              closeEl: true,
              barsSize: {
                top: 0,
                bottom: "auto",
              },
            };
          }
        },

        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload() {
          if (this.splideContainer) {
            this.splideContainer.destroy();
          }
        },
      }); // Pull this out to a seperate component so that events are reinitialized on destroy.

      const SplideProduct = (Splide) => {
        Splide.root.addEventListener("click", (event) => {
          if (event.target.classList.contains("splide__pagination__page")) {
            Splide.paginationClicked = true;
          }
        });

        function handleDestroy() {
          const elements = Splide.Components.Elements.slides;
          elements.forEach((element) => {
            element.removeAttribute("inert");
          });
        }

        function handleMountedMoved() {
          applyInert(Splide);

          if (Splide.paginationClicked) {
            Splide.paginationClicked = false;
            const elements = Splide.Components.Elements;
            const newSlide = elements.getSlide(Splide.index).slide;
            setTimeout(
              () =>
                newSlide.focus({
                  preventScroll: true,
                }),
              0
            );
          }
        }

        function handleMoved(newIndex, oldIndex) {
          const elements = Splide.Components.Elements;
          const oldSlide = elements.getSlide(oldIndex).slide.querySelector("[data-product-single-media-wrapper]");
          const newSlide = elements.getSlide(newIndex).slide.querySelector("[data-product-single-media-wrapper]");
          if (oldSlide) oldSlide.dispatchEvent(new CustomEvent("mediaHidden"));
          if (newSlide) newSlide.dispatchEvent(new CustomEvent("mediaVisible"));
        }

        function handleMove(newIndex, oldIndex) {
          const elements = Splide.Components.Elements;
          const newSlide = elements.getSlide(newIndex).slide;
          const newSlideMedia = newSlide.querySelector(".product-media-height");
          newSlide.closest(".splide__track").style.maxHeight = newSlideMedia.offsetHeight + "px";
        }

        return {
          mount() {
            Splide.on("mounted moved", handleMountedMoved);
            Splide.on("moved", handleMoved);
            Splide.on("move", handleMove);
            Splide.on("destroy", handleDestroy);
          },
        };
      };
      // CONCATENATED MODULE: ./src/scripts/sections/product-recommendations.js
      /**
       * Product recommendations section script
       * ------------------------------------------------------------------------------
       * A file that contains scripts for the Product recommendations section
       *
       * @namespace product-recommendations
       */

      /* harmony default export */
      var product_recommendations = register("product-recommendations", {
        onLoad() {
          const productRecommendationsSection = this.container;
          const requestUrl = productRecommendationsSection.dataset.requestUrl;
          const request = new XMLHttpRequest();
          request.open("GET", requestUrl);

          request.onload = function () {
            if (request.status >= 200 && request.status < 300) {
              const container = document.createElement("div");
              container.innerHTML = request.response;

              if (container.querySelector(".product-recommendations")) {
                productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
              }
            }
          };

          request.send();
        },

        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload() {},
      });
      // CONCATENATED MODULE: ./src/scripts/sections/slideshow.js
      /**
       * Slideshow
       * ------------------------------------------------------------------------------
       * Scripts for the Slideshow section
       *
       * @namespace slideshow
       */

      /**
       * Slideshow section constructor. Runs on page load as well as Theme Editor
       * `section:load` events.
       * @param {string} container - selector for the section container DOM element
       */

      register("slideshow", {
        onLoad() {
          // Arbitrary constant found here https://github.com/Splidejs/splide/issues/58
          this.flag = 99;
          this.slides = this.container.querySelector(".splide");
          this.slideList = this.container.querySelector(".splide__list");
          this.autoplayControl = this.container.querySelector(".splide__autoplay-control");
          this.timer = null;
          this.paginationClicked = false;
          this.splideContainer = new splide_esm_default.a(this.slides, {
            perPage: 1,
            type: "loop",
            pagination: true,
            arrows: true,
            drag: this.container.dataset.autoRotate === "true" ? false : true,
            pauseOnHover: false,
            // We replicate this later in a way that does not conflict with our play and pause button.
            pauseOnFocus: false,
            classes: {
              // Add classes for pagination.
              pagination: "splide__pagination absolute inline-block left-0 ml-1 lg:ml-4 bottom-3 w-auto text-current", // container
            },
          });
          this.bindEvents();
          this.setUpPlayButton();
          this.splideContainer.mount();
          this.autoplay = this.splideContainer.Components.Autoplay;
        },

        bindEvents() {
          this.container.addEventListener("click", (event) => {
            if (event.target.classList.contains("splide__pagination__page")) {
              this.paginationClicked = true;
            }
          }); // 2 is the internal library flag for focus.
          // We want to be able to pause if the user is interacting with the slide via focus,
          // but resume the autoplay once focus leaves, provided that the pause button has not manually been pressed

          this.container.addEventListener("focusin", (event) => {
            if (!event.target.classList.contains("splide__autoplay-control")) {
              this.autoplay.pause(2);
            }
          });
          this.container.addEventListener("focusout", (event) => {
            this.autoplay.play(2);
          });
          this.splideContainer.on("mounted updated", () => {
            if (this.splideContainer.options.autoplay === true) {
              this.autoplayControl.classList.remove("opacity-0");
            } else {
              this.autoplayControl.classList.add("opacity-0");
            }
          });
          this.splideContainer.on("mounted moved", () => {
            applyInert(this.splideContainer);

            if (this.paginationClicked) {
              // If pagination is clicked, move focus to that slide.
              this.paginationClicked = false;
              const elements = this.splideContainer.Components.Elements;
              const newSlide = elements.getSlide(this.splideContainer.index).slide;
              setTimeout(
                () =>
                  newSlide.focus({
                    preventScroll: true,
                  }),
                0
              );
            }
          });
        },

        setUpPlayButton() {
          if (this.autoplayControl) {
            const pausedClass = "splide__autoplay-control--paused";
            const playText = this.autoplayControl.dataset.play;
            const pauseText = this.autoplayControl.dataset.pause;
            this.splideContainer.on("autoplay:play", () => {
              this.autoplayControl.classList.remove(pausedClass);
              this.autoplayControl.setAttribute("aria-label", pauseText);
            });
            this.splideContainer.on("autoplay:pause", () => {
              this.autoplayControl.classList.add(pausedClass);
              this.autoplayControl.setAttribute("aria-label", playText);
            });
            this.splideContainer.on(
              "click",
              () => {
                if (this.autoplayControl.classList.contains(pausedClass)) {
                  this.autoplay.play(this.flag);
                } else {
                  this.autoplay.pause(this.flag);
                }
              },
              this.autoplayControl
            );
          }
        },

        onBlockSelect(event) {
          const block = event.target;
          const index = parseInt(block.dataset.index);
          this.splideContainer.go(index);
          this.autoplay.pause(this.flag);
        },

        onBlockDeselect() {
          if (this.splideContainer.options.autoplay) {
            this.autoplay.play(this.flag);
          }
        },

        onUnload() {
          if (this.splideContainer) {
            this.splideContainer.destroy(true);
          }
        },
      });
      // CONCATENATED MODULE: ./node_modules/@switchthemes/disclosure/index.js
      const Disclosure = (function () {
        var selectors = {
          disclosureForm: "[data-disclosure-form]",
          disclosureList: "[data-disclosure-list]",
          disclosureToggle: "[data-disclosure-toggle]",
          disclosureInput: "[data-disclosure-input]",
          disclosureOptions: "[data-disclosure-option]",
        };

        var classes = {
          listVisible: "opacity-100",
          listZIndex: "z-10",
        };

        function Disclosure(disclosure) {
          this.container = disclosure;
          this._cacheSelectors();
          this._setupListeners();
        }

        Disclosure.prototype = Object.assign({}, Disclosure.prototype, {
          _cacheSelectors: function () {
            this.cache = {
              disclosureForm: this.container.closest(selectors.disclosureForm),
              disclosureList: this.container.querySelector(selectors.disclosureList),
              disclosureToggle: this.container.querySelector(selectors.disclosureToggle),
              disclosureInput: this.container.querySelector(selectors.disclosureInput),
              disclosureOptions: this.container.querySelectorAll(selectors.disclosureOptions),
            };
          },

          _setupListeners: function () {
            this.eventHandlers = this._setupEventHandlers();

            this.cache.disclosureToggle.addEventListener("click", this.eventHandlers.toggleList);

            this.cache.disclosureOptions.forEach(function (disclosureOption) {
              disclosureOption.addEventListener("click", this.eventHandlers.connectOptions);
            }, this);

            this.container.addEventListener("keyup", this.eventHandlers.onDisclosureKeyUp);

            this.cache.disclosureList.addEventListener("focusout", this.eventHandlers.onDisclosureListFocusOut);

            this.cache.disclosureToggle.addEventListener("focusout", this.eventHandlers.onDisclosureToggleFocusOut);

            document.body.addEventListener("click", this.eventHandlers.onBodyClick);
          },

          _setupEventHandlers: function () {
            return {
              connectOptions: this._connectOptions.bind(this),
              toggleList: this._toggleList.bind(this),
              onBodyClick: this._onBodyClick.bind(this),
              onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
              onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
              onDisclosureToggleFocusOut: this._onDisclosureToggleFocusOut.bind(this),
            };
          },

          _connectOptions: function (event) {
            event.preventDefault();
            this._submitForm(event.currentTarget.dataset.value);
          },

          _onDisclosureToggleFocusOut: function (event) {
            var disclosureLostFocus = this.container.contains(event.relatedTarget) === false;

            if (disclosureLostFocus) {
              this._hideList();
            }
          },

          _onDisclosureListFocusOut: function (event) {
            var childInFocus = event.currentTarget.contains(event.relatedTarget);

            var isVisible = this.cache.disclosureList.classList.contains(classes.listVisible);

            if (isVisible && !childInFocus) {
              this._hideList();
            }
          },

          _onDisclosureKeyUp: function (event) {
            if (event.key !== "Escape") return;
            this._hideList();
            this.cache.disclosureToggle.focus();
          },

          _onBodyClick: function (event) {
            var isOption = this.container.contains(event.target);
            var isVisible = this.cache.disclosureList.classList.contains(classes.listVisible);

            if (isVisible && !isOption) {
              this._hideList();
            }
          },

          _submitForm: function (value) {
            this.cache.disclosureInput.value = value;
            this.cache.disclosureForm.submit();
          },

          _hideList: function () {
            this.cache.disclosureList.setAttribute("inert", true);
            this.cache.disclosureList.classList.remove(classes.listVisible);
            this.cache.disclosureToggle.setAttribute("aria-expanded", false);
          },

          _toggleList: function () {
            var ariaExpanded = this.cache.disclosureToggle.getAttribute("aria-expanded") === "true";
            if (ariaExpanded) {
              this.cache.disclosureList.setAttribute("inert", true);
            } else {
              this.cache.disclosureList.removeAttribute("inert");
            }
            this.cache.disclosureList.classList.toggle(classes.listVisible);
            this.cache.disclosureList.classList.toggle(classes.listZIndex);
            this.cache.disclosureToggle.setAttribute("aria-expanded", !ariaExpanded);
          },

          destroy: function () {
            this.cache.disclosureToggle.removeEventListener("click", this.eventHandlers.toggleList);

            this.cache.disclosureOptions.forEach(function (disclosureOption) {
              disclosureOption.removeEventListener("click", this.eventHandlers.connectOptions);
            }, this);

            this.container.removeEventListener("keyup", this.eventHandlers.onDisclosureKeyUp);

            this.cache.disclosureList.removeEventListener("focusout", this.eventHandlers.onDisclosureListFocusOut);

            this.cache.disclosureToggle.removeEventListener("focusout", this.eventHandlers.onDisclosureToggleFocusOut);

            document.body.removeEventListener("click", this.eventHandlers.onBodyClick);
          },
        });

        return Disclosure;
      })();

      /* harmony default export */
      var disclosure = Disclosure;

      // CONCATENATED MODULE: ./src/scripts/sections/footer.js
      /**
       * Footer section script
       * ------------------------------------------------------------------------------
       * A file that contains scripts for the Footer section
       *
       * @namespace footer
       */

      /* harmony default export */
      var footer = register("footer", {
        onLoad() {
          this.selectors = {
            disclosureLocale: "[data-disclosure-locale]",
            disclosureCountry: "[data-disclosure-country]",
          };
          this.cache = {};
          this.cacheSelectors();

          if (this.cache.localeDisclosure) {
            this.localeDisclosure = new disclosure(this.cache.localeDisclosure);
          }

          if (this.cache.countryDisclosure) {
            this.countryDisclosure = new disclosure(this.cache.countryDisclosure);
          }
        },

        cacheSelectors() {
          this.cache = {
            localeDisclosure: this.container.querySelector(this.selectors.disclosureLocale),
            countryDisclosure: this.container.querySelector(this.selectors.disclosureCountry),
          };
        },

        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload() {
          if (this.cache.localeDisclosure) {
            this.localeDisclosure.destroy();
          }

          if (this.cache.countryDisclosure) {
            this.countryDisclosure.destroy();
          }
        },
      });
      // CONCATENATED MODULE: ./node_modules/@switchthemes/video-component-observer/index.js
      /**
       * Video Component Observer
       *
       * Creates a global instance of IntersectionObserver,
       * with a rootMargin tuned for pausing out-of-viewport
       * video components
       *
       * @fires VideoComponentObserver#`${namespace}:video-component:visible`
       * @fires VideoComponentObserver#`${namespace}:video-component:not-visible`
       */

      const VideoComponentObserver = (function () {
        function VideoComponentObserver() {
          const namespace = true ? "Baseline".toLowerCase() : undefined;

          this.options = {
            rootMargin: "25% 0px 75% 0px",
          };

          this.callback = function (entries, observer) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.dispatchEvent(
                  new CustomEvent(`${namespace}:video-component:visible`, {
                    bubbles: false,
                    cancelable: false,
                  })
                );
              } else {
                entry.target.dispatchEvent(
                  new CustomEvent(`${namespace}:video-component:not-visible`, {
                    bubbles: false,
                    cancelable: false,
                  })
                );
              }
            });
          };

          this._observedElementsCount = 0;
        }

        VideoComponentObserver.prototype = Object.assign({}, VideoComponentObserver.prototype, {
          _init: function () {
            if (!("IntersectionObserver" in window)) {
              return;
            }

            this._observer = new IntersectionObserver(this.callback, this.options);
          },

          _isInitialized: function () {
            if (this._observedElementsCount > 0) {
              return true;
            }

            return false;
          },

          /**
           * Start observing the video section
           *
           * @param {HTMLElement} containerEl The video section’s container element
           */

          observe: function (containerEl) {
            try {
              if (!this._isInitialized()) {
                this._init();
              }

              this._observer.observe(containerEl);

              this._observedElementsCount++;
            } catch (e) {
              console.error(e);
            }
          },

          /**
           * Stop observing the video section
           *
           * @param {HTMLElement} containerEl The video section’s container element
           */

          unobserve: function (containerEl) {
            if (this._observer) {
              this._observer.unobserve(containerEl);
              this._observedElementsCount--;

              if (this._observedElementsCount === 0) {
                this._deInit();
              }
            }
          },

          _deInit: function () {
            this._observer.disconnect();
          },
        });

        return VideoComponentObserver;
      })();

      /* harmony default export */
      var video_component_observer = VideoComponentObserver;

      // CONCATENATED MODULE: ./src/scripts/components/background-video.js

      /**
       * Background video component
       * ------------------------------------------------------------------------------
       *
       */
      // Keeping the players here instead of
      // as a property on the section
      // inexplicably makes playback smoother

      const ytPlayers = [];

      class background_video_BackgroundVideo {
        constructor(container) {
          this.container = container;
          this.componentId = this.container.dataset.componentId;
          this.videoProvider = this.container.dataset.videoType;
          this.videoId = this.container.dataset.videoId;
          this.playerId = `player-${this.componentId}`;
          this.YTReady = false;
          this.selectors = {
            fallBackImage: "[data-fallback-image]",
            player: `#${this.playerId}`,
          };
          this.classes = {
            isPlaying: "is-playing",
            hidden: "hide",
            errorElClass: "background-video__error",
            tallIframeClass: "background-video-iframe--tall",
          };
          this.eventHandlers = {};

          this._init();
        }
        /**
         * Reacts to player state changes; possible values,
         * as defined in the YouTube API, are:
         *
         * - -1 (unstarted)
         * - 0 (ended)
         * - 1 (playing)
         * - 2 (paused)
         * - 3 (buffering)
         * - 5 (video cued)
         *
         * @param {Number} playerState Integer representing player state
         */

        _onPlayerStateChange(playerState) {
          const thisPlayer = ytPlayers[this.playerId];

          if (playerState === 1) {
            this._hideFallBackImage();

            this.container.classList.add(this.classes.isPlaying);
          }

          if (playerState === -1) {
            this.container.classList.remove(this.classes.isPlaying);

            if (thisPlayer.didBuffer === true) {
              // Loading or playing failed
              this._showFallBackImage();
            }
          }

          if (playerState === 3) {
            thisPlayer.didBuffer = true;
          }
        }

        _init() {
          if (this.videoProvider === "youtube") {
            if (typeof YT !== "undefined") {
              this._initYTVideo();
            } else {
              document.body.addEventListener("youtubeiframeapiready", () => {
                this._initYTVideo();
              });
              library_loader.load("youtubeSdk");
            }
          } else {
            this.htmlVideoEl = this.container.querySelector("video");
            this.htmlVideoEl.id = this.playerId;

            this._initVideoContainerObserver();
          }

          this.fallBackImageEl = this.container.querySelector(this.selectors.fallBackImage);
          this.playerEl = this.container.querySelector(this.selectors.player);
          this.eventHandlers.inView = this._inView.bind(this);
          this.eventHandlers.outOfView = this._outOfView.bind(this);
          this.container.addEventListener("baseline:video-component:visible", this.eventHandlers.inView);
          this.container.addEventListener("baseline:video-component:not-visible", this.eventHandlers.outOfView);
        }

        _showFallBackImage() {
          if (!this.fallBackImageEl) return;
          this.fallBackImageEl.classList.remove(this.classes.hidden);
          if (!this.playerEl) return;
          this.playerEl.classList.add(this.classes.hidden);
        }

        _hideFallBackImage() {
          if (!this.fallBackImageEl) return;
          this.fallBackImageEl.classList.add(this.classes.hidden);
          if (!this.playerEl) return;
          this.playerEl.classList.remove(this.classes.hidden);
        }

        _showErrorMessage(errorMessage) {
          const existingErrorEl = this.container.querySelector(`.${this.classes.errorElClass}`);

          if (existingErrorEl !== null) {
            existingErrorEl.remove();
          }

          const errorEl = document.createElement("div");
          errorEl.classList.add(this.classes.errorElClass);
          errorEl.innerText = errorMessage;
          this.container.prepend(errorEl);
        }

        _onYTPlayerError(e) {
          let errorMessage = "";

          switch (e.data) {
            case 2:
              errorMessage = "Baseline Background Video: Invalid parameter value";
              break;

            case 100:
              errorMessage = "Baseline Background Video: Video not found";
              break;

            case 101:
            case 150:
              errorMessage = "Baseline Background Video: Video owner does not permit embedding";
              break;

            default:
              errorMessage = "Baseline Background Video: An error occurred";
          }

          if (errorMessage !== "") {
            console.error(errorMessage);

            if (Shopify.designMode) {
              this._showErrorMessage(errorMessage);
            }
          }

          if (!Shopify.designMode) {
            this._showFallBackImage();
          }
        }

        _onYTPlayerReady() {
          if (this.YTReady === true) {
            this._play();
          } else {
            this.YTReady = true;

            this._initResponsiveVideoContainer();

            this._initVideoContainerObserver();
          }
        }

        _initYTVideo() {
          ytPlayers[this.playerId] = new YT.Player(this.playerId, {
            videoId: this.videoId,
            width: 1280,
            height: 720,
            events: {
              onError: function (e) {
                this._onYTPlayerError(e);
              }.bind(this),
              onReady: function (e) {
                this._onYTPlayerReady(e);
              }.bind(this),
              onStateChange: function (e) {
                // Loop; call method on player
                // directly to minimize brief flash
                if (e.data === 0) {
                  e.target.seekTo(0);
                }

                this._onPlayerStateChange(e.data);
              }.bind(this),
            },
            playerVars: {
              autohide: 0,
              branding: 0,
              cc_load_policy: 0,
              controls: 0,
              fs: 0,
              iv_load_policy: 3,
              modestbranding: 1,
              playsinline: 1,
              quality: "hd720",
              rel: 0,
              showinfo: 0,
              wmode: "opaque",
            },
          });
          document.getElementById(this.playerId).setAttribute("tabindex", "-1");
        }

        _inView() {
          this._play();
        }

        _outOfView() {
          this._pause();
        }

        _play() {
          if (this.videoProvider === "youtube") {
            if (this.YTReady === true) {
              const ytPlayer = ytPlayers[this.playerId];
              ytPlayer.mute();
              ytPlayer.playVideo();
            }
          } else {
            this.htmlVideoEl.play();
          }
        }

        _pause() {
          if (this.videoProvider === "youtube") {
            if (this.YTReady === true) {
              ytPlayers[this.playerId].pauseVideo();
            }
          } else {
            this.htmlVideoEl.pause();
          }
        }
        /**
         * Watch the aspect ratio of the container
         * and assign classes accordingly; for tall
         * iframes, calculate width and left offset
         */

        _checkContainerSize() {
          const playerEl = document.getElementById(this.playerId);
          /**
           * Assume 16/9 ratio
           */

          const videoRatio = (16 / 9).toFixed(2);
          const containerAspectRatio = (this.container.clientWidth / this.container.clientHeight).toFixed(2);
          playerEl.classList.remove(this.classes.tallIframeClass);
          playerEl.style.width = "";
          playerEl.style.left = "";

          if (containerAspectRatio < videoRatio) {
            playerEl.classList.add(this.classes.tallIframeClass);
            const newWidth = ((videoRatio / containerAspectRatio) * 100).toFixed(2);
            const newLeft = (newWidth - 100) / 2;
            playerEl.style.width = `${newWidth}%`;
            playerEl.style.left = `-${newLeft}%`;
          }
        }

        _initResponsiveVideoContainer() {
          this._checkContainerSize();

          this._debouncedCheckContainerSize = debounce_default()(this._checkContainerSize.bind(this), 300);
          window.addEventListener("resize", this._debouncedCheckContainerSize);
        }

        _initVideoContainerObserver() {
          if (typeof window.Baseline._videoComponentObserver === "undefined") {
            window.Baseline._videoComponentObserver = new video_component_observer();
          }

          window.Baseline._videoComponentObserver.observe(this.container);
        }

        deinit() {
          window.Baseline._videoComponentObserver.unobserve(this.container);

          window.removeEventListener("resize", this._debouncedCheckContainerSize);
          this.container.removeEventListener("baseline:video-component:visible", this.eventHandlers.inView);
          this.container.removeEventListener("baseline:video-component:not-visible", this.eventHandlers.outOfView);
          window.removeEventListener("resize", this._debouncedCheckContainerSize);
          ytPlayers[this.playerId].destroy();
        }
      }

      /* harmony default export */
      var background_video = background_video_BackgroundVideo;
      // CONCATENATED MODULE: ./src/scripts/sections/video-with-text-overlay.js
      /**
       * Slideshow
       * ------------------------------------------------------------------------------
       * Scripts for the Slideshow section
       *
       * @namespace slideshow
       */

      /**
       * Slideshow section constructor. Runs on page load as well as Theme Editor
       * `section:load` events.
       * @param {string} container - selector for the section container DOM element
       */

      register("video-with-text-overlay", {
        onLoad() {
          const backgroundVideoEl = this.container.querySelector("[data-background-video]");

          if (backgroundVideoEl) {
            this.backgroundVideo = new background_video(backgroundVideoEl);
          }
        },

        onBlockDeselect() {},

        onUnload() {},
      });
      // CONCATENATED MODULE: ./src/scripts/sections/collection.js

      register("collection", {
        onLoad() {
          const section = this;

          window["ThemeSection_collection"] = () => {
            return {
              filtersOpen: false,
              sortOpen: false,
              filterData: [],

              clickAway(event, property) {
                this[property] = false;
              },

              focusOut(event, property) {
                if (event.relatedTarget) {
                  const dropdownParent = event.relatedTarget.closest("[data-collection-dropdown]");

                  if (!dropdownParent) {
                    this[property] = false;
                  }
                }
              },

              mounted() {
                document.addEventListener("keyup", (event) => {
                  if (event.key === "Escape") {
                    if (this.filtersOpen) {
                      this.filtersOpen = false;
                      this.$refs.filter.focus();
                    }

                    if (this.sortOpen) {
                      this.sortOpen = false;
                      this.$refs.sort.focus();
                    }
                  }
                });
                section.container.addEventListener("baseline:collection:open-filters", () => {
                  this.filtersOpen = true;
                });
                window.addEventListener("popstate", this.onHistoryChange.bind(this));
                this.$watch("price_range", (value) => {
                  let params = new URLSearchParams(value);
                  this.price_min = params.get("min");
                  this.price_max = params.get("max");
                });
              },

              filterFormSubmit(e) {
                const formData = new FormData(e.target.closest("form"));
                const searchParams = new URLSearchParams(formData);
                searchParams.delete("price_range");
                this.renderPage(searchParams.toString(), e);
              },

              getSections() {
                return [
                  {
                    id: "main-collection-product-grid",
                    section: document.getElementById("main-collection-product-grid").dataset.id,
                  },
                ];
              },

              clearAllFilters(e) {
                this.renderPage(new URL(e.currentTarget.href).searchParams.toString());
              },

              renderPage(searchParams, event, updateURLHash = true) {
                const sections = this.getSections();
                document.getElementById("main-collection-product-grid").classList.add("opacity-10");
                sections.forEach((section) => {
                  const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;

                  const filterDataUrl = (element) => element.url === url;

                  this.filterData.some(filterDataUrl)
                    ? this.renderSectionFromCache(filterDataUrl, event)
                    : this.renderSectionFromFetch(url, event);
                });
                if (updateURLHash) this.updateURLHash(searchParams);
              },

              renderSectionFromFetch(url, event) {
                fetch(url)
                  .then((response) => response.text())
                  .then((responseText) => {
                    const html = responseText;
                    this.filterData = [
                      ...this.filterData,
                      {
                        html,
                        url,
                      },
                    ];
                    this.renderFilters(html, event);
                    this.renderProductGrid(html);
                  });
              },

              renderSectionFromCache(filterDataUrl, event) {
                const html = this.filterData.find(filterDataUrl).html;
                this.renderFilters(html, event);
                this.renderProductGrid(html);
              },

              renderProductGrid(html) {
                const innerHTML = new DOMParser()
                  .parseFromString(html, "text/html")
                  .getElementById("CollectionProductGrid").innerHTML;
                document.getElementById("CollectionProductGrid").innerHTML = innerHTML;
                document.getElementById("main-collection-product-grid").classList.remove("opacity-10");
              },

              renderFilters(html) {
                const parsedHTML = new DOMParser().parseFromString(html, "text/html");
                const innerHTML = parsedHTML.getElementById("CollectionFiltersForm").innerHTML;
                document.getElementById("CollectionFiltersForm").innerHTML = innerHTML;
              },

              updateURLHash(searchParams) {
                history.pushState(
                  {
                    searchParams,
                  },
                  "",
                  `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
                );
              },

              onHistoryChange(event) {
                const searchParams = event.state.searchParams || "";
                this.renderPage(searchParams, null, false);
              },
            };
          };
        },

        onBlockSelect(event) {
          this.container.dispatchEvent(new CustomEvent("baseline:collection:open-filters"));
        },

        onUnload() {},
      });
      // CONCATENATED MODULE: ./src/scripts/sections/availability-drawer.js
      /**
       * Header
       * ------------------------------------------------------------------------------
       *
       * @namespace header
       */

      register("availability-drawer", {
        onLoad() {
          window["ThemeSection_availabilityDrawer"] = () => {
            return {
              get currentVariantAvailability() {
                // this is on a lag to the actual current variant so that we can display an intermediary state while the fetch request is happening
                if (window.Spruce.store("availability").current_variant) {
                  const id = window.Spruce.store("availability").current_variant.id;
                  const storeData = window.Spruce.store("availability").availability[id];

                  if (storeData) {
                    return storeData.list;
                  }
                }

                return [];
              },
            };
          };
        },

        onSelect: function () {
          Spruce.store("drawer").availabilityDrawerOpen = true;
        },
        onDeselect: function () {
          Spruce.store("drawer").availabilityDrawerOpen = false;
        },

        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload() {},
      });
      // EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
      var js_cookie = __webpack_require__(2);
      var js_cookie_default = /*#__PURE__*/ __webpack_require__.n(js_cookie);

      // CONCATENATED MODULE: ./src/scripts/sections/popup.js
      /**
       * Popup
       * ------------------------------------------------------------------------------
       * Scripts for the Popup section
       *
       * @namespace popup
       */

      /**
       * Popup section constructor. Runs on page load as well as Theme Editor
       * `section:load` events.
       * @param {string} container - selector for the section container DOM element
       */

      register("popup", {
        onLoad() {
          this.sectionId = this.id;
          this.initSelected = false;
          const cookieName = "popup-" + this.sectionId;

          window["ThemeSection_popup"] = () => {
            return {
              show: false,
              delay: null,
              frequency: null,
              selected: this.initSelected,
              cookie: js_cookie_default.a.get(cookieName),
              section_id: this.sectionId,

              mounted() {
                document.addEventListener("keyup", (event) => {
                  if (event.key === "Escape") {
                    this.closePopUp();
                  }
                });

                if (window.location.pathname === "/challenge") {
                  return;
                }

                if (!this.cookie && !window.Shopify.designMode) {
                  this.openPopUp(this.delay);
                } // Open modal if errors or success message exist or if selected

                if (this.$refs["form-success"] || this.$refs["form-errors"] || this.selected) {
                  this.openPopUp(0);
                } // Set cookie as opened if success message

                if (this.$refs["form-success"]) {
                  js_cookie_default.a.set(this.cookieName, "opened", {
                    path: "/",
                    expires: 200,
                  });
                  return;
                } //check if form is a success

                window.addEventListener("shopify:section:select", (event) => {
                  if (event.detail.sectionId === this.section_id) {
                    this.selected = true;
                    this.openPopUp(0);
                  }
                });
                window.addEventListener("shopify:section:deselect", (event) => {
                  if (event.detail.sectionId === this.section_id) {
                    this.closePopUp();
                    this.selected = false;
                  }
                });
              },

              openPopUp(delay) {
                setTimeout(() => {
                  this.show = true;
                }, delay * 1000);
              },

              closePopUp(event) {
                if (event) {
                  event.stopPropagation();
                }

                this.show = false;

                if (this.selected) {
                  js_cookie_default.a.remove(this.cookieName, {
                    path: "/",
                  });
                  return;
                }

                const expiry = this.frequency;
                js_cookie_default.a.set(cookieName, "opened", {
                  path: "/",
                  expires: expiry,
                });
              },
            };
          };
        },

        onSelect(event) {
          this.initSelected = true;
        },
      });
      // CONCATENATED MODULE: ./src/scripts/sections/cart.js
      /**
       * Cart section script
       * ------------------------------------------------------------------------------
       * A file that contains scripts for the Footer section
       *
       * @namespace cart
       */

      /* harmony default export */
      var sections_cart = register("cart", {
        onLoad() {
          this.sectionId = this.id;

          window.ThemeSection_Cart = () => {
            return {
              currentItemCount: null,
              lineItemStatusElement: document.getElementById("shopping-cart-line-item-status"),
              errorMessages: {},

              mounted() {
                this.currentItemCount = Array.from(
                  document.getElementById("main-cart-items").querySelectorAll('[name="updates[]"]')
                ).reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);
                const debouncedOnChange = debounce_default()((event) => {
                  this.onChange(event);
                }, 300);
                document.body.addEventListener("change", debouncedOnChange.bind(this));
              },

              onChange(event) {
                this.updateQuantity(event.detail.line, event.detail.value, event.detail.name);
              },

              updateQuantity(line, quantity, name) {
                const lastQuantity = parseInt(document.getElementById(`CartItem-${line}`).dataset.lastQuantity, 10);
                document.getElementById("main-cart-items").classList.add("opacity-10");
                this.lineItemStatusElement.setAttribute("aria-hidden", false);
                const body = JSON.stringify({
                  line,
                  quantity,
                  sections: this.getSectionsToRender().map((section) => section.section),
                  sections_url: window.location.pathname,
                });
                fetch(`${window.theme.routes.cart_change_url}`, {
                  ...{
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      "Accept": "application/javascript",
                    },
                  },
                  ...{
                    body,
                  },
                })
                  .then((response) => {
                    return response.text();
                  })
                  .then((state) => {
                    const parsedState = JSON.parse(state);

                    if (parsedState.status === 422) {
                      document.getElementById(`CartItem-${line}`).dispatchEvent(
                        new CustomEvent("quantity-error", {
                          detail: {
                            message: parsedState.message,
                            lastQuantity,
                          },
                        })
                      );
                    } else {
                      document
                        .getElementById("main-cart-footer")
                        .classList.toggle("hidden", parsedState.item_count === 0);
                      this.getSectionsToRender().forEach((section) => {
                        const elementToReplace =
                          document.getElementById(section.id).querySelector(section.selector) ||
                          document.getElementById(section.id);
                        elementToReplace.innerHTML = this.getSectionInnerHTML(
                          parsedState.sections[section.section],
                          section.selector
                        );
                      });
                      const cartCountEls = document.querySelectorAll("[data-cart-count]");

                      if (cartCountEls.length) {
                        cartCountEls.forEach((el) => {
                          el.textContent = parsedState.item_count;
                        });
                      }

                      this.updateLiveRegions(line, parsedState.item_count);
                      document.body.dispatchEvent(
                        new CustomEvent("baseline:modalcart:itemcountupdate", {
                          detail: {
                            count: parsedState.item_count,
                          },
                        })
                      );
                    }

                    document.getElementById("main-cart-items").classList.remove("opacity-10");
                    document.getElementById(`CartItem-${line}`).querySelector(`[name="${name}"]`).focus();
                  })
                  .catch((error) => {
                    console.error("Updating quantity resulted in an error", error);
                    document.getElementById("main-cart-items").classList.remove("opacity-10");
                    document.getElementById("cart-errors").textContent = window.theme.strings.cartError;
                  });
              },

              getSectionInnerHTML(html, selector) {
                return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
              },

              getSectionsToRender() {
                return [
                  {
                    id: "main-cart-items",
                    section: document.getElementById("main-cart-items").dataset.id,
                    selector: ".js-contents",
                  },
                  {
                    id: "main-cart-footer",
                    section: document.getElementById("main-cart-footer").dataset.id,
                    selector: ".js-contents",
                  },
                  {
                    id: "cart-live-region-text",
                    section: "cart-live-region-text",
                    selector: ".shopify-section",
                  },
                ];
              },

              updateLiveRegions(line, itemCount) {
                if (this.currentItemCount === itemCount) {
                  document.getElementById(`Line-item-error-${line}`).querySelector(".cart-item-error-text").innerHTML =
                    window.theme.strings.cartQuantityError.replace(
                      "[quantity]",
                      document.getElementById(`Quantity-${line}`).value
                    );
                  document.getElementById(`Line-item-error-${line}`).classList.remove("hidden");
                } else {
                  const cartErrors = document.querySelectorAll(".cart-item-error");
                  cartErrors.forEach((el) => {
                    el.classList.add("hidden");
                  });
                }

                this.currentItemCount = itemCount;
                this.lineItemStatusElement.setAttribute("aria-hidden", true);
                const cartStatus = document.getElementById("cart-live-region-text");
                cartStatus.setAttribute("aria-hidden", false);
                setTimeout(() => {
                  cartStatus.setAttribute("aria-hidden", true);
                }, 1000);
              },
            };
          };
        },

        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload() {},
      });
      // CONCATENATED MODULE: ./src/scripts/sections/search.js

      register("search", {
        onLoad() {
          const section = this;

          window["ThemeSection_search"] = () => {
            return {
              filtersOpen: false,
              sortOpen: false,
              filterData: [],

              clickAway(event, property) {
                this[property] = false;
              },

              focusOut(event, property) {
                if (event.relatedTarget) {
                  const dropdownParent = event.relatedTarget.closest("[data-collection-dropdown]");

                  if (!dropdownParent) {
                    this[property] = false;
                  }
                }
              },

              mounted() {
                document.addEventListener("keyup", (event) => {
                  if (event.key === "Escape") {
                    if (this.filtersOpen) {
                      this.filtersOpen = false;
                      this.$refs.filter.focus();
                    }

                    if (this.sortOpen) {
                      this.sortOpen = false;
                      this.$refs.sort.focus();
                    }
                  }
                });
                section.container.addEventListener("baseline:search:open-filters", () => {
                  this.filtersOpen = true;
                });
                window.addEventListener("popstate", this.onHistoryChange.bind(this));
                this.$watch("price_range", (value) => {
                  let params = new URLSearchParams(value);
                  this.price_min = params.get("min");
                  this.price_max = params.get("max");
                });
              },

              filterFormSubmit(e) {
                const formData = new FormData(e.target.closest("form"));
                const searchParams = new URLSearchParams(formData);
                searchParams.delete("price_range");
                this.renderPage(searchParams.toString(), e);
              },

              getSections() {
                return [
                  {
                    id: "main-search",
                    section: document.getElementById("main-search").dataset.id,
                  },
                ];
              },

              clearAllFilters(e) {
                this.renderPage(new URL(e.currentTarget.href).searchParams.toString());
              },

              renderPage(searchParams, event, updateURLHash = true) {
                const sections = this.getSections();
                document.getElementById("main-search").classList.add("opacity-10");
                sections.forEach((section) => {
                  const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;

                  const filterDataUrl = (element) => element.url === url;

                  this.filterData.some(filterDataUrl)
                    ? this.renderSectionFromCache(filterDataUrl, event)
                    : this.renderSectionFromFetch(url, event);
                });
                if (updateURLHash) this.updateURLHash(searchParams);
              },

              renderSectionFromFetch(url, event) {
                fetch(url)
                  .then((response) => response.text())
                  .then((responseText) => {
                    const html = responseText;
                    this.filterData = [
                      ...this.filterData,
                      {
                        html,
                        url,
                      },
                    ];
                    this.renderFilters(html, event);
                    this.renderSearchGrid(html);
                    this.renderAdditionalElements(html);
                  });
              },

              renderSectionFromCache(filterDataUrl, event) {
                const html = this.filterData.find(filterDataUrl).html;
                this.renderFilters(html, event);
                this.renderSearchGrid(html);
                this.renderAdditionalElements(html);
              },

              renderSearchGrid(html) {
                const parsedHTML = new DOMParser().parseFromString(html, "text/html");
                const parsedSearchGrid = parsedHTML.getElementById("SearchGrid");
                const searchGrid = document.getElementById("SearchGrid");

                if (parsedSearchGrid && searchGrid) {
                  searchGrid.innerHTML = parsedSearchGrid.innerHTML;
                }

                document.getElementById("main-search").classList.remove("opacity-10");
              },

              renderFilters(html) {
                const parsedHTML = new DOMParser().parseFromString(html, "text/html");
                const parsedSearchFiltersForm = parsedHTML.getElementById("SearchFiltersForm");
                const searchFiltersForm = document.getElementById("SearchFiltersForm");

                if (parsedSearchFiltersForm && searchFiltersForm) {
                  searchFiltersForm.innerHTML = parsedSearchFiltersForm.innerHTML;
                }
              },

              renderAdditionalElements(html) {
                const parsedHTML = new DOMParser().parseFromString(html, "text/html");
                const selectors = ["[data-main-search-title]", "[data-main-search-status]"];
                selectors.forEach((selector) => {
                  const el = document.querySelector(selector);
                  const parsedEl = parsedHTML.querySelector(selector);

                  if (el && parsedEl) {
                    el.innerHTML = parsedEl.innerHTML;
                  }
                });
              },

              updateURLHash(searchParams) {
                history.pushState(
                  {
                    searchParams,
                  },
                  "",
                  `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
                );
              },

              onHistoryChange(event) {
                const searchParams = event.state.searchParams || "";
                this.renderPage(searchParams, null, false);
              },
            };
          };
        },

        onBlockSelect() {
          this.container.dispatchEvent(new CustomEvent("baseline:search:open-filters"));
        },
      });
      // CONCATENATED MODULE: ./src/scripts/sections/collapsible.js

      register("collapsible", {
        onLoad() {
          this.sectionId = this.id;
          const alpineId = this.container.dataset.alpineId;
          const functionName = "ThemeSection_" + alpineId;
          const singleTabAtATime = this.container.dataset.singleTabATime === "true";
          const firstTabOpenOnLoad = this.container.dataset.firstTabOpened === "true";
          const tabsCount = parseInt(this.container.dataset.tabsCount, 10);
          const tabOpen = {};

          for (let i = 0; i < tabsCount; i++) {
            tabOpen["tab" + i] = i === 0 && firstTabOpenOnLoad;
          }

          window[functionName] = () => {
            return {
              tabOpen,
              singleTabAtATime,

              mounted() {},

              openTab(index) {
                if (singleTabAtATime) {
                  for (let i = 0; i < tabsCount; i++) {
                    if (index !== i) {
                      this.tabOpen["tab" + i] = false;
                    }
                  }
                }

                this.tabOpen["tab" + index] = !this.tabOpen["tab" + index];
              },
            };
          };
        },

        onUnload() {},
      });
      // CONCATENATED MODULE: ./src/scripts/sections/predictive-search.js

      window.ThemeComponent_PredictiveSearch = (resources) => {
        return {
          cachedResults: {},
          loading: false,
          resultsOpen: false,
          rawQuery: "",
          results: false,
          resultsMarkup: null,
          resources: resources,

          get trimmedQuery() {
            return this.rawQuery.trim();
          },

          get queryKey() {
            return this.trimmedQuery.replace(" ", "-").toLowerCase();
          },

          mounted() {
            this.cachedResults = {};
            const toggles = document.querySelectorAll("[data-open-search]");
            toggles.forEach((toggle) => {
              toggle.setAttribute("role", "button");
            });
            document.addEventListener("keyup", (event) => {
              if (event.key === "Escape") {
                this.close(false);
              }
            });
            this.$watch("searchOpen", (value) => {
              if (value === true) {
                this.onOpen();
              }
            });
          },

          close(clearSearchTerm = true) {
            this.closeResults(clearSearchTerm);
            this.closePredictiveSearch();
          },

          closePredictiveSearch() {
            document.body.dispatchEvent(new CustomEvent("baseline:search:closebutton"));
          },

          closeResults(clearSearchTerm = false) {
            this.resultsOpen = false;

            if (clearSearchTerm) {
              this.rawQuery = "";
            }

            const selected = this.$el.querySelector('[aria-selected="true"]');
            if (selected) selected.setAttribute("aria-selected", false);
            this.$refs.input.setAttribute("aria-activedescendant", "");
            this.$refs.input.setAttribute("aria-expanded", false);
            document.documentElement.style.overflowY = "auto";
          },

          getSearchResults() {
            this.loading = true;
            liveRegion(window.theme.strings.loading);
            fetch(
              `${window.theme.routes.predictive_search_url}?q=${encodeURIComponent(
                this.trimmedQuery
              )}&${encodeURIComponent("resources[type]")}=${this.resources}&section_id=predictive-search`
            )
              .then((response) => {
                this.loading = false;

                if (!response.ok) {
                  var error = new Error(response.status);
                  this.close(true);
                  throw error;
                }

                return response.text();
              })
              .then((text) => {
                this.results = true;
                const resultsMarkup = new DOMParser()
                  .parseFromString(text, "text/html")
                  .querySelector("#shopify-section-predictive-search").innerHTML;
                const liveRegionText = new DOMParser()
                  .parseFromString(text, "text/html")
                  .querySelector("#predictive-search-count").textContent;
                this.cachedResults[this.queryKey] = resultsMarkup;
                this.renderSearchResults(resultsMarkup);
                liveRegion(liveRegionText);
              })
              .catch((error) => {
                this.close(true);
                throw error;
              });
          },

          onChange() {
            if (!this.trimmedQuery.length) {
              this.closeResults();
            } else {
              this.openResults();
              this.getSearchResults();
            }
          },

          onFocus() {
            if (!this.trimmedQuery.length) return;

            if (this.results === true) {
              this.openResults();
            } else {
              this.getSearchResults();
            }
          },

          onFocusOut() {
            // If search bar is open, trap focus in it until it is closed
            if (this.searchOpen) {
              setTimeout(() => {
                if (!this.$refs.searchFieldComponent.contains(document.activeElement)) {
                  focusable(this.$el)[0].focus();
                }
              });
            }
          },

          onFormSubmit(event) {
            if (!this.trimmedQuery.length || this.$el.querySelector('[aria-selected="true"] a')) event.preventDefault();
          },

          onOpen() {
            if (this.trimmedQuery.length) {
              this.openResults();
              this.$nextTick(() => {
                if (this.cachedResults[this.queryKey]) {
                  this.renderSearchResults(this.cachedResults[this.queryKey]);
                } else {
                  this.getSearchResults();
                }
              });
            }
          },

          openResults() {
            this.resultsOpen = true;
            this.$refs.input.setAttribute("aria-expanded", true);
            document.documentElement.style.overflowY = "hidden";
          },

          renderSearchResults(resultsMarkup) {
            this.$refs.results.innerHTML = resultsMarkup;
            this.results = true;
            this.openResults();
            setTimeout(() => {
              trapFocus(this.$el);
              this.$refs.input.focus();
            }, 300);
          },
        };
      };
      // CONCATENATED MODULE: ./src/scripts/theme.js
      window.Baseline = window.Baseline || {};

      __webpack_require__.p = window.baseAssetsUrl || "/"; // YouTube API callback
      // eslint-disable-next-line no-unused-vars
      // eslint-disable-next-line no-unused-vars

      window.onYouTubeIframeAPIReady = () => {
        document.body.dispatchEvent(new CustomEvent("youtubeiframeapiready"));
      }; // Common a11y fixes

      focusHash();
      bindInPageLinks(); // wrap iframes and tables
      // Theme-specific selectors to make tables scrollable

      var tableSelectors = ".rte table";
      wrapTable({
        tables: document.querySelectorAll(tableSelectors),
        tableWrapperClass: "table-wrapper",
      }); // Theme-specific selectors to make iframes responsive

      var iframeSelectors = '.rte iframe[src*="youtube.com/embed"],' + '.rte iframe[src*="player.vimeo"]';
      wrapIframe({
        iframes: document.querySelectorAll(iframeSelectors),
        iframeWrapperClass: "video-wrapper",
      }); // Apply a specific class to the html element for browser support of cookies.

      if (window.navigator.cookieEnabled) {
        document.documentElement.className = document.documentElement.className.replace(
          "supports-no-cookies",
          "supports-cookies"
        );
      }

      load("*");

      /***/
    },
    /******/
  ]
);


